import {
  DEALER_CAPABILITIES,
  MovePlannerContext,
  MovePlannerHostProvider,
  appliedConfigRooftopId,
  isRooftopConfigLoaded,
  moveOfferingFor,
  offeredTypesOnceLoaded,
  resolveCapabilities,
  typeAllowList,
  useMovePlanner,
  useMovePlannerHost
} from "./chunk-HLQMKPF5.mjs";
import {
  MOVE_PLANNER_TYPES,
  MoveRequestPlanError,
  buildVehicleMoveRequest,
  isClientUpdateRequiredError,
  readVehicleMoveResult,
  resolveIntendedProduct,
  resolveMovePlannerTypes,
  vehicleMoveErrorMessage
} from "./chunk-WEMXH2UM.mjs";

// src/provider/MovePlannerProvider.tsx
import React3 from "react";
import dayjs7 from "dayjs";
import { useLazyQuery, useMutation } from "@apollo/client";
import { LinearProgress } from "@mui/material";

// src/kit/selectors/queries/getPayers.query.generated.ts
import { resolveExecutor } from "@hopdrive/sdk-core";
var GetPayersDocument = { "__text": "query getPayers($payersArray: [bigint!]) {\n  customers(\n    where: {active: {_eq: 1}, id: {_in: $payersArray}}\n    order_by: {name: asc}\n  ) {\n    id\n    name\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getPayers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "payersArray" } }, "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "payersArray" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };

// src/kit/selectors/queries/getWorkflowsets.query.generated.ts
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";
var GetWorkflowsetsDocument = { "__text": 'query getWorkflowsets($rooftopId: bigint!) {\n  workflowsets(where: {customer_id: {_eq: $rooftopId}}, order_by: {name: asc}) {\n    id\n    name\n    description\n    pickup_workflow_id\n    delivery_workflow_id\n    public\n    confirmationset {\n      id\n      description\n      confirmation_flow\n    }\n    moveCreateWorkflow {\n      name\n      steps\n    }\n    contracts(\n      where: {customer_id: {_eq: $rooftopId}, begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}\n      order_by: {begin_date: asc}\n      limit: 1\n    ) {\n      id\n      sla {\n        id\n        label\n        duration_hrs\n      }\n    }\n    activeContracts: contracts(\n      where: {customer_id: {_eq: $rooftopId}, begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}\n    ) {\n      id\n      artriggers {\n        product_key\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getWorkflowsets" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "workflowsets" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "public" } }, { "kind": "Field", "name": { "kind": "Name", "value": "confirmationset" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "confirmation_flow" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "moveCreateWorkflow" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "steps" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sla" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "label" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_hrs" } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "activeContracts" }, "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }] } }] } }] } }] } }] };

// src/content/RelatedMovesSelectionModal.tsx
import React from "react";
import dayjs from "dayjs";
import { css } from "@emotion/css";
import { useTheme, Button, Typography, Box } from "@mui/material";
import { BiSolidCalendar, BiSolidCar } from "react-icons/bi";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var RelatedMovesSelectionModalContent = ({
  onClose,
  relatedMoves,
  referenceNum
}) => {
  const theme = useTheme();
  const cls = useStyles(theme);
  const host = useMovePlannerHost();
  const { ModalHeader, ModalContent, ModalFooter } = host.components;
  const customerConfig = host.rooftop.useCustomerConfig();
  const refLabel = customerConfig?.reference_num_label || "Reference ID";
  const [selectedMove, setSelectedMove] = React.useState(null);
  const handleClose = () => {
    onClose();
  };
  const handleSelect = () => {
    if (selectedMove) {
      onClose(selectedMove);
    }
  };
  const formatPickupTime = (pickupTime) => {
    return dayjs(pickupTime).format("MMM D, YYYY \u2022 h:mm A");
  };
  const getMoveFamily = (move) => {
    const family = [];
    if (move.parentMove) family.push("Parent");
    if (move.childMoves && move.childMoves.length > 0)
      family.push(`${move.childMoves.length} Child${move.childMoves.length > 1 ? "ren" : ""}`);
    return family;
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(ModalHeader, { handleClose, children: [
      "Select Related Move to Assign ",
      refLabel
    ] }),
    /* @__PURE__ */ jsx(
      ModalContent,
      {
        subtitle: `Multiple related moves with the same VIN were found. Select which move should have its ${refLabel} updated to "${referenceNum}". If there is a loaner attached to this move, its ${refLabel} will also be updated.`,
        children: /* @__PURE__ */ jsx(Box, { children: relatedMoves.map((move) => {
          const isSelected = selectedMove?.id === move.id;
          const family = getMoveFamily(move);
          return /* @__PURE__ */ jsxs(
            Box,
            {
              className: `${cls.moveButton} ${isSelected ? cls.moveButtonSelected : ""}`,
              onClick: () => setSelectedMove(move),
              role: "button",
              tabIndex: 0,
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setSelectedMove(move);
                }
              },
              children: [
                /* @__PURE__ */ jsxs(Box, { className: cls.moveHeader, children: [
                  /* @__PURE__ */ jsx(BiSolidCar, { size: 20, color: theme?.palette?.primary?.main }),
                  /* @__PURE__ */ jsxs(Typography, { variant: "h6", children: [
                    "HopDrive ID - ",
                    /* @__PURE__ */ jsxs("strong", { children: [
                      "#",
                      move.id
                    ] })
                  ] }),
                  family.length > 0 && /* @__PURE__ */ jsx(Box, { className: cls.familyBadge, children: family.join(" \u2022 ") })
                ] }),
                /* @__PURE__ */ jsxs(Box, { className: cls.moveDetails, children: [
                  /* @__PURE__ */ jsxs(Box, { className: cls.detailItem, children: [
                    /* @__PURE__ */ jsx(BiSolidCalendar, { size: 14 }),
                    /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
                      "Planned Pickup @ ",
                      formatPickupTime(move?.pickup_time)
                    ] })
                  ] }),
                  move?.delivery_successful ? /* @__PURE__ */ jsxs(Box, { className: cls.detailItem, children: [
                    /* @__PURE__ */ jsx(BiSolidCalendar, { size: 14 }),
                    /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
                      "Delivered @ ",
                      formatPickupTime(move?.delivery_successful)
                    ] })
                  ] }) : null,
                  move?.reference_num ? /* @__PURE__ */ jsxs(Fragment, { children: [
                    /* @__PURE__ */ jsx("div", { style: { width: "100%", height: theme.spacing(2) } }),
                    /* @__PURE__ */ jsx(Box, { className: cls.detailItem, children: /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
                      "Current ",
                      refLabel,
                      ": ",
                      /* @__PURE__ */ jsx("strong", { children: move?.reference_num })
                    ] }) })
                  ] }) : null
                ] })
              ]
            },
            move.id
          );
        }) })
      }
    ),
    /* @__PURE__ */ jsxs(ModalFooter, { children: [
      /* @__PURE__ */ jsx(Button, { variant: "text", color: "utility", onClick: handleClose, children: "Skip Selection" }),
      /* @__PURE__ */ jsxs(Button, { variant: "contained", color: "primary", disabled: !selectedMove, onClick: handleSelect, children: [
        "Update ",
        refLabel
      ] })
    ] })
  ] });
};
var useStyles = (theme) => {
  return {
    moveButton: css`
      width: 100%;
      padding: 20px;
      margin-bottom: 12px;
      border: 2px solid ${theme?.palette?.divider};
      border-radius: 12px;
      background-color: ${theme?.palette?.background?.paper};
      text-transform: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      cursor: pointer;
      user-select: none;
      transition:
        border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;

      &:hover {
        border-color: ${theme?.palette?.primary?.main};
        background-color: ${theme?.palette?.action?.hover};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      &:active {
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
      }

      &:focus {
        outline: 2px solid ${theme?.palette?.primary?.main};
        outline-offset: 2px;
      }
    `,
    moveButtonSelected: css`
      border-color: ${theme?.palette?.primary?.main};
      background-color: ${theme?.palette?.action?.selected};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    `,
    moveHeader: css`
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
      width: 100%;
      pointer-events: none;
    `,
    moveDetails: css`
      width: 100%;
      margin-top: 4px;
      pointer-events: none;
    `,
    detailItem: css`
      display: flex;
      align-items: center;
      gap: 6px;
      color: ${theme?.palette?.text?.secondary};
    `,
    infoBox: css`
      padding: 16px;
      border-radius: 8px;
      background-color: ${theme?.palette?.action?.hover};
      margin-bottom: 16px;
    `,
    familyBadge: css`
      padding: 4px 8px;
      border-radius: 6px;
      background-color: ${theme?.palette?.info?.light};
      color: ${theme?.palette?.info?.dark};
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    `
  };
};
var RelatedMovesSelectionModal = ({ open, onClose, relatedMoves, referenceNum }) => {
  const { Modal } = useMovePlannerHost().components;
  return /* @__PURE__ */ jsx(Modal, { open, width: "md", children: open && relatedMoves.length > 0 ? /* @__PURE__ */ jsx(RelatedMovesSelectionModalContent, { onClose, relatedMoves, referenceNum }) : null });
};
var RelatedMovesSelectionModal_default = RelatedMovesSelectionModal;

// src/forms/product-choice/liteMode.ts
import { isLiteProduct } from "@hopdrive/sdk-moves";
function liteModeFor(productKey) {
  if (!productKey) return "pending";
  return isLiteProduct(productKey) ? "lite" : "full";
}
function rooftopLiteMode(offering) {
  const sellers = Object.values(offering).flatMap((typeOffering) => typeOffering.sellers);
  if (sellers.length === 0) return "pending";
  return sellers.some((key) => isLiteProduct(key)) ? "lite" : "full";
}
function plannerLiteMode({ offering, productKey, choicePending }) {
  if (productKey) return liteModeFor(productKey);
  if (!offering || choicePending) return "pending";
  return rooftopLiteMode(offering);
}

// src/forms/product-choice/productChoice.ts
import { VALET_TIER_TIE_BREAK } from "@hopdrive/sdk-moves";
import { productLabel } from "@hopdrive/sdk-products/catalog";
var NO_CHOICE = { required: false, sellers: [], defaultSeller: null };
function productChoiceFor(offering, type) {
  const typeOffering = type ? offering?.[type] : void 0;
  if (!typeOffering) return NO_CHOICE;
  return { required: typeOffering.requiresChoice, sellers: typeOffering.sellers, defaultSeller: typeOffering.defaultSeller };
}
function isSellerChosen(choice, chosenKey) {
  return !!chosenKey && choice.sellers.includes(chosenKey);
}
function effectiveProductKey(choice, chosenKey, switchOn) {
  if (!switchOn) return choice.defaultSeller;
  if (choice.required) return isSellerChosen(choice, chosenKey) ? chosenKey : null;
  return choice.sellers.length === 1 ? choice.sellers[0] : null;
}
function isProductChoiceUnmade(choice, chosenKey) {
  return choice.required && !isSellerChosen(choice, chosenKey);
}
function appointmentProductKey(choice) {
  if (choice.sellers.length <= 1) return choice.sellers[0] ?? null;
  return VALET_TIER_TIE_BREAK.find((key) => choice.sellers.includes(key)) ?? null;
}
function plannerProductKey(choice, chosenKey, path) {
  if (path.isAppointment) return appointmentProductKey(choice);
  return effectiveProductKey(choice, chosenKey, path.switchOn);
}
function isProductChoicePending(choice, chosenKey, path) {
  return path.switchOn && !path.isAppointment && isProductChoiceUnmade(choice, chosenKey);
}
function productChoicePrompt(sellers) {
  const labels = sellers.map(productLabel);
  if (labels.length <= 2) return `Choose ${labels.join(" or ")}`;
  return `Choose ${labels.slice(0, -1).join(", ")}, or ${labels[labels.length - 1]}`;
}

// src/forms/type/typeOffer.ts
function typeRefusal(type, offered, types = MOVE_PLANNER_TYPES) {
  if (!type || !offered) return null;
  if (offered.types.some((t) => t.value === type)) return null;
  const label = types.find((t) => t.value === type)?.label ?? type;
  return { type, message: `This rooftop cannot order ${label} moves.` };
}
function typeAfterRooftopSwitch(type, offered, typeFixed) {
  if (typeFixed || !typeRefusal(type, offered)) return type ?? "";
  return "";
}
function offeredProductKey(productKey, offered, refusal) {
  if (!offered || refusal) return null;
  return productKey ?? null;
}
function nothingOfferedCopy(narrowedBy, reason) {
  if (narrowedBy === "list") {
    return {
      title: "No Move Types Enabled",
      message: `None of the move types this rooftop can order are enabled in its settings. Contact your HopDrive representative to enable one.`
    };
  }
  if (narrowedBy === "offering") {
    const because = reason ? ` ${reason.replace(/\.?$/, ".")}` : "";
    return {
      title: "Moves Are Not Available",
      message: `This rooftop cannot order moves right now.${because} Contact your HopDrive representative with any questions.`
    };
  }
  return null;
}
function typeNoticeMessage(refusal, nothingOffered) {
  return nothingOffered?.message ?? refusal?.message ?? null;
}

// src/utils/moveWorkflowsets.ts
import {
  PRODUCT_KEY_OPERATIONAL_MOVES,
  PRODUCT_KEY_VALET_FULL_SERVICE,
  PRODUCT_KEY_VALET_LITE
} from "@hopdrive/sdk-products/catalog";
var MOVE_PRODUCT_KEYS = [PRODUCT_KEY_VALET_FULL_SERVICE, PRODUCT_KEY_VALET_LITE, PRODUCT_KEY_OPERATIONAL_MOVES];
function moveWorkflowsets(workflowsets) {
  return (workflowsets ?? []).filter(
    (workflowset) => workflowset.activeContracts?.some(
      (contract) => contract?.artriggers?.some((trigger) => !!trigger?.product_key && MOVE_PRODUCT_KEYS.includes(trigger.product_key))
    )
  );
}
function replacementMoveWorkflowsetId(workflowsets, workflowsetId) {
  const offered = moveWorkflowsets(workflowsets);
  if (!offered.length || offered.some((workflowset) => workflowset.id === workflowsetId)) return null;
  return offered[0].id;
}

// src/provider/applyEmbedSettings.ts
function embedSettingsStart(embed) {
  return { initialType: embed?.settings.initialType || void 0 };
}

// src/provider/applyPrefill.ts
var over = (values) => (previous) => ({ ...previous, ...values });
function prefillUpdates(prefill) {
  if (!prefill) return {};
  const updates = {};
  if (prefill.consumer) updates.consumer = over(prefill.consumer);
  if (prefill.contactInfo) updates.contactInfo = over(prefill.contactInfo);
  if (prefill.contactPrefillSameAsPickup) updates.contactPrefillSameAsPickup = true;
  if (prefill.vehicle1) updates.vehicle1 = over(prefill.vehicle1);
  if (prefill.vehicle2) updates.vehicle2 = over(prefill.vehicle2);
  if (prefill.additional1) updates.additional1 = over(prefill.additional1);
  if (prefill.additional2) updates.additional2 = over(prefill.additional2);
  if (prefill.time != null) updates.time = prefill.time;
  return updates;
}

// src/provider/composeLaneLifecycle.ts
function composeLaneLifecycle({
  main,
  inverse,
  requiresInverseLane,
  retry
}) {
  const lanes = requiresInverseLane ? [main, inverse] : [main];
  const failed = lanes.find((lifecycle) => lifecycle.failed) ?? null;
  const enriching = lanes.some((lifecycle) => lifecycle.enriching);
  const gaveUp = !failed && lanes.some((lifecycle) => lifecycle.gaveUp === true);
  const stalled = !failed && !gaveUp && lanes.some((lifecycle) => lifecycle.stalled === true);
  return {
    phase: failed ? "failed" : enriching ? "enriching" : main.phase,
    status: failed?.status ?? main.status,
    retrying: main.retrying || inverse.retrying,
    retry,
    stalled,
    gaveUp,
    error: lanes.map((lifecycle) => lifecycle.error).find((error) => error !== void 0 && error !== null)
  };
}
var LANE_GAVE_UP_MESSAGE = "We couldn't calculate this route. Check both addresses, or reload the page to try again.";
function laneLifecycleNotice(lifecycle) {
  if (!lifecycle) return null;
  if (lifecycle.phase === "failed") return "failed";
  if (lifecycle.phase !== "enriching") return null;
  if (lifecycle.gaveUp) return "gave-up";
  if (lifecycle.error !== void 0 && lifecycle.error !== null) return "lost";
  if (lifecycle.stalled) return "stalled";
  return "calculating";
}

// src/provider/connectorMerge.ts
function connectorMerge({
  record,
  vehicleIndex,
  overwriteExisting,
  triggerType,
  excludeFields,
  type,
  consumer,
  vehicle1,
  vehicle2,
  merge
}) {
  const isLoanerMove = type === "concierge-loaner";
  const loanerVehicleIsFirst = consumer?.first === "loaner";
  let vehicleSlot = vehicleIndex === 2 ? 2 : 1;
  const isLoanerVehicleData = triggerType === "contract-detail";
  if (isLoanerMove && isLoanerVehicleData) {
    vehicleSlot = loanerVehicleIsFirst ? 1 : 2;
  }
  const targetVehicle = vehicleSlot === 2 ? vehicle2 : vehicle1;
  const { consumerUpdates, vehicleUpdates } = merge(
    record,
    consumer,
    targetVehicle,
    overwriteExisting,
    excludeFields
  );
  const result = { consumerUpdates, vehicleSlot, vehicleUpdates };
  if (isLoanerMove && isLoanerVehicleData && record.referenceNumber && !excludeFields.includes("referenceId")) {
    const consumerSlot = loanerVehicleIsFirst ? 2 : 1;
    const consumerVehicle = consumerSlot === 2 ? vehicle2 : vehicle1;
    if (!consumerVehicle?.referenceId || overwriteExisting) {
      result.referenceCopy = { vehicleSlot: consumerSlot, referenceId: String(record.referenceNumber) };
    }
  }
  return result;
}
function connectorEndpoints({
  customerLocation,
  dealershipLocation,
  action,
  pickup,
  delivery,
  overwriteExisting
}) {
  const endpoints = {};
  const customerEnd = action === "return" ? "delivery" : "pickup";
  const dealershipEnd = action === "return" ? "pickup" : "delivery";
  const current = { pickup, delivery };
  if (!current[customerEnd]?.id || overwriteExisting) endpoints[customerEnd] = customerLocation;
  if (dealershipLocation && (!current[dealershipEnd]?.id || overwriteExisting)) endpoints[dealershipEnd] = dealershipLocation;
  return endpoints;
}

// src/provider/plannerDefaults.ts
var validationDefaults = /* @__PURE__ */ new Map();
function defaultValidationFor(capabilities) {
  const key = `${capabilities.roCapture}|${capabilities.dynamicWorkflowSteps}|${capabilities.confirmationContacts}`;
  if (!validationDefaults.has(key)) validationDefaults.set(key, buildDefaultValidation(capabilities));
  return validationDefaults.get(key);
}
function buildDefaultValidation(capabilities) {
  return {
    rooftopId: true,
    payerId: true,
    workflowsetId: true,
    type: true,
    emails: true,
    consumer: {
      name: true,
      phone: true,
      ...capabilities.roCapture ? { referenceId: true } : {},
      action: true,
      first: true
    },
    time: true,
    ...capabilities.dynamicWorkflowSteps ? { dynamic: {} } : {},
    lane: true,
    pickup: true,
    delivery: true,
    vehicle1: {
      referenceId: true,
      manual: true,
      vin: true,
      stock: true,
      make: true,
      model: true,
      year: true,
      color: true
    },
    vehicle2: {
      referenceId: true,
      manual: true,
      vin: true,
      stock: true,
      make: true,
      model: true,
      year: true,
      color: true
    },
    additional1: {
      contact: true,
      notes: true
    },
    additional2: {
      contact: true,
      notes: true
    },
    contactInfo: {
      pickupName: true,
      pickupPhone: true,
      ...capabilities.confirmationContacts ? { pickupEmail: true } : {},
      deliveryName: true,
      deliveryPhone: true,
      ...capabilities.confirmationContacts ? { deliveryEmail: true } : {}
    }
  };
}
var defaultType = ``;
var defaultEmails = [];
var DEFAULT_CONSUMER_WITH_RO = {
  name: ``,
  phone: ``,
  referenceId: ``,
  action: `pickup`,
  first: `loaner`
};
var DEFAULT_CONSUMER = {
  name: ``,
  phone: ``,
  action: `pickup`,
  first: `loaner`
};
function defaultConsumerFor(capabilities) {
  return capabilities.roCapture ? DEFAULT_CONSUMER_WITH_RO : DEFAULT_CONSUMER;
}
var defaultTime = null;
var defaultIsDefaultTime = false;
var defaultDynamic = {};
var defaultLane = null;
var defaultLocation = null;
var defaultMove1Title = `MOVE 1`;
var defaultMove2Title = `MOVE 2`;
var defaultVehicle = {
  referenceId: ``,
  manual: false,
  vin: ``,
  stock: ``,
  make: ``,
  model: ``,
  year: ``,
  color: ``
};
var defaultAdditional = {
  contact: ``,
  notes: ``
};
var defaultContactInfo = {
  pickupName: ``,
  pickupMobile: ``,
  pickupLandline: ``,
  pickupEmail: ``,
  deliveryName: ``,
  deliveryMobile: ``,
  deliveryLandline: ``,
  deliveryEmail: ``,
  // Kept beside the mobile number for contacts written before mobile and landline split
  pickupPhone: ``,
  deliveryPhone: ``
};

// src/provider/plannerLoaders.ts
function rooftopQueryFor(userRole, userId, customerId, { programAdminsMayPlan }) {
  if (!userRole) throw new Error(`User role not found`);
  const linkedRoles = ["dealer-admin", "dealer-super-admin", ...programAdminsMayPlan ? ["program-admin"] : []];
  if (userRole !== "admin" && userRole !== "dealer" && !linkedRoles.includes(userRole)) throw new Error(`User role not allowed`);
  if (userRole === "admin") return { query: "all" };
  if (userRole === "dealer") {
    if (!customerId) throw new Error(`Dealer user missing customer ID`);
    return { query: "allowed", customerIdArr: [customerId] };
  }
  if (!userId) throw new Error(`User id not found`);
  return { query: "linked", userId };
}
async function loadRooftops({ session, capabilities, getHeaderRooftops, getAllowedHeaderRooftops, getLinkedHeaderRooftops }) {
  const userClaims = await session.readClaims();
  if (!userClaims) throw new Error(`User claims not found`);
  const rooftopQuery = rooftopQueryFor(userClaims.role, session.userId, session.customerId || void 0, capabilities);
  const res = rooftopQuery.query === "all" ? await getHeaderRooftops({ fetchPolicy: "cache-and-network" }) : rooftopQuery.query === "linked" ? await getLinkedHeaderRooftops({ variables: { userId: rooftopQuery.userId }, fetchPolicy: "cache-and-network" }) : await getAllowedHeaderRooftops({ variables: { customerIdArr: rooftopQuery.customerIdArr }, fetchPolicy: "cache-and-network" });
  return res?.data?.customers || [];
}
function initialRooftop(rooftops, restoreRooftopId) {
  const storedId = restoreRooftopId();
  const stored = storedId ? rooftops.find((r) => r?.id === storedId) : void 0;
  if (stored) return { rooftop: stored, remember: false };
  return { rooftop: rooftops?.[0], remember: !!rooftops?.[0] };
}
async function loadPayers(allowedPayerIds, getPayers) {
  if (!allowedPayerIds?.length) return [];
  const res = await getPayers({ variables: { payersArray: allowedPayerIds } });
  return res?.data?.customers || [];
}
async function loadForRooftop(rooftopId, overrideRooftopId, trigger, read) {
  if (!(overrideRooftopId || rooftopId)) return [];
  const rooftopIdToUse = overrideRooftopId || rooftopId;
  const res = await trigger({ variables: { rooftopId: rooftopIdToUse || 0 } });
  return read(res?.data) || [];
}
var loadWorkflowsets = (rooftopId, getWorkflowsets, overrideRooftopId) => loadForRooftop(rooftopId, overrideRooftopId, getWorkflowsets, (data) => data?.workflowsets);
var loadLanes = (rooftopId, getLanes, overrideRooftopId) => loadForRooftop(rooftopId, overrideRooftopId, getLanes, (data) => data?.lanes);
var loadLocations = (rooftopId, getLocations, overrideRooftopId) => loadForRooftop(rooftopId, overrideRooftopId, getLocations, (data) => data?.locations);
async function loadSourceMoves(sourceState, getMovesFromProps) {
  const moveIds = [];
  if (sourceState?.moveId1) moveIds.push(sourceState.moveId1);
  if (sourceState?.moveId2) moveIds.push(sourceState.moveId2);
  const res = await getMovesFromProps({ variables: { moveIds } });
  return res?.data?.moves || [];
}
async function loadPlannerConfig(rooftops, rooftopId, readPlannerConfig) {
  if (!rooftops?.length || !rooftopId) return {};
  const selectedRooftop = rooftops?.find((r) => r?.id === rooftopId);
  if (!selectedRooftop) return {};
  if (readPlannerConfig) return await readPlannerConfig(selectedRooftop) || {};
  return selectedRooftop?.effective_config || {};
}

// src/provider/plannerState.ts
import { MoveRequestType } from "@hopdrive/sdk-moves";
function moveTitles(type, consumerFirst) {
  if (type === `concierge`) return { move1Title: `CUSTOMER MOVE`, move2Title: ``, resetDefaultTime: true };
  if (type === `concierge-loaner`) {
    if (consumerFirst === `loaner`) return { move1Title: `LOANER MOVE`, move2Title: `CUSTOMER MOVE`, resetDefaultTime: true };
    if (consumerFirst === `consumer`) return { move1Title: `CUSTOMER MOVE`, move2Title: `LOANER MOVE`, resetDefaultTime: true };
    return null;
  }
  if (type === `one-way`) return { move1Title: `MOVE`, move2Title: ``, resetDefaultTime: false };
  if (type === `round-trip`) return { move1Title: `MOVE 1`, move2Title: `MOVE 2`, resetDefaultTime: false };
  return null;
}
function loanerSwapOnTypeChange(state) {
  if (state.type !== "concierge-loaner") return null;
  const expectedFirst = state.consumer?.action === "return" ? "consumer" : "loaner";
  if (state.consumer?.first === expectedFirst) return null;
  return {
    vehicle1: { ...state.vehicle2 },
    vehicle2: { ...state.vehicle1 },
    additional1: { ...state.additional2 },
    additional2: { ...state.additional1 },
    validation: {
      ...state.validation,
      vehicle1: state.validation?.vehicle2,
      vehicle2: state.validation?.vehicle1
    },
    consumer: { ...state.consumer, first: expectedFirst }
  };
}
function customerSection(type, first) {
  return type === "concierge-loaner" && first === "loaner" ? 2 : 1;
}
function reorderOnTypeChange(state) {
  const { fromType, type, consumer } = state;
  if (fromType === type) return null;
  const first = consumer?.first;
  const nextFirst = type === "concierge-loaner" ? consumer?.action === "return" ? "consumer" : "loaner" : first;
  const moves = customerSection(fromType, first) !== customerSection(type, nextFirst);
  if (!moves && nextFirst === first) return null;
  return {
    vehicle1: moves ? { ...state.vehicle2 } : state.vehicle1,
    vehicle2: moves ? { ...state.vehicle1 } : state.vehicle2,
    additional1: moves ? { ...state.additional2 } : state.additional1,
    additional2: moves ? { ...state.additional1 } : state.additional2,
    validation: moves ? { ...state.validation, vehicle1: state.validation?.vehicle2, vehicle2: state.validation?.vehicle1 } : state.validation,
    consumer: { ...consumer, first: nextFirst }
  };
}
function enforcementModeFor(config) {
  return config?.appointment_management?.enabled === true && config?.appointment_management?.full_planning_enabled === true && config?.appointment_management?.enforcement_mode === "forced" ? "forced" : "suggested";
}
function configPatch({ config, state, hasPlanningContext, initialType, actorEmail, capabilities }) {
  const patch = {
    resetLane: !state && !hasPlanningContext,
    rooftopConfig: config || {},
    storeConfig: !!(config && Object.keys(config)?.length)
  };
  if (config && Object.keys(config)?.length) {
    const defaultWorkflowsetIdOverride = config?.public_workflowsets === false ? 0 : 1;
    patch.movePlannerLocked = config?.add_moves_always ? false : config?.add_moves_disabled ?? false;
    patch.showEmailNotifications = state?.appointment ? true : config?.allow_email_notifications ?? false;
    patch.showDistanceEstimates = state?.appointment ? true : config?.distance_estimates ?? false;
    patch.showPriceEstimates = state?.appointment ? true : config?.price_estimates ?? false;
    if (capabilities.enforcementMode) patch.enforcementMode = enforcementModeFor(config);
    if (!state) {
      patch.payerId = config?.require_third_party_payer && config?.default_payer ? config.default_payer : 0;
      if (!capabilities.defaultWorkflowsetWithSourceMove) {
        patch.workflowsetId = config?.default_workflow_set_id || defaultWorkflowsetIdOverride;
      }
      if (!initialType) patch.type = config?.default_move_type || ``;
      if (config?.allow_email_notifications && actorEmail) patch.emails = [actorEmail];
    }
    if (capabilities.defaultWorkflowsetWithSourceMove && !state?.appointment?.workflow_set_id) {
      patch.workflowsetId = config?.default_workflow_set_id || defaultWorkflowsetIdOverride;
    }
  }
  return patch;
}
var APPOINTMENT_MOVE_TYPE = MoveRequestType.CONCIERGE;
function appointmentFormFields(appointment) {
  return {
    pickup: appointment?.pickup || null,
    delivery: appointment?.delivery || null,
    vehicle1: {
      referenceId: appointment?.config?.claim_number || "",
      manual: appointment?.vehicle_manual || false,
      vin: appointment?.vehicle_vin || "",
      make: appointment?.vehicle_make || "",
      model: appointment?.vehicle_model || "",
      year: String(appointment?.vehicle_year || ""),
      color: appointment?.vehicle_color || ""
    },
    additional1: { notes: appointment?.driver_notes || "" },
    consumer: {
      name: appointment?.consumer_name || "",
      phone: appointment?.consumer_phone || "",
      action: appointment?.consumer_at_pickup ? "pickup" : "return"
    }
  };
}
function planningContextType(config, currentType) {
  if (config?.default_move_type) return config.default_move_type;
  return currentType ? void 0 : MoveRequestType.ONE_WAY;
}

// src/provider/MovePlannerProvider.tsx
import { useUpdateActions } from "@hopdrive/sdk-app-updater/react";

// src/provider/plannerReloadGuard.ts
import { useReloadGuard } from "@hopdrive/sdk-app-updater/react";

// src/utils/serviceLocationUtils.ts
var getServiceLocationPosition = (type, consumerAction) => {
  if (type === "concierge") return consumerAction === "pickup" ? "delivery" : "pickup";
  if (type === "concierge-loaner") return "pickup";
  return null;
};
var computeServiceLocations = (input) => {
  const isConciergeType = input.type === "concierge" || input.type === "concierge-loaner";
  if (!isConciergeType) {
    return null;
  }
  if (!input.rooftopLocation || input.serviceLocationOverride) return null;
  const servicePosition = getServiceLocationPosition(input.type, input.consumerAction ?? void 0);
  if (!servicePosition) return null;
  const serviceField = servicePosition === "pickup" ? input.pickup : input.delivery;
  const customerField = servicePosition === "pickup" ? input.delivery : input.pickup;
  if (serviceField?.id === input.rooftopLocation.id) return null;
  let newCustomerField = customerField ?? null;
  if (customerField?.id === input.rooftopLocation.id) {
    newCustomerField = serviceField?.id ? serviceField : null;
  }
  const newPickup = servicePosition === "pickup" ? input.rooftopLocation : newCustomerField;
  const newDelivery = servicePosition === "pickup" ? newCustomerField : input.rooftopLocation;
  return { pickup: newPickup, delivery: newDelivery, clearOverride: false };
};

// src/provider/plannerReloadGuard.ts
var PLANNER_GUARD_REASON = "Move planner";
var VEHICLE_KEYS = ["referenceId", "vin", "stock", "make", "model", "year", "color"];
var ADDITIONAL_KEYS = ["contact", "notes"];
var CONSUMER_KEYS = ["name", "phone", "referenceId"];
var text = (value) => typeof value === "string" ? value.trim() : "";
var answer = (value) => typeof value === "string" ? value.trim() || null : value ?? null;
var place = (location) => location ? location.id ?? JSON.stringify(location) : null;
var pick = (record, keys) => keys.map((k) => text(record?.[k]));
var answered = (record, read) => Object.entries(record ?? {}).map(([k, v]) => [k, read(v)]).filter(([, v]) => v !== "" && v !== null).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0);
function snapshot(fields) {
  const { pickup, delivery, vehicle1, vehicle2, additional1, additional2, consumer, contactInfo, dynamic } = fields;
  return JSON.stringify([
    place(pickup),
    place(delivery),
    pick(vehicle1, VEHICLE_KEYS),
    pick(vehicle2, VEHICLE_KEYS),
    pick(additional1, ADDITIONAL_KEYS),
    pick(additional2, ADDITIONAL_KEYS),
    pick(consumer, CONSUMER_KEYS),
    answered(contactInfo, text),
    answered(dynamic, answer)
  ]);
}
var EMPTY_FIELDS = {
  pickup: null,
  delivery: null,
  vehicle1: {},
  vehicle2: {},
  additional1: {},
  additional2: {},
  consumer: {},
  contactInfo: {},
  dynamic: {}
};
var EMPTY_SNAPSHOT = snapshot(EMPTY_FIELDS);
function plannerHasUnsavedWork(fields, seed) {
  return snapshot(fields) !== (seed ? snapshot(seed) : EMPTY_SNAPSHOT);
}
function usePlannerReloadGuard(fields, saving, seed) {
  useReloadGuard(saving || plannerHasUnsavedWork(fields, seed), PLANNER_GUARD_REASON);
}
function seedWithServiceFill(seed, fill) {
  const base = seed ?? EMPTY_FIELDS;
  const placed = computeServiceLocations({
    type: fill.type,
    consumerAction: fill.consumerAction,
    pickup: base.pickup,
    delivery: base.delivery,
    rooftopLocation: fill.rooftopLocation,
    serviceLocationOverride: false
  });
  return placed ? { ...base, pickup: placed.pickup, delivery: placed.delivery } : seed;
}

// src/provider/plannerSubmit.ts
import dayjs6 from "dayjs";
import { evaluateMoveLocations, LIVE_REGION_STATUS } from "@hopdrive/sdk-moves";
import { UPDATE_REQUIRED_HEADLINE } from "@hopdrive/sdk-app-updater/react";

// src/capabilities/eventlog/eventlogService.ts
import dayjs2 from "dayjs";
function buildEventlogMetadata(params) {
  const {
    customerId,
    customerName,
    payerId,
    payerName,
    workflowsetId,
    workflowsetName,
    type,
    emails,
    consumer,
    time,
    isDefaultTime,
    earliestAvailableTime,
    dynamic,
    pickup,
    delivery,
    mainLane,
    inverseLane,
    vehicle1,
    vehicle2,
    additional1,
    additional2,
    contactInfo,
    slaId,
    slaHrs,
    deliverBy1,
    deliverBy2,
    moveClass,
    classOverride,
    isLite,
    assignedDriverId,
    assignedDriverName,
    isScheduleTimelineMode,
    createRideForReturn
  } = params;
  const includeSecondVehicle = type === "round-trip" || type === "concierge-loaner";
  const includeContactInfo = type === "one-way" || type === "round-trip";
  return {
    // Basic Info
    customerId,
    customerName,
    payerId,
    payerName,
    workflowsetId,
    workflowsetName,
    type,
    // Emails
    emails,
    // Consumer Info
    consumer: {
      name: consumer?.name || null,
      phone: consumer?.phone || null,
      referenceId: consumer?.referenceId || null,
      action: consumer?.action || null,
      first: consumer?.first || null
    },
    // Time
    time,
    isDefaultTime,
    earliestAvailableTime,
    // Dynamic workflow fields
    dynamic,
    // Pickup Location (raw input + region after lane upsert)
    pickup: {
      id: pickup?.id || null,
      name: pickup?.name || "",
      address: pickup?.address || "",
      latitude: pickup?.latitude || null,
      longitude: pickup?.longitude || null,
      region_id: pickup?.region?.id || null
    },
    // Delivery Location (raw input + region after lane upsert)
    delivery: {
      id: delivery?.id || null,
      name: delivery?.name || "",
      address: delivery?.address || "",
      latitude: delivery?.latitude || null,
      longitude: delivery?.longitude || null,
      region_id: delivery?.region?.id || null
    },
    // Lane info (populated after upsert)
    mainLaneId: mainLane?.id || null,
    inverseLaneId: inverseLane?.id || null,
    // Vehicle 1
    vehicle1: {
      referenceId: vehicle1?.referenceId || null,
      manual: vehicle1?.manual || false,
      vin: vehicle1?.vin || null,
      stock: vehicle1?.stock || null,
      make: vehicle1?.make || null,
      model: vehicle1?.model || null,
      year: vehicle1?.year || null,
      color: vehicle1?.color || null
    },
    // Vehicle 2 (for round-trip and concierge-loaner)
    vehicle2: includeSecondVehicle ? {
      referenceId: vehicle2?.referenceId || null,
      manual: vehicle2?.manual || false,
      vin: vehicle2?.vin || null,
      stock: vehicle2?.stock || null,
      make: vehicle2?.make || null,
      model: vehicle2?.model || null,
      year: vehicle2?.year || null,
      color: vehicle2?.color || null
    } : null,
    // Additional Info
    additional1: {
      contact: additional1?.contact || null,
      notes: additional1?.notes || null
    },
    additional2: includeSecondVehicle ? {
      contact: additional2?.contact || null,
      notes: additional2?.notes || null
    } : null,
    // Contact Information (for one-way and round-trip)
    contactInfo: includeContactInfo ? {
      pickupName: contactInfo?.pickupName || null,
      pickupMobile: contactInfo?.pickupMobile || null,
      pickupLandline: contactInfo?.pickupLandline || null,
      pickupEmail: contactInfo?.pickupEmail || null,
      pickupNotes: contactInfo?.pickupNotes || null,
      deliveryName: contactInfo?.deliveryName || null,
      deliveryMobile: contactInfo?.deliveryMobile || null,
      deliveryLandline: contactInfo?.deliveryLandline || null,
      deliveryEmail: contactInfo?.deliveryEmail || null,
      deliveryNotes: contactInfo?.deliveryNotes || null
    } : null,
    // Calculated fields
    calculatedFields: {
      slaId,
      slaHrs,
      deliverBy1,
      deliverBy2,
      moveClass,
      classOverride
    },
    // Session context
    isLite,
    assignedDriverId,
    assignedDriverName,
    isScheduleTimelineMode,
    createRideForReturn,
    // Timestamp
    submittedAt: dayjs2().toISOString()
  };
}
async function updateEventlogsWithMoveIds(params) {
  try {
    const { eventlogIds, moveIds, eventKey, updateMutation } = params;
    if (eventlogIds.length !== moveIds.length) {
      console.error(
        `Mismatch between eventlog count (${eventlogIds.length}) and move count (${moveIds.length}) - skipping eventlog updates`
      );
      return;
    }
    for (let i = 0; i < eventlogIds.length; i++) {
      try {
        await updateMutation({
          variables: {
            eventlogId: eventlogIds[i],
            moveId: moveIds[i],
            eventKey
          }
        });
      } catch (err) {
        console.error(`Failed to update eventlog ${eventlogIds[i]} with move_id ${moveIds[i]}:`, err);
      }
    }
  } catch (err) {
    console.error(`Unexpected failure while updating eventlogs (non-blocking):`, err);
  }
}

// src/utils/lanePersistence.ts
function lanesNeedPersisting(lanes) {
  return lanes.some((lane) => !lane?.id);
}

// src/utils/moveLegRanges.ts
import dayjs3 from "dayjs";
function computeMoveLegRanges(input) {
  const { time, type, consumerAction, consumerFirst, mainLane, inverseLane } = input;
  const base = time ? dayjs3(time) : dayjs3();
  const forwardSec = mainLane?.duration_sec || 0;
  const inverseSec = inverseLane?.duration_sec || 0;
  const isConciergeLoaner = type === "concierge-loaner";
  const range = (start, end) => ({
    start: start.toDate(),
    end: end.toDate()
  });
  let leg1;
  let leg2;
  if (type === "one-way" || type === "round-trip" || type === "concierge" || isConciergeLoaner && consumerAction === "return") {
    leg1 = range(base, base.add(forwardSec, "second"));
  }
  if (type === "round-trip" || isConciergeLoaner && consumerAction === "return") {
    const leg2Start = base.add(forwardSec, "second");
    leg2 = range(leg2Start, leg2Start.add(inverseSec, "second"));
  }
  if (isConciergeLoaner && consumerAction === "pickup") {
    if (consumerFirst === "loaner") {
      leg1 = range(base.subtract(forwardSec, "second"), base);
      leg2 = range(base, base.add(inverseSec, "second"));
    } else if (consumerFirst === "consumer") {
      leg1 = range(base, base.add(forwardSec, "second"));
      const leg2Start = base.add(forwardSec, "second");
      leg2 = range(leg2Start, leg2Start.add(inverseSec, "second"));
    }
  }
  const legs = [leg1, leg2].filter((leg) => leg != null);
  const ready = forwardSec > 0 && (leg2 == null || inverseSec > 0);
  return { legs, ready };
}

// src/provider/followOns.ts
import dayjs4 from "dayjs";
async function queryRelatedConciergeMoves(getRelatedConciergeMoves, vins = [], minDate = dayjs4().subtract(14, "days").format()) {
  if (vins?.length === 0 || !minDate) return [];
  try {
    const { data } = await getRelatedConciergeMoves({ variables: { vins, minDate } });
    return data?.moves || [];
  } catch (err) {
    console.error("\u274C Error searching for related concierge moves:", err);
    return [];
  }
}
function collectMostRecentMoveIdsToUpdate(relatedMoves = [], additionalMoveIds = []) {
  const moveIdsToUpdate = [];
  if (additionalMoveIds && additionalMoveIds?.length > 0) moveIdsToUpdate.push(...additionalMoveIds);
  const mostRecentMove = relatedMoves?.length > 0 ? relatedMoves?.[0] : null;
  if (mostRecentMove) {
    moveIdsToUpdate.push(mostRecentMove?.id);
    if (mostRecentMove?.parentMove?.id) moveIdsToUpdate.push(mostRecentMove?.parentMove?.id);
    mostRecentMove?.childMoves?.forEach((child) => {
      if (child?.id) moveIdsToUpdate.push(child?.id);
    });
  }
  return moveIdsToUpdate;
}
function relatedMoveFamily(selectedMove) {
  const selectedMoveIds = [selectedMove.id];
  if (selectedMove.parentMove?.id) selectedMoveIds.push(selectedMove.parentMove.id);
  if (selectedMove.childMoves?.length) selectedMoveIds.push(...selectedMove.childMoves.map((child) => child.id));
  return selectedMoveIds;
}
async function mutateRelatedConciergeMoves(updateReferenceNumOnRelatedConciergeMoves, moveIdsToUpdate = [], referenceNum = null, actorEmail = null) {
  if (moveIdsToUpdate.length === 0) return void 0;
  if (!referenceNum) return void 0;
  try {
    await updateReferenceNumOnRelatedConciergeMoves({
      variables: {
        moveIds: moveIdsToUpdate,
        referenceNum,
        updatedBy: actorEmail || "updateReferenceNumOnRelatedMoves"
      }
    });
    return true;
  } catch (err) {
    console.error("\u274C Error updating reference IDs for related moves:", err);
    return false;
  }
}
async function logRequestAttempts(logEvent2, input) {
  const eventlogIds = [];
  for (let i = 0; i < input.moveCount; i++) {
    try {
      const eventRes = await logEvent2("move.request.failed", {
        user: input.actorEmail || "dealer",
        role: "dealer",
        customer_id: input.rooftopId,
        lane_id: i === 0 ? input.mainLaneId ?? void 0 : input.inverseLaneId ?? void 0,
        metadata: input.metadata,
        safeWithResponse: true
      });
      if (eventRes.success) {
        if (eventRes.data?.id) eventlogIds.push(eventRes.data.id);
      } else {
        console.error(`[logEvent] Failed to log move.request.failed:`, eventRes);
      }
    } catch (eventlogErr) {
      console.error(`\u26A0\uFE0F Failed to insert eventlog #${i + 1} (non-blocking):`, eventlogErr);
    }
  }
  return eventlogIds;
}

// src/provider/plannerValidation.ts
import dayjs5 from "dayjs";

// src/services/movePlannerService.ts
var defaultConciergeSla = {
  id: 2,
  name: `default_concierge`,
  label: `HopDrive Concierge`,
  description: `The HopDrive default SLA for concierge moves (Completed no later than one hour after the appointment time).`,
  duration_hrs: 1,
  public: true
};
var cleanseLocations = (locations, excludeList) => {
  if (!locations?.length && !excludeList?.length) return [];
  const cleansedLocations = [...locations]?.filter((l) => excludeList?.includes(l?.id) ? false : true)?.sort((a, b) => {
    if (a?.favorite && !b?.favorite) return -1;
    if (!a?.favorite && b?.favorite) return 1;
    if (a?.favorite === b?.favorite) {
      if (a?.name < b?.name) return -1;
      if (a?.name > b?.name) return 1;
    }
    return 0;
  });
  return cleansedLocations;
};
var getYears = () => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const yearList = Array.from({ length: 53 }, (_, i) => (currentYear - 50 + i).toString()).reverse();
  return yearList;
};
var getColors = () => [
  `Beige`,
  `Black`,
  `Blue`,
  `Brown`,
  `Gold`,
  `Gray`,
  `Green`,
  `Maroon`,
  `Orange`,
  `Pink`,
  `Purple`,
  `Red`,
  `Silver`,
  `Tan`,
  `White`,
  `Yellow`
];
var getIsRefRequired = (action, refRequiredForPickup, refRequiredForReturn) => {
  if (action === `pickup`) return refRequiredForPickup || false;
  if (action === `return`) return refRequiredForReturn || false;
  return false;
};

// src/utils/validateEmail.ts
var validateEmail = (email) => {
  if (!email) return false;
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

// src/utils/validatePhone.ts
var validatePhone = (phone) => {
  if (!phone) return false;
  return /^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone);
};

// src/provider/plannerValidation.ts
function validatePlanner(input) {
  const {
    validation,
    rooftopId,
    payerId,
    workflowsetId,
    workflowsets,
    type,
    typeRefused,
    productKey,
    emails,
    consumer,
    time,
    isDefaultTime,
    isAppointment,
    pickup,
    delivery,
    vehicle1,
    vehicle2,
    dynamic,
    contactInfo,
    rooftopConfig,
    customerConfig,
    capabilities
  } = input;
  const validity = {
    ...validation,
    consumer: { ...validation.consumer },
    vehicle1: { ...validation.vehicle1 },
    vehicle2: { ...validation.vehicle2 },
    ...validation.contactInfo ? { contactInfo: { ...validation.contactInfo } } : {}
  };
  if (capabilities.confirmationContacts && !validity.contactInfo) {
    validity.contactInfo = {};
  }
  if (!rooftopId) validity.rooftopId = false;
  else validity.rooftopId = true;
  if (customerConfig?.require_third_party_payer && !payerId) validity.payerId = false;
  else validity.payerId = true;
  if (!workflowsetId) validity.workflowsetId = false;
  else validity.workflowsetId = true;
  validity.type = !typeRefused;
  validity.productKey = isAppointment || !!productKey;
  if (emails?.length > 5) validity.emails = false;
  else validity.emails = true;
  const consumerValidity = validity.consumer;
  if (type === `concierge` || type === `concierge-loaner` || isAppointment) {
    if (!consumer?.name) consumerValidity.name = false;
    else consumerValidity.name = true;
    if (!validatePhone(consumer?.phone)) consumerValidity.phone = false;
    else consumerValidity.phone = true;
    if (capabilities.roCapture) {
      const isRefRequired = getIsRefRequired(
        consumer?.action,
        rooftopConfig?.reference_num_required_for_pickup,
        rooftopConfig?.reference_num_required_for_return
      );
      if (isRefRequired && !consumer?.referenceId) consumerValidity.referenceId = false;
      else consumerValidity.referenceId = true;
    }
  } else {
    consumerValidity.name = true;
    consumerValidity.phone = true;
    if (capabilities.roCapture) consumerValidity.referenceId = true;
  }
  if (!isDefaultTime) {
    if (!time || capabilities.timeValidityCheck && !dayjs5(time).isValid()) {
      validity.time = false;
    } else if (isAppointment) {
      const currentTimePlus120 = dayjs5().add(120, "minute");
      validity.time = !dayjs5(time).isBefore(currentTimePlus120);
    } else {
      validity.time = true;
    }
  } else {
    validity.time = true;
  }
  if (!pickup) validity.pickup = false;
  else validity.pickup = true;
  if (!delivery) validity.delivery = false;
  else validity.delivery = true;
  const vehicle1Validity = validity.vehicle1;
  const vehicle2Validity = validity.vehicle2;
  if (!customerConfig?.allow_vinless_valet && (type !== `concierge-loaner` || type === `concierge-loaner` && consumer?.first === `consumer`)) {
    if (vehicle1?.vin?.length < 6) vehicle1Validity.vin = false;
    else vehicle1Validity.vin = true;
    if (!vehicle1?.year) vehicle1Validity.year = false;
    else vehicle1Validity.year = true;
    if (!vehicle1?.make) vehicle1Validity.make = false;
    else vehicle1Validity.make = true;
    if (!vehicle1?.model) vehicle1Validity.model = false;
    else vehicle1Validity.model = true;
  } else {
    vehicle1Validity.vin = true;
    vehicle1Validity.year = true;
    vehicle1Validity.make = true;
    vehicle1Validity.model = true;
  }
  if (!customerConfig?.allow_vinless_valet && (type === `round-trip` || type === `concierge-loaner` && consumer?.first === `loaner`)) {
    if (vehicle2?.vin?.length < 6) vehicle2Validity.vin = false;
    else vehicle2Validity.vin = true;
    if (!vehicle2?.year) vehicle2Validity.year = false;
    else vehicle2Validity.year = true;
    if (!vehicle2?.make) vehicle2Validity.make = false;
    else vehicle2Validity.make = true;
    if (!vehicle2?.model) vehicle2Validity.model = false;
    else vehicle2Validity.model = true;
  } else {
    vehicle2Validity.vin = true;
    vehicle2Validity.year = true;
    vehicle2Validity.make = true;
    vehicle2Validity.model = true;
  }
  const selectedWorkflowset = workflowsets?.find((w) => w?.id === workflowsetId);
  if (capabilities.dynamicWorkflowSteps) {
    const moveCreateWorkflowSteps = selectedWorkflowset?.moveCreateWorkflow?.steps || [];
    validity.dynamic = {};
    for (const step of moveCreateWorkflowSteps) {
      if (step.required) {
        const value = dynamic?.[step.id];
        if (!value || typeof value === "string" && value.trim() === "") {
          validity.dynamic[step.id] = false;
        } else {
          validity.dynamic[step.id] = true;
        }
      } else {
        validity.dynamic[step.id] = true;
      }
    }
  }
  if (capabilities.confirmationContacts) {
    const contactValidity = validity.contactInfo;
    const requiresContactInfo = selectedWorkflowset?.confirmationset != null && type === "one-way";
    if (requiresContactInfo) {
      const confirmationFlow = selectedWorkflowset?.confirmationset?.confirmation_flow;
      const pickupContactRequired = confirmationFlow?.pickup && confirmationFlow.pickup.length > 0;
      const deliveryContactRequired = confirmationFlow?.delivery && confirmationFlow.delivery.length > 0;
      if (pickupContactRequired) {
        if (!contactInfo?.pickupName) contactValidity.pickupName = false;
        else contactValidity.pickupName = true;
        if (!validateEmail(contactInfo?.pickupEmail)) contactValidity.pickupEmail = false;
        else contactValidity.pickupEmail = true;
        if (!validatePhone(contactInfo?.pickupMobile) && !validatePhone(contactInfo?.pickupLandline)) {
          contactValidity.pickupPhone = false;
        } else {
          contactValidity.pickupPhone = true;
        }
      } else {
        contactValidity.pickupName = true;
        contactValidity.pickupEmail = true;
        contactValidity.pickupPhone = true;
      }
      if (deliveryContactRequired) {
        if (!contactInfo?.deliveryName) contactValidity.deliveryName = false;
        else contactValidity.deliveryName = true;
        if (!validateEmail(contactInfo?.deliveryEmail)) contactValidity.deliveryEmail = false;
        else contactValidity.deliveryEmail = true;
        if (!validatePhone(contactInfo?.deliveryMobile) && !validatePhone(contactInfo?.deliveryLandline)) {
          contactValidity.deliveryPhone = false;
        } else {
          contactValidity.deliveryPhone = true;
        }
      } else {
        contactValidity.deliveryName = true;
        contactValidity.deliveryEmail = true;
        contactValidity.deliveryPhone = true;
      }
    } else {
      contactValidity.pickupName = true;
      contactValidity.pickupEmail = true;
      contactValidity.pickupPhone = true;
      contactValidity.deliveryName = true;
      contactValidity.deliveryEmail = true;
      contactValidity.deliveryPhone = true;
    }
  }
  const invalid = invalidFields(validity);
  return { validity, isValid: invalid.length === 0, invalid };
}
function invalidFields(validity) {
  const invalid = [];
  for (const [key, value] of Object.entries(validity)) {
    if (typeof value === `object`) {
      for (const [subKey, subValue] of Object.entries(value ?? {})) {
        if (!subValue) invalid.push(`${key}.${subKey}`);
      }
    } else if (!value) {
      invalid.push(key);
    }
  }
  return invalid;
}

// src/provider/locationRefusal.ts
var RADIUS_CHECK_TOAST_ID = "move-planner-radius-check";
function coordinatesOf(location) {
  const latitude = location?.latitude;
  const longitude = location?.longitude;
  if (typeof latitude !== "number" || !Number.isFinite(latitude)) return null;
  if (typeof longitude !== "number" || !Number.isFinite(longitude)) return null;
  return { latitude, longitude };
}
function locationRefusal(verdict, originAddress) {
  const around = originAddress || "your business address";
  return {
    message: `The pickup and delivery locations are both outside your service area (${verdict.radiusMiles} mile radius around ${around}). Choose a location within your service area, or contact HopDrive to change it.`,
    toastId: RADIUS_CHECK_TOAST_ID
  };
}

// src/provider/plannerSubmit.ts
var SUBMIT_FAILED = `Failed to plan moves! Please refresh and try again. If the problem persists, please contact us.`;
function detectLanes(lanes, pickup, delivery) {
  const mainLane = lanes?.find((l) => l?.pickup?.id === pickup?.id && l?.delivery?.id === delivery?.id) ?? null;
  const inverseLane = lanes?.find((l) => l?.pickup?.id === delivery?.id && l?.delivery?.id === pickup?.id) ?? null;
  return { mainLane, inverseLane };
}
function stripLaneEndpoints(lane) {
  const copy = JSON.parse(JSON.stringify(lane));
  if (copy?.pickup) delete copy.pickup;
  if (copy?.delivery) delete copy.delivery;
  return copy;
}
function filteredDynamicFor(dynamic, workflowset) {
  const workflowStepIds = workflowset?.moveCreateWorkflow?.steps?.map((step) => step.id) || [];
  return Object.keys(dynamic || {}).reduce(
    (acc, key) => {
      if (workflowStepIds.includes(key)) acc[key] = dynamic?.[key];
      return acc;
    },
    {}
  );
}
async function finalizePlan(state, deps) {
  const { capabilities, host } = deps;
  const {
    type,
    consumer,
    vehicle1,
    vehicle2,
    additional1,
    additional2,
    pickup,
    delivery,
    time,
    isDefaultTime,
    liteMode,
    rooftopId,
    productKey,
    typeRefused,
    payerId,
    workflowsetId,
    workflowsets,
    rooftops,
    payers,
    lanes,
    emails,
    dynamic,
    contactInfo,
    earliestAvailableTime,
    driverRowNumber,
    assignToDriverId,
    assignToDriverName,
    createRideForReturn,
    rooftopConfig,
    customerConfig,
    sourceState,
    hasPlanningContext,
    clientApp,
    clientVersion,
    buildSha
  } = state;
  const isLite = liteMode === "lite";
  deps.setSaving(true);
  const plannerStateContext = {
    type,
    consumerAction: consumer?.action,
    consumerFirst: consumer?.first,
    hasVehicle1Vin: !!vehicle1?.vin,
    hasVehicle2Vin: !!vehicle2?.vin,
    pickupId: pickup?.id,
    deliveryId: delivery?.id,
    hasTime: !!time,
    isDefaultTime,
    isLite,
    rooftopId,
    workflowsetId,
    hasEarliestAvailableTime: !!earliestAvailableTime,
    role: host.session.reportIdentity.role,
    customerId: host.session.reportIdentity.customerId
  };
  const tokenContext = await host.session.tokenInfo();
  const captureFinalizePlanError = (err, step, extraContexts) => {
    try {
      const tags = { feature: "move-planner", step };
      if (err instanceof Error && err.message?.includes("JWTExpired")) {
        tags.jwtExpired = "true";
      }
      host.report.captureException(err, {
        tags,
        contexts: {
          plannerState: plannerStateContext,
          token: tokenContext,
          ...extraContexts
        }
      });
    } catch (sentryErr) {
      console.error("Failed to capture exception to Sentry:", sentryErr);
    }
  };
  const fail = () => {
    deps.setSaving(false);
    return false;
  };
  const { validity, isValid: isFormValid, invalid } = validatePlanner({
    validation: state.validation,
    rooftopId,
    payerId,
    workflowsetId,
    workflowsets,
    type,
    typeRefused,
    productKey,
    emails,
    consumer,
    time,
    isDefaultTime,
    isAppointment: !!sourceState?.appointment,
    pickup,
    delivery,
    vehicle1,
    vehicle2,
    dynamic,
    contactInfo,
    rooftopConfig,
    customerConfig,
    capabilities
  });
  deps.setValidation(validity);
  if (!isFormValid) {
    console.warn(`Move planner submit blocked by invalid fields:`, invalid, {
      ...plannerStateContext,
      productKey,
      typeRefused,
      isAppointment: !!sourceState?.appointment
    });
    host.notify.warning(`Please fill out all required fields before submitting!`, { toastId: `move-planner-validation` });
    return fail();
  }
  const inServiceArea = capabilities.liveRegionGate ? pickup?.region?.status === LIVE_REGION_STATUS || delivery?.region?.status === LIVE_REGION_STATUS : !!pickup?.region_id || !!delivery?.region_id;
  if (!inServiceArea && !isLite) {
    if (capabilities.liveRegionGate) {
      console.error(`Pickup location region ${pickup?.region?.name} (${pickup?.region?.id}) status is ${pickup?.region?.status}.`);
      console.error(`Delivery location region ${delivery?.region?.name} (${delivery?.region?.id}) status is ${delivery?.region?.status}.`);
    } else {
      if (!pickup?.region_id) console.error(`Pickup location is missing a region ID.`);
      if (!delivery?.region_id) console.error(`Delivery location is missing a region ID.`);
    }
    host.notify.error(
      `At least one of the selected locations must be within the Hopdrive service area! It is possible a location is slightly outside of our area. If you believe this is the case, please contact us.`,
      { toastId: `move-planner-submit`, autoClose: false }
    );
    return fail();
  }
  if (isLite) {
    const homeLocation = rooftops?.find((r) => r?.id === rooftopId)?.location;
    const verdict = evaluateMoveLocations({
      lite: true,
      pickup: { regionStatus: pickup?.region?.status ?? null, coordinates: coordinatesOf(pickup) },
      delivery: { regionStatus: delivery?.region?.status ?? null, coordinates: coordinatesOf(delivery) },
      origin: { coordinates: coordinatesOf(homeLocation) },
      radiusMiles: customerConfig?.customer_serviceable_radius_miles
    });
    if ("rule" in verdict && verdict.rule === "radius") {
      const { message, toastId } = locationRefusal(verdict, homeLocation?.address);
      host.notify.error(message, { toastId, autoClose: false });
      return fail();
    }
  }
  let mainLane = null;
  let inverseLane = null;
  try {
    ({ mainLane, inverseLane } = detectLanes(lanes, pickup, delivery));
    if (!mainLane || !inverseLane) throw new Error(`One or both lanes were not found in the lanes array.`);
  } catch (err) {
    console.error(`Failed to detect lanes needed for move creation:`, err);
    captureFinalizePlanError(err, "detectLanes");
    host.notify.error(SUBMIT_FAILED, { toastId: `move-planner-submit`, autoClose: false });
    return fail();
  }
  try {
    mainLane = stripLaneEndpoints(mainLane);
    inverseLane = stripLaneEndpoints(inverseLane);
  } catch (err) {
    console.error(`Failed to remove pickup and delivery from lane:`, err);
    captureFinalizePlanError(err, "stripLaneObjects");
    host.notify.error(SUBMIT_FAILED, { toastId: `move-planner-submit`, autoClose: false });
    return fail();
  }
  if (lanesNeedPersisting([mainLane, inverseLane])) {
    try {
      const upsertableLanes = [mainLane, inverseLane];
      const upsertRes = await deps.upsertLanes({ variables: { upsertableLanes } });
      const upsertedLanes = upsertRes?.data?.insert_lanes?.returning;
      if (upsertedLanes?.length) {
        const mutableLanes = JSON.parse(JSON.stringify(upsertedLanes));
        mainLane = mutableLanes?.find((l) => l?.pickup?.id === pickup?.id && l?.delivery?.id === delivery?.id) ?? null;
        inverseLane = mutableLanes?.find((l) => l?.pickup?.id === delivery?.id && l?.delivery?.id === pickup?.id) ?? null;
      } else {
        console.error(`\u{1F6E3}\uFE0F No upserted lanes were returned from mutation`);
        throw new Error(`No upserted lanes were returned.`);
      }
    } catch (err) {
      console.error(`\u{1F6E3}\uFE0F Failed to save lanes:`, err);
      if (err instanceof Error) {
        console.error(`\u{1F6E3}\uFE0F Lane upsert error details:`, { message: err.message, stack: err.stack });
      }
      captureFinalizePlanError(err, "upsertLanes", {
        lanes: { mainLaneHasId: !!mainLane?.id, inverseLaneHasId: !!inverseLane?.id }
      });
      host.notify.error(SUBMIT_FAILED, { toastId: `move-planner-submit`, autoClose: false });
      return fail();
    }
  }
  const isConciergeType = type === "concierge" || type === "concierge-loaner";
  const effectiveVehicleRefId1 = capabilities.roCapture && isConciergeType && consumer?.referenceId ? consumer.referenceId : vehicle1?.referenceId;
  const effectiveVehicleRefId2 = capabilities.roCapture && isConciergeType && consumer?.referenceId ? consumer.referenceId : vehicle2?.referenceId;
  const selectedWorkflowset = workflowsets?.find((w) => w?.id === workflowsetId);
  const filteredDynamic = capabilities.dynamicWorkflowSteps ? filteredDynamicFor(dynamic, selectedWorkflowset) : void 0;
  const { legs: moveLegRanges } = computeMoveLegRanges({
    time,
    type,
    consumerAction: consumer?.action,
    consumerFirst: consumer?.first,
    mainLane,
    inverseLane
  });
  let moveRequest;
  try {
    moveRequest = buildVehicleMoveRequest({
      rooftopId,
      productKey,
      payerId,
      workflowsetId,
      type,
      consumerAction: consumer?.action,
      consumerFirst: consumer?.first,
      consumerName: consumer?.name,
      consumerPhone: consumer?.phone,
      mainLaneId: mainLane?.id,
      inverseLaneId: inverseLane?.id,
      readyBy: moveLegRanges[0]?.start.toISOString() ?? time,
      secondLegReadyBy: moveLegRanges[1]?.start.toISOString(),
      vehicle1,
      vehicle2,
      referenceNum1: effectiveVehicleRefId1,
      contact1: additional1?.contact,
      notes1: additional1?.notes,
      referenceNum2: effectiveVehicleRefId2,
      contact2: additional2?.contact,
      notes2: additional2?.notes,
      emails,
      contactInfo,
      clientApp,
      clientVersion,
      buildSha,
      ...capabilities.driverRows ? { driverRowNumber } : {},
      ...capabilities.dynamicWorkflowSteps ? { workflowResponses: filteredDynamic } : {},
      ...capabilities.scheduledFromPlanningContext ? { isScheduleTimeline: hasPlanningContext } : {}
    });
  } catch (err) {
    console.error(`Failed to build the move request:`, err);
    captureFinalizePlanError(err, "buildMoveRequest");
    host.notify.error(err instanceof MoveRequestPlanError ? err.message : SUBMIT_FAILED, {
      toastId: `move-planner-submit`,
      autoClose: false
    });
    return fail();
  }
  let eventlogIds = [];
  if (capabilities.eventlogAudit && host.events) {
    const selectedRooftopForMeta = rooftops?.find((r) => r?.id === rooftopId);
    const selectedPayerForMeta = payers?.find((p) => p?.id === payerId);
    const sla = selectedWorkflowset?.raterulegroups?.[0]?.sla;
    const eventlogMetadata = buildEventlogMetadata({
      customerId: rooftopId,
      customerName: selectedRooftopForMeta?.name || "",
      payerId,
      payerName: selectedPayerForMeta?.name || null,
      workflowsetId,
      workflowsetName: selectedWorkflowset?.name || "",
      type,
      emails,
      consumer,
      time,
      isDefaultTime,
      earliestAvailableTime,
      dynamic: filteredDynamic ?? {},
      pickup,
      delivery,
      mainLane,
      inverseLane,
      vehicle1,
      vehicle2,
      additional1,
      additional2,
      contactInfo,
      slaId: sla?.id || 1,
      slaHrs: sla?.duration_hrs || 48,
      // The server derives these. The audit records that the browser did not
      // know rather than inventing a value; the real ones are on the move row.
      deliverBy1: null,
      deliverBy2: null,
      moveClass: null,
      classOverride: null,
      isLite,
      assignedDriverId: assignToDriverId,
      assignedDriverName: assignToDriverName,
      isScheduleTimelineMode: hasPlanningContext,
      createRideForReturn
    });
    const events = host.events;
    eventlogIds = await logRequestAttempts(
      (name, payload) => Promise.resolve(events.logEvent(name, payload)),
      {
        moveCount: type === "round-trip" || type === "concierge-loaner" ? 2 : 1,
        actorEmail: host.session.actorEmail,
        rooftopId,
        mainLaneId: mainLane?.id,
        inverseLaneId: inverseLane?.id,
        metadata: eventlogMetadata
      }
    );
  }
  if (capabilities.roCapture && rooftopConfig?.auto_assign_ref && consumer?.action === "return") {
    const additionalMoveIds = [];
    if (sourceState?.moveId1) additionalMoveIds.push(sourceState?.moveId1);
    if (sourceState?.moveId2) additionalMoveIds.push(sourceState?.moveId2);
    try {
      const relatedConciergeMoves = await queryRelatedConciergeMoves(
        deps.getRelatedConciergeMoves,
        [vehicle1?.vin].filter(Boolean)
      );
      if (additionalMoveIds?.length === 0 && relatedConciergeMoves.length > 1) {
        const selectedMove = await deps.chooseRelatedMove(relatedConciergeMoves, effectiveVehicleRefId1 || "");
        if (selectedMove) {
          const success = await mutateRelatedConciergeMoves(
            deps.updateReferenceNumOnRelatedConciergeMoves,
            [...relatedMoveFamily(selectedMove), ...additionalMoveIds],
            effectiveVehicleRefId1,
            host.session.actorEmail
          );
          if (!success) console.error(`\u26A0\uFE0F Failed to update reference numbers on selected move family (non-blocking)`);
        }
      } else {
        const moveIdsToUpdate = collectMostRecentMoveIdsToUpdate(relatedConciergeMoves, additionalMoveIds);
        const success = await mutateRelatedConciergeMoves(
          deps.updateReferenceNumOnRelatedConciergeMoves,
          moveIdsToUpdate,
          effectiveVehicleRefId1,
          host.session.actorEmail
        );
        if (!success) console.error(`\u26A0\uFE0F Failed to update reference numbers on related moves (non-blocking)`);
      }
    } catch (err) {
      console.error(`\u26A0\uFE0F Failed to update reference numbers on related moves (non-blocking):`, err);
    }
  }
  try {
    const res = await deps.requestVehicleMove({ variables: { request: moveRequest } });
    const requested = readVehicleMoveResult(res?.data?.requestVehicleMove);
    const { primaryMoveId, moveIds, scenario, replayed, contactsSaved } = requested;
    if (contactsSaved === false) {
      host.notify.warning("Moves created successfully, but contact information could not be saved.", { toastId: "move-planner-submit" });
    }
    console.log(`\u2705 Move requested successfully:`, {
      scenarioId: scenario.id,
      productKey: scenario.product_key,
      usecaseKey: scenario.usecase_key,
      primaryMoveId,
      moveIds,
      rideMoveIds: requested.rideMoveIds,
      replayed
    });
    if (capabilities.eventlogAudit && eventlogIds.length > 0 && moveIds.length > 0) {
      try {
        await updateEventlogsWithMoveIds({
          eventlogIds,
          moveIds,
          eventKey: "move.request",
          updateMutation: deps.updateEventlogMoveId
        });
      } catch (eventlogUpdateErr) {
        console.error(`\u26A0\uFE0F Failed to update eventlog(s) with move IDs (non-blocking):`, eventlogUpdateErr);
      }
    }
    if (assignToDriverId && isLite) {
      deps.setIsDispatching(true);
      deps.setPendingDispatch({
        moveId: primaryMoveId,
        driverId: assignToDriverId,
        driverName: assignToDriverName,
        time: time || dayjs6().format(),
        ...capabilities.rideshareForReturn ? { withRideshare: createRideForReturn } : {}
      });
    } else {
      deps.setSuccessMoveId(primaryMoveId);
      deps.onSuccess?.(primaryMoveId);
      host.notify.success(
        `Your move(s) have been planned! A dispatcher will assign it to a driver around the time it's ready.`,
        { toastId: `move-planner-submit` }
      );
    }
  } catch (err) {
    if (isClientUpdateRequiredError(err)) {
      console.warn(`Move request refused: this build is below the server's minimum client version.`);
      if (!deps.requireUpdate?.({ headline: UPDATE_REQUIRED_HEADLINE })) {
        host.notify.error(vehicleMoveErrorMessage(err), { toastId: `move-planner-submit`, autoClose: false });
      }
      return fail();
    }
    console.error(`Failed to request the move:`, err);
    captureFinalizePlanError(err, "requestVehicleMove", {
      moves: { usecaseKey: moveRequest.usecaseKey, hasSecondLeg: !!moveRequest.secondLeg }
    });
    host.notify.error(vehicleMoveErrorMessage(err), { toastId: `move-planner-submit`, autoClose: false });
    return fail();
  }
  deps.setSaving(false);
  return true;
}

// src/provider/sourceMoveRebuild.ts
function dynamicFromMove(move, workflowsets) {
  const workflowset = workflowsets?.find((w) => w?.id === move?.workflowset_id);
  if (!workflowset) return null;
  const workflowsetStepIds = workflowset?.moveCreateWorkflow?.steps?.map((step) => step.id);
  return workflowsetStepIds?.reduce(
    (acc, stepId) => {
      acc[stepId] = move?.config?.[stepId];
      return acc;
    },
    {}
  );
}
var vehicleFrom = (move) => ({
  referenceId: move?.reference_num || ``,
  manual: move?.manual_flag || false,
  vin: move?.vehicle_vin || ``,
  stock: move?.vehicle_stock || ``,
  make: move?.vehicle_make || ``,
  model: move?.vehicle_model || ``,
  year: move?.vehicle_year || ``,
  color: move?.vehicle_color || ``
});
var additionalFrom = (move) => ({
  contact: move?.dealer_contact || ``,
  notes: move?.move_details || ``
});
var fillEnd = (info, end, ctm) => {
  info[`${end}Name`] = ctm?.contact?.name || "";
  info[`${end}Mobile`] = ctm?.contact?.mobile_number || "";
  info[`${end}Landline`] = ctm?.contact?.landline_number || "";
  info[`${end}Email`] = ctm?.contact?.email || "";
  info[`${end}Notes`] = ctm?.contact?.notes || "";
};
function contactsFromSourceMoves(move1, move2, isInverse) {
  const extractedContactInfo = { ...defaultContactInfo };
  move1?.contactstomoves?.forEach((ctm) => {
    if (ctm?.contact_type === "pickup") fillEnd(extractedContactInfo, "pickup", ctm);
    else if (ctm?.contact_type === "delivery") fillEnd(extractedContactInfo, "delivery", ctm);
  });
  move2?.contactstomoves?.forEach((ctm) => {
    if (ctm?.contact_type === "pickup" && !extractedContactInfo.pickupName) fillEnd(extractedContactInfo, "pickup", ctm);
    else if (ctm?.contact_type === "delivery" && !extractedContactInfo.deliveryName) fillEnd(extractedContactInfo, "delivery", ctm);
  });
  if (isInverse) {
    const tempPickup = {
      name: extractedContactInfo.pickupName,
      mobile: extractedContactInfo.pickupMobile,
      landline: extractedContactInfo.pickupLandline,
      email: extractedContactInfo.pickupEmail,
      notes: extractedContactInfo.pickupNotes
    };
    extractedContactInfo.pickupName = extractedContactInfo.deliveryName;
    extractedContactInfo.pickupMobile = extractedContactInfo.deliveryMobile;
    extractedContactInfo.pickupLandline = extractedContactInfo.deliveryLandline;
    extractedContactInfo.pickupEmail = extractedContactInfo.deliveryEmail;
    extractedContactInfo.pickupNotes = extractedContactInfo.deliveryNotes;
    extractedContactInfo.deliveryName = tempPickup.name;
    extractedContactInfo.deliveryMobile = tempPickup.mobile;
    extractedContactInfo.deliveryLandline = tempPickup.landline;
    extractedContactInfo.deliveryEmail = tempPickup.email;
    extractedContactInfo.deliveryNotes = tempPickup.notes;
  }
  return extractedContactInfo;
}
function rebuildFromSourceMoves({ moves, sourceState, workflowsets, defaultConsumer, capabilities }) {
  if (!moves?.length) return null;
  const isInverse = sourceState?.inverse || false;
  let move1 = moves?.find(
    (m) => !sourceState?.moveId2 ? m?.id === sourceState?.moveId1 : isInverse ? m?.id === sourceState?.moveId2 : m?.id === sourceState?.moveId1
  );
  let move2 = moves?.find(
    (m) => !sourceState?.moveId2 ? void 0 : isInverse ? m?.id === sourceState?.moveId1 : m?.id === sourceState?.moveId2
  );
  const lane1 = move1?.lane;
  const lane2 = move2?.lane;
  if (!move1 && !move2) return null;
  let foundType = defaultType;
  if (move1?.consumer_type === `loaner` || move2?.consumer_type === `loaner`) {
    foundType = `concierge-loaner`;
    if (isInverse && move1) {
      move1 = { ...move1, lane: lane2 };
    }
    if (isInverse && move2) {
      move2 = { ...move2, lane: lane1 };
    }
  } else if (move1?.consumer_type === `customer`) {
    foundType = `concierge`;
  } else if (move1 && move2) {
    foundType = `round-trip`;
  } else {
    foundType = `one-way`;
  }
  const found = {};
  if (move1?.consumer_name || move2?.consumer_name) {
    found.name = move1?.consumer_name || move2?.consumer_name;
  }
  if (move1?.consumer_phone || move2?.consumer_phone) {
    found.phone = move1?.consumer_phone || move2?.consumer_phone;
  }
  if (move1?.consumer_type === `loaner` && move1?.consumer_at_pickup === 1 || move1?.consumer_type === `customer` && move1?.consumer_at_pickup === 0) {
    found.action = isInverse ? `pickup` : `return`;
  } else {
    found.action = isInverse ? `return` : `pickup`;
  }
  if (move1?.consumer_type === `customer`) {
    found.first = `consumer`;
  } else {
    found.first = `loaner`;
  }
  const foundConsumer = { ...defaultConsumer, ...found };
  let foundLane = defaultLane;
  if (move1 && !move2) {
    foundLane = (isInverse ? move1?.lane?.inverse : move1?.lane) ?? null;
  } else {
    foundLane = move1?.lane ?? null;
  }
  const rebuild = {
    rooftopId: move1?.customer_id || 0,
    payerId: move1?.payer_id || 0,
    workflowsetId: move1?.workflowset_id || 0,
    type: foundType || defaultType,
    emails: move1?.config?.emailsToNotify || defaultEmails,
    consumer: foundConsumer,
    lane: foundLane || defaultLane,
    pickup: foundLane?.pickup || defaultLocation,
    delivery: foundLane?.delivery || defaultLocation,
    vehicle1: vehicleFrom(move1),
    additional1: additionalFrom(move1),
    vehicle2: vehicleFrom(move2),
    additional2: additionalFrom(move2)
  };
  if (capabilities.dynamicWorkflowSteps) {
    let foundDynamic = defaultDynamic;
    if (move1?.workflowset_id) foundDynamic = dynamicFromMove(move1, workflowsets) ?? foundDynamic;
    else if (move2?.workflowset_id) foundDynamic = dynamicFromMove(move2, workflowsets) ?? foundDynamic;
    rebuild.dynamic = foundDynamic || defaultDynamic;
  }
  if (capabilities.contactsFromSourceMove) {
    rebuild.contactInfo = contactsFromSourceMoves(move1, move2, isInverse);
  }
  return rebuild;
}

// src/provider/useMoveOffering.ts
import React2 from "react";
function useMoveOffering(rooftopId) {
  const facts = useMovePlannerHost().products.useRooftopFacts(rooftopId);
  return React2.useMemo(() => ({ offering: moveOfferingFor(facts), accessReason: facts.reason }), [facts]);
}

// src/provider/queries/getAllowedHeaderRooftops.query.generated.ts
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";
var GetAllowedHeaderRooftopsDocument = { "__text": "query getAllowedHeaderRooftops($customerIdArr: [bigint!]!) {\n  customers(\n    where: {active: {_eq: 1}, id: {_in: $customerIdArr}}\n    order_by: {name: asc}\n  ) {\n    id\n    name\n    phone\n    category\n    config\n    effective_config\n    tier\n    location {\n      id\n      address\n      phone\n      latitude\n      longitude\n      name\n      timezone\n      region {\n        id\n        name\n        status\n      }\n    }\n    organization {\n      id\n      name\n      config\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getAllowedHeaderRooftops" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerIdArr" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerIdArr" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "category" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] } }] };

// src/provider/queries/getHeaderRooftops.query.generated.ts
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
var GetHeaderRooftopsDocument = { "__text": "query getHeaderRooftops {\n  customers(where: {active: {_eq: 1}}, order_by: {name: asc}) {\n    id\n    name\n    phone\n    category\n    config\n    effective_config\n    tier\n    location {\n      id\n      address\n      phone\n      latitude\n      longitude\n      timezone\n      name\n      region {\n        id\n        name\n        status\n      }\n    }\n    organization {\n      id\n      name\n      config\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getHeaderRooftops" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "category" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] } }] };

// src/provider/queries/getLinkedHeaderRooftops.query.generated.ts
import { resolveExecutor as resolveExecutor5 } from "@hopdrive/sdk-core";
var GetLinkedHeaderRooftopsDocument = { "__text": "query getLinkedHeaderRooftops($userId: bigint!) {\n  customers(\n    where: {active: {_eq: 1}, customerstousers: {user_id: {_eq: $userId}}}\n    order_by: {name: asc}\n  ) {\n    id\n    name\n    phone\n    category\n    config\n    effective_config\n    tier\n    location {\n      id\n      address\n      phone\n      latitude\n      longitude\n      timezone\n      name\n      region {\n        id\n        name\n        status\n      }\n    }\n    organization {\n      id\n      name\n      config\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getLinkedHeaderRooftops" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "userId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customerstousers" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "user_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "userId" } } }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "category" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] } }] };

// src/provider/queries/getLocations.query.generated.ts
import { resolveExecutor as resolveExecutor6 } from "@hopdrive/sdk-core";
var GetLocationsDocument = { "__text": "query getLocations($rooftopId: bigint!) {\n  locations(\n    where: {active: {_eq: 1}, customer_id: {_eq: $rooftopId}}\n    order_by: {name: asc}\n  ) {\n    id\n    address\n    address_line_one\n    address_line_two\n    city\n    customer_id\n    favorite\n    latitude\n    longitude\n    name\n    place_id\n    region_id\n    region {\n      id\n      name\n      status\n    }\n    state\n    timezone\n    zip_code\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getLocations" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "locations" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_one" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_two" } }, { "kind": "Field", "name": { "kind": "Name", "value": "city" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "place_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "state" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "zip_code" } }] } }] } }] };

// src/provider/queries/getMovePlannerDefaultMoves.query.generated.ts
import { resolveExecutor as resolveExecutor7 } from "@hopdrive/sdk-core";
var GetMovePlannerDefaultMovesDocument = { "__text": "query getMovePlannerDefaultMoves($moveIds: [bigint!]) {\n  moves(where: {id: {_in: $moveIds}}, order_by: {id: asc}) {\n    id\n    config\n    consumer_at_pickup\n    consumer_name\n    consumer_phone\n    consumer_type\n    customer_id\n    dealer_contact\n    manual_flag\n    move_details\n    payer_id\n    reference_num\n    vehicle_color\n    vehicle_make\n    vehicle_model\n    vehicle_stock\n    vehicle_vin\n    vehicle_year\n    workflowset_id\n    lane {\n      id\n      customer_id\n      status\n      enriched_at\n      route_polyline\n      distance_miles\n      tolls\n      duration_sec\n      favorite\n      pickup {\n        id\n        address\n        address_line_one\n        address_line_two\n        city\n        customer_id\n        favorite\n        latitude\n        longitude\n        name\n        place_id\n        region_id\n        region {\n          id\n          name\n          status\n        }\n        state\n        timezone\n        zip_code\n      }\n      delivery {\n        id\n        address\n        address_line_one\n        address_line_two\n        city\n        customer_id\n        favorite\n        latitude\n        longitude\n        name\n        place_id\n        region_id\n        region {\n          id\n          name\n          status\n        }\n        state\n        timezone\n        zip_code\n      }\n      inverse {\n        id\n        customer_id\n        status\n        enriched_at\n        route_polyline\n        distance_miles\n        tolls\n        duration_sec\n        favorite\n        pickup {\n          id\n          address\n          address_line_one\n          address_line_two\n          city\n          customer_id\n          favorite\n          latitude\n          longitude\n          name\n          place_id\n          region_id\n          region {\n            id\n            name\n            status\n          }\n          state\n          timezone\n          zip_code\n        }\n        delivery {\n          id\n          address\n          address_line_one\n          address_line_two\n          city\n          customer_id\n          favorite\n          latitude\n          longitude\n          name\n          place_id\n          region_id\n          region {\n            id\n            name\n            status\n          }\n          state\n          timezone\n          zip_code\n        }\n      }\n    }\n    contactstomoves {\n      id\n      contact_type\n      contact {\n        id\n        name\n        mobile_number\n        landline_number\n        email\n        notes\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getMovePlannerDefaultMoves" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveIds" } }, "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveIds" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_at_pickup" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_phone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "dealer_contact" } }, { "kind": "Field", "name": { "kind": "Name", "value": "manual_flag" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_details" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enriched_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_polyline" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_one" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_two" } }, { "kind": "Field", "name": { "kind": "Name", "value": "city" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "place_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "state" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "zip_code" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_one" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_two" } }, { "kind": "Field", "name": { "kind": "Name", "value": "city" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "place_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "state" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "zip_code" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "inverse" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enriched_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_polyline" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_one" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_two" } }, { "kind": "Field", "name": { "kind": "Name", "value": "city" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "place_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "state" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "zip_code" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_one" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address_line_two" } }, { "kind": "Field", "name": { "kind": "Name", "value": "city" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "place_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "state" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timezone" } }, { "kind": "Field", "name": { "kind": "Name", "value": "zip_code" } }] } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contactstomoves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contact_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contact" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "mobile_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "landline_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }] } }] } }] } }] } }] };

// src/provider/queries/getMovePlannerLanes.query.generated.ts
import { resolveExecutor as resolveExecutor8 } from "@hopdrive/sdk-core";
var GetMovePlannerLanesDocument = { "__text": "query getMovePlannerLanes($rooftopId: bigint!) {\n  lanes(\n    where: {active: {_eq: 1}, customer_id: {_eq: $rooftopId}}\n    order_by: {pickup: {name: asc}, delivery: {name: asc}}\n  ) {\n    id\n    customer_id\n    status\n    enriched_at\n    route_polyline\n    distance_miles\n    tolls\n    duration_sec\n    favorite\n    inverse {\n      id\n      customer_id\n      status\n      enriched_at\n      route_polyline\n      distance_miles\n      tolls\n      duration_sec\n    }\n    pickup {\n      id\n      name\n      address\n      region {\n        id\n        name\n        status\n      }\n    }\n    delivery {\n      id\n      name\n      address\n      region {\n        id\n        name\n        status\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getMovePlannerLanes" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "lanes" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enriched_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_polyline" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "inverse" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enriched_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "route_polyline" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "region" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] } }] };

// src/provider/queries/getRelatedConciergeMoves.query.generated.ts
import { resolveExecutor as resolveExecutor9 } from "@hopdrive/sdk-core";
var GetRelatedConciergeMovesDocument = { "__text": 'query getRelatedConciergeMoves($vins: [String!]!, $minDate: timestamptz!) {\n  moves(\n    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_type: {_eq: "customer"}, consumer_at_pickup: {_eq: 1}, pickup_time: {_gte: $minDate}, vehicle_vin: {_in: $vins}}\n    order_by: {pickup_time: desc}\n  ) {\n    id\n    delivery_successful\n    pickup_time\n    reference_num\n    childMoves(where: {move_type: {_eq: "drive"}}) {\n      id\n    }\n    parentMove {\n      id\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getRelatedConciergeMoves" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vins" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "minDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "move_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "drive", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "customer", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_at_pickup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "minDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vins" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_successful" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "childMoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "drive", "block": false } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "parentMove" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] };

// src/provider/queries/getScenarioToMoves.query.generated.ts
import { resolveExecutor as resolveExecutor10 } from "@hopdrive/sdk-core";
var GetScenarioToMovesDocument = { "__text": "query GetScenarioToMoves($moveId: bigint!) {\n  scenariotomoves(\n    where: {move_id: {_eq: $moveId}}\n    order_by: {id: desc}\n    limit: 1\n  ) {\n    id\n    move_id\n    scenario_id\n    cardinality\n    scenario {\n      id\n      status\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioToMoves" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenariotomoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] };

// src/provider/queries/requestVehicleMove.mutation.generated.ts
import { resolveExecutor as resolveExecutor11 } from "@hopdrive/sdk-core";
var RequestVehicleMoveDocument = { "__text": "mutation requestVehicleMove($request: BrowserMoveRequestInput!) {\n  requestVehicleMove(request: $request) {\n    scenario {\n      id\n      scenario_key\n      product_key\n      usecase_key\n      status\n    }\n    move {\n      id\n      role\n      cardinality\n      parent_move_id\n      move_type\n      consumer_type\n      lane_id\n      status\n      usecase_key\n      ready_by\n      deliver_by\n      vehicle_vin\n    }\n    peerMoves {\n      id\n      role\n      cardinality\n      parent_move_id\n      move_type\n      consumer_type\n      lane_id\n      status\n      usecase_key\n      ready_by\n      deliver_by\n      vehicle_vin\n    }\n    replayed\n    contactsSaved\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestVehicleMove" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "request" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "BrowserMoveRequestInput" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "requestVehicleMove" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "request" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "request" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "role" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "peerMoves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "role" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cardinality" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent_move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "usecase_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "deliver_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "replayed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contactsSaved" } }] } }] } }] };

// src/provider/queries/updateEventlogMoveId.mutation.generated.ts
import { resolveExecutor as resolveExecutor12 } from "@hopdrive/sdk-core";
var UpdateEventlogMoveIdDocument = { "__text": "mutation updateEventlogMoveId($eventlogId: bigint!, $moveId: bigint!, $eventKey: String!) {\n  update_eventlogs_by_pk(\n    pk_columns: {id: $eventlogId}\n    _set: {move_id: $moveId, event_key: $eventKey}\n  ) {\n    id\n    move_id\n    event_key\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateEventlogMoveId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "eventlogId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "eventKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_eventlogs_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "eventlogId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "event_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "eventKey" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "event_key" } }] } }] } }] };

// src/provider/queries/updateReferenceNumOnRelatedConciergeMoves.mutation.generated.ts
import { resolveExecutor as resolveExecutor13 } from "@hopdrive/sdk-core";
var UpdateReferenceNumOnRelatedConciergeMovesDocument = { "__text": 'mutation updateReferenceNumOnRelatedConciergeMoves($moveIds: [bigint!]!, $referenceNum: String!, $updatedBy: String!) {\n  update_moves(\n    where: {id: {_in: $moveIds}}\n    _set: {reference_num: $referenceNum, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      reference_num\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateReferenceNumOnRelatedConciergeMoves" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "referenceNum" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveIds" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "reference_num" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "referenceNum" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }] } }] } }] } }] };

// src/provider/queries/upsertMovePlannerLanes.mutation.generated.ts
import { resolveExecutor as resolveExecutor14 } from "@hopdrive/sdk-core";
var UpsertMovePlannerLanesDocument = { "__text": "mutation upsertMovePlannerLanes($upsertableLanes: [lanes_insert_input!]!) {\n  insert_lanes(\n    objects: $upsertableLanes\n    on_conflict: {constraint: lanes_customer_id_origin_location_id_destination_location_id_ke, update_columns: [active, favorite, updatedat]}\n  ) {\n    affected_rows\n    returning {\n      id\n      distance_miles\n      tolls\n      duration_sec\n      favorite\n      pickup {\n        id\n        name\n        address\n      }\n      delivery {\n        id\n        name\n        address\n      }\n      inverse {\n        id\n        duration_sec\n        pickup_inspection_sec\n        delivery_inspection_sec\n        return_ride_wait_sec\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "upsertMovePlannerLanes" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "upsertableLanes" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "lanes_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_lanes" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "upsertableLanes" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "lanes_customer_id_origin_location_id_destination_location_id_ke" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "active" }, { "kind": "EnumValue", "value": "favorite" }, { "kind": "EnumValue", "value": "updatedat" }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "inverse" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "duration_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_inspection_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_inspection_sec" } }, { "kind": "Field", "name": { "kind": "Name", "value": "return_ride_wait_sec" } }] } }] } }] } }] } }] };

// src/provider/MovePlannerProvider.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var RIDESHARE_FEATURE = "dispatching-rideshare";
var MovePlannerProvider = ({
  children,
  state,
  planningContext,
  onSuccess,
  onPlanned,
  clientApp,
  clientVersion,
  buildSha
}) => {
  const host = useMovePlannerHost();
  const { capabilities, session } = host;
  const hostRef = React3.useRef(host);
  hostRef.current = host;
  const connector = host.embed?.connector;
  const { initialType } = embedSettingsStart(host.embed);
  const defaultValidation = defaultValidationFor(capabilities);
  const defaultConsumer = defaultConsumerFor(capabilities);
  const hasAdminPrivileges = session.isPowerRole;
  const globalCustomerConfig = host.rooftop.useCustomerConfig();
  const [getHeaderRooftops] = useLazyQuery(GetHeaderRooftopsDocument);
  const [getAllowedHeaderRooftops] = useLazyQuery(GetAllowedHeaderRooftopsDocument);
  const [getLinkedHeaderRooftops] = useLazyQuery(GetLinkedHeaderRooftopsDocument);
  const [getPayers] = useLazyQuery(GetPayersDocument);
  const [getWorkflowsets] = useLazyQuery(GetWorkflowsetsDocument);
  const [getLanes] = useLazyQuery(GetMovePlannerLanesDocument);
  const [getLocations] = useLazyQuery(GetLocationsDocument);
  const [getMovesFromProps] = useLazyQuery(GetMovePlannerDefaultMovesDocument);
  const [getRelatedConciergeMoves] = useLazyQuery(GetRelatedConciergeMovesDocument);
  const [upsertLanes] = useMutation(UpsertMovePlannerLanesDocument);
  const [requestVehicleMove] = useMutation(RequestVehicleMoveDocument);
  const [updateReferenceNumOnRelatedConciergeMoves] = useMutation(UpdateReferenceNumOnRelatedConciergeMovesDocument);
  const [updateEventlogMoveId] = useMutation(UpdateEventlogMoveIdDocument);
  const [movePlannerLocked, setMovePlannerLocked] = React3.useState(false);
  const [showEmailNotifications, setShowEmailNotifications] = React3.useState(false);
  const [showDistanceEstimates, setShowDistanceEstimates] = React3.useState(false);
  const [showPriceEstimates, setShowPriceEstimates] = React3.useState(false);
  const [validation, setValidation] = React3.useState(defaultValidation);
  const rooftopStore = host.rooftop.useWorkingRooftop();
  const [rooftopConfig, setRooftopConfig] = React3.useState({});
  const [configRooftopId, setConfigRooftopId] = React3.useState(null);
  const [rooftops, setRooftops] = React3.useState([]);
  const [payers, setPayers] = React3.useState([]);
  const [workflowsets, setWorkflowsets] = React3.useState([]);
  const [workflowsetsRooftopId, setWorkflowsetsRooftopId] = React3.useState(null);
  const [lanes, setLanes] = React3.useState([]);
  const [locations, setLocations] = React3.useState([]);
  const [rooftopId, setRooftopId] = React3.useState(0);
  const { offering, accessReason } = useMoveOffering(rooftopId || void 0);
  const [payerId, setPayerId] = React3.useState(0);
  const [workflowsetId, setWorkflowsetId] = React3.useState(0);
  const hasRideshareFeature = capabilities.rideshareForReturn ? session.useFeature(RIDESHARE_FEATURE, rooftopId || void 0) : false;
  const [type, setType] = React3.useState(initialType || defaultType);
  const [chosenProductKey, setChosenProductKey] = React3.useState(null);
  const [emails, setEmails] = React3.useState(defaultEmails);
  const [consumer, setConsumer] = React3.useState(defaultConsumer);
  const [time, setTime] = React3.useState(state?.appointment?.appointment_time || defaultTime);
  const [isDefaultTime, setIsDefaultTime] = React3.useState(state?.appointment ? false : defaultIsDefaultTime);
  const [dynamic, setDynamic] = React3.useState(defaultDynamic);
  const [lane, setLane] = React3.useState(defaultLane);
  const [pickup, setPickup] = React3.useState(defaultLocation);
  const [delivery, setDelivery] = React3.useState(defaultLocation);
  const [move1Title, setMove1Title] = React3.useState(defaultMove1Title);
  const [move2Title, setMove2Title] = React3.useState(defaultMove2Title);
  const [vehicle1, setVehicle1] = React3.useState(defaultVehicle);
  const [vehicle2, setVehicle2] = React3.useState(defaultVehicle);
  const [additional1, setAdditional1] = React3.useState(defaultAdditional);
  const [additional2, setAdditional2] = React3.useState(defaultAdditional);
  const [contactInfo, setContactInfo] = React3.useState(defaultContactInfo);
  const [contactPrefillSameAsPickup, setContactPrefillSameAsPickup] = React3.useState(false);
  const [earliestAvailableTime, setEarliestAvailableTime] = React3.useState(defaultTime);
  const [saving, setSaving] = React3.useState(false);
  const [guardSeed, setGuardSeed] = React3.useState(null);
  const seedServiceFill = React3.useCallback((fill) => setGuardSeed((seed) => seedWithServiceFill(seed, fill)), []);
  usePlannerReloadGuard(
    { pickup, delivery, vehicle1, vehicle2, additional1, additional2, consumer, contactInfo, dynamic },
    saving,
    guardSeed
  );
  const { requireUpdate } = useUpdateActions();
  const isAppointment = !!state?.appointment;
  const typeOverrides = host.embed?.settings?.typeOverrides;
  const plannerTypes = React3.useMemo(() => resolveMovePlannerTypes(typeOverrides), [typeOverrides]);
  const allowList = typeAllowList(rooftopConfig, isAppointment);
  const rooftopConfigLoaded = isRooftopConfigLoaded(configRooftopId, rooftopId);
  const offeredTypes = React3.useMemo(
    () => offeredTypesOnceLoaded(plannerTypes, offering, { loaded: rooftopConfigLoaded, allowList }),
    [plannerTypes, offering, rooftopConfigLoaded, allowList]
  );
  const typeRefusal2 = React3.useMemo(() => typeRefusal(type, offeredTypes, plannerTypes), [type, offeredTypes, plannerTypes]);
  const nothingOffered = offeredTypes ? nothingOfferedCopy(offeredTypes.narrowedBy, accessReason) : null;
  const typeFixed = !!host.embed?.settings?.skipTypeSelection || !!host.embed?.settings?.locks.type;
  const productChoice = React3.useMemo(() => productChoiceFor(offering, type), [offering, type]);
  const productPath = { switchOn: capabilities.productChoiceSwitch, isAppointment };
  const effectiveProductKey2 = offeredProductKey(plannerProductKey(productChoice, chosenProductKey, productPath), offeredTypes, typeRefusal2);
  const liteMode = plannerLiteMode({
    offering,
    productKey: effectiveProductKey2,
    choicePending: isProductChoicePending(productChoice, chosenProductKey, productPath)
  });
  const isLite = liteMode === "lite";
  const laneSelectionMode = `${isAppointment ? "appointment" : planningContext ? "timeline" : "standard"}:${type || "unset"}`;
  const laneSelectionKey = `${rooftopId}:${laneSelectionMode}:${pickup?.id ?? "none"}:${pickup?.address ?? ""}:${delivery?.id ?? "none"}:${delivery?.address ?? ""}`;
  const laneGenerationRef = React3.useRef({ key: laneSelectionKey, generation: 0 });
  if (laneGenerationRef.current.key !== laneSelectionKey) {
    laneGenerationRef.current = {
      key: laneSelectionKey,
      generation: laneGenerationRef.current.generation + 1
    };
  }
  const laneGeneration = `${laneGenerationRef.current.generation}:${laneSelectionKey}`;
  const currentMainLane = React3.useMemo(() => {
    if (!pickup?.id || !delivery?.id) return null;
    const matchesSelection = (candidate) => Number(candidate?.customer_id) === rooftopId && candidate?.pickup?.id === pickup.id && candidate?.pickup?.address === pickup.address && candidate?.delivery?.id === delivery.id && candidate?.delivery?.address === delivery.address;
    const listedLane = lanes?.find(matchesSelection);
    if (listedLane) return listedLane;
    return matchesSelection(lane) ? lane : null;
  }, [delivery?.address, delivery?.id, lane, lanes, pickup?.address, pickup?.id, rooftopId]);
  const currentInverseLane = React3.useMemo(() => {
    if (!pickup?.id || !delivery?.id) return null;
    return lanes?.find(
      (l) => Number(l?.customer_id) === rooftopId && l?.pickup?.id === delivery.id && l?.pickup?.address === delivery.address && l?.delivery?.id === pickup.id && l?.delivery?.address === pickup.address
    ) ?? null;
  }, [delivery?.address, delivery?.id, lanes, pickup?.address, pickup?.id, rooftopId]);
  const { mergeLaneEstimates } = host.lanes;
  const handleLaneUpdate = React3.useCallback(
    (updated) => {
      setLane((prev) => prev?.id === updated.id ? mergeLaneEstimates(prev, updated) : prev);
      setLanes((prev) => prev?.map((l) => l && l.id === updated.id ? mergeLaneEstimates(l, updated) : l));
    },
    [mergeLaneEstimates]
  );
  const requiresInverseLane = type === "one-way" || type === "round-trip" || type === "concierge-loaner" || type === "concierge" && rooftopConfig?.rideshare_calling_enabled === true;
  const mainLaneLifecycle = host.lanes.useLaneEnrichment(currentMainLane, laneGeneration, handleLaneUpdate);
  const inverseLaneLifecycle = host.lanes.useLaneEnrichment(
    requiresInverseLane ? currentInverseLane : null,
    laneGeneration,
    handleLaneUpdate
  );
  const lanesReady = React3.useMemo(() => {
    if (!pickup?.id || !delivery?.id) return false;
    return host.lanes.lanesReadyForRequest(currentMainLane, currentInverseLane, requiresInverseLane);
  }, [currentInverseLane, currentMainLane, delivery?.id, pickup?.id, requiresInverseLane]);
  const retryLaneCalculation = React3.useCallback(async () => {
    await Promise.all([
      mainLaneLifecycle.failed ? mainLaneLifecycle.retry() : Promise.resolve(),
      requiresInverseLane && inverseLaneLifecycle.failed ? inverseLaneLifecycle.retry() : Promise.resolve()
    ]);
  }, [inverseLaneLifecycle, mainLaneLifecycle, requiresInverseLane]);
  const laneLifecycle = React3.useMemo(
    () => composeLaneLifecycle({
      main: mainLaneLifecycle,
      inverse: inverseLaneLifecycle,
      requiresInverseLane,
      retry: retryLaneCalculation
    }),
    [inverseLaneLifecycle, mainLaneLifecycle, requiresInverseLane, retryLaneCalculation]
  );
  const [assignToDriverId, setAssignToDriverId] = React3.useState(null);
  const [assignToDriverName, setAssignToDriverName] = React3.useState(null);
  const [driverRowNumber, setDriverRowNumber] = React3.useState(null);
  const [isDispatching, setIsDispatching] = React3.useState(false);
  const [successMoveId, setSuccessMoveId] = React3.useState(null);
  const [enforcementMode, setEnforcementMode] = React3.useState("suggested");
  const [createRideForReturn, setCreateRideForReturn] = React3.useState(false);
  const [pendingDispatch, setPendingDispatch] = React3.useState(null);
  const [relatedMovesModalOpen, setRelatedMovesModalOpen] = React3.useState(false);
  const [relatedMovesData, setRelatedMovesData] = React3.useState([]);
  const [pendingReferenceNum, setPendingReferenceNum] = React3.useState("");
  const relatedMoveResolveRef = React3.useRef(null);
  const [pollForScenario, { data: scenarioToMovesData, stopPolling }] = useLazyQuery(GetScenarioToMovesDocument, {
    fetchPolicy: "network-only",
    pollInterval: 500
    // Poll every 500ms
  });
  const isMountedRef = React3.useRef(true);
  React3.useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  React3.useEffect(() => {
    if (pendingDispatch?.moveId) {
      pollForScenario({ variables: { moveId: pendingDispatch.moveId } });
    }
    return () => {
      if (pendingDispatch?.moveId) stopPolling?.();
    };
  }, [pendingDispatch?.moveId, pollForScenario, stopPolling]);
  const { dispatch } = host.transport;
  React3.useEffect(() => {
    if (!pendingDispatch || !scenarioToMovesData?.scenariotomoves?.length) return;
    const scenarioLink = scenarioToMovesData.scenariotomoves[0];
    const scenarioId = scenarioLink?.scenario_id;
    const scenarioStatus = scenarioLink?.scenario?.status;
    if (!scenarioId) return;
    if (scenarioStatus !== "manual") return;
    stopPolling?.();
    const performDispatch = async () => {
      if (!isMountedRef.current) return;
      try {
        const fullMove = await dispatch.refetchMove(pendingDispatch.moveId);
        if (!isMountedRef.current) return;
        if (fullMove) {
          await dispatch.dispatchToDriver({
            move: fullMove,
            driverId: pendingDispatch.driverId,
            time: pendingDispatch.time,
            withRideshare: pendingDispatch.withRideshare
          });
          if (!isMountedRef.current) return;
          hostRef.current.notify.success(`Move created and offered to ${pendingDispatch.driverName || "driver"}!`, {
            toastId: "move-planner-dispatch-success"
          });
          setSuccessMoveId(pendingDispatch.moveId);
          if (onSuccess) onSuccess(pendingDispatch.moveId);
        } else {
          throw new Error("Could not refetch move data for dispatch");
        }
      } catch (dispatchError) {
        console.error("Failed to auto-dispatch move to driver:", dispatchError);
        if (!isMountedRef.current) return;
        hostRef.current.notify.warning(
          "Move created successfully, but the offer could not be sent to the driver. You can manually assign it from the dashboard.",
          { toastId: "move-planner-dispatch-warning", autoClose: 1e4 }
        );
      } finally {
        if (isMountedRef.current) {
          setIsDispatching(false);
          setPendingDispatch(null);
        }
      }
    };
    performDispatch();
  }, [scenarioToMovesData, pendingDispatch, dispatch, stopPolling, onSuccess]);
  React3.useEffect(() => {
    if (!pendingDispatch) return;
    const timeoutId = setTimeout(() => {
      if (!isMountedRef.current) return;
      console.error("\u23F1\uFE0F Timeout waiting for scenario to be linked to move");
      stopPolling?.();
      hostRef.current.notify.error(
        "Timeout waiting for scenario creation. The move was created but could not be offered to the driver. Please manually assign it from the dashboard.",
        { toastId: "move-planner-dispatch-timeout", autoClose: 1e4 }
      );
      setIsDispatching(false);
      setPendingDispatch(null);
    }, 2e4);
    return () => {
      clearTimeout(timeoutId);
      if (pendingDispatch?.moveId) stopPolling?.();
    };
  }, [pendingDispatch, stopPolling]);
  const rooftopQueries = {
    getHeaderRooftops,
    getAllowedHeaderRooftops,
    getLinkedHeaderRooftops
  };
  React3.useEffect(() => {
    const fetchRooftops = async () => {
      try {
        const resRooftops = await loadRooftops({ session, capabilities, ...rooftopQueries });
        setRooftops(resRooftops);
        if (resRooftops?.length && !rooftopStore?.id) {
          const { rooftop: rooftopToSet, remember } = initialRooftop(resRooftops, host.rooftop.restoreRooftopId);
          if (rooftopToSet && remember) host.rooftop.rememberRooftopId(rooftopToSet.id);
          if (rooftopToSet) {
            host.rooftop.setWorkingRooftop(rooftopToSet);
            setRooftopId(rooftopToSet?.id);
          }
        }
      } catch (error) {
        console.error("MovePlanner: Failed to fetch rooftops:", error);
        setRooftops([]);
      }
    };
    fetchRooftops();
  }, [session]);
  React3.useEffect(() => {
    loadPayers(session.allowedPayerIds, getPayers).then(setPayers);
  }, [session]);
  const fetchWorkflowsets = async (overrideRooftopId) => {
    const resWorkflowsets = await loadWorkflowsets(rooftopId, getWorkflowsets, overrideRooftopId);
    setWorkflowsets(resWorkflowsets);
    setWorkflowsetsRooftopId(overrideRooftopId ?? rooftopId);
    return resWorkflowsets;
  };
  React3.useEffect(() => {
    fetchWorkflowsets();
    loadLanes(rooftopId, getLanes).then(setLanes);
    loadLocations(rooftopId, getLocations).then(setLocations);
  }, [rooftopId, globalCustomerConfig?.public_workflowsets]);
  const fetchMovesFromProps = async () => {
    const resMoves = await loadSourceMoves(state || {}, getMovesFromProps);
    if (!resMoves?.length) return;
    const fetchedWorkflowsets = capabilities.dynamicWorkflowSteps ? await fetchWorkflowsets(rooftopStore?.id) : void 0;
    const rebuild = rebuildFromSourceMoves({
      moves: resMoves,
      sourceState: state || {},
      workflowsets: fetchedWorkflowsets,
      defaultConsumer,
      capabilities
    });
    if (!rebuild) return;
    setRooftopId(rebuild.rooftopId);
    setPayerId(rebuild.payerId);
    setWorkflowsetId(rebuild.workflowsetId);
    setType(rebuild.type);
    setEmails(rebuild.emails);
    setConsumer(rebuild.consumer);
    if (rebuild.dynamic) setDynamic(rebuild.dynamic);
    setLane(rebuild.lane);
    setPickup(rebuild.pickup);
    setDelivery(rebuild.delivery);
    setVehicle1(rebuild.vehicle1);
    setAdditional1(rebuild.additional1);
    setVehicle2(rebuild.vehicle2);
    setAdditional2(rebuild.additional2);
    if (rebuild.contactInfo) setContactInfo(rebuild.contactInfo);
  };
  React3.useEffect(() => {
    if (state?.moveId1 || state?.moveId1 && state?.moveId2) {
      fetchMovesFromProps();
    }
    if (state?.appointment) {
      const seeded = appointmentFormFields(state.appointment);
      setPickup(seeded.pickup);
      setDelivery(seeded.delivery);
      setLane(state?.appointment?.lane || null);
      const newLocations = [];
      if (state.appointment.pickup) newLocations.push(state.appointment.pickup);
      if (state.appointment.delivery) newLocations.push(state.appointment.delivery);
      if (newLocations.length > 0) setLocations(newLocations);
      setEmails(state?.appointment?.config?.emailsToNotify || defaultEmails);
      if (capabilities.defaultWorkflowsetWithSourceMove) {
        if (state?.appointment?.workflow_set_id) setWorkflowsetId(state.appointment.workflow_set_id);
      } else {
        setWorkflowsetId(state?.appointment?.workflow_set_id || 1);
      }
      setVehicle1(seeded.vehicle1);
      setAdditional1(seeded.additional1);
      setConsumer(seeded.consumer);
      setGuardSeed({
        vehicle2: defaultVehicle,
        additional2: defaultAdditional,
        contactInfo: defaultContactInfo,
        dynamic: defaultDynamic,
        ...seeded
      });
      setTime(state?.appointment?.appointment_time || "");
      setIsDefaultTime(false);
      setType(APPOINTMENT_MOVE_TYPE);
    }
  }, [state]);
  const appliedPrefillRef = React3.useRef(false);
  const prefill = host.embed?.prefill;
  React3.useEffect(() => {
    if (state || appliedPrefillRef.current || !prefill) return;
    appliedPrefillRef.current = true;
    const updates = prefillUpdates(prefill);
    if (updates.consumer) setConsumer(updates.consumer);
    if (updates.contactInfo) setContactInfo(updates.contactInfo);
    if (updates.contactPrefillSameAsPickup) setContactPrefillSameAsPickup(true);
    if (updates.vehicle1) setVehicle1(updates.vehicle1);
    if (updates.vehicle2) setVehicle2(updates.vehicle2);
    if (updates.additional1) setAdditional1(updates.additional1);
    if (updates.additional2) setAdditional2(updates.additional2);
    if (updates.time != null) setTime(updates.time);
  }, [state, prefill]);
  React3.useEffect(() => {
    if (planningContext) {
      setPickup(planningContext.pickup);
      setDelivery(planningContext.delivery);
      setLocations([planningContext.pickup, planningContext.delivery]);
      setTime(dayjs7(planningContext.dateTime).format("YYYY-MM-DDTHH:mm:ss"));
      setIsDefaultTime(false);
      const contextType = planningContextType(rooftopConfig, type);
      if (contextType) setType(contextType);
    }
  }, [planningContext]);
  React3.useEffect(() => {
    if (planningContext) {
      if (planningContext.driverId && liteMode === "lite") {
        setAssignToDriverId(planningContext.driverId);
      } else {
        setAssignToDriverId(null);
        setAssignToDriverName(null);
      }
    }
  }, [planningContext, liteMode]);
  React3.useEffect(() => {
    if (!capabilities.rideshareForReturn) return;
    setCreateRideForReturn(rooftopConfig?.rideshare_calling_enabled === true && hasRideshareFeature);
  }, [rooftopConfig, hasRideshareFeature, capabilities.rideshareForReturn]);
  React3.useEffect(() => {
    if (rooftopStore && !rooftopId) setRooftopId(rooftopStore?.id);
  }, [rooftopStore]);
  React3.useEffect(() => {
    let cancelled = false;
    const appliedFor = appliedConfigRooftopId(rooftops, rooftopId);
    const updateRooftopConfigAndLocations = async () => {
      try {
        const config = await loadPlannerConfig(rooftops, rooftopId, host.rooftop.readPlannerConfig);
        if (cancelled) return;
        const patch = configPatch({
          config,
          state,
          hasPlanningContext: !!planningContext,
          initialType,
          actorEmail: session.actorEmail,
          capabilities
        });
        if (patch.movePlannerLocked !== void 0) setMovePlannerLocked(patch.movePlannerLocked);
        if (patch.showEmailNotifications !== void 0) setShowEmailNotifications(patch.showEmailNotifications);
        if (patch.showDistanceEstimates !== void 0) setShowDistanceEstimates(patch.showDistanceEstimates);
        if (patch.showPriceEstimates !== void 0) setShowPriceEstimates(patch.showPriceEstimates);
        if (patch.enforcementMode) setEnforcementMode(patch.enforcementMode);
        if (patch.payerId !== void 0) setPayerId(patch.payerId);
        if (patch.type !== void 0) setType(patch.type);
        if (patch.emails) setEmails(patch.emails);
        if (patch.workflowsetId !== void 0) setWorkflowsetId(patch.workflowsetId);
        if (patch.resetLane) {
          setLane(defaultLane);
          setPickup(defaultLocation);
          setDelivery(defaultLocation);
          setGuardSeed((seed) => seed && { ...seed, pickup: defaultLocation, delivery: defaultLocation });
        }
        setRooftopConfig(patch.rooftopConfig);
        if (appliedFor) setConfigRooftopId(appliedFor);
        if (patch.storeConfig) host.rooftop.setCustomerConfig(patch.rooftopConfig);
      } catch (err) {
        if (cancelled) return;
        console.error(`MovePlanner: Failed to update rooftop config and locations:`, err);
        setRooftopConfig({});
        if (appliedFor) setConfigRooftopId(appliedFor);
        hostRef.current.notify.error(`Could not load this rooftop's planner settings. Refresh the page to try again.`, {
          toastId: `move-planner-config-load`
        });
      }
    };
    updateRooftopConfigAndLocations();
    return () => {
      cancelled = true;
    };
  }, [rooftops, rooftopId]);
  React3.useEffect(() => {
    if (workflowsetsRooftopId !== rooftopId) return;
    const replacement = replacementMoveWorkflowsetId(workflowsets, workflowsetId);
    if (replacement !== null) {
      setWorkflowsetId(replacement);
      return;
    }
    if (!capabilities.workflowsetResetToFirstListed) return;
    if (workflowsets?.length && workflowsetId) {
      const isValidWorkflowset = workflowsets.some((w) => w.id === workflowsetId);
      if (!isValidWorkflowset) setWorkflowsetId(workflowsets[0]?.id || 1);
    }
  }, [workflowsets, workflowsetsRooftopId, rooftopId, workflowsetId, capabilities.workflowsetResetToFirstListed]);
  React3.useEffect(() => {
    setValidation(defaultValidation);
  }, [type]);
  const rooftopSwitchPendingRef = React3.useRef(false);
  const selectRooftop = React3.useCallback(
    (id) => {
      if (id !== rooftopId) rooftopSwitchPendingRef.current = true;
      setRooftopId(id);
    },
    [rooftopId]
  );
  React3.useEffect(() => {
    if (!rooftopSwitchPendingRef.current || !offeredTypes) return;
    rooftopSwitchPendingRef.current = false;
    const nextType = typeAfterRooftopSwitch(type, offeredTypes, typeFixed);
    if (nextType !== type) setType(nextType);
  }, [offeredTypes]);
  React3.useEffect(() => {
    setChosenProductKey(null);
  }, [type, rooftopId]);
  React3.useEffect(() => {
    if (!capabilities.loanerSwapOnTypeChange) return;
    const swap = loanerSwapOnTypeChange({ type, consumer, vehicle1, vehicle2, additional1, additional2, validation });
    if (!swap) return;
    setVehicle1(swap.vehicle1);
    setVehicle2(swap.vehicle2);
    setAdditional1(swap.additional1);
    setAdditional2(swap.additional2);
    setValidation(swap.validation);
    setConsumer(swap.consumer);
  }, [type]);
  const changeType = (next) => {
    const toType = typeof next === "function" ? next(type) : next;
    if (capabilities.loanerSwapOnTypeChange) {
      const reorder = reorderOnTypeChange({ fromType: type, type: toType, consumer, vehicle1, vehicle2, additional1, additional2, validation });
      if (reorder) {
        setVehicle1(reorder.vehicle1);
        setVehicle2(reorder.vehicle2);
        setAdditional1(reorder.additional1);
        setAdditional2(reorder.additional2);
        setValidation(reorder.validation);
        setConsumer(reorder.consumer);
      }
    }
    setType(toType);
  };
  React3.useEffect(() => {
    const titles = moveTitles(type, consumer?.first);
    if (!titles) return;
    setMove1Title(titles.move1Title);
    setMove2Title(titles.move2Title);
    if (titles.resetDefaultTime) setIsDefaultTime(false);
  }, [type, consumer]);
  React3.useEffect(() => {
    if ((time || isDefaultTime) && lane?.pickup && lane?.delivery && type && liteMode !== "lite") {
      const moveTime = isDefaultTime ? dayjs7().add(1, "minute").format() : time;
      const isMovePair = type === `round-trip` || type === `concierge-loaner`;
      checkBusinessHours(lane, dayjs7(moveTime), isMovePair);
    }
  }, [time, isDefaultTime, lane, type, liteMode]);
  const checkBusinessHours = async (lane2, time2, isMovePair) => {
    try {
      const { duration_sec = 0 } = lane2;
      const businessHoursCheck = await host.transport.checkBusinessHours({ lane: lane2, readyBy: time2.format(), isMovePair });
      if (!businessHoursCheck.success) {
        console.error("Error checking business hours:", businessHoursCheck.error);
        return;
      }
      if (businessHoursCheck.earliestAvailableTimeMessageOne) {
        setEarliestAvailableTime(dayjs7(businessHoursCheck.earliestAvailableTimeOne).utc().format());
        return;
      }
      if (isMovePair && businessHoursCheck.earliestAvailableTimeMessageTwo) {
        setEarliestAvailableTime(dayjs7(businessHoursCheck.earliestAvailableTimeTwo).subtract(duration_sec, "seconds").utc().format());
        return;
      }
    } catch (error) {
      console.error("Error checking business hours:", error);
    }
  };
  const validateForm = () => {
    const { validity, isValid } = validatePlanner({
      validation,
      rooftopId,
      payerId,
      workflowsetId,
      workflowsets,
      type,
      typeRefused: !!typeRefusal2,
      productKey: effectiveProductKey2,
      emails,
      consumer,
      time,
      isDefaultTime,
      isAppointment,
      pickup,
      delivery,
      vehicle1,
      vehicle2,
      dynamic,
      contactInfo,
      rooftopConfig,
      customerConfig: globalCustomerConfig,
      capabilities
    });
    setValidation(validity);
    return isValid;
  };
  const applyConnector = React3.useCallback(
    async (record, vehicleIndex, overwriteExisting, triggerType, excludeFields) => {
      if (!connector) return;
      const { consumerUpdates, vehicleSlot, vehicleUpdates, referenceCopy } = connectorMerge({
        record,
        vehicleIndex,
        overwriteExisting,
        triggerType,
        excludeFields,
        type,
        consumer,
        vehicle1,
        vehicle2,
        merge: connector.merge
      });
      if (Object.keys(consumerUpdates).length > 0) setConsumer((prev) => ({ ...prev, ...consumerUpdates }));
      if (Object.keys(vehicleUpdates).length > 0) {
        (vehicleSlot === 2 ? setVehicle2 : setVehicle1)((prev) => ({ ...prev, ...vehicleUpdates }));
      }
      if (referenceCopy) {
        (referenceCopy.vehicleSlot === 2 ? setVehicle2 : setVehicle1)((prev) => ({ ...prev, referenceId: referenceCopy.referenceId }));
      }
      const hasAddress = record.customerAddressLine1 || record.customerAddressCity;
      const isConcierge = type === "concierge" || type === "concierge-loaner";
      const dealershipLocation = rooftops?.find((r) => r?.id === rooftopId)?.location;
      if (hasAddress && isConcierge) {
        const customerLocation = await connector.resolveCustomerLocation(record, rooftopId);
        if (customerLocation) {
          setLocations((prev) => prev.some((loc) => loc?.id === customerLocation.id) ? prev : [...prev, customerLocation]);
          const endpoints = connectorEndpoints({
            customerLocation,
            dealershipLocation,
            action: consumer?.action,
            pickup,
            delivery,
            overwriteExisting
          });
          if (endpoints.pickup) setPickup(endpoints.pickup);
          if (endpoints.delivery) setDelivery(endpoints.delivery);
        }
      }
    },
    [connector, consumer, vehicle1, vehicle2, type, pickup, delivery, rooftops, rooftopId]
  );
  const handleConnectorFetch = React3.useCallback(
    async (triggerType, lookupValue, vehicleIndex, excludeFields = []) => {
      if (!connector || !lookupValue?.trim()) return;
      try {
        const record = await connector.fetch(triggerType, lookupValue);
        if (record) applyConnector(record, vehicleIndex, connector.overwriteExisting(triggerType), triggerType, excludeFields);
      } catch (error) {
        console.error("[Connector] Fetch failed:", error);
      }
    },
    [applyConnector, connector]
  );
  const handleRelatedMovesModalClose = (selectedMove) => {
    setRelatedMovesModalOpen(false);
    relatedMoveResolveRef.current?.(selectedMove);
    relatedMoveResolveRef.current = null;
  };
  const chooseRelatedMove = (relatedMoves, referenceNum) => new Promise((resolve) => {
    setRelatedMovesData(relatedMoves);
    setPendingReferenceNum(referenceNum);
    setRelatedMovesModalOpen(true);
    relatedMoveResolveRef.current = resolve;
  });
  const submitPlan = () => finalizePlan(
    {
      type,
      consumer,
      vehicle1,
      vehicle2,
      additional1,
      additional2,
      pickup,
      delivery,
      time,
      isDefaultTime,
      liteMode,
      rooftopId,
      productKey: effectiveProductKey2,
      typeRefused: !!typeRefusal2,
      payerId,
      workflowsetId,
      workflowsets,
      rooftops,
      payers,
      lanes,
      emails,
      dynamic,
      contactInfo,
      earliestAvailableTime,
      driverRowNumber,
      assignToDriverId,
      assignToDriverName,
      createRideForReturn,
      validation,
      rooftopConfig,
      customerConfig: globalCustomerConfig,
      sourceState: state,
      hasPlanningContext: !!planningContext,
      clientApp,
      clientVersion,
      buildSha
    },
    {
      capabilities,
      host,
      upsertLanes,
      requestVehicleMove,
      updateEventlogMoveId,
      getRelatedConciergeMoves,
      updateReferenceNumOnRelatedConciergeMoves,
      chooseRelatedMove,
      setSaving,
      setValidation,
      setIsDispatching,
      setPendingDispatch,
      setSuccessMoveId,
      onSuccess,
      requireUpdate
    }
  );
  const handleSubmit = async () => {
    const success = await submitPlan();
    if (success) onPlanned?.();
  };
  const handleSubmitAndAddAnother = async () => {
    await submitPlan();
  };
  const handleSubmitOnScheduleTimeline = async () => {
    await submitPlan();
  };
  return /* @__PURE__ */ jsxs2(
    MovePlannerContext.Provider,
    {
      value: {
        hasAdminPrivileges,
        movePlannerLocked,
        showEmailNotifications,
        showDistanceEstimates,
        showPriceEstimates,
        validation,
        rooftopConfig,
        liteMode,
        isLite,
        offering,
        offeredTypes,
        typeRefusal: typeRefusal2,
        nothingOffered,
        chosenProductKey,
        effectiveProductKey: effectiveProductKey2,
        rooftops,
        payers,
        workflowsets,
        lanes,
        locations,
        rooftopId,
        payerId,
        workflowsetId,
        type,
        emails,
        consumer,
        time,
        isDefaultTime,
        dynamic,
        lane,
        pickup,
        delivery,
        move1Title,
        move2Title,
        vehicle1,
        vehicle2,
        additional1,
        additional2,
        contactInfo,
        contactPrefillSameAsPickup,
        saving,
        lanesReady,
        laneLifecycle,
        assignToDriverId,
        assignToDriverName,
        driverRowNumber,
        isDispatching,
        pendingMoveId: pendingDispatch?.moveId || null,
        successMoveId,
        enforcementMode,
        createRideForReturn,
        setCreateRideForReturn,
        ...connector ? { handleConnectorFetch } : {},
        setValidation,
        setRooftopConfig,
        setRooftops,
        setPayers,
        setWorkflowsets,
        setLanes,
        setLocations,
        setRooftopId: selectRooftop,
        setPayerId,
        setWorkflowsetId,
        setType: changeType,
        setChosenProductKey,
        setEmails,
        setConsumer,
        setTime,
        setIsDefaultTime,
        setDynamic,
        setLane,
        setPickup,
        setDelivery,
        seedServiceFill,
        setMove1Title,
        setMove2Title,
        setVehicle1,
        setVehicle2,
        setAdditional1,
        setAdditional2,
        setContactInfo,
        setSaving,
        setAssignToDriverId,
        setAssignToDriverName,
        setDriverRowNumber,
        setIsDispatching,
        handleSubmit,
        handleSubmitAndAddAnother,
        handleSubmitOnScheduleTimeline,
        isScheduleTimelineMode: !!planningContext,
        validateForm,
        defaultValidation,
        defaultLocation,
        defaultLane,
        defaultVehicle,
        defaultAdditional,
        defaultContactInfo,
        defaultConsumer,
        defaultTime,
        defaultIsDefaultTime
      },
      children: [
        rooftopStore?.id && rooftops?.length ? children : /* @__PURE__ */ jsx2(LinearProgress, {}),
        capabilities.roCapture ? /* @__PURE__ */ jsx2(
          RelatedMovesSelectionModal_default,
          {
            open: relatedMovesModalOpen,
            onClose: handleRelatedMovesModalClose,
            relatedMoves: relatedMovesData,
            referenceNum: pendingReferenceNum
          }
        ) : null
      ]
    }
  );
};

// src/content/MovePlannerContent.tsx
import { css as css31 } from "@emotion/css";
import { useTheme as useTheme31, Button as Button6, CircularProgress as CircularProgress2, Paper, Typography as Typography13, Box as Box4, Tooltip as Tooltip7 } from "@mui/material";
import { BiCar } from "react-icons/bi";
import { MdMap } from "react-icons/md";
import { MdDoNotDisturb } from "react-icons/md";
import { Divider as Divider2 } from "@hopdrive/sdk-ui";

// src/forms/additional/MovePlannerAdditionalForm.tsx
import { css as css3 } from "@emotion/css";
import { useTheme as useTheme3, InputAdornment, TextField } from "@mui/material";
import { BiDetail, BiSolidContact } from "react-icons/bi";

// src/kit/InfoBlurb.tsx
import { css as css2 } from "@emotion/css";
import { alpha, useTheme as useTheme2, Typography as Typography2 } from "@mui/material";
import { BiSolidInfoCircle } from "react-icons/bi";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var InfoBlurb = ({ icon, color, children, actions, disableTypography }) => {
  const theme = useTheme2();
  const cls = useStyles2(theme, color, !!actions);
  return /* @__PURE__ */ jsxs3("div", { className: cls.container, children: [
    /* @__PURE__ */ jsxs3("div", { className: cls.content, children: [
      /* @__PURE__ */ jsx3("span", { className: cls.icon, children: icon || /* @__PURE__ */ jsx3(BiSolidInfoCircle, {}) }),
      disableTypography ? children : /* @__PURE__ */ jsx3(Typography2, { variant: "body2", sx: { textWrap: "pretty", color: color || theme?.palette?.text?.secondary }, children })
    ] }),
    actions && /* @__PURE__ */ jsx3("div", { className: cls.actions, children: actions })
  ] });
};
var useStyles2 = (theme, color, hasActions) => ({
  container: css2`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border: 1px solid ${color ? alpha(color, 0.24) : theme?.palette?.divider};
    border-radius: 10px;
    margin-bottom: 12px;
    background-color: ${color ? alpha(color, 0.08) : theme?.palette?.action?.hover};
    ${hasActions ? "justify-content: space-between;" : ""}
  `,
  content: css2`
    display: flex;
    align-items: center;
    gap: 10px;
  `,
  icon: css2`
    display: flex;
    align-items: center;
    min-width: 20px;
    min-height: 20px;
    margin-top: -2px;
    font-size: 20px;
    color: ${color || theme?.palette?.text?.secondary};
  `,
  actions: css2`
    flex-shrink: 0;
    margin-left: auto;
  `
});
var InfoBlurb_default = InfoBlurb;

// src/forms/additional/MovePlannerAdditionalForm.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var maxContactLength = 128;
var maxNotesLength = 512;
var MovePlannerAdditionalForm = ({ additional, setAdditional, appointmentMode }) => {
  const theme = useTheme3();
  const cls = useStyles3(theme);
  return /* @__PURE__ */ jsxs4("div", { className: cls.additional, children: [
    /* @__PURE__ */ jsx4(InfoBlurb_default, { children: appointmentMode ? `Any additional information concerning this appointment will be shared with the driver moving the vehicle.` : `Any additional information concerning this move will be shared with the driver performing the move. Please reserve the "Contact Info" field for contact information only. All other information can be added to the "Notes/Instructions" field.` }),
    !appointmentMode && /* @__PURE__ */ jsxs4(Fragment2, { children: [
      /* @__PURE__ */ jsxs4("label", { className: cls.textFieldLabel, htmlFor: "additional-contact", children: [
        "Contact Info",
        " ",
        /* @__PURE__ */ jsxs4("span", { className: cls.textFieldLength, children: [
          "(",
          additional?.contact?.length || 0,
          "/",
          maxContactLength,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ jsx4(
        TextField,
        {
          fullWidth: true,
          multiline: true,
          name: "additional-contact",
          placeholder: "Enter contact info...",
          value: additional?.contact || ``,
          onChange: (e) => {
            const value = e?.target?.value || ``;
            if (value?.length > maxContactLength) return;
            if (setAdditional) setAdditional({ ...additional, contact: value });
          },
          slotProps: {
            input: {
              startAdornment: /* @__PURE__ */ jsx4(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx4(BiSolidContact, { size: 20 }) })
            }
          }
        }
      ),
      /* @__PURE__ */ jsx4("div", { className: cls.spacer })
    ] }),
    /* @__PURE__ */ jsxs4("label", { className: cls.textFieldLabel, htmlFor: "additional-notes", children: [
      "Notes/Instructions",
      " ",
      /* @__PURE__ */ jsxs4("span", { className: cls.textFieldLength, children: [
        "(",
        additional?.notes?.length || 0,
        "/",
        maxNotesLength,
        ")"
      ] })
    ] }),
    /* @__PURE__ */ jsx4(
      TextField,
      {
        fullWidth: true,
        multiline: true,
        name: "additional-notes",
        placeholder: "Enter additional notes/instructions...",
        value: additional?.notes || ``,
        onChange: (e) => {
          const value = e?.target?.value || ``;
          if (value?.length > maxNotesLength) return;
          if (setAdditional) setAdditional({ ...additional, notes: value });
        },
        slotProps: {
          input: {
            startAdornment: /* @__PURE__ */ jsx4(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx4(BiDetail, { size: 20 }) })
          }
        }
      }
    )
  ] });
};
var useStyles3 = (theme) => {
  return {
    additional: css3`
      position: relative;
      margin-top: 18px;
    `,
    textFieldLabel: css3`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLength: css3`
      color: ${theme?.palette?.text?.secondary};
    `,
    textFieldLabelRequired: css3`
      color: ${theme?.palette?.error?.main};
    `,
    flex: css3`
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      ${theme?.breakpoints?.down("sm")} {
        flex-direction: column;
      }
    `,
    flexItem: css3`
      flex: 1;
      width: 100%;
    `,
    spacer: css3`
      width: 100%;
      height: 12px;
    `
  };
};
var MovePlannerAdditionalForm_default = MovePlannerAdditionalForm;

// src/forms/contacts/MovePlannerContactInfoForm.tsx
import React5 from "react";
import { useQuery } from "@apollo/client";
import { css as css5 } from "@emotion/css";
import { useTheme as useTheme5, InputAdornment as InputAdornment3, TextField as TextField3, Typography as Typography3, Checkbox, FormControlLabel } from "@mui/material";
import { BiMobile, BiPhone, BiEnvelope, BiUser, BiNotepad } from "react-icons/bi";

// src/forms/consumer/PhoneCheckAdornment.tsx
import { css as css4, keyframes } from "@emotion/css";
import { useTheme as useTheme4, Tooltip } from "@mui/material";
import { BiErrorCircle, BiLoaderCircle, BiMinusCircle, BiSolidCheckCircle } from "react-icons/bi";
import { jsx as jsx5 } from "react/jsx-runtime";
var PhoneCheckAdornment = ({ loading, isMobile }) => {
  const theme = useTheme4();
  const cls = useStyles4();
  return /* @__PURE__ */ jsx5("div", { className: cls.phoneValidation, children: loading ? /* @__PURE__ */ jsx5(Tooltip, { title: "Validating...", children: /* @__PURE__ */ jsx5("span", { children: /* @__PURE__ */ jsx5(BiLoaderCircle, { className: cls.phoneValidationLoader, size: 20, style: { color: theme?.palette?.text?.disabled } }) }) }) : isMobile === true ? /* @__PURE__ */ jsx5(Tooltip, { title: "Phone is able to receive SMS.", children: /* @__PURE__ */ jsx5("span", { children: /* @__PURE__ */ jsx5(BiSolidCheckCircle, { className: cls.phoneValidationIcon, size: 20, style: { color: theme?.palette?.success?.main } }) }) }) : isMobile === false ? /* @__PURE__ */ jsx5(Tooltip, { title: "Phone is NOT able to receive SMS!", children: /* @__PURE__ */ jsx5("span", { children: /* @__PURE__ */ jsx5(BiErrorCircle, { className: cls.phoneValidationIcon, size: 20, style: { color: theme?.palette?.error?.main } }) }) }) : /* @__PURE__ */ jsx5(Tooltip, { title: "Please enter a valid mobile phone number with SMS capability. Do NOT include the country code.", children: /* @__PURE__ */ jsx5("span", { children: /* @__PURE__ */ jsx5(BiMinusCircle, { className: cls.phoneValidationIcon, size: 20, style: { color: theme?.palette?.text?.disabled } }) }) }) });
};
var useStyles4 = () => {
  const loader = keyframes`
    0% {
      opacity: 1;
      rotate: 0deg;
    }
    6.25% {
      opacity: 0.5;
    }
    12.5% {
      opacity: 1;
    }
    18.75% {
      opacity: 0.5;
    }
    25% {
      opacity: 1;
    }
    31.25% {
      opacity: 0.5;
    }
    37.5% {
      opacity: 1;
    }
    43.75% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
      rotate: 180deg;
    }
    56.25% {
      opacity: 0.5;
    }
    62.5% {
      opacity: 1;
    }
    68.75% {
      opacity: 0.5;
    }
    75% {
      opacity: 1;
    }
    81.25% {
      opacity: 0.5;
    }
    87.5% {
      opacity: 1;
    }
    93.75% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      rotate: 360deg;
    }
  `;
  return {
    phoneValidation: css4``,
    phoneValidationIcon: css4`
      display: block;
      cursor: pointer;
    `,
    phoneValidationLoader: css4`
      display: block;
      animation: ${loader} 5s linear infinite;
    `
  };
};
var PhoneCheckAdornment_default = PhoneCheckAdornment;

// src/forms/consumer/phoneValidation.ts
import React4 from "react";
function shouldVerifyPhone(phone, lastVerified, dedupe) {
  return !(dedupe && phone && phone === lastVerified);
}
function nextVerifiedPhone(phone, isMobile) {
  return isMobile === null ? null : phone || null;
}
function useMobilePhoneCheck(errorLabel, { dedupe = false } = {}) {
  const host = useMovePlannerHost();
  const [isMobile, setIsMobile] = React4.useState(null);
  const [loading, setLoading] = React4.useState(false);
  const lastVerified = React4.useRef(null);
  const verify = async (phone) => {
    if (!shouldVerifyPhone(phone, lastVerified.current, dedupe)) return;
    setLoading(true);
    if (!validatePhone(phone)) {
      setIsMobile(null);
      lastVerified.current = null;
      setLoading(false);
      return;
    }
    try {
      const result = await host.transport.verifyMobilePhone(phone);
      setIsMobile(result);
      lastVerified.current = nextVerifiedPhone(phone, result);
      setLoading(false);
    } catch (err) {
      console.error(`Failed to verify ${errorLabel}:`, err);
      setIsMobile(null);
      lastVerified.current = null;
      setLoading(false);
    }
  };
  return { isMobile, loading, verify };
}

// src/forms/contacts/ContactField.tsx
import { Autocomplete, InputAdornment as InputAdornment2, TextField as TextField2 } from "@mui/material";
import { Fragment as Fragment3, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ContactField = ({
  name,
  placeholder,
  value,
  onChange,
  maxLength,
  icon,
  type,
  required,
  disabled,
  error,
  helperText,
  onBlur,
  endAdornment,
  autofill
}) => {
  if (!autofill) {
    return /* @__PURE__ */ jsx6(
      TextField2,
      {
        fullWidth: true,
        required,
        disabled,
        error,
        type,
        name,
        placeholder,
        helperText: helperText || void 0,
        value,
        onChange: (e) => onChange(e?.target?.value || ``),
        onBlur,
        slotProps: {
          htmlInput: {
            maxLength
          },
          input: {
            startAdornment: /* @__PURE__ */ jsx6(InputAdornment2, { position: "start", children: icon }),
            ...endAdornment ? { endAdornment } : {}
          }
        }
      }
    );
  }
  const { contacts, optionField, onSelect } = autofill;
  const options = optionField === "name" ? contacts : contacts.filter((c) => c?.[optionField]);
  return /* @__PURE__ */ jsx6(
    Autocomplete,
    {
      freeSolo: true,
      options,
      getOptionLabel: (option) => {
        if (typeof option === "string") return option;
        return option?.[optionField] || "";
      },
      value,
      onChange: (_, newValue) => {
        if (typeof newValue === "string") {
          onChange(newValue);
        } else if (newValue) {
          onSelect(newValue);
        }
      },
      onInputChange: (_, newInputValue) => {
        onChange(newInputValue);
      },
      renderInput: (params) => /* @__PURE__ */ jsx6(
        TextField2,
        {
          ...params,
          required,
          disabled,
          error,
          type,
          name,
          placeholder,
          onBlur,
          helperText,
          slotProps: {
            htmlInput: {
              ...params.inputProps,
              maxLength
            },
            input: {
              ...params.InputProps,
              startAdornment: /* @__PURE__ */ jsxs5(Fragment3, { children: [
                /* @__PURE__ */ jsx6(InputAdornment2, { position: "start", children: icon }),
                params.InputProps.startAdornment
              ] }),
              ...endAdornment ? {
                endAdornment: /* @__PURE__ */ jsxs5(Fragment3, { children: [
                  endAdornment,
                  params.InputProps.endAdornment
                ] })
              } : {}
            }
          }
        }
      )
    }
  );
};
var ContactField_default = ContactField;

// src/forms/contacts/contactsAutofill.ts
function uniqueContacts(data) {
  if (!data?.contactstomoves?.length) return [];
  const seen = /* @__PURE__ */ new Set();
  return data.contactstomoves.filter((ctm) => {
    if (seen.has(ctm?.contact?.id)) return false;
    seen.add(ctm?.contact?.id);
    return true;
  }).map((ctm) => ctm.contact);
}
function fillFromContact(contactInfo, end, contact) {
  return {
    ...contactInfo,
    [`${end}Name`]: contact.name || "",
    [`${end}Mobile`]: contact.mobile_number || "",
    [`${end}Landline`]: contact.landline_number || "",
    [`${end}Email`]: contact.email || ""
  };
}
function copyPickupToDelivery(contactInfo) {
  return {
    ...contactInfo,
    deliveryName: contactInfo?.pickupName || ``,
    deliveryMobile: contactInfo?.pickupMobile || ``,
    deliveryLandline: contactInfo?.pickupLandline || ``,
    deliveryEmail: contactInfo?.pickupEmail || ``,
    deliveryNotes: contactInfo?.pickupNotes || ``
  };
}

// src/forms/contacts/queries/getContactsByLocation.query.generated.ts
import { resolveExecutor as resolveExecutor15 } from "@hopdrive/sdk-core";
var GetContactsByLocationDocument = { "__text": "query getContactsByLocation($locationId: bigint!, $contactType: String!) {\n  contactstomoves(\n    where: {contact_type: {_eq: $contactType}, move: {lane: {_or: [{origin_location_id: {_eq: $locationId}}, {destination_location_id: {_eq: $locationId}}]}}}\n    order_by: {created_at: desc}\n    limit: 20\n  ) {\n    contact {\n      id\n      name\n      mobile_number\n      landline_number\n      email\n      notes\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getContactsByLocation" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contactType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contactstomoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contact_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contactType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "move" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "lane" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "origin_location_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "destination_location_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } } }] } }] }] } }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "created_at" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "20" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contact" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "mobile_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "landline_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "email" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }] } }] } }] } }] };

// src/forms/contacts/requiredContacts.ts
function requiredContacts(workflowsets, workflowsetId, type, enabled) {
  if (!enabled) return { pickup: false, delivery: false };
  const selectedWorkflowset = workflowsets?.find((w) => w?.id === workflowsetId);
  const contactsRequired = selectedWorkflowset?.confirmationset != null && type === "one-way";
  const confirmationFlow = selectedWorkflowset?.confirmationset?.confirmation_flow;
  return {
    pickup: !!(contactsRequired && confirmationFlow?.pickup && confirmationFlow.pickup.length > 0),
    delivery: !!(contactsRequired && confirmationFlow?.delivery && confirmationFlow.delivery.length > 0)
  };
}

// src/forms/contacts/MovePlannerContactInfoForm.tsx
import { Fragment as Fragment4, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var MovePlannerContactInfoForm = ({ contactInfo, setContactInfo }) => {
  const theme = useTheme5();
  const cls = useStyles5(theme);
  const host = useMovePlannerHost();
  const { contactsAutofill, confirmationContacts, notesLabelOptional } = host.capabilities;
  const { pickup, delivery, workflowsets, workflowsetId, validation, type, contactPrefillSameAsPickup } = useMovePlanner();
  const pickupMobileCheck = useMobilePhoneCheck("pickup mobile");
  const deliveryMobileCheck = useMobilePhoneCheck("delivery mobile");
  const [sameAsPickup, setSameAsPickup] = React5.useState(contactPrefillSameAsPickup ?? false);
  React5.useEffect(() => {
    if (contactPrefillSameAsPickup) setSameAsPickup(true);
  }, [contactPrefillSameAsPickup]);
  const { data: pickupContactsData } = useQuery(GetContactsByLocationDocument, {
    variables: {
      locationId: pickup?.id || 0,
      contactType: "pickup"
    },
    skip: !contactsAutofill || !pickup?.id
  });
  const { data: deliveryContactsData } = useQuery(GetContactsByLocationDocument, {
    variables: {
      locationId: delivery?.id || 0,
      contactType: "delivery"
    },
    skip: !contactsAutofill || !delivery?.id
  });
  const uniquePickupContacts = React5.useMemo(() => uniqueContacts(pickupContactsData), [pickupContactsData]);
  const uniqueDeliveryContacts = React5.useMemo(() => uniqueContacts(deliveryContactsData), [deliveryContactsData]);
  const required = requiredContacts(workflowsets, workflowsetId, type, confirmationContacts);
  const handleContactSelect = (end, contact) => {
    if (!contact || !setContactInfo) return;
    setContactInfo(fillFromContact(contactInfo, end, contact));
    if (contact.mobile_number) {
      const check = end === "pickup" ? pickupMobileCheck : deliveryMobileCheck;
      const mobile = end === "pickup" ? contactInfo?.pickupMobile : contactInfo?.deliveryMobile;
      setTimeout(() => check.verify(mobile), 100);
    }
  };
  const handleSameAsPickupChange = (checked) => {
    setSameAsPickup(checked);
    if (checked && setContactInfo) {
      setContactInfo(copyPickupToDelivery(contactInfo));
      if (contactInfo?.pickupMobile) {
        deliveryMobileCheck.verify(contactInfo?.deliveryMobile);
      }
    }
  };
  const setField = (field) => (value) => {
    if (setContactInfo) setContactInfo({ ...contactInfo, [field]: value });
  };
  const autofillFor = (end, optionField) => contactsAutofill ? {
    contacts: end === "pickup" ? uniquePickupContacts : uniqueDeliveryContacts,
    optionField,
    onSelect: (contact) => handleContactSelect(end, contact)
  } : void 0;
  const renderEnd = (end) => {
    const endRequired = required[end];
    const check = end === "pickup" ? pickupMobileCheck : deliveryMobileCheck;
    const location = end === "pickup" ? pickup : delivery;
    const title = end === "pickup" ? "Pickup" : "Delivery";
    const errors = validation?.contactInfo;
    const nameValid = end === "pickup" ? errors?.pickupName : errors?.deliveryName;
    const phoneValid = end === "pickup" ? errors?.pickupPhone : errors?.deliveryPhone;
    const emailValid = end === "pickup" ? errors?.pickupEmail : errors?.deliveryEmail;
    const phoneHelper = endRequired && !phoneValid ? "At least one phone number (mobile or landline) is required" : "";
    const optional = endRequired ? /* @__PURE__ */ jsx7("span", { className: cls.textFieldLabelRequired, children: " *" }) : " (Optional)";
    return /* @__PURE__ */ jsxs6(Fragment4, { children: [
      /* @__PURE__ */ jsx7("div", { className: cls.sectionTitle, children: /* @__PURE__ */ jsxs6(Typography3, { variant: "subtitle2", sx: { fontWeight: 600 }, children: [
        `${title} Contact (`,
        location?.name || "Not Selected",
        ")"
      ] }) }),
      /* @__PURE__ */ jsxs6("label", { className: cls.textFieldLabel, htmlFor: `${end}-contact-name`, children: [
        "Contact Name",
        endRequired && /* @__PURE__ */ jsx7("span", { className: cls.textFieldLabelRequired, children: " *" })
      ] }),
      /* @__PURE__ */ jsx7(
        ContactField_default,
        {
          required: endRequired,
          error: endRequired && !nameValid,
          name: `${end}-contact-name`,
          placeholder: `Enter ${end} contact name...`,
          helperText: endRequired && !nameValid ? "Contact name is required" : "",
          value: contactInfo?.[`${end}Name`] || "",
          onChange: setField(`${end}Name`),
          maxLength: 48,
          icon: /* @__PURE__ */ jsx7(BiUser, { style: { fontSize: 20 } }),
          autofill: autofillFor(end, "name")
        }
      ),
      /* @__PURE__ */ jsx7("div", { className: cls.spacer }),
      /* @__PURE__ */ jsxs6("label", { className: cls.textFieldLabel, htmlFor: `${end}-contact-mobile`, children: [
        "Mobile Phone Number",
        endRequired && /* @__PURE__ */ jsx7("span", { className: cls.textFieldLabelRequired, children: " *" })
      ] }),
      /* @__PURE__ */ jsx7(
        ContactField_default,
        {
          disabled: check.loading,
          error: endRequired && !phoneValid,
          type: "tel",
          name: `${end}-contact-mobile`,
          placeholder: `Enter ${end} mobile phone...`,
          onBlur: () => check.verify(contactInfo?.[`${end}Mobile`]),
          helperText: phoneHelper,
          value: contactInfo?.[`${end}Mobile`] || "",
          onChange: setField(`${end}Mobile`),
          maxLength: 14,
          icon: /* @__PURE__ */ jsx7(BiMobile, { style: { fontSize: 20 } }),
          endAdornment: /* @__PURE__ */ jsx7(PhoneCheckAdornment_default, { loading: check.loading, isMobile: check.isMobile }),
          autofill: autofillFor(end, "mobile_number")
        }
      ),
      /* @__PURE__ */ jsx7("div", { className: cls.spacer }),
      /* @__PURE__ */ jsxs6("label", { className: cls.textFieldLabel, htmlFor: `${end}-contact-landline`, children: [
        "Landline Phone Number",
        optional
      ] }),
      /* @__PURE__ */ jsx7(
        ContactField_default,
        {
          error: endRequired && !phoneValid,
          type: "tel",
          name: `${end}-contact-landline`,
          placeholder: `Enter ${end} landline phone...`,
          helperText: phoneHelper,
          value: contactInfo?.[`${end}Landline`] || "",
          onChange: setField(`${end}Landline`),
          maxLength: 14,
          icon: /* @__PURE__ */ jsx7(BiPhone, { style: { fontSize: 20 } }),
          autofill: autofillFor(end, "landline_number")
        }
      ),
      /* @__PURE__ */ jsx7("div", { className: cls.spacer }),
      /* @__PURE__ */ jsxs6("label", { className: cls.textFieldLabel, htmlFor: `${end}-contact-email`, children: [
        "Email Address",
        optional
      ] }),
      /* @__PURE__ */ jsx7(
        ContactField_default,
        {
          required: endRequired,
          error: endRequired && !emailValid,
          type: "email",
          name: `${end}-contact-email`,
          placeholder: `Enter ${end} contact email...`,
          helperText: endRequired && !emailValid ? "Valid email is required" : "",
          value: contactInfo?.[`${end}Email`] || "",
          onChange: setField(`${end}Email`),
          maxLength: 100,
          icon: /* @__PURE__ */ jsx7(BiEnvelope, { style: { fontSize: 20 } }),
          autofill: autofillFor(end, "email")
        }
      ),
      /* @__PURE__ */ jsx7("div", { className: cls.spacer }),
      /* @__PURE__ */ jsx7("label", { className: cls.textFieldLabel, htmlFor: `${end}-contact-notes`, children: notesLabelOptional ? "Notes (Optional)" : "Notes" }),
      /* @__PURE__ */ jsx7(
        TextField3,
        {
          fullWidth: true,
          multiline: true,
          rows: 3,
          name: `${end}-contact-notes`,
          placeholder: `Enter any notes or special instructions for ${end}...`,
          value: contactInfo?.[`${end}Notes`] || ``,
          onChange: (e) => setField(`${end}Notes`)(e?.target?.value || ``),
          slotProps: {
            htmlInput: {
              maxLength: 500
            },
            input: {
              startAdornment: /* @__PURE__ */ jsx7(InputAdornment3, { position: "start", children: /* @__PURE__ */ jsx7(BiNotepad, { style: { fontSize: 20, alignSelf: "flex-start", marginTop: "8px" } }) })
            }
          }
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs6("div", { className: cls.contactInfo, children: [
    /* @__PURE__ */ jsx7(InfoBlurb_default, { children: "Contact information for pickup and delivery locations. This information will be shared with the driver to help coordinate the move." }),
    /* @__PURE__ */ jsxs6("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsxs6("div", { className: cls.flexItem, children: [
        renderEnd("pickup"),
        /* @__PURE__ */ jsx7("div", { className: cls.spacer }),
        /* @__PURE__ */ jsx7("div", { className: cls.checkboxSection, children: /* @__PURE__ */ jsx7(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsx7(Checkbox, { checked: sameAsPickup, onChange: (e) => handleSameAsPickupChange(e?.target?.checked) }),
            label: /* @__PURE__ */ jsx7(Typography3, { variant: "body2", sx: { fontWeight: 500 }, children: "Delivery contact is the same as pickup contact" })
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx7("div", { className: cls.flexItem, children: renderEnd("delivery") })
    ] })
  ] });
};
var useStyles5 = (theme) => {
  return {
    contactInfo: css5`
      position: relative;
    `,
    sectionTitle: css5`
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 12px;
    `,
    textFieldLabel: css5`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelRequired: css5`
      color: ${theme?.palette?.error?.main};
    `,
    flex: css5`
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 12px;
      ${theme?.breakpoints?.down("md")} {
        flex-direction: column;
      }
    `,
    flexItem: css5`
      flex: 1;
      width: 100%;
    `,
    checkboxSection: css5`
      display: flex;

      padding: 0 12px;
      border: 1px solid ${theme?.palette?.divider};
      border-radius: 10px;
      background-color: ${theme?.palette?.action?.hover};
      width: 100%;
    `,
    spacer: css5`
      width: 100%;
      height: 12px;
    `
  };
};
var MovePlannerContactInfoForm_default = MovePlannerContactInfoForm;

// src/forms/consumer/MovePlannerConsumerForm.tsx
import React6 from "react";
import { css as css6 } from "@emotion/css";
import { useTheme as useTheme6, FormControl, InputAdornment as InputAdornment4, TextField as TextField4, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { BiClipboard, BiMobile as BiMobile2, BiSolidArrowFromBottom, BiUndo, BiUser as BiUser2 } from "react-icons/bi";
import { Fragment as Fragment5, jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var MovePlannerConsumerForm = () => {
  const theme = useTheme6();
  const cls = useStyles6(theme);
  const host = useMovePlannerHost();
  const connector = host.embed?.connector;
  const lockConsumerAction = !!host.embed?.settings.locks.consumerAction;
  const { roCapture } = host.capabilities;
  const customerConfig = host.rooftop.useCustomerConfig();
  const refLabel = customerConfig?.reference_num_label || "Reference ID";
  const {
    validation,
    type,
    consumer,
    vehicle1,
    vehicle2,
    additional1,
    additional2,
    setValidation,
    setConsumer,
    setVehicle1,
    setVehicle2,
    setAdditional1,
    setAdditional2,
    handleConnectorFetch
  } = useMovePlanner();
  const isRefRequired = getIsRefRequired(
    consumer?.action,
    customerConfig?.reference_num_required_for_pickup,
    customerConfig?.reference_num_required_for_return
  );
  const phoneCheck = useMobilePhoneCheck("mobile phone", { dedupe: !!connector });
  const loading = phoneCheck.loading;
  React6.useEffect(() => {
    const phone = consumer?.phone;
    if (connector && phone && validatePhone(phone)) {
      phoneCheck.verify(phone);
    }
  }, [consumer?.phone]);
  const action = consumer?.action || "pickup";
  const handleActionChange = (newAction) => {
    if (newAction === action) return;
    if (type === `concierge-loaner`) {
      const expectedFirst = newAction === "pickup" ? "loaner" : "consumer";
      if (consumer?.first !== expectedFirst && setValidation && setVehicle1 && setVehicle2 && setAdditional1 && setAdditional2) {
        setValidation({
          ...validation,
          vehicle1: validation?.vehicle2,
          vehicle2: validation?.vehicle1
        });
        setVehicle1({ ...vehicle2 });
        setVehicle2({ ...vehicle1 });
        setAdditional1({ ...additional2 });
        setAdditional2({ ...additional1 });
      }
      if (setConsumer) setConsumer({ ...consumer, action: newAction, first: expectedFirst });
    } else {
      if (setConsumer) setConsumer({ ...consumer, action: newAction });
    }
  };
  const nameHelper = !validation?.consumer?.name ? `Please enter your customer's name!` : ``;
  const phoneHelper = !validation?.consumer?.phone ? `Please enter your customer's mobile phone number!` : ``;
  const phoneAdornment = /* @__PURE__ */ jsx8(PhoneCheckAdornment_default, { loading, isMobile: phoneCheck.isMobile });
  if (type === `concierge` || type === `concierge-loaner`) {
    return /* @__PURE__ */ jsxs7("div", { className: cls.consumer, children: [
      /* @__PURE__ */ jsxs7("div", { className: cls.flex, children: [
        /* @__PURE__ */ jsx8("div", { className: cls.flexItem, children: connector ? /* @__PURE__ */ jsx8(
          connector.Field,
          {
            triggerType: "consumer-name",
            label: "Customer Name",
            name: "consumer-name",
            value: consumer?.name || "",
            onChange: (value) => {
              if (setConsumer) setConsumer({ ...consumer, name: value });
            },
            onSelect: (result) => {
              if (setConsumer) setConsumer({ ...consumer, name: String(result.displayValue || "") });
              if (handleConnectorFetch) handleConnectorFetch("consumer-detail", String(result.id));
            },
            placeholder: "Start typing customer name...",
            required: true,
            error: !validation?.consumer?.name,
            helperText: nameHelper
          }
        ) : /* @__PURE__ */ jsxs7(Fragment5, { children: [
          /* @__PURE__ */ jsxs7("label", { className: cls.textFieldLabel, htmlFor: "consumer-name", children: [
            "Customer Name",
            /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
          ] }),
          /* @__PURE__ */ jsx8(
            TextField4,
            {
              fullWidth: true,
              required: true,
              error: !validation?.consumer?.name,
              name: "consumer-name",
              placeholder: "Enter customer name...",
              helperText: nameHelper,
              value: consumer?.name || ``,
              onChange: (e) => {
                if (setConsumer) setConsumer({ ...consumer, name: e?.target?.value || `` });
              },
              slotProps: {
                htmlInput: {
                  maxLength: 48
                },
                input: {
                  startAdornment: /* @__PURE__ */ jsx8(InputAdornment4, { position: "start", children: /* @__PURE__ */ jsx8(BiUser2, { style: { fontSize: 20 } }) })
                }
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx8("div", { className: cls.flexItem, children: connector ? /* @__PURE__ */ jsx8(
          connector.Field,
          {
            triggerType: "consumer-phone",
            label: "Customer Mobile Phone",
            name: "consumer-phone",
            value: consumer?.phone || "",
            onChange: (value) => {
              if (setConsumer) setConsumer({ ...consumer, phone: value });
            },
            onSelect: (result) => {
              if (setConsumer) setConsumer({ ...consumer, phone: String(result.displayValue || "") });
              if (handleConnectorFetch) handleConnectorFetch("consumer-detail", String(result.id));
            },
            onBlur: () => phoneCheck.verify(consumer?.phone),
            placeholder: "Enter customer mobile phone number...",
            required: true,
            disabled: loading,
            error: !validation?.consumer?.phone,
            helperText: phoneHelper,
            inputType: "tel",
            maxLength: 14,
            startAdornment: /* @__PURE__ */ jsx8(BiMobile2, { style: { fontSize: 20 } }),
            endAdornment: phoneAdornment
          }
        ) : /* @__PURE__ */ jsxs7(Fragment5, { children: [
          /* @__PURE__ */ jsxs7("label", { className: cls.textFieldLabel, htmlFor: "consumer-phone", children: [
            "Customer Mobile Phone",
            /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
          ] }),
          /* @__PURE__ */ jsx8(
            TextField4,
            {
              fullWidth: true,
              required: true,
              disabled: loading,
              error: !validation?.consumer?.phone,
              type: "tel",
              name: "consumer-phone",
              placeholder: "Enter customer mobile phone number...",
              helperText: phoneHelper,
              value: consumer?.phone || ``,
              onChange: (e) => {
                if (setConsumer) setConsumer({ ...consumer, phone: e?.target?.value || `` });
              },
              onBlur: () => phoneCheck.verify(consumer?.phone),
              slotProps: {
                htmlInput: {
                  maxLength: 14
                },
                input: {
                  startAdornment: /* @__PURE__ */ jsx8(InputAdornment4, { position: "start", children: /* @__PURE__ */ jsx8(BiMobile2, { style: { fontSize: 20 } }) }),
                  endAdornment: phoneAdornment
                }
              }
            }
          )
        ] }) })
      ] }),
      roCapture ? /* @__PURE__ */ jsx8("div", { className: cls.flexAlt, children: /* @__PURE__ */ jsxs7("div", { className: cls.flexItem, children: [
        /* @__PURE__ */ jsxs7("label", { className: cls.textFieldLabel, htmlFor: "consumer-reference-id", children: [
          refLabel,
          isRefRequired ? /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" }) : null
        ] }),
        /* @__PURE__ */ jsx8(
          TextField4,
          {
            fullWidth: true,
            required: isRefRequired,
            error: !validation?.consumer?.referenceId,
            name: "consumer-reference-id",
            placeholder: `Enter ${refLabel}...`,
            helperText: !validation?.consumer?.referenceId ? `Please enter the ${refLabel}!` : ``,
            value: consumer?.referenceId || ``,
            onChange: (e) => {
              if (setConsumer) setConsumer({ ...consumer, referenceId: e?.target?.value || `` });
            },
            slotProps: {
              htmlInput: {
                maxLength: 48
              },
              input: {
                startAdornment: /* @__PURE__ */ jsx8(InputAdornment4, { position: "start", children: /* @__PURE__ */ jsx8(BiClipboard, { style: { fontSize: 20 } }) })
              }
            }
          }
        )
      ] }) }) : null,
      /* @__PURE__ */ jsx8("div", { className: cls.flexAlt, children: /* @__PURE__ */ jsx8("div", { className: cls.flexItem, children: /* @__PURE__ */ jsxs7(FormControl, { children: [
        /* @__PURE__ */ jsxs7("label", { className: cls.textFieldLabel, htmlFor: "consumer-action", children: [
          "The customer's vehicle needs to be...",
          /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
        ] }),
        /* @__PURE__ */ jsxs7(
          ToggleButtonGroup,
          {
            exclusive: true,
            value: action,
            onChange: (_event, value) => {
              if (value !== null) handleActionChange(value);
            },
            sx: {
              "& .MuiToggleButton-root.Mui-selected": {
                backgroundColor: "success.main",
                color: "success.contrastText",
                "&:hover": {
                  backgroundColor: "success.dark"
                }
              }
            },
            children: [
              /* @__PURE__ */ jsxs7(ToggleButton, { disabled: lockConsumerAction, value: "pickup", color: "success", children: [
                /* @__PURE__ */ jsx8(BiSolidArrowFromBottom, { style: { marginRight: 8 } }),
                "Brought in for service"
              ] }),
              /* @__PURE__ */ jsxs7(ToggleButton, { disabled: lockConsumerAction, value: "return", color: "success", children: [
                /* @__PURE__ */ jsx8(BiUndo, { style: { marginRight: 8 } }),
                "Returned to the customer"
              ] })
            ]
          }
        )
      ] }) }) })
    ] });
  }
  return null;
};
var useStyles6 = (theme) => {
  return {
    consumer: css6`
      position: relative;
      margin-top: 18px;
    `,
    textFieldLabel: css6`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelRequired: css6`
      color: ${theme?.palette?.error?.main};
    `,
    flex: css6`
      display: flex;
      align-items: center;
      gap: 12px;
      ${theme?.breakpoints?.down("sm")} {
        flex-direction: column;
      }
    `,
    flexAlt: css6`
      display: flex;
      align-items: center;
      gap: 12px;
      margin-top: 18px;
      ${theme?.breakpoints?.down("md")} {
        flex-direction: column;
      }
    `,
    flexItem: css6`
      flex: 1;
      width: 100%;
    `
  };
};
var MovePlannerConsumerForm_default = MovePlannerConsumerForm;

// src/forms/email/MovePlannerEmailForm.tsx
import React7 from "react";
import { css as css7 } from "@emotion/css";
import { useTheme as useTheme7, Chip, InputAdornment as InputAdornment5, TextField as TextField5 } from "@mui/material";
import { BiMailSend } from "react-icons/bi";

// src/forms/email/emailCopy.ts
var EMAIL_COPY = Object.freeze({
  "internal-team": {
    label: "Internal Team Email Notifications",
    placeholder: "Enter a team member email for pickup/delivery updates, then press enter...",
    appointmentPlaceholder: "Enter a team member email to receive appointment updates, then press enter..."
  },
  "emails-to-notify": {
    label: "Emails To Notify",
    placeholder: "Enter an email to notify on pickup and delivery, then press enter...",
    appointmentPlaceholder: "Enter an email to receive a copy of the appointment offer, then press enter..."
  }
});

// src/forms/email/MovePlannerEmailForm.tsx
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var maxEmailsLength = 5;
var MovePlannerEmailForm = ({ appointmentMode }) => {
  const theme = useTheme7();
  const cls = useStyles7(theme);
  const host = useMovePlannerHost();
  const copy = EMAIL_COPY[host.capabilities.emailCopy];
  const [input, setInput] = React7.useState(``);
  const { showEmailNotifications, validation, emails = [], setEmails } = useMovePlanner();
  const isValidEmail = (email) => validateEmail(email);
  const handleAddEmail = (value) => {
    setInput(``);
    if (!value) return;
    if (!isValidEmail(value)) {
      host.notify.warning(`Email entered was invalid and could not be added!`, { toastId: `move-planner-emails` });
      return;
    }
    if (emails?.includes(value)) {
      host.notify.warning(`Email was already added!`, { toastId: `move-planner-emails` });
      return;
    }
    const newEmails = [...emails, value];
    if (newEmails?.length > maxEmailsLength) {
      host.notify.warning(`You can only add up to ${maxEmailsLength} emails!`, { toastId: `move-planner-emails` });
      return;
    }
    if (setEmails) setEmails(newEmails);
  };
  const handleOnBlur = () => {
    handleAddEmail(input);
  };
  const handleOnKeyDown = (event) => {
    if (event?.key === `Enter`) {
      handleAddEmail(input);
    }
  };
  if (showEmailNotifications) {
    return /* @__PURE__ */ jsxs8("div", { className: cls.emails, children: [
      /* @__PURE__ */ jsxs8("label", { className: cls.textFieldLabel, htmlFor: "emails", children: [
        copy.label,
        " ",
        /* @__PURE__ */ jsxs8("span", { className: cls.textFieldLength, children: [
          "(",
          emails?.length || 0,
          "/",
          maxEmailsLength,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ jsx9(
        TextField5,
        {
          fullWidth: true,
          error: !validation?.emails,
          name: "emails",
          placeholder: appointmentMode ? copy.appointmentPlaceholder : copy.placeholder,
          helperText: !validation?.emails ? `Please do not enter more than 5 emails!` : ``,
          value: input,
          onChange: (e) => setInput(e?.target?.value || ``),
          onBlur: () => handleOnBlur(),
          onKeyDown: (e) => handleOnKeyDown(e),
          slotProps: {
            input: {
              startAdornment: /* @__PURE__ */ jsx9(InputAdornment5, { position: "start", children: /* @__PURE__ */ jsx9(BiMailSend, { style: { fontSize: 20 } }) })
            }
          }
        }
      ),
      emails?.length ? /* @__PURE__ */ jsx9("div", { className: cls.flex, children: emails?.map((email, index) => /* @__PURE__ */ jsx9(
        Chip,
        {
          label: email,
          onDelete: () => {
            const newEmails = emails?.filter((_, i) => i !== index);
            if (setEmails) setEmails(newEmails);
          }
        },
        `emails-${index}`
      )) }) : null
    ] });
  }
  return null;
};
var useStyles7 = (theme) => {
  return {
    emails: css7`
      position: relative;
      margin-top: 18px;
    `,
    textFieldLabel: css7`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLength: css7`
      color: ${theme?.palette?.text?.secondary};
    `,
    textFieldLabelRequired: css7`
      color: ${theme?.palette?.error?.main};
    `,
    flex: css7`
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: 6px;
    `
  };
};
var MovePlannerEmailForm_default = MovePlannerEmailForm;

// src/forms/lane/MovePlannerLaneForm.tsx
import React13 from "react";
import { useMutation as useMutation3 } from "@apollo/client";
import { css as css12, cx as cx2, keyframes as keyframes3 } from "@emotion/css";
import { Alert as Alert2, Button as Button3, useTheme as useTheme12, Tooltip as Tooltip4, Typography as Typography8 } from "@mui/material";
import {
  BiHeart as BiHeart2,
  BiLoaderCircle as BiLoaderCircle3,
  BiPencil,
  BiSolidErrorCircle,
  BiSolidHeart as BiSolidHeart2,
  BiSolidMapPin as BiSolidMapPin3,
  BiTransfer
} from "react-icons/bi";

// src/location/MovePlannerLocationSelect.tsx
import React9 from "react";
import { useMutation as useMutation2 } from "@apollo/client";
import { resolveLocation, suggestAddresses, createSessionToken } from "@hopdrive/sdk-lanes";

// src/location/NearbyLocationPickerModal.tsx
import React8 from "react";
import { css as css8 } from "@emotion/css";
import { useTheme as useTheme8, Button as Button2, Typography as Typography4, Box as Box2 } from "@mui/material";
import { BiSolidMapPin, BiPlus } from "react-icons/bi";
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var NearbyLocationPickerModal = ({ open, onClose, onSelectExisting, onCreateNew, candidates, geocodedAddress }) => {
  const { Modal } = useMovePlannerHost().components;
  return /* @__PURE__ */ jsx10(Modal, { open, width: "sm", children: open && geocodedAddress ? /* @__PURE__ */ jsx10(
    NearbyLocationPickerContent,
    {
      onClose,
      onSelectExisting,
      onCreateNew,
      candidates,
      geocodedAddress
    }
  ) : null });
};
var NearbyLocationPickerContent = ({ onClose, onSelectExisting, onCreateNew, candidates, geocodedAddress }) => {
  const { ModalHeader, ModalContent, ModalFooter } = useMovePlannerHost().components;
  const theme = useTheme8();
  const cls = useStyles8(theme);
  const [selectedOption, setSelectedOption] = React8.useState(null);
  const geocodedKey = geocodedAddress?.formattedAddress?.toLowerCase().replace(/[^a-z0-9]/g, "") || "";
  const existingMatchesGeocoded = candidates.some((c) => {
    const candidateKey = c.location.address?.toLowerCase().replace(/[^a-z0-9]/g, "") || "";
    return candidateKey === geocodedKey;
  });
  const optionKeys = React8.useMemo(() => {
    const keys = candidates.map((c) => `existing-${c.location.id}`);
    if (!existingMatchesGeocoded) keys.push("create-new");
    return keys;
  }, [candidates, existingMatchesGeocoded]);
  const handleConfirm = () => {
    if (!selectedOption) return;
    if (selectedOption === "create-new") {
      onCreateNew();
    } else {
      const candidate = candidates.find((c) => `existing-${c.location.id}` === selectedOption);
      if (candidate) onSelectExisting(candidate.location);
    }
  };
  const handleKeyDown = (e) => {
    e.stopPropagation();
    if (e.key === "Escape") {
      e.preventDefault();
      onClose();
      return;
    }
    if (e.key === "Enter" && selectedOption) {
      e.preventDefault();
      handleConfirm();
      return;
    }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      const currentIndex = selectedOption ? optionKeys.indexOf(selectedOption) : -1;
      let nextIndex;
      if (e.key === "ArrowDown") {
        nextIndex = currentIndex < optionKeys.length - 1 ? currentIndex + 1 : 0;
      } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : optionKeys.length - 1;
      }
      setSelectedOption(optionKeys[nextIndex]);
    }
  };
  const containerRef = React8.useRef(null);
  React8.useEffect(() => {
    containerRef.current?.focus();
  }, []);
  return /* @__PURE__ */ jsxs9(Box2, { ref: containerRef, tabIndex: -1, onKeyDown: handleKeyDown, sx: { outline: "none" }, children: [
    /* @__PURE__ */ jsx10(ModalHeader, { handleClose: onClose, children: "Similar Location Found" }),
    /* @__PURE__ */ jsx10(
      ModalContent,
      {
        subtitle: `You entered "${geocodedAddress?.streetAddress}". A similar location already exists nearby. Would you like to use it or create a new location?`,
        children: /* @__PURE__ */ jsxs9(Box2, { children: [
          candidates.map((candidate) => {
            const key = `existing-${candidate.location.id}`;
            const isSelected = selectedOption === key;
            const distanceLabel = candidate.distanceMeters != null ? `~${Math.round(candidate.distanceMeters)}m away` : null;
            const scoreLabel = `${Math.round(candidate.score * 100)}% match`;
            return /* @__PURE__ */ jsxs9(
              Box2,
              {
                className: `${cls.card} ${isSelected ? cls.cardSelected : ""}`,
                onClick: () => setSelectedOption(key),
                role: "button",
                tabIndex: 0,
                children: [
                  /* @__PURE__ */ jsxs9(Box2, { className: cls.cardHeader, children: [
                    /* @__PURE__ */ jsx10(BiSolidMapPin, { size: 20, color: theme?.palette?.primary?.main }),
                    /* @__PURE__ */ jsx10(Typography4, { variant: "subtitle1", fontWeight: 600, children: candidate.location.name || candidate.location.address })
                  ] }),
                  /* @__PURE__ */ jsxs9(Box2, { className: cls.cardDetails, children: [
                    /* @__PURE__ */ jsx10(Typography4, { variant: "body2", color: "text.secondary", children: candidate.location.address }),
                    /* @__PURE__ */ jsx10(Typography4, { variant: "caption", color: "text.secondary", children: [distanceLabel, scoreLabel].filter(Boolean).join(" \u2022 ") })
                  ] })
                ]
              },
              key
            );
          }),
          !existingMatchesGeocoded && /* @__PURE__ */ jsxs9(
            Box2,
            {
              className: `${cls.card} ${selectedOption === "create-new" ? cls.cardSelected : ""}`,
              onClick: () => setSelectedOption("create-new"),
              role: "button",
              tabIndex: 0,
              children: [
                /* @__PURE__ */ jsxs9(Box2, { className: cls.cardHeader, children: [
                  /* @__PURE__ */ jsx10(BiPlus, { size: 20, color: theme?.palette?.success?.main }),
                  /* @__PURE__ */ jsx10(Typography4, { variant: "subtitle1", fontWeight: 600, children: geocodedAddress?.formattedAddress?.split(",")[0] || geocodedAddress?.streetAddress })
                ] }),
                /* @__PURE__ */ jsxs9(Box2, { className: cls.cardDetails, children: [
                  /* @__PURE__ */ jsx10(Typography4, { variant: "body2", color: "text.secondary", children: geocodedAddress?.formattedAddress }),
                  /* @__PURE__ */ jsx10(Typography4, { variant: "caption", color: "text.secondary", children: "Create as a new location" })
                ] })
              ]
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ jsxs9(ModalFooter, { children: [
      /* @__PURE__ */ jsx10(Button2, { variant: "text", color: "utility", onClick: onClose, children: "Cancel" }),
      /* @__PURE__ */ jsx10(Button2, { variant: "contained", color: "primary", disabled: !selectedOption, onClick: handleConfirm, children: "Confirm" })
    ] })
  ] });
};
var useStyles8 = (theme) => ({
  card: css8`
    width: 100%;
    padding: 16px 20px;
    margin-bottom: 12px;
    border: 2px solid ${theme?.palette?.divider};
    border-radius: 12px;
    background-color: ${theme?.palette?.background?.paper};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    cursor: pointer;
    user-select: none;
    transition:
      border-color 0.2s ease-in-out,
      background-color 0.2s ease-in-out,
      box-shadow 0.2s ease-in-out;

    &:hover {
      background-color: ${theme?.palette?.action?.hover};
    }

    &:focus {
      outline: 2px solid ${theme?.palette?.primary?.main};
      outline-offset: 2px;
    }
  `,
  cardSelected: css8`
    border-color: ${theme?.palette?.primary?.main};
    background-color: ${theme?.palette?.action?.selected};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  `,
  cardHeader: css8`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    width: 100%;
    pointer-events: none;
  `,
  cardDetails: css8`
    width: 100%;
    padding-left: 28px;
    pointer-events: none;
  `
});
var NearbyLocationPickerModal_default = NearbyLocationPickerModal;

// src/location/locationResolution.ts
var findSuiteSiblings = (resolved, locations = []) => {
  if (!resolved?.address_line_one) return null;
  const siblings = locations?.filter(
    (l) => l?.id !== resolved.id && l?.address_line_one?.toLowerCase() === resolved.address_line_one?.toLowerCase()
  );
  if (!siblings || siblings.length === 0) return null;
  const allLocations = [resolved, ...siblings];
  return {
    candidates: allLocations.map((l) => ({
      location: l,
      score: 1,
      distanceMeters: 0
    })),
    geocoded: {
      streetAddress: resolved.address_line_one || "",
      formattedAddress: resolved.address || "",
      lat: resolved.latitude || 0,
      lng: resolved.longitude || 0,
      placeId: resolved.place_id || void 0
    }
  };
};
var findExactGeocodedCandidate = (candidates, geocoded) => {
  const normalize = (s) => s?.toLowerCase().replace(/[^a-z0-9]/g, "") || "";
  const geocodedKey = normalize(geocoded?.formattedAddress);
  if (!geocodedKey || candidates.length !== 1) return null;
  const only = candidates[0];
  return normalize(only?.location?.address) === geocodedKey ? only.location : null;
};

// src/utils/addressMatchUtils.ts
var getStreetNumber = (address) => {
  const match = (address || ``).trim().match(/^(\d+)(?:-\d+)?\b/);
  return match ? match[1] : null;
};
var normalizeForPrefix = (value) => (value || ``).toLowerCase().trim().replace(/[.,]/g, ``).replace(/\s+/g, ` `);
var findPrefixMatch = (predictions, typed) => {
  const key = normalizeForPrefix(typed);
  if (!key) return void 0;
  return predictions.find((s) => normalizeForPrefix(s.fullText).startsWith(key));
};
var hasStreetNumberMismatch = (requestedAddress, resolved) => getStreetNumber(requestedAddress) !== getStreetNumber(resolved?.address_line_one || resolved?.address);
var classifyStreetNumber = (requestedAddress, resolved, geocodedStreetAddress) => {
  const requested = getStreetNumber(requestedAddress);
  if (requested === getStreetNumber(resolved?.address_line_one || resolved?.address)) return "match";
  if (!geocodedStreetAddress) return "different-location";
  return getStreetNumber(geocodedStreetAddress) === requested ? "different-location" : "address-not-found";
};
var addressNotFoundMessage = (requestedAddress, geocodedStreetAddress) => {
  const number = getStreetNumber(requestedAddress);
  const road = (geocodedStreetAddress || (requestedAddress || ``).split(`,`)[0] || `that address`).trim().replace(/^\d+(?:-\d+)?\s+/, ``) || `that address`;
  return `Google has no record of ${number ? `${number} ` : ``}${road}. Check the street number, or choose an address from the suggestions.`;
};

// src/location/queries/updateMovePlannerLocationFavorite.mutation.generated.ts
import { resolveExecutor as resolveExecutor16 } from "@hopdrive/sdk-core";
var UpdateMovePlannerLocationFavoriteDocument = { "__text": "mutation updateMovePlannerLocationFavorite($locationId: bigint!, $favoriteFlag: Boolean!) {\n  update_locations(\n    where: {id: {_eq: $locationId}}\n    _set: {favorite: $favoriteFlag}\n  ) {\n    affected_rows\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateMovePlannerLocationFavorite" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "favoriteFlag" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_locations" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "locationId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "favorite" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "favoriteFlag" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };

// src/location/MovePlannerLocationSelect.tsx
import { css as css9, cx, keyframes as keyframes2 } from "@emotion/css";
import { useTheme as useTheme9, Autocomplete as Autocomplete2, InputAdornment as InputAdornment6, MenuItem, TextField as TextField6, Tooltip as Tooltip2, Typography as Typography5 } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { BiHeart, BiLoaderCircle as BiLoaderCircle2, BiLogoGoogle, BiSolidHeart, BiSolidMapPin as BiSolidMapPin2 } from "react-icons/bi";
import { Fragment as Fragment6, jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
import { createElement } from "react";
var MovePlannerLocationSelect = ({
  rooftopId,
  required,
  disabled,
  loading: loadingProp = false,
  error,
  name = `location-select`,
  label = ``,
  placeholder = `Select location...`,
  helperText = ``,
  locations = [],
  location,
  onLocationChange,
  onLocationFavorite,
  nameOverride,
  displayValue,
  ...rest
}) => {
  const log = true;
  const theme = useTheme9();
  const cls = useStyles9(theme);
  const host = useMovePlannerHost();
  const [updateLocationFavorite] = useMutation2(UpdateMovePlannerLocationFavoriteDocument);
  const [internalError, setInternalError] = React9.useState(false);
  const [internalErrorText, setInternalErrorText] = React9.useState(``);
  const [loading, setLoading] = React9.useState(false);
  const resolvingRef = React9.useRef(false);
  const [userInput, setUserInput] = React9.useState(``);
  const [pickerOpen, setPickerOpen] = React9.useState(false);
  const [pickerCandidates, setPickerCandidates] = React9.useState([]);
  const [pickerGeocoded, setPickerGeocoded] = React9.useState(void 0);
  const [pendingResolveParams, setPendingResolveParams] = React9.useState(null);
  const { suggestions: sdkSuggestions, loading: loadingGoogle, search, clear } = host.transport.useAddressSuggestions();
  const showLoading = loadingProp || loading;
  const mappedSuggestions = sdkSuggestions.map((s) => ({
    name: s.mainText,
    address: s.fullText,
    place_id: s.placeId
  }));
  React9.useEffect(() => {
    const display = displayValue === "address" ? location?.address || location?.name : location?.name || location?.address;
    setUserInput(display || ``);
  }, [location, displayValue]);
  const showAddressNotFoundError = (requestedAddress, geocodedStreetAddress) => {
    setLoading(false);
    setUserInput(requestedAddress);
    setInternalError(true);
    setInternalErrorText(addressNotFoundMessage(requestedAddress, geocodedStreetAddress));
  };
  const promptOnStreetNumberMismatch = (requestedAddress, resolved, params) => {
    setPickerCandidates([{ location: resolved, score: 1, distanceMeters: 0 }]);
    setPickerGeocoded(
      params?.geocoded ?? {
        streetAddress: requestedAddress.split(`,`)[0]?.trim() || requestedAddress,
        formattedAddress: requestedAddress,
        lat: resolved?.latitude || 0,
        lng: resolved?.longitude || 0,
        placeId: resolved?.place_id || ``,
        plusCode: ``
      }
    );
    setPendingResolveParams({
      address: requestedAddress,
      name: params?.name,
      placeId: params?.placeId
    });
    setLoading(false);
    setPickerOpen(true);
  };
  const handleLocationChange = async (selectedLocation, isNewLocation) => {
    if (selectedLocation?.id) {
      if (!isNewLocation) {
        const siblingResult = findSuiteSiblings(selectedLocation, locations);
        if (siblingResult) {
          setPickerCandidates(siblingResult.candidates);
          setPickerGeocoded(siblingResult.geocoded);
          setPendingResolveParams({
            address: selectedLocation?.address || "",
            placeId: selectedLocation?.place_id || void 0
          });
          setPickerOpen(true);
          return;
        }
      }
      if (onLocationChange) onLocationChange(selectedLocation, isNewLocation);
      return;
    }
    if (!selectedLocation?.id) {
      if (selectedLocation?.place_id || selectedLocation?.address) {
        const existingLocation = locations?.find(
          (l) => l?.place_id === selectedLocation?.place_id || l?.address === selectedLocation?.address
        );
        if (existingLocation) {
          const siblingResult = findSuiteSiblings(existingLocation, locations);
          if (siblingResult) {
            setPickerCandidates(siblingResult.candidates);
            setPickerGeocoded(siblingResult.geocoded);
            setPendingResolveParams({
              address: selectedLocation?.address || existingLocation?.address || "",
              placeId: selectedLocation?.place_id || existingLocation?.place_id || void 0
            });
            setPickerOpen(true);
            return;
          }
          if (onLocationChange) onLocationChange(existingLocation, isNewLocation);
          return;
        }
        await handleBuildAndUpsertLocationFromSuggestion(selectedLocation);
        return;
      }
    }
    if (onLocationChange) onLocationChange(selectedLocation, isNewLocation);
  };
  const handleInputChange = (value, reason) => {
    setInternalError(false);
    setInternalErrorText(``);
    setUserInput(value);
    if (reason === `input`) {
      search(value);
    } else {
      clear();
    }
  };
  const handleFavoriteChange = async () => {
    setLoading(true);
    if (location?.id && !loading) {
      try {
        const res = await updateLocationFavorite({
          variables: { locationId: location?.id, favoriteFlag: !location?.favorite || false }
        });
        const resSuccess = res?.data?.update_locations?.affected_rows !== 0;
        if (resSuccess && onLocationFavorite) await onLocationFavorite(location, !location?.favorite || false);
      } catch (err) {
        console.error(`Failed to favorite location:`, err);
      }
    }
    setLoading(false);
  };
  const handleFocusEnter = async () => {
    setInternalError(false);
    setInternalErrorText(``);
  };
  const handleFocusExit = async () => {
    if (resolvingRef.current) return;
    if (!location?.id && userInput?.length >= 3 && !pickerOpen && !internalError) {
      await handleBuildAndUpsertLocationFromAddress(userInput);
    }
  };
  const handleBuildAndUpsertLocationFromSuggestion = async (selectedLoc) => {
    setLoading(true);
    const sdkSuggestion = sdkSuggestions.find((s) => s.placeId === selectedLoc?.place_id);
    const address = sdkSuggestion?.fullText || selectedLoc?.address || ``;
    const ADDRESS_TYPES = ["street_address", "route", "premise", "subpremise", "geocode"];
    const isPlainAddress = !!sdkSuggestion?.types?.some((t) => ADDRESS_TYPES.includes(t)) && !sdkSuggestion?.types?.includes("establishment");
    const resolvedName = nameOverride?.trim() || (isPlainAddress ? void 0 : selectedLoc?.name || void 0);
    try {
      const result = await resolveLocation({
        address,
        customerId: rooftopId,
        name: resolvedName,
        placeId: sdkSuggestion?.placeId || selectedLoc?.place_id || void 0
      });
      if (!result.location) {
        if (result.candidates?.length && result.geocoded) {
          const exact = findExactGeocodedCandidate(result.candidates, result.geocoded);
          if (exact && !hasStreetNumberMismatch(address, exact)) {
            setLoading(false);
            if (onLocationChange) onLocationChange(JSON.parse(JSON.stringify(exact)), false);
            return;
          }
          setPickerCandidates(result.candidates);
          setPickerGeocoded(result.geocoded);
          setPendingResolveParams({
            address,
            name: resolvedName,
            placeId: sdkSuggestion?.placeId || selectedLoc?.place_id || void 0
          });
          setLoading(false);
          setPickerOpen(true);
          return;
        }
        throw new Error(`Location could not be resolved`);
      }
      const verdict = classifyStreetNumber(
        address,
        result.location,
        result.geocoded?.streetAddress
      );
      if (verdict === "address-not-found") {
        showAddressNotFoundError(address, result.geocoded?.streetAddress);
        return;
      }
      if (verdict === "different-location") {
        promptOnStreetNumberMismatch(address, result.location, {
          name: resolvedName,
          placeId: sdkSuggestion?.placeId || selectedLoc?.place_id || void 0,
          geocoded: result.geocoded
        });
        return;
      }
      const siblingResult = findSuiteSiblings(result.location, locations);
      if (siblingResult) {
        setPickerCandidates(siblingResult.candidates);
        setPickerGeocoded(result.geocoded ?? siblingResult.geocoded);
        setPendingResolveParams({
          address,
          name: resolvedName,
          placeId: sdkSuggestion?.placeId || selectedLoc?.place_id || void 0
        });
        setLoading(false);
        setPickerOpen(true);
        return;
      }
      setLoading(false);
      const mutableLocation = JSON.parse(JSON.stringify(result.location));
      handleLocationChange(mutableLocation, true);
      console.log(`[Click to go to Move Details](${host.config.adminUrl}moves/${result.location.id})`);
      if (!result.location.region_id) {
        try {
          const variables = {
            type: `action`,
            title: `Region null for ${result.location.name} (ID: ${result.location.id})`,
            body: `New location ${result.location.name} (ID: ${result.location.id}) was created with a null region ID. Try refetching the region from the location's details page, which you can find by clicking the link in the notes below.`,
            notes: `[Click to go to Move Details](${host.config.adminUrl}moves/${result.location.id})`,
            createdat: `now()`,
            createdby: `location-build.dealer`
          };
          await host.transport.writeAdminNotification(variables);
          log && console.log("notification written", variables.title);
        } catch (err) {
          console.error(`Failed to create notification:`, err);
        }
      }
    } catch (err) {
      console.error(`Failed to resolve location:`, err);
      setLoading(false);
      setInternalError(true);
      setInternalErrorText(`Failed to build location! If this problem persists, please contact us.`);
    }
  };
  const handleBuildAndUpsertLocationFromAddress = async (input) => {
    if (resolvingRef.current) return;
    resolvingRef.current = true;
    setLoading(true);
    let matchingSuggestion = findPrefixMatch(sdkSuggestions, input);
    if (!matchingSuggestion && input && input.length >= 3) {
      try {
        const sessionToken = createSessionToken();
        const freshResult = await suggestAddresses({
          input,
          sessionToken,
          includedRegionCodes: ["us"]
        });
        matchingSuggestion = findPrefixMatch(freshResult.predictions ?? [], input);
      } catch (err) {
        console.error(`Failed to fetch fresh suggestions on blur:`, err);
      }
    }
    const address = matchingSuggestion?.fullText || input || ``;
    try {
      const result = await resolveLocation({
        address,
        customerId: rooftopId,
        placeId: matchingSuggestion?.placeId || void 0
      });
      if (!result.location) {
        if (result.candidates?.length && result.geocoded) {
          const exact = findExactGeocodedCandidate(result.candidates, result.geocoded);
          if (exact && !hasStreetNumberMismatch(address, exact)) {
            setLoading(false);
            if (onLocationChange) onLocationChange(JSON.parse(JSON.stringify(exact)), false);
            return;
          }
          setPickerCandidates(result.candidates);
          setPickerGeocoded(result.geocoded);
          setPendingResolveParams({
            address,
            placeId: matchingSuggestion?.placeId || void 0
          });
          setLoading(false);
          setPickerOpen(true);
          return;
        }
        throw new Error(`Location could not be resolved`);
      }
      const verdict = classifyStreetNumber(
        address,
        result.location,
        result.geocoded?.streetAddress
      );
      if (verdict === "address-not-found") {
        showAddressNotFoundError(address, result.geocoded?.streetAddress);
        return;
      }
      if (verdict === "different-location") {
        promptOnStreetNumberMismatch(address, result.location, {
          placeId: matchingSuggestion?.placeId || void 0,
          geocoded: result.geocoded
        });
        return;
      }
      const siblingResult = findSuiteSiblings(result.location, locations);
      if (siblingResult) {
        setPickerCandidates(siblingResult.candidates);
        setPickerGeocoded(result.geocoded ?? siblingResult.geocoded);
        setPendingResolveParams({
          address,
          placeId: matchingSuggestion?.placeId || void 0
        });
        setLoading(false);
        setPickerOpen(true);
        return;
      }
      setLoading(false);
      const mutableLocation = JSON.parse(JSON.stringify(result.location));
      handleLocationChange(mutableLocation, true);
      console.log(`[Click to go to Move Details](${host.config.adminUrl}moves/${result.location.id})`);
      if (!result.location.region_id) {
        try {
          const variables = {
            type: `action`,
            title: `Region null for ${result.location.name} (ID: ${result.location.id})`,
            body: `New location ${result.location.name} (ID: ${result.location.id}) was created with a null region ID. Try refetching the region from the location's details page, which you can find by clicking the link in the notes below.`,
            notes: `[Click to go to Move Details](${host.config.adminUrl}moves/${result.location.id})`,
            createdat: `now()`,
            createdby: `location-build.dealer`
          };
          await host.transport.writeAdminNotification(variables);
          log && console.log("notification written", variables.title);
        } catch (err) {
          console.error(`Failed to create notification:`, err);
        }
      }
    } catch (err) {
      console.error(`Failed to resolve location from address:`, err);
      setLoading(false);
      setInternalError(true);
      setInternalErrorText(
        `Failed to build location based on the address provided! Please provide a full address or select from the ${host.capabilities.googleSuggestionsCopy ? `Google suggestions` : `suggestions`} in the list. If this problem persists, please contact us.`
      );
    } finally {
      resolvingRef.current = false;
    }
  };
  const handlePickerSelectExisting = (location2) => {
    setPickerOpen(false);
    const mutableLocation = JSON.parse(JSON.stringify(location2));
    if (onLocationChange) onLocationChange(mutableLocation, false);
  };
  const handlePickerCancel = () => {
    setPickerOpen(false);
    setLoading(false);
    setPickerCandidates([]);
    setPickerGeocoded(void 0);
    setPendingResolveParams(null);
  };
  const handlePickerCreateNew = async () => {
    setPickerOpen(false);
    if (!pendingResolveParams) return;
    setLoading(true);
    try {
      const result = await resolveLocation({
        address: pendingResolveParams.address,
        customerId: rooftopId,
        name: pendingResolveParams.name,
        placeId: pendingResolveParams.placeId,
        addressLineTwo: pendingResolveParams.addressLineTwo,
        resolution: { forceCreate: true }
      });
      if (!result.location) throw new Error("Location could not be created");
      if (hasStreetNumberMismatch(pendingResolveParams.address, result.location)) {
        showAddressNotFoundError(pendingResolveParams.address, result.geocoded?.streetAddress);
        return;
      }
      setLoading(false);
      const mutableLocation = JSON.parse(JSON.stringify(result.location));
      handleLocationChange(mutableLocation, true);
    } catch (err) {
      console.error("Failed to create location:", err);
      setLoading(false);
      setInternalError(true);
      setInternalErrorText("Failed to build location! If this problem persists, please contact us.");
    }
  };
  const InputIcon = () => {
    const tooltipText = !location?.id ? `` : location?.favorite ? `Unfavorite Location` : `Favorite Location`;
    return /* @__PURE__ */ jsx11(Tooltip2, { title: tooltipText, placement: "top", followCursor: false, children: /* @__PURE__ */ jsx11("div", { children: showLoading || loadingGoogle ? /* @__PURE__ */ jsx11(BiLoaderCircle2, { className: cx(cls.icon, cls.iconLoader), size: 20 }) : !location?.id ? /* @__PURE__ */ jsx11(BiSolidMapPin2, { className: cls.icon, size: 20 }) : location?.favorite ? /* @__PURE__ */ jsx11(BiSolidHeart, { className: cx(cls.icon, cls.iconHeartFull), size: 20 }) : /* @__PURE__ */ jsx11(BiHeart, { className: cx(cls.icon, cls.iconHeart), size: 20 }) }) });
  };
  const MenuItemIcon = ({ option }) => {
    return /* @__PURE__ */ jsx11(Fragment6, { children: option?.id ? option?.favorite ? /* @__PURE__ */ jsx11(Tooltip2, { placement: "top", title: "Favored Location", children: /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(BiSolidHeart, { className: cx(cls.icon, cls.optionIcon_favorite), size: 20 }) }) }) : /* @__PURE__ */ jsx11(Tooltip2, { placement: "top", title: "Stored Location", children: /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(BiSolidMapPin2, { className: cx(cls.icon, cls.optionIcon_db), size: 20 }) }) }) : /* @__PURE__ */ jsx11(Tooltip2, { placement: "top", title: "Google-Suggested Location", children: /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11(BiLogoGoogle, { className: cx(cls.icon, cls.optionIcon_google), size: 20 }) }) }) });
  };
  return /* @__PURE__ */ jsxs10(Fragment6, { children: [
    label ? /* @__PURE__ */ jsxs10("label", { className: cls.locationLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx11("span", { className: cls.locationLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx11(
      NearbyLocationPickerModal_default,
      {
        open: pickerOpen,
        onClose: handlePickerCancel,
        onSelectExisting: handlePickerSelectExisting,
        onCreateNew: handlePickerCreateNew,
        candidates: pickerCandidates,
        geocodedAddress: pickerGeocoded ?? null
      }
    ),
    /* @__PURE__ */ jsx11(
      Autocomplete2,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        disabled: disabled || showLoading,
        loading: locations?.length ? false : true,
        loadingText: `Loading locations...`,
        noOptionsText: `No locations found`,
        options: locations.concat(mappedSuggestions),
        filterOptions: (options, state) => {
          const localFilter = createFilterOptions({
            stringify: (option) => `${option?.name || ""} ${option?.nickname || ""} ${option?.address || ""}`
          });
          const storedOptions = options.filter((o) => o?.id);
          const googleOptions = options.filter((o) => !o?.id);
          return [...localFilter(storedOptions, state), ...googleOptions];
        },
        renderOption: (props, option) => /* @__PURE__ */ createElement(MenuItem, { ...props, key: `location-builder-${option?.id || option?.place_id}`, value: option?.id ?? void 0 }, /* @__PURE__ */ jsxs10("div", { className: cls.option, children: [
          /* @__PURE__ */ jsx11(MenuItemIcon, { option }),
          /* @__PURE__ */ jsxs10("div", { className: cls.optionBlock, children: [
            /* @__PURE__ */ jsx11(Typography5, { variant: "body2", sx: { display: `block`, fontWeight: 500 }, children: option?.name }),
            /* @__PURE__ */ jsx11(Typography5, { variant: "caption", sx: { display: `block`, color: theme?.palette?.text?.secondary }, children: option?.address })
          ] })
        ] })),
        getOptionKey: (option) => option?.id || 0,
        getOptionLabel: (option) => option?.name || option?.address || "",
        isOptionEqualToValue: (option, value) => option?.id === value?.id || option?.place_id === value?.place_id,
        value: location,
        inputValue: userInput,
        onChange: (event, value) => {
          if (typeof value === "string") {
            handleBuildAndUpsertLocationFromAddress(value);
            return;
          }
          handleLocationChange(value);
        },
        onInputChange: (event, value, reason) => handleInputChange(value, reason),
        onFocus: () => handleFocusEnter(),
        onBlur: () => handleFocusExit(),
        renderInput: (params) => /* @__PURE__ */ jsx11(
          TextField6,
          {
            ...params,
            fullWidth: true,
            disabled: disabled || showLoading,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              input: {
                ...params?.InputProps,
                onKeyDown: (e) => {
                  if (e?.key === `Enter` && sdkSuggestions.length === 0 && !showLoading) {
                    e?.stopPropagation();
                    handleFocusExit();
                  }
                },
                startAdornment: /* @__PURE__ */ jsx11(
                  InputAdornment6,
                  {
                    position: "start",
                    onClick: () => handleFavoriteChange(),
                    sx: { marginLeft: `8px`, marginRight: 0, cursor: `pointer` },
                    children: /* @__PURE__ */ jsx11(InputIcon, {})
                  }
                )
              }
            }
          }
        ),
        sx: showLoading ? { userSelect: `none`, pointerEvents: `none` } : void 0
      }
    )
  ] });
};
var useStyles9 = (theme) => {
  const loader = keyframes2`
    0% {
      opacity: 1;
      rotate: 0deg;
    }
    6.25% {
      opacity: 0.5;
    }
    12.5% {
      opacity: 1;
    }
    18.75% {
      opacity: 0.5;
    }
    25% {
      opacity: 1;
    }
    31.25% {
      opacity: 0.5;
    }
    37.5% {
      opacity: 1;
    }
    43.75% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
      rotate: 180deg;
    }
    56.25% {
      opacity: 0.5;
    }
    62.5% {
      opacity: 1;
    }
    68.75% {
      opacity: 0.5;
    }
    75% {
      opacity: 1;
    }
    81.25% {
      opacity: 0.5;
    }
    87.5% {
      opacity: 1;
    }
    93.75% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      rotate: 360deg;
    }
  `;
  const styles = {
    locationLabel: css9`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    locationLabelRequired: css9`
      color: ${theme?.palette?.error?.main};
    `,
    locationIcon: css9`
      margin-left: 8px;
      margin-right: -6px;
      font-size: 18px;
      color: ${theme?.palette?.action?.active};
    `,
    locationIconDisabled: css9`
      color: ${theme?.palette?.action?.disabled};
    `,
    option: css9`
      display: flex;
      align-items: center;
      gap: 12px;
    `,
    optionIcon_db: css9`
      color: ${theme?.palette?.text?.secondary};
    `,
    optionIcon_favorite: css9`
      color: ${theme?.palette?.error?.main};
    `,
    optionIcon_google: css9`
      color: ${theme?.palette?.text?.disabled};
    `,
    optionBlock: css9`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    `,
    iconHeart: css9`
      :hover {
        color: ${theme?.palette?.error?.main};
      }
    `,
    iconHeartFull: css9`
      color: ${theme?.palette?.error?.main};
    `,
    iconLoader: css9`
      animation: ${loader} 5s linear infinite;
      user-select: none;
      pointer-events: none;
    `,
    iconDisabled: css9`
      color: ${theme?.palette?.action?.disabled};
      user-select: none;
      pointer-events: none;
    `,
    icon: css9`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      transition: 0.1s ease-in-out;
    `
  };
  return styles;
};
var MovePlannerLocationSelect_default = MovePlannerLocationSelect;

// src/estimates/MovePlannerLaneEstimates.tsx
import React11 from "react";
import { useLazyQuery as useLazyQuery2 } from "@apollo/client";

// src/estimates/intendedProductMessage.ts
import { productLabel as productLabel2 } from "@hopdrive/sdk-products/catalog";
function intendedProductMessage(intended) {
  switch (intended.outcome) {
    case "ambiguous":
      return `${chooseProduct(intended.candidates)} for this move to estimate and place it.`;
    case "none-owned":
      return `Your rooftop is not set up for this move type yet. Contact your HopDrive representative to add it, or choose a different move type.`;
    case "unavailable":
      return `${productLabel2(intended.productKey ?? "")} is not accepting new move requests for your rooftop right now. Contact your HopDrive representative.`;
    default:
      return null;
  }
}
function chooseProduct(candidates) {
  return candidates.length > 0 ? productChoicePrompt(candidates) : "Choose the product";
}

// src/estimates/laneEstimateColumns.ts
var LANE_ESTIMATE_COLUMN = {
  DISTANCE: "distance",
  DURATION: "duration",
  RATE: "rate",
  PRICE: "price",
  /** Stands in for rate and price when a program coverage contract prices the move. */
  PROGRAM_PRICE: "program_price"
};
function laneEstimateColumns(input) {
  const columns = [];
  if (input.showDistanceEstimates) columns.push(LANE_ESTIMATE_COLUMN.DISTANCE, LANE_ESTIMATE_COLUMN.DURATION);
  if (!input.showPriceEstimates) return columns;
  if (input.programGoverns) {
    columns.push(LANE_ESTIMATE_COLUMN.PROGRAM_PRICE);
    return columns;
  }
  if (input.showDistanceEstimates) columns.push(LANE_ESTIMATE_COLUMN.RATE);
  columns.push(LANE_ESTIMATE_COLUMN.PRICE);
  return columns;
}

// src/estimates/selectEstimateBand.ts
import { productKeyScope, resolveContractRule } from "@hopdrive/sdk-ar";
function selectEstimateBand(rows, productKey) {
  const byRule = /* @__PURE__ */ new Map();
  for (const row of rows) {
    const ruleId = row.contract_rule?.id;
    if (ruleId == null) continue;
    const rule = byRule.get(ruleId) ?? { id: ruleId, product_key: row.contract_rule?.product_key ?? null, raterules: [] };
    rule.raterules.push(row);
    byRule.set(ruleId, rule);
  }
  const rules = [...byRule.values()].map((rule) => ({
    ...rule,
    name: null,
    schema_key: null,
    config: {},
    raterules: rule.raterules.map((r) => ({ id: r.id, distance_start: r.distance_start ?? null, distance_end: null }))
  }));
  if (rules.length === 0) return { outcome: "none" };
  const resolved = resolveContractRule({
    rules,
    criteria: { carriesBands: true },
    scope: productKeyScope(productKey),
    context: { purpose: "move planner estimate" }
  });
  if (!("rule" in resolved)) {
    const ids = (resolved.metadata ?? {}).candidateContractRuleIds ?? [];
    return { outcome: "ambiguous", candidateContractRuleIds: ids };
  }
  const chosen = byRule.get(resolved.rule.id);
  return { outcome: "selected", band: chosen.raterules[0], contractRuleId: chosen.id, selection: resolved.selection };
}

// src/estimates/estimatePresentedEvent.ts
var ESTIMATE_PRESENTED_EVENT = "appointment.estimate.presented";
function estimatePresentedKey({ rooftopId, lane, type, workflowsetId, price }) {
  if (!lane?.pickup?.id || !lane?.delivery?.id) return null;
  return `${rooftopId ?? ""}|${lane.pickup.id}|${lane.delivery.id}|${type ?? ""}|${workflowsetId ?? ""}|${price}`;
}
function estimatePresentedPayload(input, actorEmail) {
  const { rooftopId, lane, type, workflowsetId, distance, duration, rateText, price, showDistanceEstimates, showPriceEstimates, programGoverns } = input;
  return {
    user: actorEmail || "dealer",
    role: "dealer",
    customer_id: rooftopId ?? void 0,
    lane_id: lane?.id ?? void 0,
    metadata: {
      type,
      workflowset_id: workflowsetId,
      pickup_location_id: lane?.pickup?.id,
      delivery_location_id: lane?.delivery?.id,
      distance_miles: distance,
      duration_min: duration,
      rate_text: rateText,
      price,
      show_distance_estimates: !!showDistanceEstimates,
      show_price_estimates: !!showPriceEstimates,
      program_governs: programGoverns
    },
    safeWithResponse: true
  };
}

// src/estimates/useIntendedProduct.ts
import React10 from "react";

// src/estimates/intendedFor.ts
function effectiveKeyDecides({ switchOn, offeringKnown }) {
  return !switchOn && offeringKnown;
}
function intendedFor(effectiveKey, resolved, source) {
  if (effectiveKey) return { outcome: "selected", productKey: effectiveKey, candidates: [effectiveKey], loading: false };
  if (effectiveKeyDecides(source)) return { outcome: "undecided", productKey: null, candidates: [], loading: !source.offeredTypesKnown };
  return resolved;
}

// src/estimates/useIntendedProduct.ts
var IDLE = { outcome: "undecided", productKey: null, candidates: [], loading: false };
function useIntendedProduct() {
  const host = useMovePlannerHost();
  const ctx = React10.useContext(MovePlannerContext);
  const rooftopId = ctx?.rooftopId;
  const type = ctx?.type;
  const direction = ctx?.consumer?.action ?? null;
  const effectiveKey = ctx?.effectiveProductKey ?? null;
  const source = {
    switchOn: host.capabilities.productChoiceSwitch,
    offeringKnown: !!ctx?.offering,
    offeredTypesKnown: !!ctx?.offeredTypes
  };
  const keyDecides = effectiveKeyDecides(source);
  const facts = host.products.useRooftopFacts(rooftopId);
  const ownedProductKeys = facts.heldValetKeys;
  const snapshotLoading = facts.loading;
  const canCreate = facts.canCreate;
  const [state, setState] = React10.useState(IDLE);
  React10.useEffect(() => {
    if (effectiveKey || keyDecides || typeof rooftopId !== "number" || rooftopId <= 0 || !type) {
      setState(IDLE);
      return;
    }
    if (snapshotLoading) {
      setState({ ...IDLE, loading: true });
      return;
    }
    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true }));
    resolveIntendedProduct({
      type,
      direction,
      ownedProductKeys,
      // The facts are the product service's own verdict for this rooftop
      // (`docs/patterns/product-service.md`). A product they do not carry is
      // not re-derived here: it counts as orderable, exactly as the Action
      // treats a product it was not asked about.
      canCreateNew: canCreate
    }).then((result) => {
      if (!cancelled) setState({ ...result, loading: false });
    }).catch((err) => {
      console.error("useIntendedProduct: could not resolve the intended product", err);
      if (!cancelled) setState(IDLE);
    });
    return () => {
      cancelled = true;
    };
  }, [effectiveKey, keyDecides, rooftopId, type, direction, ownedProductKeys, canCreate, snapshotLoading]);
  return intendedFor(effectiveKey, state, source);
}

// src/estimates/queries/getMovePlannerRaterule.query.generated.ts
import { resolveExecutor as resolveExecutor17 } from "@hopdrive/sdk-core";
var GetMovePlannerRateruleDocument = { "__text": 'query getMovePlannerRaterule($rooftopId: bigint!, $distance: numeric!, $class: String!, $workflowsetId: bigint!) {\n  raterules(\n    where: {customer_id: {_eq: $rooftopId}, distance_start: {_lte: $distance}, distance_end: {_gte: $distance}, class: {_eq: $class}, contract_rule: {active: {_eq: true}, contract: {begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}], workflowset_id: {_eq: $workflowsetId}}}}\n  ) {\n    id\n    rate\n    flat_rate\n    distance_start\n    type\n    contract_rule {\n      id\n      product_key\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getMovePlannerRaterule" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "distance" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "numeric" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "class" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "distance_start" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "distance" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "distance_end" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "distance" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "class" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "class" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_rule" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "contract" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } } }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rule" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }] } }] } }] } }] };

// src/estimates/MovePlannerLaneEstimates.tsx
import { css as css10 } from "@emotion/css";
import { useTheme as useTheme10, Collapse, LinearProgress as LinearProgress2, Typography as Typography6, Alert, CircularProgress, Tooltip as Tooltip3 } from "@mui/material";
import { Fragment as Fragment7, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var NO_PROGRAM = { programGoverns: false, quote: null, loading: false };
var PROGRAM_PRICE_TOOLTIP = "At your program's rates. See Program Coverage above for how it splits.";
var PROGRAM_PRICE_PENDING_TOOLTIP = "Finish entering the vehicle to see the price.";
var MovePlannerLaneEstimates = ({
  showDistanceEstimates,
  showPriceEstimates,
  rooftopId,
  type,
  lane,
  workflowsetId,
  appointmentMode,
  productKey
}) => {
  const theme = useTheme10();
  const cls = useStyles10(theme);
  const host = useMovePlannerHost();
  const { programCoverage, appointmentMode: appointmentEvents, priceNoteFullWidth } = host.capabilities;
  const [showEstimates, setShowEstimates] = React11.useState(false);
  const [distance, setDistance] = React11.useState(0);
  const [duration, setDuration] = React11.useState(0);
  const [rateText, setRateText] = React11.useState(``);
  const [price, setPrice] = React11.useState(0);
  const [loading, setLoading] = React11.useState(false);
  const [error, setError] = React11.useState(false);
  const [errorText, setErrorText] = React11.useState(``);
  const lastPresentedKeyRef = React11.useRef(null);
  const [getRaterule] = useLazyQuery2(GetMovePlannerRateruleDocument);
  const intended = useIntendedProduct();
  const effectiveProductKey2 = productKey ?? intended.productKey;
  const productMessage = intended.loading ? null : intendedProductMessage(intended);
  const { programGoverns, quote, loading: quoteLoading, priceReady = true } = programCoverage && host.programs ? host.programs.useCoverageQuote() : NO_PROGRAM;
  const programMoveCost = priceReady ? quote?.projectedMoneyFlow.totalCost ?? null : null;
  const columns = laneEstimateColumns({
    showDistanceEstimates: !!showDistanceEstimates,
    showPriceEstimates: !!showPriceEstimates,
    programGoverns
  });
  const showColumn = (column) => columns.includes(column);
  const gaveUp = React11.useContext(MovePlannerContext)?.laneLifecycle?.gaveUp ?? false;
  const isCalculating = host.lanes.laneNeedsEnrichment(lane);
  const fetchEstimates = async (existingRaterule) => {
    setLoading(true);
    const distance2 = lane?.distance_miles || 0;
    const duration2 = (lane?.duration_sec || 0) / 60;
    const moveClass = type === `round-trip` ? `base` : `stranded`;
    let raterule = existingRaterule || null;
    const existingRateruleWorkflowsetMatch = existingRaterule?.contract_rule?.contract?.workflowset_id === workflowsetId;
    try {
      if (!existingRaterule || !existingRateruleWorkflowsetMatch) {
        const res = await getRaterule({ variables: { rooftopId: rooftopId || 0, distance: distance2, class: moveClass, workflowsetId: workflowsetId || 0 } });
        const selected = selectEstimateBand(res.data?.raterules ?? [], effectiveProductKey2);
        if (selected.outcome === "selected") raterule = selected.band;
        else if (selected.outcome === "ambiguous") {
          setError(true);
          setErrorText(`Several pricing rules apply to this rooftop, so a rate cannot be estimated yet. Rules ${selected.candidateContractRuleIds.join(", ")}.`);
        }
      }
    } catch (err) {
      console.error(`Error fetching raterule:`, err);
      setError(true);
      setErrorText(`Failed to fetch lane estimates. If this problem persists, please contact us.`);
    }
    const generateRateText = (raterule2) => {
      if (raterule2?.type === `flatPlusPer`) return `$${raterule2?.flat_rate?.toFixed(2)} Flat + $${raterule2?.rate?.toFixed(2)} / mi`;
      else if (raterule2?.type === `per`) return `$${raterule2?.rate?.toFixed(2)} / mi`;
      else if (raterule2?.type === `flat`) return `$${raterule2?.flat_rate?.toFixed(2)} Flat`;
      else return `$0.00 Flat`;
    };
    setDistance(distance2);
    setDuration(duration2);
    setRateText(generateRateText(raterule));
    const startDistance = raterule?.distance_start || 0;
    if (raterule?.type === `per`) setPrice((raterule?.rate || 0) * distance2);
    else if (raterule?.type === `flat`) setPrice(raterule?.flat_rate || 0);
    else if (raterule?.type === `flatPlusPer`) setPrice((raterule?.flat_rate || 0) + (raterule?.rate || 0) * (distance2 - startDistance));
    else setPrice(0);
    setLoading(false);
  };
  React11.useEffect(() => {
    setError(false);
    setErrorText(``);
    if (lane?.pickup && lane?.delivery && (showDistanceEstimates || showPriceEstimates)) {
      setShowEstimates(true);
      fetchEstimates();
    } else setShowEstimates(false);
  }, [type, lane, showDistanceEstimates, showPriceEstimates, workflowsetId, effectiveProductKey2]);
  React11.useEffect(() => {
    if (!appointmentMode || !appointmentEvents || !host.events) return;
    if (!showEstimates || loading || error) return;
    if (!showPriceEstimates) return;
    const presented = {
      rooftopId,
      lane,
      type,
      workflowsetId,
      distance,
      duration,
      rateText,
      price,
      showDistanceEstimates,
      showPriceEstimates,
      programGoverns
    };
    const key = estimatePresentedKey(presented);
    if (!key) return;
    if (lastPresentedKeyRef.current === key) return;
    lastPresentedKeyRef.current = key;
    Promise.resolve(host.events.logEvent(ESTIMATE_PRESENTED_EVENT, estimatePresentedPayload(presented, host.session.actorEmail))).catch(
      (err) => {
        console.error(`Failed to log appointment.estimate.presented event:`, err);
      }
    );
  }, [
    appointmentMode,
    appointmentEvents,
    showEstimates,
    loading,
    error,
    showPriceEstimates,
    showDistanceEstimates,
    lane,
    type,
    workflowsetId,
    rooftopId,
    price,
    distance,
    duration,
    rateText,
    host.events,
    host.session.actorEmail,
    programGoverns
  ]);
  return /* @__PURE__ */ jsx12(Collapse, { in: showEstimates && !loading && !gaveUp, children: /* @__PURE__ */ jsxs11(Fragment7, { children: [
    /* @__PURE__ */ jsx12(
      Typography6,
      {
        variant: "body2",
        sx: {
          marginTop: `18px`,
          marginBottom: `6px`,
          textAlign: `center`,
          fontWeight: 600,
          color: theme?.palette?.text?.disabled,
          userSelect: `none`
        },
        children: "LANE ESTIMATES"
      }
    ),
    error && errorText ? /* @__PURE__ */ jsx12(
      Typography6,
      {
        variant: "body1",
        sx: { marginBottom: `6px`, textAlign: `center`, color: theme?.palette?.error?.main },
        children: errorText
      }
    ) : loading ? /* @__PURE__ */ jsx12(LinearProgress2, {}) : isCalculating ? /* @__PURE__ */ jsxs11("div", { className: cls.calculating, children: [
      /* @__PURE__ */ jsx12(Typography6, { variant: "body1", sx: { fontWeight: 600 }, children: "Calculating lane estimates, please wait..." }),
      /* @__PURE__ */ jsx12(CircularProgress, { size: 18 })
    ] }) : productMessage && showPriceEstimates ? (
      // The Action would refuse this move, so the strip says so rather
      // than quoting a rate the invoice would not honour.
      /* @__PURE__ */ jsx12(
        Typography6,
        {
          variant: "body1",
          "data-testid": "lane-estimate-product-message",
          sx: { marginBottom: `6px`, textAlign: `center`, color: theme?.palette?.warning?.dark ?? theme?.palette?.text?.primary },
          children: productMessage
        }
      )
    ) : /* @__PURE__ */ jsxs11("div", { className: cls.estimates, children: [
      showColumn(LANE_ESTIMATE_COLUMN.DISTANCE) ? /* @__PURE__ */ jsxs11(Fragment7, { children: [
        /* @__PURE__ */ jsxs11("div", { className: cls.estimatesItem, children: [
          /* @__PURE__ */ jsx12(
            Typography6,
            {
              variant: "body2",
              sx: { fontSize: `10px`, fontWeight: 600, color: theme?.palette?.text?.disabled },
              children: "DISTANCE"
            }
          ),
          /* @__PURE__ */ jsxs11(Typography6, { variant: "body1", sx: { marginTop: `4px`, fontWeight: 600 }, children: [
            distance?.toFixed(1),
            " mi"
          ] })
        ] }),
        /* @__PURE__ */ jsxs11("div", { className: cls.estimatesItem, children: [
          /* @__PURE__ */ jsx12(
            Typography6,
            {
              variant: "body2",
              sx: { fontSize: `10px`, fontWeight: 600, color: theme?.palette?.text?.disabled },
              children: "DURATION"
            }
          ),
          /* @__PURE__ */ jsxs11(Typography6, { variant: "body1", sx: { marginTop: `4px`, fontWeight: 600 }, children: [
            duration?.toFixed(0),
            " min"
          ] })
        ] })
      ] }) : null,
      showColumn(LANE_ESTIMATE_COLUMN.PROGRAM_PRICE) ? /* @__PURE__ */ jsxs11("div", { className: cls.estimatesItem, children: [
        /* @__PURE__ */ jsx12(
          Typography6,
          {
            variant: "body2",
            sx: { fontSize: `10px`, fontWeight: 600, color: theme?.palette?.text?.disabled },
            children: "PRICE"
          }
        ),
        /* @__PURE__ */ jsx12(Tooltip3, { title: priceReady ? PROGRAM_PRICE_TOOLTIP : PROGRAM_PRICE_PENDING_TOOLTIP, placement: "top", arrow: true, children: /* @__PURE__ */ jsxs11(Typography6, { variant: "body1", sx: { marginTop: `4px`, fontWeight: 600, cursor: "help" }, children: [
          programMoveCost != null ? `$${programMoveCost.toFixed(2)}` : quoteLoading ? "\u2026" : "\u2014",
          programMoveCost != null && type === `round-trip` ? ` x2` : ``
        ] }) })
      ] }) : null,
      showColumn(LANE_ESTIMATE_COLUMN.RATE) ? /* @__PURE__ */ jsxs11("div", { className: cls.estimatesItem, children: [
        /* @__PURE__ */ jsx12(
          Typography6,
          {
            variant: "body2",
            sx: { fontSize: `10px`, fontWeight: 600, color: theme?.palette?.text?.disabled },
            children: "RATE"
          }
        ),
        /* @__PURE__ */ jsx12(Typography6, { variant: "body1", sx: { marginTop: `4px`, fontWeight: 600 }, children: rateText })
      ] }) : null,
      showColumn(LANE_ESTIMATE_COLUMN.PRICE) ? /* @__PURE__ */ jsxs11(Fragment7, { children: [
        /* @__PURE__ */ jsxs11("div", { className: cls.estimatesItem, children: [
          /* @__PURE__ */ jsx12(
            Typography6,
            {
              variant: "body2",
              sx: { fontSize: `10px`, fontWeight: 600, color: theme?.palette?.text?.disabled },
              children: "PRICE"
            }
          ),
          /* @__PURE__ */ jsxs11(Typography6, { variant: "body1", sx: { marginTop: `4px`, fontWeight: 600 }, children: [
            "$",
            price?.toFixed(2),
            type === `round-trip` ? ` x2` : ``
          ] })
        ] }),
        /* @__PURE__ */ jsx12(
          Alert,
          {
            severity: "info",
            ...priceNoteFullWidth ? { sx: { width: "100%", marginTop: `4px` } } : { style: { width: "fit-content" } },
            children: "Price estimates are based on vehicle weight classes 1 & 2. The price will increase for class 3 vehicles and above."
          }
        )
      ] }) : null
    ] })
  ] }) });
};
var useStyles10 = (theme) => {
  return {
    calculating: css10`
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
      margin-top: 18px;
      margin-bottom: 18px;
    `,
    estimates: css10`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 12px;
      width: 100%;
      margin-bottom: 6px;
    `,
    estimatesItem: css10`
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 128px;
      max-width: 256px;
      padding: 12px;
      border: 1px solid ${theme?.palette?.divider};
      border-radius: 10px;
      text-align: center;
      background-color: ${theme?.palette?.action?.hover};
    `
  };
};
var MovePlannerLaneEstimates_default = MovePlannerLaneEstimates;

// src/utils/laneRoleLabels.ts
var getLaneRoles = (type, consumerAction) => {
  if (type === "concierge") {
    return consumerAction === "pickup" ? { pickup: "customer", delivery: "service" } : { pickup: "service", delivery: "customer" };
  }
  if (type === "concierge-loaner") {
    return { pickup: "service", delivery: "customer" };
  }
  return { pickup: "pickup", delivery: "delivery" };
};
var capitalizeLaneRole = (role) => `${role.charAt(0).toUpperCase()}${role.slice(1)}`;
var getLaneRoleLocationLabel = (role) => `${capitalizeLaneRole(role)} Location`;

// src/forms/lane/laneBuild.ts
async function buildLanePair({ transport, customerId, pickup, delivery, reuse, isCurrent, label }) {
  const findPair = async () => {
    const { forward, inverse } = await transport.findLanePair({ customerId, pickupId: pickup.id, deliveryId: delivery.id });
    return forward && inverse && isCurrent() ? { kind: "reused", forward, inverse } : null;
  };
  try {
    if (reuse) {
      const existing = await findPair();
      if (existing) return existing;
      if (!isCurrent()) return { kind: "stale" };
    }
    const builtLanes = await transport.buildLaneAndInverse({ customerId, pickup, delivery });
    if (!isCurrent()) return { kind: "stale" };
    return builtLanes ? { kind: "built", lanes: builtLanes } : { kind: "not-built" };
  } catch (err) {
    console.error(`Failed to build ${label} lane:`, err);
    if (!isCurrent()) return { kind: "stale" };
    const errorMessage = err?.response?.data?.message || "";
    if (reuse && errorMessage.includes("Two lanes already exist")) {
      try {
        const recovered = await findPair();
        if (recovered) return recovered;
      } catch (recoveryErr) {
        console.error("Failed to recover by fetching existing lanes:", recoveryErr);
      }
    }
    return isCurrent() ? { kind: "failed" } : { kind: "stale" };
  }
}

// src/forms/lane/endpointFallback.ts
function resolveLaneEndpoint(locations, picked) {
  return locations?.find((l) => l?.id === picked.id) ?? picked;
}
function laneBuildResolution(locations, pickup, delivery, pickupLocation, deliveryLocation) {
  const pickupInLocations = !!locations?.find((l) => l?.id === pickup?.id);
  const deliveryInLocations = !!locations?.find((l) => l?.id === delivery?.id);
  return {
    pickupId: pickup?.id ?? null,
    deliveryId: delivery?.id ?? null,
    locationIds: locations?.map((l) => l?.id) ?? [],
    pickupInLocations,
    deliveryInLocations,
    usedPickupFallback: !pickupInLocations,
    usedDeliveryFallback: !deliveryInLocations,
    resolvedPickup: { id: pickupLocation?.id ?? null, hasName: !!pickupLocation?.name, hasAddress: !!pickupLocation?.address },
    resolvedDelivery: { id: deliveryLocation?.id ?? null, hasName: !!deliveryLocation?.name, hasAddress: !!deliveryLocation?.address }
  };
}

// src/forms/lane/MovePlannerLaneFavorites.tsx
import React12 from "react";
import { css as css11 } from "@emotion/css";
import { useTheme as useTheme11, Collapse as Collapse2, Typography as Typography7 } from "@mui/material";
import { BiRightArrowAlt } from "react-icons/bi";
import { Fragment as Fragment8, jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var MovePlannerLaneFavorites = ({ lanes, locations, setPickup, setDelivery }) => {
  const theme = useTheme11();
  const cls = useStyles11(theme);
  const [showFavorites, setShowFavorites] = React12.useState(false);
  const favoriteLanes = [...lanes]?.filter((l) => l?.favorite)?.sort((a, b) => {
    if (a?.pickup?.name < b?.pickup?.name) return -1;
    if (a?.pickup?.name > b?.pickup?.name) return 1;
    if (a?.pickup?.name === b?.pickup?.name) {
      if (a?.delivery?.name < b?.delivery?.name) return -1;
      if (a?.delivery?.name > b?.delivery?.name) return 1;
    }
    return 0;
  });
  const handleLaneSelect = (lane) => {
    if (lane) {
      const foundPickup = locations?.find((l) => l?.id === lane?.pickup?.id);
      const foundDelivery = locations?.find((l) => l?.id === lane?.delivery?.id);
      if (foundPickup && foundDelivery) {
        if (setPickup) setPickup(foundPickup);
        if (setDelivery) setDelivery(foundDelivery);
      }
    }
  };
  return /* @__PURE__ */ jsxs12(Fragment8, { children: [
    /* @__PURE__ */ jsx13(Collapse2, { in: showFavorites, children: /* @__PURE__ */ jsxs12(Fragment8, { children: [
      /* @__PURE__ */ jsx13(
        Typography7,
        {
          variant: "body2",
          onClick: () => setShowFavorites(!showFavorites),
          sx: {
            marginTop: `12px`,
            marginBottom: `6px`,
            textAlign: `center`,
            fontWeight: 600,
            color: theme?.palette?.text?.disabled,
            cursor: `pointer`,
            transition: `0.1s ease-in-out`,
            userSelect: `none`,
            "&:hover": {
              color: theme?.palette?.utility?.main
            }
          },
          children: "FAVORITE LANES"
        }
      ),
      /* @__PURE__ */ jsx13("div", { className: cls.favoriteList, children: favoriteLanes?.map((l) => {
        return /* @__PURE__ */ jsxs12(
          "div",
          {
            className: cls.favoriteItem,
            onClick: () => handleLaneSelect(l),
            children: [
              /* @__PURE__ */ jsxs12("div", { className: cls.favoriteItemLocation, children: [
                /* @__PURE__ */ jsx13(Typography7, { children: l?.pickup?.name }),
                /* @__PURE__ */ jsx13(Typography7, { variant: "caption", sx: { color: theme?.palette?.text?.secondary }, children: l?.pickup?.address })
              ] }),
              /* @__PURE__ */ jsx13(BiRightArrowAlt, { size: 28 }),
              /* @__PURE__ */ jsxs12("div", { className: cls.favoriteItemLocation, children: [
                /* @__PURE__ */ jsx13(Typography7, { children: l?.delivery?.name }),
                /* @__PURE__ */ jsx13(Typography7, { variant: "caption", sx: { color: theme?.palette?.text?.secondary }, children: l?.delivery?.address })
              ] })
            ]
          },
          `favorite-lane-${l?.id || `${l?.pickup?.id}-${l?.delivery?.id}`}`
        );
      }) })
    ] }) }),
    /* @__PURE__ */ jsx13("div", { className: cls.favoriteBtn, onClick: () => setShowFavorites(!showFavorites), children: /* @__PURE__ */ jsx13(
      Typography7,
      {
        variant: "caption",
        sx: { fontWeight: 600, color: theme?.palette?.text?.contrastPrimary, userSelect: `none` },
        children: showFavorites ? `HIDE FAVORITE LANES` : `SHOW FAVORITE LANES`
      }
    ) })
  ] });
};
var useStyles11 = (theme) => {
  return {
    favoriteBtn: css11`
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0;
      bottom: -28px;
      left: 0;
      right: 0;
      width: fit-content;
      padding: 4px 8px;
      border-radius: 6px;
      margin: 0 auto;
      background-color: ${theme?.palette?.utility?.main};
      cursor: pointer;
      transition: 0.1s ease-in-out;
      :hover {
        background-color: ${theme?.palette?.utility?.dark};
      }
    `,
    favoriteList: css11`
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 12px;
      border: 1px solid ${theme?.palette?.divider};
      border-radius: 10px;
      margin-bottom: 6px;
      background-color: ${theme?.palette?.action?.hover};
    `,
    favoriteItem: css11`
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      padding: 6px;
      border-radius: 6px;
      text-align: center;
      cursor: pointer;
      transition: 0.1s ease-in-out;
      :hover {
        background-color: ${theme?.palette?.action?.hover};
      }
    `,
    favoriteItemLocation: css11`
      flex: 1;
      width: 100%;
    `
  };
};
var MovePlannerLaneFavorites_default = MovePlannerLaneFavorites;

// src/forms/lane/queries/updateMovePlannerLaneFavorite.mutation.generated.ts
import { resolveExecutor as resolveExecutor18 } from "@hopdrive/sdk-core";
var UpdateMovePlannerLaneFavoriteDocument = { "__text": "mutation updateMovePlannerLaneFavorite($laneId: bigint!, $favoriteFlag: Boolean!) {\n  update_lanes(where: {id: {_eq: $laneId}}, _set: {favorite: $favoriteFlag}) {\n    affected_rows\n    returning {\n      id\n      favorite\n      origin_location_id\n      destination_location_id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateMovePlannerLaneFavorite" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "laneId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "favoriteFlag" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_lanes" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "laneId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "favorite" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "favoriteFlag" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "favorite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "origin_location_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "destination_location_id" } }] } }] } }] } }] };

// src/forms/lane/MovePlannerLaneForm.tsx
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var ServiceLocationDisplay = ({
  location,
  label,
  onOverride,
  styles
}) => /* @__PURE__ */ jsxs13("div", { children: [
  /* @__PURE__ */ jsxs13("label", { className: styles.serviceLabel, children: [
    label,
    " ",
    /* @__PURE__ */ jsx14("span", { className: styles.serviceLabelAuto, children: "(Auto-set)" })
  ] }),
  /* @__PURE__ */ jsxs13("div", { className: styles.serviceLocationBox, children: [
    /* @__PURE__ */ jsx14(BiSolidMapPin3, { className: styles.serviceLocationIcon, size: 20 }),
    /* @__PURE__ */ jsxs13("div", { className: styles.serviceLocationText, children: [
      /* @__PURE__ */ jsx14(Typography8, { variant: "body2", sx: { fontWeight: 500 }, children: location?.name || "Rooftop Location" }),
      /* @__PURE__ */ jsx14(Typography8, { variant: "caption", sx: { color: "text.secondary" }, children: location?.address || "No address available" })
    ] }),
    /* @__PURE__ */ jsx14(Tooltip4, { title: "Override service location", placement: "top", children: /* @__PURE__ */ jsx14("div", { className: styles.serviceOverrideBtn, onClick: onOverride, children: /* @__PURE__ */ jsx14(BiPencil, { size: 18 }) }) })
  ] })
] });
var MovePlannerLaneForm = ({ appointmentMode, mapVisible = true, laneMap: LaneMap }) => {
  const theme = useTheme12();
  const cls = useStyles12(theme);
  const host = useMovePlannerHost();
  const {
    serviceLocations: serviceLocationsOn,
    lanePairReuse,
    laneMap: laneMapOn,
    swapHiddenForValet,
    laneFailureCopy,
    laneEndpointsFromLocations
  } = host.capabilities;
  const {
    showDistanceEstimates,
    showPriceEstimates,
    validation,
    rooftopId,
    type,
    consumer,
    lanes,
    lane,
    locations,
    pickup,
    delivery,
    workflowsetId,
    laneLifecycle,
    setLanes,
    setLane,
    setLocations,
    setPickup,
    setDelivery,
    seedServiceFill
  } = useMovePlanner();
  const laneNotice = laneLifecycleNotice(laneLifecycle);
  const rooftop = host.rooftop.useWorkingRooftop();
  const [updateLaneFavorite] = useMutation3(UpdateMovePlannerLaneFavoriteDocument);
  const [loading, setLoading] = React13.useState(false);
  const [loadingFavoriteLane, setLoadingFavoriteLane] = React13.useState(false);
  const [error, setError] = React13.useState(false);
  const [errorText, setErrorText] = React13.useState(``);
  const lanePairKey = `${rooftopId}:${type}:${pickup?.id ?? ``}:${pickup?.address ?? ``}:${delivery?.id ?? ``}:${delivery?.address ?? ``}:${appointmentMode ? `appointment` : `standard`}`;
  const laneRequestRef = React13.useRef({ key: lanePairKey, generation: 0 });
  if (laneRequestRef.current.key !== lanePairKey) {
    laneRequestRef.current = {
      key: lanePairKey,
      generation: laneRequestRef.current.generation + 1
    };
  }
  const [serviceLocationOverride, setServiceLocationOverride] = React13.useState(false);
  const isConciergeType = type === "concierge" || type === "concierge-loaner";
  const serviceLocationPosition = React13.useMemo(() => {
    if (type === "concierge") {
      return consumer?.action === "pickup" ? "delivery" : "pickup";
    }
    if (type === "concierge-loaner") {
      return "pickup";
    }
    return null;
  }, [type, consumer?.action]);
  const isServiceLocationRooftop = React13.useMemo(() => {
    if (!serviceLocationsOn || !rooftop?.location?.id) return false;
    if (serviceLocationPosition === "pickup") {
      return pickup?.id === rooftop.location.id;
    }
    if (serviceLocationPosition === "delivery") {
      return delivery?.id === rooftop.location.id;
    }
    return false;
  }, [serviceLocationsOn, serviceLocationPosition, pickup?.id, delivery?.id, rooftop?.location?.id]);
  React13.useEffect(() => {
    const generation = laneRequestRef.current.generation;
    const pickupSnapshot = pickup;
    const deliverySnapshot = delivery;
    if (pickup?.id && delivery?.id) {
      const newLocations = [...locations || []];
      let locationsUpdated = false;
      if (!locations?.find((l) => l?.id === pickup?.id)) {
        newLocations.push(pickup);
        locationsUpdated = true;
      }
      if (!locations?.find((l) => l?.id === delivery?.id)) {
        newLocations.push(delivery);
        locationsUpdated = true;
      }
      if (locationsUpdated) {
        setLocations(newLocations);
      }
      const selectedLane = lanes?.find(
        (l) => Number(l?.customer_id) === rooftopId && l?.pickup?.id === pickup?.id && l?.pickup?.address === pickup?.address && l?.delivery?.id === delivery?.id && l?.delivery?.address === delivery?.address
      );
      if (selectedLane) {
        setLoading(false);
        setError(false);
        setLane({
          ...selectedLane,
          pickup,
          delivery
        });
      } else {
        setLane({ ...defaultLane, pickup: pickupSnapshot, delivery: deliverySnapshot });
        handleBuildOrFetchLane(
          appointmentMode ? "appointment" : "standard",
          generation,
          pickupSnapshot,
          deliverySnapshot
        );
      }
    } else {
      setLoading(false);
      setError(false);
      setLane({
        ...defaultLane,
        pickup: pickup ?? defaultLocation,
        delivery: delivery ?? defaultLocation
      });
    }
  }, [pickup, delivery, rooftopId, type, appointmentMode]);
  React13.useEffect(() => {
    if (!serviceLocationsOn) return;
    const result = computeServiceLocations({
      type,
      consumerAction: consumer?.action,
      pickup,
      delivery,
      rooftopLocation: rooftop?.location || null,
      serviceLocationOverride
    });
    if (!result) return;
    if (result.clearOverride) setServiceLocationOverride(false);
    setPickup(result.pickup);
    setDelivery(result.delivery);
    seedServiceFill?.({ type, consumerAction: consumer?.action, rooftopLocation: rooftop?.location || null });
  }, [type, consumer?.action, rooftop?.location, isConciergeType, serviceLocationOverride]);
  const handleLocationChange = (position, location, isNewLocation) => {
    const otherLocation = position === "pickup" ? delivery : pickup;
    const setter = position === "pickup" ? setPickup : setDelivery;
    if (location && location?.id !== otherLocation?.id) {
      if (isNewLocation && location?.id && !locations?.some((l) => l?.id === location.id)) {
        setLocations(locations?.length ? [...locations, location] : [location]);
      }
      setter(location);
    } else {
      setter(defaultLocation);
    }
  };
  const handleLocationsSwap = () => {
    if (!loading && !loadingFavoriteLane) {
      setPickup(delivery);
      setDelivery(pickup);
    }
  };
  const handleLocationsReset = () => {
    if (!loading && !loadingFavoriteLane) {
      const customerLocationId = rooftop?.location?.id;
      if (pickup?.id !== customerLocationId) setPickup(defaultLocation);
      if (delivery?.id !== customerLocationId) setDelivery(defaultLocation);
      setLane(defaultLane);
    }
  };
  const handleLaneFavorite = async () => {
    if (!loading && !loadingFavoriteLane) {
      setLoadingFavoriteLane(true);
      try {
        if (lane?.id) {
          const res = await updateLaneFavorite({ variables: { laneId: lane?.id, favoriteFlag: !lane?.favorite } });
          const resSuccess = res?.data?.update_lanes?.affected_rows !== 0;
          if (resSuccess) {
            const updatedLane = { ...lane, favorite: !lane?.favorite };
            setLanes(lanes?.map((l) => l?.id === lane?.id ? updatedLane : l));
            setLane(updatedLane);
          }
        } else if (pickup?.id && delivery?.id) {
          const updatedLane = { ...lane, favorite: !lane?.favorite };
          setLanes(
            lanes?.map((l) => l?.pickup?.id === pickup?.id && l?.delivery?.id === delivery?.id ? updatedLane : l)
          );
          setLane(updatedLane);
        }
      } catch (err) {
        console.error(`Failed to favorite lane:`, err);
      }
      setLoadingFavoriteLane(false);
    }
  };
  const handleLocationFavorite = async (location, favorite, type2) => {
    if (location) {
      const updatedLocation = { ...location, favorite };
      setLocations(locations?.map((l) => l?.id === location?.id ? updatedLocation : l));
      if (type2 === `pickup`) setPickup(updatedLocation);
      if (type2 === `delivery`) setDelivery(updatedLocation);
    }
  };
  const handleBuildOrFetchLane = async (mode, generation, pickupSnapshot, deliverySnapshot) => {
    const isCurrentRequest = () => generation === laneRequestRef.current.generation;
    if (!pickupSnapshot?.id || !deliverySnapshot?.id || pickupSnapshot.id === deliverySnapshot.id) {
      if (isCurrentRequest()) setLoading(false);
      return;
    }
    setLoading(true);
    setError(false);
    setErrorText(``);
    let pickupLocation = pickupSnapshot;
    let deliveryLocation = deliverySnapshot;
    if (laneEndpointsFromLocations) {
      pickupLocation = resolveLaneEndpoint(locations, pickupSnapshot);
      deliveryLocation = resolveLaneEndpoint(locations, deliverySnapshot);
      try {
        console.log(
          `[LaneBuild] ${appointmentMode ? `handleBuildAppointmentLane` : `handleBuildLane`} resolving lane locations`,
          laneBuildResolution(locations, pickupSnapshot, deliverySnapshot, pickupLocation, deliveryLocation)
        );
      } catch (err) {
        console.warn(`[LaneBuild] Failed to log lane build resolution:`, err);
      }
    }
    const result = await buildLanePair({
      transport: host.transport,
      customerId: rooftopId,
      pickup: pickupLocation,
      delivery: deliveryLocation,
      reuse: lanePairReuse,
      isCurrent: isCurrentRequest,
      label: mode
    });
    if (result.kind === "stale") return;
    if (result.kind === "reused") {
      const existingLanes = [result.forward, result.inverse];
      setLanes(lanes?.length ? [...lanes, ...existingLanes] : [...existingLanes]);
      setLane(result.forward);
    } else if (result.kind === "built") {
      const newLanes = lanes?.length ? [...lanes, ...result.lanes] : [...result.lanes];
      setLanes(newLanes);
      setLane(result.lanes[0]);
    } else if (result.kind === "failed") {
      setLoading(false);
      setError(true);
      setErrorText(`Failed to build lane! If this problem persists, please contact us.`);
      return;
    }
    setLoading(false);
  };
  const laneRoles = getLaneRoles(type, consumer?.action);
  const getPickupLocationTitle = (capitalize) => {
    const role = laneRoles.pickup;
    return capitalize ? role.charAt(0).toUpperCase() + role.slice(1) : role;
  };
  const getDeliveryLocationTitle = (capitalize) => {
    const role = laneRoles.delivery;
    return capitalize ? role.charAt(0).toUpperCase() + role.slice(1) : role;
  };
  return /* @__PURE__ */ jsxs13("div", { className: cls.lane, children: [
    type === `concierge` ? /* @__PURE__ */ jsx14(InfoBlurb_default, { children: consumer?.action === `pickup` ? `The vehicle will be picked up from the customer and brought to the service location.` : `The vehicle will be returned to the customer from the service location.` }) : null,
    type === `concierge-loaner` ? /* @__PURE__ */ jsx14(InfoBlurb_default, { children: consumer?.action === `pickup` ? `The loaner vehicle will be brought to the customer and the customer's vehicle will be picked up and brought to the service location.` : `The customer's vehicle will be returned to the customer and the loaner vehicle will be returned to the service location.` }) : null,
    type === `round-trip` ? /* @__PURE__ */ jsxs13(InfoBlurb_default, { children: [
      "The second move will be an inverse of this lane (Delivery ",
      `->`,
      " Pickup)."
    ] }) : null,
    laneMapOn && LaneMap && mapVisible && /* @__PURE__ */ jsx14(
      LaneMap,
      {
        locations,
        pickup,
        delivery,
        customerLocation: rooftop?.location,
        laneRoles,
        onReset: handleLocationsReset,
        onPickupSelect: (location) => handleLocationChange("pickup", location, false),
        onDeliverySelect: (location) => handleLocationChange("delivery", location, false),
        onPickupDeselect: () => {
          if (!loading && !loadingFavoriteLane) setPickup(defaultLocation);
        },
        onDeliveryDeselect: () => {
          if (!loading && !loadingFavoriteLane) setDelivery(defaultLocation);
        }
      }
    ),
    /* @__PURE__ */ jsxs13("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsx14("div", { className: cls.flexItem, children: isConciergeType && serviceLocationPosition === "pickup" && isServiceLocationRooftop && !serviceLocationOverride ? /* @__PURE__ */ jsx14(
        ServiceLocationDisplay,
        {
          location: pickup,
          label: `${getPickupLocationTitle(true)} Location`,
          onOverride: () => setServiceLocationOverride(true),
          styles: cls
        }
      ) : /* @__PURE__ */ jsx14(
        MovePlannerLocationSelect_default,
        {
          rooftopId,
          required: true,
          disabled: loading || loadingFavoriteLane,
          error: !validation?.pickup,
          label: `${getPickupLocationTitle(true)} Location`,
          placeholder: `Select the ${getPickupLocationTitle()} location...`,
          helperText: !validation?.pickup ? `Please select the ${getPickupLocationTitle()} location!` : pickup?.address || `No location selected`,
          locations: cleanseLocations(locations, delivery?.id ? [delivery?.id] : []),
          location: pickup,
          onLocationChange: (loc, isNew) => handleLocationChange("pickup", loc, isNew),
          onLocationFavorite: (location, favorite) => handleLocationFavorite(location, favorite, `pickup`)
        }
      ) }),
      /* @__PURE__ */ jsxs13("div", { className: cls.controls, children: [
        !(swapHiddenForValet && isConciergeType) && /* @__PURE__ */ jsx14("div", { className: cls.controlsItem, children: /* @__PURE__ */ jsx14(Tooltip4, { title: "Swap Pickup & Delivery", placement: "top", followCursor: false, children: /* @__PURE__ */ jsx14(
          "div",
          {
            className: cx2(cls.controlsSwap, !pickup?.id && !delivery?.id ? cls.controlsDisabled : null),
            onClick: () => handleLocationsSwap(),
            children: /* @__PURE__ */ jsx14(BiTransfer, { className: cls.iconSwap, size: 24 })
          }
        ) }) }),
        /* @__PURE__ */ jsx14("div", { className: cls.controlsItem, children: /* @__PURE__ */ jsx14(Tooltip4, { title: lane?.favorite ? `Unfavorite Lane` : `Favorite Lane`, placement: "top", followCursor: false, children: /* @__PURE__ */ jsx14(
          "div",
          {
            className: cx2(
              cls.controlsFavorite,
              !lane?.id && !lane?.pickup?.id && !lane?.delivery?.id ? cls.controlsDisabled : null
            ),
            onClick: () => handleLaneFavorite(),
            children: loading || loadingFavoriteLane ? /* @__PURE__ */ jsx14(BiLoaderCircle3, { className: cls.iconLoader, size: 24 }) : lane?.favorite ? /* @__PURE__ */ jsx14(BiSolidHeart2, { className: cls.iconHeartFull, size: 24 }) : /* @__PURE__ */ jsx14(BiHeart2, { className: cls.iconHeart, size: 24 })
          }
        ) }) })
      ] }),
      /* @__PURE__ */ jsx14("div", { className: cls.flexItem, children: isConciergeType && serviceLocationPosition === "delivery" && isServiceLocationRooftop && !serviceLocationOverride ? /* @__PURE__ */ jsx14(
        ServiceLocationDisplay,
        {
          location: delivery,
          label: `${getDeliveryLocationTitle(true)} Location`,
          onOverride: () => setServiceLocationOverride(true),
          styles: cls
        }
      ) : /* @__PURE__ */ jsx14(
        MovePlannerLocationSelect_default,
        {
          rooftopId,
          required: true,
          disabled: loading || loadingFavoriteLane,
          error: !validation?.delivery,
          label: `${getDeliveryLocationTitle(true)} Location`,
          placeholder: `Select the ${getDeliveryLocationTitle()} location...`,
          helperText: !validation?.delivery ? `Please select the ${getDeliveryLocationTitle()} location!` : delivery?.address || `No location selected`,
          locations: cleanseLocations(locations, pickup?.id ? [pickup?.id] : []),
          location: delivery,
          onLocationChange: (loc, isNew) => handleLocationChange("delivery", loc, isNew),
          onLocationFavorite: (location, favorite) => handleLocationFavorite(location, favorite, `delivery`)
        }
      ) })
    ] }),
    error && laneFailureCopy === "alert" && errorText ? /* @__PURE__ */ jsx14(Alert2, { severity: "error", sx: { mt: 2 }, children: errorText }) : null,
    error && laneFailureCopy === "route-box" ? /* @__PURE__ */ jsxs13("div", { className: cls.errorBox, children: [
      /* @__PURE__ */ jsx14(BiSolidErrorCircle, { className: cls.errorIcon, size: 20 }),
      /* @__PURE__ */ jsxs13(Typography8, { variant: "body2", sx: { color: "text.secondary", textWrap: "pretty", lineHeight: 1.6 }, children: [
        /* @__PURE__ */ jsx14(Typography8, { component: "span", variant: "body2", sx: { fontWeight: 600, color: "text.primary" }, children: "We couldn't build a route between these two locations." }),
        " ",
        "This usually fails when the map is unable to pin one of the addresses to an exact spot - for example, a street with no house number, or an incorrect house number that couldn't be matched to a street. Please validate the locations above and confirm that both show a full street address (re-select them from the suggestions if needed), then try again."
      ] })
    ] }) : null,
    laneNotice === "calculating" ? /* @__PURE__ */ jsx14(Alert2, { severity: "info", sx: { mt: 2 }, children: "Calculating the route. You can continue filling out the move details." }) : null,
    laneNotice === "stalled" ? /* @__PURE__ */ jsx14(Alert2, { severity: "warning", sx: { mt: 2 }, children: "Calculating the route is taking longer than usual. We're still working on it, and you can keep filling out the move details." }) : null,
    laneNotice === "gave-up" ? /* @__PURE__ */ jsx14(Alert2, { severity: "error", sx: { mt: 2 }, children: LANE_GAVE_UP_MESSAGE }) : null,
    laneNotice === "lost" ? /* @__PURE__ */ jsx14(Alert2, { severity: "error", sx: { mt: 2 }, children: "We lost track of the route calculation. Reload the page to check it again." }) : null,
    laneLifecycle && laneNotice === "failed" ? /* @__PURE__ */ jsx14(
      Alert2,
      {
        severity: "error",
        sx: { mt: 2 },
        action: /* @__PURE__ */ jsx14(Button3, { color: "inherit", size: "small", disabled: laneLifecycle.retrying, onClick: () => laneLifecycle.retry(), children: laneLifecycle.retrying ? `Retrying\u2026` : `Retry route` }),
        children: "Route calculation failed. Retry it or change either address."
      }
    ) : null,
    /* @__PURE__ */ jsx14(
      MovePlannerLaneEstimates_default,
      {
        showDistanceEstimates,
        showPriceEstimates,
        rooftopId,
        type,
        lane,
        workflowsetId,
        appointmentMode
      }
    ),
    /* @__PURE__ */ jsx14(MovePlannerLaneFavorites_default, { lanes, locations, setPickup, setDelivery })
  ] });
};
var useStyles12 = (theme) => {
  const loader = keyframes3`
    0% {
      opacity: 1;
      rotate: 0deg;
    }
    6.25% {
      opacity: 0.5;
    }
    12.5% {
      opacity: 1;
    }
    18.75% {
      opacity: 0.5;
    }
    25% {
      opacity: 1;
    }
    31.25% {
      opacity: 0.5;
    }
    37.5% {
      opacity: 1;
    }
    43.75% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
      rotate: 180deg;
    }
    56.25% {
      opacity: 0.5;
    }
    62.5% {
      opacity: 1;
    }
    68.75% {
      opacity: 0.5;
    }
    75% {
      opacity: 1;
    }
    81.25% {
      opacity: 0.5;
    }
    87.5% {
      opacity: 1;
    }
    93.75% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      rotate: 360deg;
    }
  `;
  return {
    lane: css12`
      position: relative;
    `,
    controls: css12`
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      border-radius: 6px;
      ${theme?.breakpoints?.down("md")} {
      }
    `,
    controlsItem: css12``,
    controlsSwap: css12`
      color: ${theme?.palette?.text?.secondary};
      cursor: pointer;
      transition: 0.1s ease-in-out;
    `,
    controlsFavorite: css12`
      color: ${theme?.palette?.text?.secondary};
      cursor: pointer;
      transition: 0.1s ease-in-out;
    `,
    controlsDisabled: css12`
      color: ${theme?.palette?.action?.disabled} !important;
      user-select: none;
      pointer-events: none;
    `,
    iconSwap: css12`
      display: block;
      :hover {
        color: ${theme?.palette?.text?.primary};
      }
    `,
    iconHeart: css12`
      display: block;
      :hover {
        color: ${theme?.palette?.error?.main};
      }
    `,
    iconHeartFull: css12`
      display: block;
      color: ${theme?.palette?.error?.main};
    `,
    iconLoader: css12`
      display: block;
      animation: ${loader} 5s linear infinite;
    `,
    flex: css12`
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      ${theme?.breakpoints?.down("md")} {
        flex-direction: column;
        gap: 2px;
      }
    `,
    flexItem: css12`
      flex: 1;
      width: 100%;
    `,
    errorBox: css12`
      display: flex;
      align-items: flex-start;
      gap: 14px;
      padding: 18px 22px;
      margin: 8px 0 12px;
      border: 1px solid ${theme?.palette?.error?.main};
      border-radius: 10px;
      background-color: transparent;
    `,
    errorIcon: css12`
      flex-shrink: 0;
      margin-top: 2px;
      color: ${theme?.palette?.error?.main};
    `,
    serviceLabel: css12`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    serviceLabelAuto: css12`
      font-weight: 400;
      color: ${theme?.palette?.text?.secondary};
    `,
    serviceLocationBox: css12`
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 14px 16px;
      border: 1px solid ${theme?.palette?.divider};
      border-radius: 4px;
      background-color: ${theme?.palette?.action?.hover};
    `,
    serviceLocationIcon: css12`
      color: ${theme?.palette?.text?.secondary};
      flex-shrink: 0;
    `,
    serviceLocationText: css12`
      display: flex;
      flex-direction: column;
      min-width: 0;
      flex: 1;
    `,
    serviceOverrideBtn: css12`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px;
      border-radius: 4px;
      color: ${theme?.palette?.text?.secondary};
      cursor: pointer;
      transition: 0.15s ease-in-out;
      &:hover {
        background-color: ${theme?.palette?.action?.hover};
        color: ${theme?.palette?.primary?.main};
      }
    `
  };
};
var MovePlannerLaneForm_default = MovePlannerLaneForm;

// src/forms/product-choice/MovePlannerProductChoiceForm.tsx
import { productLabel as productLabel3 } from "@hopdrive/sdk-products/catalog";
import { Divider } from "@hopdrive/sdk-ui";

// src/kit/BigButton/BigButtonGroup.tsx
import React14 from "react";
import { css as css13, cx as cx3 } from "@emotion/css";
import { useTheme as useTheme13, Typography as Typography9, Skeleton } from "@mui/material";
import { jsx as jsx15, jsxs as jsxs14 } from "react/jsx-runtime";
var BigButtonContext = React14.createContext(null);
var BigButtonGroup = ({
  value: controlledValue,
  defaultValue,
  onChange,
  allowMultiple = false,
  direction = "horizontal",
  columns,
  fullWidth = false,
  size = "md",
  loading = false,
  skeletonCount = 3,
  error = false,
  helperText,
  disabled = false,
  children
}) => {
  const theme = useTheme13();
  const groupRef = React14.useRef(null);
  const isControlled = controlledValue !== void 0;
  const [internalValue, setInternalValue] = React14.useState(
    defaultValue ?? (allowMultiple ? [] : "")
  );
  const currentValue = isControlled ? controlledValue : internalValue;
  const handleChange = React14.useCallback(
    (buttonValue) => {
      let newValue;
      if (allowMultiple) {
        const arr = Array.isArray(currentValue) ? currentValue : [currentValue].filter(Boolean);
        newValue = arr.includes(buttonValue) ? arr.filter((v) => v !== buttonValue) : [...arr, buttonValue];
      } else {
        newValue = buttonValue;
      }
      if (!isControlled) setInternalValue(newValue);
      onChange?.(newValue);
    },
    [allowMultiple, currentValue, isControlled, onChange]
  );
  React14.useLayoutEffect(() => {
    const group = groupRef.current;
    if (!group || loading) return;
    const buttons = Array.from(group.querySelectorAll("[data-big-button]:not(:disabled)"));
    const hasTabbable = buttons.some((el) => el.getAttribute("tabindex") === "0");
    if (!hasTabbable && buttons.length > 0) {
      buttons[0].setAttribute("tabindex", "0");
    }
  });
  const handleKeyDown = React14.useCallback(
    (e) => {
      const group = groupRef.current;
      if (!group) return;
      const buttons = Array.from(group.querySelectorAll("[data-big-button]:not(:disabled)"));
      if (!buttons.length) return;
      const currentIndex = buttons.indexOf(document.activeElement);
      let nextIndex = -1;
      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
          e.preventDefault();
          nextIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          e.preventDefault();
          nextIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
          break;
        case "Home":
          e.preventDefault();
          nextIndex = 0;
          break;
        case "End":
          e.preventDefault();
          nextIndex = buttons.length - 1;
          break;
        default:
          return;
      }
      if (nextIndex >= 0) {
        buttons[nextIndex].focus();
        if (!allowMultiple) {
          const val = buttons[nextIndex].getAttribute("data-value");
          if (val) handleChange(val);
        }
      }
    },
    [allowMultiple, handleChange]
  );
  const contextValue = React14.useMemo(
    () => ({ value: currentValue, onChange: handleChange, size, disabled, allowMultiple, fullWidth }),
    [currentValue, handleChange, size, disabled, allowMultiple, fullWidth]
  );
  const cls = useStyles13(theme, { direction, columns, fullWidth, size });
  const borderRadius = theme.shape.borderRadius * 2;
  const skeletonHeight = size === "sm" ? 80 : size === "lg" ? 120 : 100;
  if (loading) {
    return /* @__PURE__ */ jsx15("div", { className: cls.wrapper, children: Array.from({ length: skeletonCount }).map((_, i) => /* @__PURE__ */ jsx15(
      Skeleton,
      {
        variant: "rectangular",
        className: cls.skeleton,
        height: skeletonHeight,
        sx: { borderRadius: `${borderRadius}px` }
      },
      i
    )) });
  }
  return /* @__PURE__ */ jsxs14("div", { children: [
    /* @__PURE__ */ jsx15(
      "div",
      {
        ref: groupRef,
        className: cx3(cls.wrapper, error && cls.wrapperError),
        role: allowMultiple ? "group" : "radiogroup",
        onKeyDown: handleKeyDown,
        children: /* @__PURE__ */ jsx15(BigButtonContext.Provider, { value: contextValue, children })
      }
    ),
    helperText && /* @__PURE__ */ jsx15(
      Typography9,
      {
        variant: "body2",
        sx: {
          mt: theme.spacing(0.75),
          color: error ? theme.palette.error.main : theme.palette.text.secondary
        },
        children: helperText
      }
    )
  ] });
};
var useStyles13 = (theme, options) => {
  const { direction, columns, fullWidth, size } = options;
  const isGrid = columns !== void 0;
  const minWidth = size === "sm" ? 120 : size === "lg" ? 260 : 180;
  const borderRadius = theme.shape.borderRadius * 2;
  return {
    wrapper: css13`
      position: relative;
      ${isGrid ? `
          display: grid;
          grid-template-columns: repeat(${columns}, 1fr);
        ` : `
          display: flex;
          flex-direction: ${direction === "vertical" ? "column" : "row"};
          flex-wrap: wrap;
          justify-content: center;
        `}
      gap: ${size === "sm" ? theme.spacing(1) : theme.spacing(1.5)};
      ${fullWidth ? "width: 100%;" : ""}
    `,
    wrapperError: css13`
      outline: 2px solid ${theme.palette.error.main};
      outline-offset: 6px;
      border-radius: ${borderRadius + 6}px;
    `,
    skeleton: css13`
      flex: 1;
      min-width: ${minWidth}px;
    `
  };
};
var BigButtonGroup_default = BigButtonGroup;

// src/kit/BigButton/BigButton.tsx
import React15 from "react";
import { css as css14, cx as cx4 } from "@emotion/css";
import { useTheme as useTheme14, Typography as Typography10, ButtonBase, Tooltip as Tooltip5, Icon } from "@mui/material";
import { jsx as jsx16, jsxs as jsxs15 } from "react/jsx-runtime";
var BigButton = ({
  value,
  label,
  description,
  icon,
  badge,
  disabled: disabledProp = false,
  disabledReason,
  color,
  bg = "#2024300c",
  minWidth: minWidthProp,
  maxWidth: maxWidthProp
}) => {
  const theme = useTheme14();
  const ctx = React15.useContext(BigButtonContext);
  if (!ctx) throw new Error("BigButton must be used within a BigButtonGroup");
  const { value: groupValue, onChange, size, disabled: groupDisabled, allowMultiple, fullWidth } = ctx;
  const isDisabled = disabledProp || groupDisabled;
  const isSelected = allowMultiple ? Array.isArray(groupValue) && groupValue.includes(value) : groupValue === value;
  const paletteColor = theme.palette[color || "primary"] || theme.palette.primary;
  const activeMain = paletteColor.main;
  const activeDark = paletteColor.dark;
  const activeContrastText = paletteColor.contrastText;
  const cls = useStyles14(theme, { size, isSelected, isDisabled, fullWidth, activeMain, activeDark, activeContrastText, bg, minWidthOverride: minWidthProp, maxWidthOverride: maxWidthProp });
  const handleClick = () => {
    if (!isDisabled) onChange(value);
  };
  const tabIndex = (() => {
    if (isDisabled) return -1;
    if (!allowMultiple) return isSelected ? 0 : -1;
    if (Array.isArray(groupValue) && groupValue.length > 0 && groupValue[0] === value) return 0;
    return -1;
  })();
  const titleVariant = size === "sm" ? "body1" : size === "lg" ? "h4" : "h6";
  const descriptionVariant = size === "sm" ? "caption" : size === "lg" ? "body1" : "body2";
  const titleWeight = size === "sm" ? 500 : 600;
  const checkFontSize = size === "sm" ? 12 : size === "lg" ? 18 : 14;
  const buttonElement = /* @__PURE__ */ jsxs15(
    ButtonBase,
    {
      className: cx4(cls.button, !!icon && cls.buttonWithIcon, isSelected && cls.buttonSelected, isDisabled && cls.buttonDisabled),
      onClick: handleClick,
      disabled: isDisabled,
      role: allowMultiple ? "checkbox" : "radio",
      "aria-checked": isSelected,
      "data-big-button": true,
      "data-value": value,
      tabIndex,
      focusRipple: true,
      children: [
        /* @__PURE__ */ jsx16("span", { className: cx4(cls.checkIndicator, isSelected && cls.checkIndicatorVisible), children: /* @__PURE__ */ jsx16(Icon, { sx: { fontSize: checkFontSize }, children: "check" }) }),
        badge && /* @__PURE__ */ jsx16("span", { className: cls.badge, children: badge }),
        /* @__PURE__ */ jsxs15("div", { className: cx4(cls.content, !!icon && cls.contentWithIcon), children: [
          icon && /* @__PURE__ */ jsx16("span", { className: cx4(cls.iconCircle, isSelected && cls.iconCircleSelected), children: icon }),
          /* @__PURE__ */ jsxs15("div", { className: cx4(cls.textBlock, !!icon && cls.textBlockWithIcon), children: [
            /* @__PURE__ */ jsx16(Typography10, { variant: titleVariant, sx: { fontWeight: titleWeight, mb: description ? "2px" : 0 }, children: label }),
            description && /* @__PURE__ */ jsx16(
              Typography10,
              {
                variant: descriptionVariant,
                sx: {
                  textWrap: "pretty",
                  color: isSelected ? theme.palette.text.contrastSecondary : theme.palette.text.secondary
                },
                children: description
              }
            )
          ] })
        ] })
      ]
    }
  );
  const rootElement = /* @__PURE__ */ jsx16("div", { className: cx4(cls.root, isDisabled && cls.rootDisabled), children: buttonElement });
  if (isDisabled && disabledReason) {
    return /* @__PURE__ */ jsx16(Tooltip5, { title: disabledReason, placement: "top", children: rootElement });
  }
  return rootElement;
};
var useStyles14 = (theme, options) => {
  const { size, activeMain, activeDark, activeContrastText, bg, minWidthOverride, maxWidthOverride } = options;
  const borderRadius = size === "sm" ? 6 : size === "lg" ? 12 : 10;
  const transition = theme.transitions.create(["background-color", "border-color", "transform"], {
    duration: theme.transitions.duration.short
  });
  const padding = size === "sm" ? `${theme.spacing(1)} ${theme.spacing(0.75)}` : size === "lg" ? theme.spacing(3) : theme.spacing(1.5);
  const defaultMinWidth = size === "sm" ? 160 : size === "lg" ? 300 : 220;
  const minWidth = minWidthOverride !== void 0 ? typeof minWidthOverride === "number" ? `${minWidthOverride}px` : minWidthOverride : `${defaultMinWidth}px`;
  const maxWidth = maxWidthOverride !== void 0 ? typeof maxWidthOverride === "number" ? `${maxWidthOverride}px` : maxWidthOverride : "none";
  const checkCircleSize = size === "sm" ? 16 : size === "lg" ? 26 : 18;
  const checkOffset = size === "sm" ? "4px" : size === "lg" ? "10px" : "6px";
  return {
    root: css14`
      display: flex;
      flex: 1;
      min-width: ${minWidth};
      max-width: ${maxWidth};
    `,
    rootDisabled: css14`
      opacity: 0.5;
      cursor: not-allowed;
    `,
    button: css14`
      && {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: ${padding};
        border: 1px solid ${theme.palette.divider};
        border-radius: ${borderRadius}px;
        overflow: hidden;
        text-align: center;
        background-color: ${bg};
        color: ${theme.palette.text.primary};
        cursor: pointer;
        transition: ${transition};

        &:hover:not(:disabled) {
          background-color: ${theme.palette.action.selected};
        }

        &:active:not(:disabled) {
          transform: scale(0.98);
          background-color: ${theme.palette.action.disabledBackground};
        }

        &:focus-visible {
          outline: 2px solid ${activeMain};
          outline-offset: 2px;
        }
      }
    `,
    buttonWithIcon: css14`
      && {
        padding: 0;
        align-items: stretch;
      }
    `,
    buttonSelected: css14`
      && {
        border-color: ${activeMain};
        background-color: ${activeMain};
        color: ${activeContrastText};

        &:hover:not(:disabled) {
          background-color: ${activeDark};
        }

        &:active:not(:disabled) {
          background-color: ${activeDark};
        }
      }
    `,
    buttonDisabled: css14`
      && {
        pointer-events: none;
      }
    `,
    checkIndicator: css14`
      position: absolute;
      top: ${checkOffset};
      right: ${checkOffset};
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${checkCircleSize}px;
      height: ${checkCircleSize}px;
      border-radius: 50%;
      background-color: ${activeContrastText};
      color: ${activeMain};
      opacity: 0;
      transform: scale(0.5);
      transition: ${theme.transitions.create(["opacity", "transform"], {
      duration: theme.transitions.duration.short
    })};
    `,
    checkIndicatorVisible: css14`
      opacity: 1;
      transform: scale(1);
    `,
    badge: css14`
      position: absolute;
      top: ${checkOffset};
      right: ${checkOffset};
    `,
    content: css14`
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    `,
    contentWithIcon: css14`
      flex-direction: row;
      align-items: stretch;
      flex: 1;
      text-align: left;
    `,
    iconCircle: css14`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${size === "sm" ? 28 : size === "lg" ? 56 : 40}px;
      font-size: ${size === "sm" ? 16 : size === "lg" ? 32 : 20}px;
      border-radius: 0;
      margin: 0;
      background-color: ${theme.palette.action.selected};
      color: inherit;
      line-height: 1;
      transition: ${theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.short
    })};
    `,
    iconCircleSelected: css14`
      background-color: ${theme.palette.action.contrastSelected};
    `,
    textBlock: css14`
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    textBlockWithIcon: css14`
      align-items: flex-start;
      justify-content: center;
      padding: ${padding};
      padding-left: ${theme.spacing(1.5)};
    `
  };
};
var BigButton_default = BigButton;

// src/forms/product-choice/MovePlannerProductChoiceForm.tsx
import { Fragment as Fragment9, jsx as jsx17, jsxs as jsxs16 } from "react/jsx-runtime";
var MovePlannerProductChoiceForm = () => {
  const { offering, type, typeRefusal: typeRefusal2, chosenProductKey, setChosenProductKey, effectiveProductKey: effectiveProductKey2, validation } = useMovePlanner();
  const choice = productChoiceFor(offering, type);
  if (!choice.required || typeRefusal2) return null;
  const prompt = productChoicePrompt(choice.sellers);
  const refused = validation?.productKey === false && !effectiveProductKey2;
  return /* @__PURE__ */ jsxs16(Fragment9, { children: [
    /* @__PURE__ */ jsx17(Divider, { spacer: true, mb: 6, tip: `${prompt} for this move.`, children: "PRODUCT" }),
    /* @__PURE__ */ jsx17(
      BigButtonGroup_default,
      {
        value: chosenProductKey || "",
        onChange: (value) => setChosenProductKey(value),
        error: refused,
        helperText: refused ? prompt : void 0,
        children: choice.sellers.map((key) => /* @__PURE__ */ jsx17(BigButton_default, { value: key, label: productLabel3(key), maxWidth: 400 }, key))
      }
    )
  ] });
};
var MovePlannerProductChoiceForm_default = MovePlannerProductChoiceForm;

// src/forms/rooftop/MovePlannerRooftopForm.tsx
import { css as css17 } from "@emotion/css";
import { useTheme as useTheme17 } from "@mui/material";

// src/kit/selectors/RooftopSelect.tsx
import React16 from "react";
import { useLazyQuery as useLazyQuery3 } from "@apollo/client";

// src/kit/selectors/queries/getRooftops.query.generated.ts
import { resolveExecutor as resolveExecutor19 } from "@hopdrive/sdk-core";
var GetRooftopsDocument = { "__text": "query getRooftops {\n  customers(where: {active: {_eq: 1}}, order_by: {name: asc}) {\n    id\n    name\n    config\n    tier\n    location {\n      id\n      address\n      latitude\n      longitude\n    }\n    organization {\n      id\n      name\n      config\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getRooftops" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "location" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "address" } }, { "kind": "Field", "name": { "kind": "Name", "value": "latitude" } }, { "kind": "Field", "name": { "kind": "Name", "value": "longitude" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] } }] };

// src/kit/selectors/RooftopSelect.tsx
import { css as css15, cx as cx5 } from "@emotion/css";
import { useTheme as useTheme15, Autocomplete as Autocomplete3, InputAdornment as InputAdornment7, TextField as TextField7 } from "@mui/material";
import { BiStore } from "react-icons/bi";
import { Fragment as Fragment10, jsx as jsx18, jsxs as jsxs17 } from "react/jsx-runtime";
var RooftopSelect = ({
  required,
  disabled,
  error,
  name = `rooftop-select`,
  label = ``,
  placeholder = `Select market...`,
  helperText = ``,
  defaultRooftops = [],
  value = 0,
  onChange,
  onFetch,
  queryOverride,
  queryCall = `onMount`,
  ...rest
}) => {
  const theme = useTheme15();
  const cls = useStyles15(theme);
  const [getRooftops] = useLazyQuery3(GetRooftopsDocument);
  const [rooftops, setRooftops] = React16.useState(defaultRooftops || []);
  const [rooftopId, setRooftopId] = React16.useState(value || 0);
  const [internalError, setInternalError] = React16.useState(false);
  const [internalErrorText, setInternalErrorText] = React16.useState(``);
  const [loading, setLoading] = React16.useState(false);
  const fetchRooftopsAndSetState = async () => {
    setLoading(true);
    try {
      let res;
      if (queryOverride) res = await queryOverride();
      else res = await getRooftops();
      const resRooftops = res?.data?.customers || [];
      const defaultRooftopId = value || 0;
      setRooftops(resRooftops);
      setRooftopId(defaultRooftopId);
      if (onFetch) onFetch(resRooftops);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch markets:`, err);
      setInternalError(true);
      setInternalErrorText(`Failed to fetch markets`);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedRooftopId = value2?.id || 0;
    setRooftopId(selectedRooftopId);
    if (onChange) onChange(selectedRooftopId);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchRooftopsAndSetState();
  };
  React16.useEffect(() => {
    if (queryCall === `onMount`) fetchRooftopsAndSetState();
  }, []);
  React16.useEffect(() => {
    setRooftops(defaultRooftops);
  }, [defaultRooftops]);
  React16.useEffect(() => {
    setRooftopId(value);
  }, [value]);
  return /* @__PURE__ */ jsxs17(Fragment10, { children: [
    label ? /* @__PURE__ */ jsxs17("label", { className: cls.rooftopLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx18("span", { className: cls.rooftopLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx18(
      Autocomplete3,
      {
        ...rest,
        fullWidth: true,
        disabled,
        loading,
        loadingText: `Loading markets...`,
        noOptionsText: `No markets found`,
        options: rooftops,
        getOptionKey: (r) => r?.id || 0,
        getOptionLabel: (r) => r?.name || ``,
        value: rooftops?.find((r) => r?.id === rooftopId) || null,
        onChange: (_, value2) => handleValueChange(value2),
        onOpen: () => handleOpen(),
        renderInput: (params) => /* @__PURE__ */ jsx18(
          TextField7,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx18(InputAdornment7, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx18(BiStore, { className: cx5(cls.rooftopIcon, disabled ? cls.rooftopIconDisabled : null) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles15 = (theme) => {
  const styles = {
    rooftopLabel: css15`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    rooftopLabelRequired: css15`
      color: ${theme?.palette?.error?.main};
    `,
    rooftopIcon: css15`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    rooftopIconDisabled: css15`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var RooftopSelect_default = RooftopSelect;

// src/kit/selectors/PayerSelect.tsx
import React17 from "react";
import { useLazyQuery as useLazyQuery4 } from "@apollo/client";
import { css as css16, cx as cx6 } from "@emotion/css";
import { useTheme as useTheme16, Autocomplete as Autocomplete4, InputAdornment as InputAdornment8, TextField as TextField8 } from "@mui/material";
import { BiDollarCircle } from "react-icons/bi";
import { Fragment as Fragment11, jsx as jsx19, jsxs as jsxs18 } from "react/jsx-runtime";
var PayerSelect = ({
  payersArray,
  required,
  disabled,
  error,
  name = `payer-select`,
  label = ``,
  placeholder = `Select payer...`,
  helperText = ``,
  defaultPayers = [],
  value = 0,
  onChange,
  onFetch,
  queryOverride,
  queryCall = `onMount`,
  ...rest
}) => {
  const theme = useTheme16();
  const cls = useStyles16(theme);
  const [getPayers] = useLazyQuery4(GetPayersDocument);
  const [payers, setPayers] = React17.useState(defaultPayers || []);
  const [payerId, setPayerId] = React17.useState(value || 0);
  const [internalError, setInternalError] = React17.useState(false);
  const [internalErrorText, setInternalErrorText] = React17.useState(``);
  const [loading, setLoading] = React17.useState(false);
  const fetchPayersAndSetState = async () => {
    setLoading(true);
    try {
      let res;
      if (queryOverride) res = await queryOverride();
      else res = await getPayers({ variables: { payersArray: payersArray || [] } });
      const resPayers = res?.data?.customers || [];
      const defaultPayerId = value || 0;
      setPayers(resPayers);
      setPayerId(defaultPayerId);
      if (onFetch) onFetch(resPayers);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch payers:`, err);
      setInternalError(true);
      setInternalErrorText(`Failed to fetch payers`);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedPayerId = value2?.id || 0;
    setPayerId(selectedPayerId);
    if (onChange) onChange(selectedPayerId);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchPayersAndSetState();
  };
  React17.useEffect(() => {
    if (queryCall === `onMount`) fetchPayersAndSetState();
  }, []);
  React17.useEffect(() => {
    setPayers(defaultPayers);
  }, [defaultPayers]);
  React17.useEffect(() => {
    setPayerId(value);
  }, [value]);
  return /* @__PURE__ */ jsxs18(Fragment11, { children: [
    label ? /* @__PURE__ */ jsxs18("label", { className: cls.payerLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx19("span", { className: cls.payerLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx19(
      Autocomplete4,
      {
        ...rest,
        fullWidth: true,
        disabled,
        loading,
        loadingText: `Loading payers...`,
        noOptionsText: `No payers found`,
        options: payers,
        getOptionKey: (p) => p?.id || 0,
        getOptionLabel: (p) => p?.name || ``,
        value: payers?.find((p) => p?.id === payerId) || null,
        onChange: (_, value2) => handleValueChange(value2),
        onOpen: () => handleOpen(),
        renderInput: (params) => /* @__PURE__ */ jsx19(
          TextField8,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx19(InputAdornment8, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx19(BiDollarCircle, { className: cx6(cls.payerIcon, disabled ? cls.payerIconDisabled : null) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles16 = (theme) => {
  const styles = {
    payerLabel: css16`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    payerLabelRequired: css16`
      color: ${theme?.palette?.error?.main};
    `,
    payerIcon: css16`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    payerIconDisabled: css16`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var PayerSelect_default = PayerSelect;

// src/forms/rooftop/MovePlannerRooftopForm.tsx
import { jsx as jsx20, jsxs as jsxs19 } from "react/jsx-runtime";
var MovePlannerRooftopForm = () => {
  const theme = useTheme17();
  const cls = useStyles17(theme);
  const host = useMovePlannerHost();
  const { hasAdminPrivileges, validation, rooftops, rooftopId, payers, payerId, setRooftopId, setPayerId } = useMovePlanner();
  const customerConfig = host.rooftop.useCustomerConfig();
  const handleRooftopChange = async (rooftopIdValue) => {
    setRooftopId(rooftopIdValue);
    const selectedRooftop = rooftops?.find((r) => r?.id === rooftopIdValue);
    if (!selectedRooftop) return;
    try {
      await host.rooftop.changeWorkingRooftop(selectedRooftop);
    } catch (error) {
      console.error("MovePlannerRooftopForm: Failed to handle rooftop change:", error);
    }
  };
  if (hasAdminPrivileges)
    return /* @__PURE__ */ jsx20("div", { className: cls.rooftop, children: /* @__PURE__ */ jsxs19("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsx20("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx20(
        RooftopSelect_default,
        {
          disableClearable: true,
          required: true,
          disabled: !rooftops?.length || rooftops?.length <= 1,
          error: !validation?.rooftopId,
          label: "Responsible Market",
          helperText: !validation?.rooftopId ? `Please select the rooftop responsible for the move!` : ``,
          defaultRooftops: rooftops,
          value: rooftopId,
          onChange: handleRooftopChange,
          queryCall: "never"
        }
      ) }),
      payers?.length ? /* @__PURE__ */ jsx20("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx20(
        PayerSelect_default,
        {
          required: customerConfig?.require_third_party_payer,
          disabled: !payers?.length,
          error: !validation?.payerId,
          label: "Responsible Payer",
          helperText: !validation?.rooftopId ? `Please select the rooftop that will pay for the move!` : ``,
          defaultPayers: payers,
          value: payerId,
          onChange: setPayerId,
          queryCall: "never"
        }
      ) }) : null
    ] }) });
  return null;
};
var useStyles17 = (theme) => {
  return {
    rooftop: css17`
      position: relative;
    `,
    flex: css17`
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 12px;
      ${theme?.breakpoints?.down("sm")} {
        flex-direction: column;
      }
    `,
    flexItem: css17`
      flex: 1;
      width: 100%;
    `
  };
};
var MovePlannerRooftopForm_default = MovePlannerRooftopForm;

// src/forms/time/MovePlannerTimeForm.tsx
import React19 from "react";
import dayjs9 from "dayjs";
import { css as css18 } from "@emotion/css";
import { useTheme as useTheme18, Button as Button4, TextField as TextField9, Typography as Typography11, Alert as Alert3 } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { BiSolidCalendarExclamation, BiSolidCheckCircle as BiSolidCheckCircle2 } from "react-icons/bi";
import { getAlgorithm } from "@hopdrive/sdk-appointments";

// src/utils/overlapEnforcement.ts
function resolveOverlapAction({ mode, overlaps, calculating }) {
  if (calculating) return "hold";
  if (!overlaps) return "allow";
  return mode === "forced" ? "block" : "warn";
}

// src/utils/resolveDriverRow.ts
import {
  assignDriverRow,
  prepareDriverScenariosForAlgorithm
} from "@hopdrive/sdk-appointments";
function resolveDriverRowForBooking(params) {
  const {
    enabled,
    time,
    type,
    consumerAction,
    consumerFirst,
    mainLane,
    inverseLane,
    existingScenarios,
    tier,
    algorithm,
    bufferMinutes,
    timezone: timezone2,
    driverCount
  } = params;
  if (!enabled || tier !== "standard" || !time || !mainLane) return null;
  const { legs, ready } = computeMoveLegRanges({
    time,
    type,
    consumerAction,
    consumerFirst,
    mainLane,
    inverseLane
  });
  if (!ready || legs.length === 0) return null;
  const { allDriverScenarios } = prepareDriverScenariosForAlgorithm({
    scenarios: existingScenarios,
    tier: "standard",
    algorithm,
    driverCount,
    bufferMinutes,
    timezone: timezone2
  });
  const assignment = assignDriverRow({
    candidateRanges: legs,
    allDriverScenarios,
    driverCount,
    bufferMinutes,
    timezone: timezone2
  });
  return assignment?.rowIndex ?? null;
}

// src/utils/rooftopTimezone.ts
var resolveViewerTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
var getRooftopTimezone = (rooftop) => rooftop?.location?.timezone || resolveViewerTimezone();

// src/utils/suggestedTimesUtils.ts
import dayjs8 from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  prepareDriverScenariosForAlgorithm as prepareDriverScenariosForAlgorithm2,
  checkMoveOverlap
} from "@hopdrive/sdk-appointments";
dayjs8.extend(utc);
dayjs8.extend(timezone);
function generateSuggestedTimes(params) {
  const {
    lane,
    existingScenarios,
    businessHours,
    selectedDate,
    timezone: timezone2,
    algorithm,
    bufferMinutes = 0,
    count = 3,
    tier,
    liteDrivers,
    standardDriverCount: standardDriverCount2 = 1,
    type,
    consumerAction,
    consumerFirst,
    inverseLane
  } = params;
  const { allDriverScenarios, driverCount: actualDriverCount } = prepareDriverScenariosForAlgorithm2({
    scenarios: existingScenarios,
    tier: tier || "standard",
    algorithm,
    driverCount: standardDriverCount2,
    bufferMinutes,
    timezone: timezone2,
    activeDrivers: tier === "lite" && liteDrivers ? liteDrivers.map((d) => ({ id: d.id })) : void 0
  });
  if (actualDriverCount === 0) {
    return [];
  }
  const driverSchedules = tier === "lite" && liteDrivers ? liteDrivers.map((driver) => driver.schedule) : [];
  const allSlots = [];
  allDriverScenarios.forEach((_, driverIndex) => {
    const slots = algorithm.generateTimeSlots({
      driverIndex,
      driverCount: actualDriverCount,
      allDriverScenarios,
      lane,
      businessHours,
      selectedDate,
      timezone: timezone2,
      bufferMinutes,
      tier,
      driverSchedule: driverSchedules[driverIndex]
      // Pass driver schedule if available
    });
    slots.forEach((slot) => {
      allSlots.push({
        endTime: slot.endTime,
        // Use appointment arrival time (same as timeline click)
        driverIndex
      });
    });
  });
  const sortedSlots = allSlots.sort((a, b) => a.endTime.getTime() - b.endTime.getTime());
  const slotsToUse = tier === "standard" ? sortedSlots.filter(
    (slot, index, arr) => index === 0 || slot.endTime.getTime() !== arr[index - 1].endTime.getTime()
  ) : sortedSlots;
  const candidateTimes = slotsToUse.map((slot) => slot.endTime);
  const resolvedTier = tier || "standard";
  const validTimes = resolvedTier === "standard" ? filterSuggestedTimesByOverlap({
    times: candidateTimes,
    allDriverScenarios,
    footprint: { type, consumerAction, consumerFirst, mainLane: lane, inverseLane },
    tier: resolvedTier,
    bufferMinutes,
    timezone: timezone2
  }) : candidateTimes;
  const suggestedDatetimes = validTimes.slice(0, count);
  const suggestedTimes = suggestedDatetimes.map((datetime) => {
    const datetimeDayjs = dayjs8(datetime).tz(timezone2);
    const displayLabel = formatDisplayLabel(datetimeDayjs, timezone2);
    const timeLabel = datetimeDayjs.format("h:mm A");
    return {
      datetime,
      displayLabel,
      timeLabel
    };
  });
  return suggestedTimes;
}
function filterSuggestedTimesByOverlap(params) {
  const { times, allDriverScenarios, footprint, tier, bufferMinutes, timezone: timezone2 } = params;
  return times.filter((time) => {
    const { legs, ready } = computeMoveLegRanges({ ...footprint, time: dayjs8(time).toISOString() });
    if (!ready || legs.length === 0) return true;
    const { overlaps } = checkMoveOverlap({
      candidateRanges: legs,
      allDriverScenarios,
      tier,
      bufferMinutes,
      timezone: timezone2
    });
    return !overlaps;
  });
}
function formatDisplayLabel(datetime, timezone2) {
  const now = dayjs8().tz(timezone2);
  const time = datetime.format("h:mm A");
  if (datetime.isSame(now, "day")) {
    return `Today ${time}`;
  }
  if (datetime.isSame(now.add(1, "day"), "day")) {
    return `Tomorrow ${time}`;
  }
  if (datetime.isBefore(now.add(7, "day"))) {
    const dayName = datetime.format("dddd");
    return `${dayName} ${time}`;
  }
  const date = datetime.format("MMM D");
  return `${date} ${time}`;
}

// src/forms/time/appointmentPlanning.ts
var parse = (rooftopConfig) => typeof rooftopConfig === "string" ? JSON.parse(rooftopConfig) : rooftopConfig;
function fullPlanningEnabled(rooftopConfig) {
  if (!rooftopConfig) return false;
  try {
    const config = parse(rooftopConfig);
    return config?.appointment_management?.enabled === true && config?.appointment_management?.full_planning_enabled === true;
  } catch (e) {
    console.error("Error parsing rooftop config for full_planning_enabled:", e);
    return false;
  }
}
function schedulingAlgorithmName(rooftopConfig) {
  if (!rooftopConfig) return "balance-drivers-v1";
  try {
    const config = parse(rooftopConfig);
    return config?.appointment_management?.enabled === true ? config?.appointment_management?.strategy || "balance-drivers-v1" : "balance-drivers-v1";
  } catch (e) {
    console.error("Error parsing rooftop config for algorithm:", e);
    return "balance-drivers-v1";
  }
}
function moveBufferMinutes(rooftopConfig) {
  if (!rooftopConfig) return 0;
  try {
    const config = parse(rooftopConfig);
    return config?.appointment_management?.enabled === true ? config?.appointment_management?.move_buffer_minutes || 0 : 0;
  } catch {
    return 0;
  }
}
function standardDriverCount(rooftopConfig, isLite) {
  if (!rooftopConfig || isLite) return 1;
  try {
    const config = parse(rooftopConfig);
    return config?.appointment_management?.enabled === true ? config?.appointment_management?.driver_count || 2 : 1;
  } catch {
    return 1;
  }
}

// src/forms/time/OverlapWarningModal.tsx
import { Fragment as Fragment12, jsx as jsx21, jsxs as jsxs20 } from "react/jsx-runtime";
var OverlapWarningModal = ({ open, onProceed, onChooseAnother }) => {
  const { Modal } = useMovePlannerHost().components;
  return /* @__PURE__ */ jsx21(Modal, { open, children: open ? /* @__PURE__ */ jsx21(OverlapWarningModalContent, { onProceed, onChooseAnother }) : null });
};
var OverlapWarningModalContent = ({ onProceed, onChooseAnother }) => {
  const { ModalHeader, ModalContent, ModalFooter, ModalAction } = useMovePlannerHost().components;
  return /* @__PURE__ */ jsxs20(Fragment12, { children: [
    /* @__PURE__ */ jsx21(ModalHeader, { handleClose: onChooseAnother, children: "Overlapping move time" }),
    /* @__PURE__ */ jsx21(
      ModalContent,
      {
        subtitle: `The time you selected overlaps another move already on the schedule. Scheduling it anyway can lead to a late arrival or a missed customer commitment. You can choose a different time, or schedule it anyway.`
      }
    ),
    /* @__PURE__ */ jsxs20(ModalFooter, { children: [
      /* @__PURE__ */ jsx21(ModalAction, { variant: "contained", color: "primary", onClick: onChooseAnother, children: "Choose a different time" }),
      /* @__PURE__ */ jsx21(ModalAction, { variant: "outlined", color: "utility", onClick: onProceed, children: "Schedule anyway" })
    ] })
  ] });
};
var OverlapWarningModal_default = OverlapWarningModal;

// src/forms/time/timeInputs.ts
var isSafari = (userAgent = typeof navigator === "undefined" ? void 0 : navigator.userAgent) => {
  if (!userAgent) return false;
  return /safari/i.test(userAgent) && !/chrome|chromium|crios|edg|android/i.test(userAgent);
};
function timeInputsDisabled({ isDefaultTime, forced, locked }) {
  return {
    date: !!isDefaultTime || locked,
    time: !!isDefaultTime || forced || locked,
    earliestTime: locked
  };
}

// src/forms/time/useOverlapStatus.ts
import React18 from "react";
import {
  checkMoveOverlap as checkMoveOverlap2,
  prepareDriverScenariosForAlgorithm as prepareDriverScenariosForAlgorithm3
} from "@hopdrive/sdk-appointments";
var NO_OVERLAP = { overlaps: false, calculating: false };
function useOverlapStatus(params) {
  const {
    enabled,
    time,
    type,
    consumerAction,
    consumerFirst,
    lane,
    inverseLane,
    existingScenarios,
    tier,
    algorithm,
    bufferMinutes,
    timezone: timezone2,
    standardDriverCount: standardDriverCount2,
    liteDrivers
  } = params;
  return React18.useMemo(() => {
    if (!enabled || !time || !lane) return NO_OVERLAP;
    const { legs, ready } = computeMoveLegRanges({
      time,
      type,
      consumerAction,
      consumerFirst,
      mainLane: lane,
      inverseLane
    });
    if (!ready) return { overlaps: false, calculating: true };
    if (legs.length === 0) return NO_OVERLAP;
    const { allDriverScenarios } = prepareDriverScenariosForAlgorithm3({
      scenarios: existingScenarios,
      tier,
      algorithm,
      driverCount: standardDriverCount2,
      bufferMinutes,
      timezone: timezone2,
      activeDrivers: tier === "lite" && liteDrivers ? liteDrivers.map((d) => ({ id: d.id })) : void 0
    });
    const { overlaps } = checkMoveOverlap2({
      candidateRanges: legs,
      allDriverScenarios,
      tier,
      bufferMinutes,
      timezone: timezone2
    });
    return { overlaps, calculating: false };
  }, [
    enabled,
    time,
    type,
    consumerAction,
    consumerFirst,
    lane,
    inverseLane,
    existingScenarios,
    tier,
    algorithm,
    bufferMinutes,
    timezone2,
    standardDriverCount2,
    liteDrivers
  ]);
}

// src/forms/time/MovePlannerTimeForm.tsx
import { Fragment as Fragment13, jsx as jsx22, jsxs as jsxs21 } from "react/jsx-runtime";
var NO_DAY = { scenarios: [], loading: false };
var NO_HOURS = { openTime: "", closeTime: "", isClosed: false };
var MovePlannerTimeForm = ({ appointmentMode }) => {
  const theme = useTheme18();
  const cls = useStyles18(theme);
  const host = useMovePlannerHost();
  const { suggestedTimes: suggestedTimesOn, overlapEnforcement, driverRows, enforcementMode: enforcementOn } = host.capabilities;
  const readsSchedule = suggestedTimesOn || overlapEnforcement || driverRows;
  const {
    validation,
    type,
    time,
    isDefaultTime,
    lane,
    lanes,
    consumer,
    isLite,
    liteMode,
    setTime,
    setIsDefaultTime,
    pickup,
    delivery,
    rooftopId,
    rooftopConfig,
    rooftops,
    setDriverRowNumber,
    enforcementMode: plannerEnforcementMode
  } = useMovePlanner();
  const enforcementMode = enforcementOn ? plannerEnforcementMode : void 0;
  const selectedRooftop = React19.useMemo(
    () => rooftops?.find((r) => r.id === rooftopId),
    [rooftops, rooftopId]
  );
  const waitingOnProduct = liteMode === "pending" && !appointmentMode;
  const fullPlanningEnabled2 = React19.useMemo(() => fullPlanningEnabled(rooftopConfig), [rooftopConfig]);
  const useMuiPickers = React19.useMemo(() => isSafari(), []);
  const disabled = timeInputsDisabled({
    isDefaultTime,
    forced: enforcementMode === "forced",
    locked: !!host.embed?.settings.locks.time
  });
  const timeDisabled = disabled.time;
  const timeInputTrapRef = host.components.useDisabledBypassTrap ? host.components.useDisabledBypassTrap(timeDisabled) : void 0;
  const [myDate, setMyDate] = React19.useState(() => time ? dayjs9(time).format("YYYY-MM-DD") : "");
  const [myTime, setMyTime] = React19.useState(() => time ? dayjs9(time).format("HH:mm") : "");
  const [helperText, setHelperText] = React19.useState(``);
  const isConcierge = type?.includes(`concierge`);
  const isConciergePickup = !!(isConcierge && consumer?.action === `pickup`);
  const selectedDate = myDate || dayjs9().format("YYYY-MM-DD");
  const timezone2 = getRooftopTimezone(selectedRooftop);
  const day = readsSchedule && host.transport.useDayScenarios ? host.transport.useDayScenarios({
    start: dayjs9(selectedDate).startOf("day").format(),
    end: dayjs9(selectedDate).endOf("day").format(),
    customerId: rooftopId || 0,
    skip: !rooftopId || !lane || !pickup || !delivery
  }) : NO_DAY;
  const scenariosLoading = day.loading;
  const businessHours = readsSchedule && host.transport.useBusinessHours ? host.transport.useBusinessHours(selectedRooftop?.location?.id?.toString(), selectedDate, timezone2) : NO_HOURS;
  const liteDrivers = readsSchedule && host.transport.useLiteDrivers ? host.transport.useLiteDrivers(rooftopId, !!isLite) : void 0;
  const algorithm = React19.useMemo(() => getAlgorithm(schedulingAlgorithmName(rooftopConfig)), [rooftopConfig]);
  const bufferMinutes = React19.useMemo(() => moveBufferMinutes(rooftopConfig), [rooftopConfig]);
  const standardDriverCount2 = React19.useMemo(() => standardDriverCount(rooftopConfig, isLite), [rooftopConfig, isLite]);
  const inverseLane = React19.useMemo(
    () => lanes?.find((l) => l?.pickup?.id === delivery?.id && l?.delivery?.id === pickup?.id) ?? null,
    [lanes, pickup?.id, delivery?.id]
  );
  const suggestedTimes = React19.useMemo(() => {
    if (!suggestedTimesOn) return [];
    if (!lane || !lane.duration_sec || isDefaultTime || businessHours.isClosed || scenariosLoading) {
      return [];
    }
    if (isLite && (!liteDrivers || liteDrivers.length === 0)) {
      return [];
    }
    try {
      const existingScenarios = day.scenarios;
      return generateSuggestedTimes({
        lane,
        existingScenarios,
        businessHours: {
          openTime: businessHours.openTime,
          closeTime: businessHours.closeTime
        },
        selectedDate,
        timezone: timezone2,
        algorithm,
        bufferMinutes,
        count: 20,
        tier: isLite ? "lite" : "standard",
        liteDrivers,
        // Pass driver info for Lite tier
        standardDriverCount: standardDriverCount2,
        // Pass driver count for Standard tier distribution
        // Move shape for the candidate footprint, so suggestions are filtered through the same
        // overlap check the inline guard applies to the selected time.
        type,
        consumerAction: consumer?.action,
        consumerFirst: consumer?.first,
        inverseLane
      });
    } catch (e) {
      console.error("Error generating suggested times:", e);
      return [];
    }
  }, [suggestedTimesOn, lane, isDefaultTime, businessHours, day.scenarios, scenariosLoading, selectedDate, timezone2, algorithm, bufferMinutes, isLite, liteDrivers, standardDriverCount2, type, consumer?.action, consumer?.first, inverseLane]);
  const [visibleCount, setVisibleCount] = React19.useState(5);
  React19.useEffect(() => {
    setVisibleCount(5);
  }, [lane, selectedDate, timezone2, businessHours, day.scenarios]);
  const displayedTimes = suggestedTimes.slice(0, visibleCount);
  const hasMoreTimes = suggestedTimes.length > visibleCount;
  const planningSuggestions = suggestedTimesOn && fullPlanningEnabled2;
  const showNoSlotsWarning = React19.useMemo(() => {
    return planningSuggestions && lane?.duration_sec && !isDefaultTime && suggestedTimes.length === 0;
  }, [planningSuggestions, lane?.duration_sec, isDefaultTime, suggestedTimes.length]);
  const showLaneCalculating = React19.useMemo(() => {
    return planningSuggestions && !isDefaultTime && host.lanes.laneNeedsEnrichment(lane);
  }, [planningSuggestions, isDefaultTime, lane, host.lanes]);
  const showNoLaneSelected = React19.useMemo(() => {
    return planningSuggestions && !isDefaultTime && (!pickup?.id || !delivery?.id);
  }, [planningSuggestions, isDefaultTime, pickup?.id, delivery?.id]);
  const appointmentFlow = !!(fullPlanningEnabled2 && !isDefaultTime && isConcierge && !appointmentMode);
  const overlapProtectionEnabled = overlapEnforcement && appointmentFlow;
  const dayScenarios = day.scenarios;
  const overlapStatus = useOverlapStatus({
    enabled: overlapProtectionEnabled,
    time,
    type,
    consumerAction: consumer?.action,
    consumerFirst: consumer?.first,
    lane,
    inverseLane,
    existingScenarios: dayScenarios,
    tier: isLite ? "lite" : "standard",
    algorithm,
    bufferMinutes,
    timezone: timezone2,
    standardDriverCount: standardDriverCount2,
    liteDrivers
  });
  const resolvedDriverRow = React19.useMemo(() => {
    return resolveDriverRowForBooking({
      enabled: driverRows && appointmentFlow && !scenariosLoading,
      time,
      type,
      consumerAction: consumer?.action,
      consumerFirst: consumer?.first,
      mainLane: lane,
      inverseLane,
      existingScenarios: dayScenarios,
      tier: isLite ? "lite" : "standard",
      algorithm,
      bufferMinutes,
      timezone: timezone2,
      driverCount: standardDriverCount2
    });
  }, [driverRows, appointmentFlow, scenariosLoading, time, type, consumer?.action, consumer?.first, lane, inverseLane, dayScenarios, isLite, algorithm, bufferMinutes, timezone2, standardDriverCount2]);
  React19.useEffect(() => {
    if (driverRows && setDriverRowNumber) setDriverRowNumber(resolvedDriverRow);
  }, [driverRows, resolvedDriverRow, setDriverRowNumber]);
  const [overlapModalOpen, setOverlapModalOpen] = React19.useState(false);
  const overlapPromptKeyRef = React19.useRef(null);
  const acknowledgedOverlapKeyRef = React19.useRef(null);
  const getOverlapSelectionKey = React19.useCallback(
    () => `${time ?? ""}|${lane?.id ?? ""}`,
    [time, lane?.id]
  );
  const clearSelectedTime = React19.useCallback(() => {
    setMyDate("");
    setMyTime("");
  }, []);
  React19.useEffect(() => {
    const action = resolveOverlapAction({
      mode: enforcementMode === "forced" ? "forced" : "suggested",
      overlaps: overlapStatus.overlaps,
      calculating: overlapStatus.calculating
    });
    if (action === "hold") return;
    if (action === "allow") {
      overlapPromptKeyRef.current = null;
      return;
    }
    const key = getOverlapSelectionKey();
    if (key === acknowledgedOverlapKeyRef.current) return;
    if (overlapPromptKeyRef.current === key) return;
    overlapPromptKeyRef.current = key;
    if (action === "block") {
      clearSelectedTime();
      host.notify.warning(`That time overlaps another move on the schedule. Please choose an available time.`, {
        toastId: `overlap-forced`
      });
    } else if (action === "warn") {
      setOverlapModalOpen(true);
    }
  }, [overlapStatus, enforcementMode, time, lane?.id, getOverlapSelectionKey]);
  const handleOverlapProceed = () => {
    acknowledgedOverlapKeyRef.current = getOverlapSelectionKey();
    setOverlapModalOpen(false);
  };
  const handleOverlapChooseAnother = () => {
    clearSelectedTime();
    setOverlapModalOpen(false);
  };
  const handleSuggestedTimeClick = (suggestedTime) => {
    const datetime = dayjs9(suggestedTime.datetime).tz(timezone2);
    setMyDate(datetime.format("YYYY-MM-DD"));
    setMyTime(datetime.format("HH:mm"));
  };
  React19.useEffect(() => {
    if (!validation?.time) {
      if (appointmentMode) {
        const timeRequirement = isLite ? "" : " at least 2 hours in the future";
        setHelperText(`Please select a date and time${timeRequirement}!`);
      } else {
        setHelperText(`Please select a date and time for the move!`);
      }
    } else {
      setHelperText(``);
    }
  }, [validation?.time, appointmentMode, isLite]);
  React19.useEffect(() => {
    if (time && !isDefaultTime) {
      setMyDate(dayjs9(time).format("YYYY-MM-DD"));
      setMyTime(dayjs9(time).format("HH:mm"));
    }
  }, [time, isDefaultTime]);
  React19.useEffect(() => {
    if (myDate && myTime) {
      const currentTime = dayjs9();
      const currentTimePlus90 = currentTime.add(90, `minute`);
      const selectedTime = dayjs9(`${myDate}T${myTime}`);
      if (selectedTime.isBefore(currentTimePlus90) && !appointmentMode && isConciergePickup && !isLite) {
        adjustTimeTo90MinuteWindow();
        return;
      }
      if (selectedTime.isBefore(currentTime) && !appointmentMode && isConciergePickup && isLite) {
        adjustTimeTo1MinuteWindow();
        return;
      }
      if (selectedTime.isBefore(currentTime) && !appointmentMode && !isConciergePickup) {
        adjustTimeTo1MinuteWindow();
        return;
      }
      if (setTime) setTime(selectedTime.format());
    } else {
      if (setTime) setTime(``);
    }
  }, [myDate, myTime, type, lane, consumer?.action, isLite]);
  React19.useEffect(() => {
    if (isDefaultTime) {
      setTime(``);
      setMyDate(``);
      setMyTime(``);
    }
  }, [isDefaultTime]);
  const adjustTimeTo90MinuteWindow = () => {
    const currentTimePlus90 = dayjs9().add(90, `minute`);
    host.notify.warning(`Time was adjusted to be 90 minutes in the future.`, { toastId: `move-planner-time` });
    setMyDate(currentTimePlus90.add(1, `minute`).format(`YYYY-MM-DD`));
    setMyTime(currentTimePlus90.add(1, `minute`).format(`HH:mm`));
  };
  const adjustTimeTo1MinuteWindow = () => {
    const currentTimePlus1 = dayjs9().add(1, `minute`);
    host.notify.warning(`Time was adjusted to be in the future.`, { toastId: `move-planner-time` });
    setMyDate(currentTimePlus1.format(`YYYY-MM-DD`));
    setMyTime(currentTimePlus1.format(`HH:mm`));
  };
  const getDefaultDateValue = (isConciergePickup2) => {
    if (isConciergePickup2 && !isLite) {
      return dayjs9().add(90, `minute`).add(1, `minute`).format(`YYYY-MM-DD`);
    } else {
      return dayjs9().add(1, `minute`).format(`YYYY-MM-DD`);
    }
  };
  const getDefaultTimeValue = (isConciergePickup2) => {
    if (isConciergePickup2 && !isLite) {
      return dayjs9().add(90, `minute`).add(1, `minute`).format(`HH:mm`);
    } else {
      return dayjs9().add(1, `minute`).format(`HH:mm`);
    }
  };
  const forcedNotice = enforcementMode === "forced" && fullPlanningEnabled2 ? /* @__PURE__ */ jsxs21(Fragment13, { children: [
    /* @__PURE__ */ jsx22("br", {}),
    /* @__PURE__ */ jsx22("strong", { style: { color: theme?.palette?.warning?.main }, children: "Time must be selected from the timeline or suggested times below." })
  ] }) : null;
  return /* @__PURE__ */ jsxs21("div", { className: cls.time, children: [
    /* @__PURE__ */ jsx22(
      OverlapWarningModal_default,
      {
        open: overlapModalOpen,
        onProceed: handleOverlapProceed,
        onChooseAnother: handleOverlapChooseAnother
      }
    ),
    /* @__PURE__ */ jsx22(InfoBlurb_default, { icon: /* @__PURE__ */ jsx22(BiSolidCalendarExclamation, {}), children: waitingOnProduct ? /* @__PURE__ */ jsxs21(Fragment13, { children: [
      "The time rules for this move are shown once its product is known.",
      forcedNotice
    ] }) : isConciergePickup ? /* @__PURE__ */ jsxs21(Fragment13, { children: [
      "Select the date & time of the appointment with your customer. Timezone is local to your machine (",
      dayjs9().format(`z`),
      ").",
      isLite ? "." : " Must be at least 90 minutes in the future.",
      forcedNotice
    ] }) : /* @__PURE__ */ jsxs21(Fragment13, { children: [
      "Select the date & time the vehicle will be ready. Timezone is local to your machine (",
      dayjs9().format(`z`),
      ").",
      !isLite ? /* @__PURE__ */ jsxs21(Fragment13, { children: [
        /* @__PURE__ */ jsx22("br", {}),
        /* @__PURE__ */ jsx22("span", { children: "NOTE: This is NOT an appointment time. The actual pickup time may vary based on volume and driver availability." })
      ] }) : null,
      forcedNotice
    ] }) }),
    /* @__PURE__ */ jsxs21("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsxs21("div", { className: cls.flexItem, children: [
        /* @__PURE__ */ jsxs21("label", { className: cls.textFieldLabel, htmlFor: "date-select", children: [
          isConcierge && consumer?.action === `pickup` ? `Appointment Date` : `Ready By Date`,
          /* @__PURE__ */ jsx22("span", { className: cls.textFieldLabelRequired, children: " *" })
        ] }),
        useMuiPickers ? /* @__PURE__ */ jsx22(
          DatePicker,
          {
            disabled: disabled.date,
            minDate: dayjs9(getDefaultDateValue(isConciergePickup)),
            value: isDefaultTime ? dayjs9(getDefaultDateValue(isConciergePickup)) : myDate ? dayjs9(myDate, "YYYY-MM-DD") : null,
            onChange: (next) => setMyDate(next ? next.format("YYYY-MM-DD") : ""),
            slotProps: {
              textField: {
                fullWidth: true,
                required: true,
                error: !validation?.time,
                helperText,
                name: "date-select",
                placeholder: "Select a date...",
                size: "small"
              }
            }
          }
        ) : /* @__PURE__ */ jsx22(
          TextField9,
          {
            fullWidth: true,
            required: true,
            disabled: disabled.date,
            error: !validation?.time,
            name: "date-select",
            type: "date",
            placeholder: "Select a date...",
            helperText,
            value: isDefaultTime ? getDefaultDateValue(isConciergePickup) : myDate || ``,
            onChange: (e) => setMyDate(e?.target?.value),
            slotProps: {
              htmlInput: {
                min: getDefaultDateValue(isConciergePickup)
              }
            }
          }
        )
      ] }),
      /* @__PURE__ */ jsxs21("div", { className: cls.flexItem, children: [
        /* @__PURE__ */ jsxs21("label", { className: cls.textFieldLabel, htmlFor: "time-select", children: [
          isConcierge && consumer?.action === `pickup` ? `Appointment Time` : `Ready By Time`,
          /* @__PURE__ */ jsx22("span", { className: cls.textFieldLabelRequired, children: " *" })
        ] }),
        useMuiPickers ? /* @__PURE__ */ jsx22(
          TimePicker,
          {
            disabled: timeDisabled,
            minTime: myDate <= getDefaultDateValue(isConciergePickup) ? dayjs9(getDefaultTimeValue(isConciergePickup), "HH:mm") : void 0,
            value: isDefaultTime ? dayjs9(getDefaultTimeValue(isConciergePickup), "HH:mm") : myTime ? dayjs9(myTime, "HH:mm") : null,
            onChange: (next) => setMyTime(next ? next.format("HH:mm") : ""),
            slotProps: {
              textField: {
                fullWidth: true,
                required: true,
                error: !validation?.time,
                helperText,
                name: "time-select",
                placeholder: "Select a time...",
                size: "small",
                inputRef: timeInputTrapRef
              }
            }
          }
        ) : /* @__PURE__ */ jsx22(
          TextField9,
          {
            fullWidth: true,
            required: true,
            disabled: timeDisabled,
            inputRef: timeInputTrapRef,
            error: !validation?.time,
            name: "time-select",
            type: "time",
            placeholder: "Select a time...",
            helperText,
            value: isDefaultTime ? getDefaultTimeValue(isConciergePickup) : myTime || ``,
            onChange: (e) => setMyTime(e?.target?.value),
            slotProps: {
              htmlInput: {
                min: myDate <= getDefaultDateValue(isConciergePickup) ? getDefaultTimeValue(isConciergePickup) : `00:00`
              }
            }
          }
        )
      ] }),
      type === `one-way` || type === `round-trip` ? /* @__PURE__ */ jsxs21("div", { className: cls.flexItemSmall, children: [
        /* @__PURE__ */ jsx22("label", { className: cls.textFieldLabelInvisible, htmlFor: "default-time-toggle", children: "Use Earliest Time" }),
        /* @__PURE__ */ jsxs21(
          Button4,
          {
            fullWidth: true,
            disabled: disabled.earliestTime,
            variant: isDefaultTime ? `contained` : `outlined`,
            color: isDefaultTime ? `success` : `utility`,
            onClick: () => {
              if (setIsDefaultTime) setIsDefaultTime(!isDefaultTime);
            },
            sx: { height: `40px` },
            children: [
              "Use Earliest Time",
              isDefaultTime ? /* @__PURE__ */ jsx22(BiSolidCheckCircle2, { style: { marginLeft: `6px` }, size: 18 }) : null
            ]
          }
        )
      ] }) : null
    ] }),
    showNoLaneSelected && /* @__PURE__ */ jsx22(Alert3, { severity: "info", sx: { mt: 2 }, children: "Select a pickup and delivery location to see available appointment times." }),
    showLaneCalculating && /* @__PURE__ */ jsx22(Alert3, { severity: "info", sx: { mt: 2 }, children: "Please wait while we calculate the route for this lane. Appointment times will appear once it's ready." }),
    suggestedTimes.length > 0 && !isDefaultTime && planningSuggestions ? /* @__PURE__ */ jsxs21("div", { className: cls.suggestedTimesContainer, children: [
      /* @__PURE__ */ jsx22(Typography11, { variant: "body2", className: cls.suggestedTimesLabel, children: "Suggested Times:" }),
      /* @__PURE__ */ jsx22("div", { className: cls.suggestedTimesFlex, children: displayedTimes.map((suggestedTime, index) => /* @__PURE__ */ jsx22(
        Button4,
        {
          variant: "outlined",
          color: "primary",
          className: cls.suggestedTimeButton,
          onClick: () => handleSuggestedTimeClick(suggestedTime),
          children: suggestedTime.displayLabel
        },
        index
      )) }),
      hasMoreTimes && /* @__PURE__ */ jsx22(
        Button4,
        {
          variant: "text",
          color: "primary",
          onClick: () => setVisibleCount((prev) => prev + 3),
          sx: { width: "100%", mt: 1, fontSize: 14 },
          children: "Show More"
        }
      )
    ] }) : null,
    showNoSlotsWarning && /* @__PURE__ */ jsx22(Alert3, { severity: businessHours.isClosed ? "error" : "warning", sx: { mt: 2 }, children: businessHours.isClosed ? `Location closed for ${businessHours.closureName || "this day"}. Please try a different date.` : "No available time slots for this address on the selected date. Please try a different date." })
  ] });
};
var useStyles18 = (theme) => {
  return {
    time: css18`
      position: relative;
    `,
    textFieldLabel: css18`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelInvisible: css18`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
      color: transparent;
      user-select: none;
      ${theme?.breakpoints?.down("md")} {
        display: none;
      }
    `,
    textFieldLabelRequired: css18`
      color: ${theme?.palette?.error?.main};
    `,
    flex: css18`
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 12px;
      ${theme?.breakpoints?.down("md")} {
        flex-direction: column;
      }
    `,
    flexItem: css18`
      flex: 2;
      width: 100%;
    `,
    flexItemSmall: css18`
      flex: 1;
      width: 100%;
    `,
    suggestedTimesContainer: css18`
      margin-top: 16px;
      padding-top: 16px;
      margin-bottom: 12px;
      border-top: 1px solid ${theme?.palette?.divider};
    `,
    suggestedTimesLabel: css18`
      padding-bottom: 12px;
      margin-left: 6px;
      font-weight: 600;
      color: ${theme?.palette?.text?.primary};
    `,
    suggestedTimesFlex: css18`
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 12px;
      flex-wrap: wrap;
    `,
    suggestedTimeButton: css18`
      min-width: 160px;
      height: 48px;
      font-size: 16px;
      font-weight: 600;
      ${theme?.breakpoints?.down("md")} {
        flex: 1 1 calc(50% - 6px);
        min-width: 120px;
      }
    `
  };
};
var MovePlannerTimeForm_default = MovePlannerTimeForm;

// src/forms/type/MovePlannerTypeNotice.tsx
import { Box as Box3, useTheme as useTheme19 } from "@mui/material";
import { BiSolidErrorCircle as BiSolidErrorCircle2 } from "react-icons/bi";
import { jsx as jsx23 } from "react/jsx-runtime";
var MovePlannerTypeNotice = () => {
  const theme = useTheme19();
  const { typeRefusal: typeRefusal2, nothingOffered } = useMovePlanner();
  const message = typeNoticeMessage(typeRefusal2, nothingOffered);
  if (!message) return null;
  return /* @__PURE__ */ jsx23(Box3, { sx: { mb: 2 }, children: /* @__PURE__ */ jsx23(InfoBlurb_default, { icon: /* @__PURE__ */ jsx23(BiSolidErrorCircle2, {}), color: theme.palette.error.main, children: message }) });
};
var MovePlannerTypeNotice_default = MovePlannerTypeNotice;

// src/forms/type/MovePlannerTypeForm.tsx
import { Fragment as Fragment14, jsx as jsx24, jsxs as jsxs22 } from "react/jsx-runtime";
var MovePlannerTypeForm = () => {
  const host = useMovePlannerHost();
  const { type, setType, offeredTypes } = useMovePlanner();
  const settings = host.embed?.settings;
  const refusal = /* @__PURE__ */ jsx24(MovePlannerTypeNotice_default, {});
  if (settings?.skipTypeSelection) return refusal;
  if (!offeredTypes) return null;
  return /* @__PURE__ */ jsxs22(Fragment14, { children: [
    refusal,
    /* @__PURE__ */ jsx24(BigButtonGroup_default, { value: type || "", onChange: (value) => setType?.(value), disabled: !!settings?.locks.type, children: offeredTypes.types.map((t) => /* @__PURE__ */ jsx24(BigButton_default, { value: t.value, label: t.label, description: t.description, color: t.color, maxWidth: 400 }, t.value)) })
  ] });
};
var MovePlannerTypeForm_default = MovePlannerTypeForm;

// src/forms/vehicle/MovePlannerVehicleForm.tsx
import { css as css25 } from "@emotion/css";
import { useTheme as useTheme26, Button as Button5, InputAdornment as InputAdornment15, TextField as TextField16 } from "@mui/material";
import { BiClipboard as BiClipboard2, BiSolidKey, BiSolidUser } from "react-icons/bi";
import { IoCog } from "react-icons/io5";
import { MdHdrAuto } from "react-icons/md";

// src/kit/lookups/StockLookup.tsx
import React20 from "react";
import dayjs10 from "dayjs";
import { useLazyQuery as useLazyQuery5 } from "@apollo/client";

// src/kit/lookups/queries/getVehiclesByStock.query.generated.ts
import { resolveExecutor as resolveExecutor20 } from "@hopdrive/sdk-core";
var GetVehiclesByStockDocument = { "__text": 'query getVehiclesByStock($rooftopId: bigint!, $afterDate: timestamptz!) {\n  moves(\n    distinct_on: vehicle_stock\n    where: {customer_id: {_eq: $rooftopId}, ready_by: {_gte: $afterDate}, _and: [{vehicle_stock: {_nilike: "0"}}, {vehicle_stock: {_nilike: ""}}, {vehicle_vin: {_nilike: "0"}}, {vehicle_vin: {_nilike: ""}}]}\n    order_by: {vehicle_stock: asc}\n  ) {\n    id\n    manual_flag\n    reference_num\n    vehicle_color\n    vehicle_make\n    vehicle_model\n    vehicle_stock\n    vehicle_vin\n    vehicle_year\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getVehiclesByStock" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "afterDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "distinct_on" }, "value": { "kind": "EnumValue", "value": "vehicle_stock" } }, { "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "afterDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "", "block": false } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "manual_flag" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }] } }] } }] };

// src/kit/lookups/StockLookup.tsx
import { css as css19, cx as cx7 } from "@emotion/css";
import { useTheme as useTheme20, Autocomplete as Autocomplete5, InputAdornment as InputAdornment9, TextField as TextField10 } from "@mui/material";
import { BiLabel } from "react-icons/bi";
import { jsx as jsx25, jsxs as jsxs23 } from "react/jsx-runtime";
var StockLookup = ({
  rooftopId,
  required,
  disabled,
  error,
  name = `stock-lookup`,
  label = ``,
  placeholder = `Enter stock...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  onFetch,
  queryCall = `onOpen`,
  ...rest
}) => {
  const theme = useTheme20();
  const cls = useStyles19(theme);
  const [getVehicles] = useLazyQuery5(GetVehiclesByStockDocument);
  const [vehicles, setVehicles] = React20.useState([]);
  const [vehicleStock, setVehicleStock] = React20.useState(value || null);
  const [internalError, setInternalError] = React20.useState(false);
  const [internalErrorText, setInternalErrorText] = React20.useState(``);
  const [loading, setLoading] = React20.useState(false);
  const fetchVehiclesAndSetState = async () => {
    setLoading(true);
    try {
      const res = await getVehicles({
        variables: { rooftopId, afterDate: dayjs10().subtract(3, `month`).format(`YYYY-MM-DD`) }
      });
      const resVehicles = res?.data?.moves || [];
      setVehicles(resVehicles);
      if (onFetch) onFetch(resVehicles);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch vehicles by stock:`, err);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedValue = value2?.toUpperCase()?.trim() || null;
    const selectedVehicle = vehicles.find((v) => v?.vehicle_stock?.toUpperCase()?.trim() === selectedValue) || null;
    setVehicleStock(selectedValue);
    if (selectedVehicle && onChange) onChange(selectedVehicle);
  };
  const handleInputChange = (input) => {
    const editedInput = input?.toUpperCase()?.trim() || null;
    if (onInputChange) onInputChange(editedInput);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchVehiclesAndSetState();
  };
  React20.useEffect(() => {
    if (queryCall === `onMount`) fetchVehiclesAndSetState();
  }, []);
  React20.useEffect(() => {
    setVehicleStock(value || null);
  }, [value]);
  return /* @__PURE__ */ jsxs23("div", { className: cls.stock, children: [
    label ? /* @__PURE__ */ jsxs23("label", { className: cls.stockLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx25("span", { className: cls.stockLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx25(
      Autocomplete5,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        includeInputInList: true,
        disabled,
        loading,
        loadingText: `Loading stocks...`,
        noOptionsText: `No stocks found`,
        options: vehicles?.map((v) => v?.vehicle_stock) || [],
        getOptionKey: (o) => o || ``,
        getOptionLabel: (o) => o || ``,
        value: vehicleStock || null,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input) => handleInputChange(input),
        onOpen: () => handleOpen(),
        renderInput: (params) => /* @__PURE__ */ jsx25(
          TextField10,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 24
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx25(InputAdornment9, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx25(BiLabel, { className: cx7(cls.stockIcon, disabled ? cls.stockIconDisabled : null) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles19 = (theme) => {
  const styles = {
    stock: css19`
      position: relative;
    `,
    stockLabel: css19`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    stockLabelRequired: css19`
      color: ${theme?.palette?.error?.main};
    `,
    stockIcon: css19`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    stockIconDisabled: css19`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var StockLookup_default = StockLookup;

// src/kit/lookups/VinLookup.tsx
import React21 from "react";
import dayjs11 from "dayjs";
import { useLazyQuery as useLazyQuery6 } from "@apollo/client";

// src/utils/validateVin.ts
var validateVin = (vin) => {
  if (!vin) return false;
  vin = vin.toLowerCase();
  if (!/^[a-hj-npr-z0-9]{8}[0-9xX][a-hj-npr-z0-9]{8}$/.test(vin)) {
    return false;
  }
  const transliterationTable = {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    a: 1,
    b: 2,
    c: 3,
    d: 4,
    e: 5,
    f: 6,
    g: 7,
    h: 8,
    j: 1,
    k: 2,
    l: 3,
    m: 4,
    n: 5,
    p: 7,
    r: 9,
    s: 2,
    t: 3,
    u: 4,
    v: 5,
    w: 6,
    x: 7,
    y: 8,
    z: 9
  };
  const weightsTable = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < vin.length; ++i) {
    sum += transliterationTable[vin.charAt(i)] * weightsTable[i];
  }
  const mod = sum % 11;
  return mod === 10 ? vin.charAt(8) === "x" : vin.charAt(8) === String(mod);
};

// src/kit/lookups/queries/getVehiclesByVin.query.generated.ts
import { resolveExecutor as resolveExecutor21 } from "@hopdrive/sdk-core";
var GetVehiclesByVinDocument = { "__text": 'query getVehiclesByVin($rooftopId: bigint!, $afterDate: timestamptz!) {\n  moves(\n    distinct_on: vehicle_vin\n    where: {customer_id: {_eq: $rooftopId}, ready_by: {_gte: $afterDate}, _and: [{vehicle_stock: {_nilike: "0"}}, {vehicle_stock: {_nilike: ""}}, {vehicle_vin: {_nilike: "0"}}, {vehicle_vin: {_nilike: ""}}]}\n    order_by: {vehicle_vin: asc}\n  ) {\n    id\n    manual_flag\n    reference_num\n    vehicle_color\n    vehicle_make\n    vehicle_model\n    vehicle_stock\n    vehicle_vin\n    vehicle_year\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getVehiclesByVin" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "afterDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "distinct_on" }, "value": { "kind": "EnumValue", "value": "vehicle_vin" } }, { "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "rooftopId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "afterDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "0", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_nilike" }, "value": { "kind": "StringValue", "value": "", "block": false } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "manual_flag" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reference_num" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_color" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_make" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_model" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_stock" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_vin" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_year" } }] } }] } }] };

// src/kit/lookups/VinLookup.tsx
import { css as css20, cx as cx8, keyframes as keyframes4 } from "@emotion/css";
import {
  useTheme as useTheme21,
  Autocomplete as Autocomplete6,
  InputAdornment as InputAdornment10,
  TextField as TextField11,
  Tooltip as Tooltip6
} from "@mui/material";
import { BiBarcode, BiHelpCircle, BiLoaderCircle as BiLoaderCircle4, BiSolidCheckCircle as BiSolidCheckCircle3 } from "react-icons/bi";
import { jsx as jsx26, jsxs as jsxs24 } from "react/jsx-runtime";
var VinLookup = ({
  rooftopId,
  required,
  disabled,
  error,
  name = `vin-lookup`,
  label = ``,
  placeholder = `Enter VIN...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  onFetch,
  queryCall = `onOpen`,
  ...rest
}) => {
  const theme = useTheme21();
  const cls = useStyles20(theme);
  const host = useMovePlannerHost();
  const decodeVin = host.capabilities.vinDecoder ? host.transport.decodeVin : void 0;
  const [getVehicles] = useLazyQuery6(GetVehiclesByVinDocument);
  const [vehicles, setVehicles] = React21.useState([]);
  const [vehicleVin, setVehicleVin] = React21.useState(value || null);
  const [internalError, setInternalError] = React21.useState(false);
  const [internalErrorText, setInternalErrorText] = React21.useState(``);
  const [loading, setLoading] = React21.useState(false);
  const [decoding, setDecoding] = React21.useState(false);
  const decodeTimerRef = React21.useRef(null);
  const containerRef = React21.useRef(null);
  const debouncedDecodeVin = React21.useCallback(
    async (vin, callback) => {
      if (decodeTimerRef.current) {
        return;
      }
      setDecoding(true);
      const result = await decodeVin?.(vin) || {};
      setDecoding(false);
      callback(result);
      decodeTimerRef.current = setTimeout(() => {
        decodeTimerRef.current = null;
      }, 1e3);
    },
    []
  );
  React21.useEffect(() => {
    return () => {
      if (decodeTimerRef.current) {
        clearTimeout(decodeTimerRef.current);
      }
    };
  }, []);
  const focusNextField = () => {
    setTimeout(() => {
      const currentInput = containerRef.current?.querySelector(`input[name="${name}"]`);
      if (!currentInput) return;
      const form = currentInput.closest("form") || currentInput.closest('div[class*="vehicle"]') || document;
      const focusableElements = form.querySelectorAll(
        "input:not([disabled]), textarea:not([disabled]), select:not([disabled]), button:not([disabled])"
      );
      const focusableArray = Array.from(focusableElements);
      const currentIndex = focusableArray.findIndex((el) => el === currentInput);
      if (currentIndex !== -1 && currentIndex < focusableArray.length - 1) {
        focusableArray[currentIndex + 1]?.focus();
      }
    }, 100);
  };
  const fetchVehiclesAndSetState = async () => {
    setLoading(true);
    try {
      const res = await getVehicles({
        variables: { rooftopId: rooftopId || 0, afterDate: dayjs11().subtract(3, `month`).format(`YYYY-MM-DD`) }
      });
      const resVehicles = res?.data?.moves || [];
      setVehicles(resVehicles);
      if (onFetch) onFetch(resVehicles);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch vehicles by VIN:`, err);
    }
    setLoading(false);
  };
  const handleValueChange = async (value2) => {
    const editedVIN = value2?.toUpperCase()?.trim() || null;
    setVehicleVin(editedVIN);
    const selectedVehicle = vehicles.find((v) => v?.vehicle_vin?.toUpperCase()?.trim() === editedVIN) || {};
    if (decodeVin && editedVIN?.length === 17) {
      debouncedDecodeVin(editedVIN, (decodedVinVehicle) => {
        const mergedVehicle = { ...selectedVehicle, ...decodedVinVehicle };
        if (mergedVehicle && onChange) onChange(mergedVehicle);
        setTimeout(() => {
          focusNextField();
        }, 200);
      });
    } else if (selectedVehicle && Object.keys(selectedVehicle).length > 0) {
      if (selectedVehicle && onChange) onChange(selectedVehicle);
    }
  };
  const handleInputChange = async (input, reason) => {
    const editedVIN = input?.toUpperCase()?.trim() || null;
    if (reason === `selectOption` || !decodeVin) {
      if (onInputChange) onInputChange(editedVIN);
      return;
    }
    const selectedVehicle = vehicles.find((v) => v?.vehicle_vin?.toUpperCase()?.trim() === editedVIN) || {};
    if (editedVIN?.length === 17) {
      debouncedDecodeVin(editedVIN, (decodedVinVehicle) => {
        const mergedVehicle = { ...selectedVehicle, ...decodedVinVehicle };
        if (mergedVehicle && onChange) onChange(mergedVehicle);
        setTimeout(() => {
          focusNextField();
        }, 200);
      });
    } else if (selectedVehicle && Object.keys(selectedVehicle).length > 0) {
      if (selectedVehicle && onChange) onChange(selectedVehicle);
    } else {
      if (onInputChange) onInputChange(editedVIN);
    }
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchVehiclesAndSetState();
  };
  React21.useEffect(() => {
    if (queryCall === `onMount`) fetchVehiclesAndSetState();
  }, []);
  React21.useEffect(() => {
    setVehicleVin(value || null);
  }, [value]);
  return /* @__PURE__ */ jsxs24("div", { className: cls.vin, ref: containerRef, children: [
    label ? /* @__PURE__ */ jsxs24("label", { className: cls.vinLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx26("span", { className: cls.vinLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx26(
      Autocomplete6,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        includeInputInList: true,
        disabled: disabled || decoding,
        loading,
        loadingText: `Loading VINs...`,
        noOptionsText: `No VINs found`,
        options: vehicles?.map((v) => v?.vehicle_vin) || [],
        getOptionKey: (o) => o || ``,
        getOptionLabel: (o) => o || ``,
        value: vehicleVin || null,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input, reason) => handleInputChange(input, reason),
        onOpen: () => handleOpen(),
        renderInput: (params) => /* @__PURE__ */ jsx26(
          TextField11,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 17
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx26(InputAdornment10, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx26(BiBarcode, { className: cx8(cls.vinIcon, disabled ? cls.vinIconDisabled : null) }) }),
                endAdornment: /* @__PURE__ */ jsx26(InputAdornment10, { position: "end", sx: { marginRight: `4px` }, children: decoding ? /* @__PURE__ */ jsx26(Tooltip6, { title: "Decoding VIN...", children: /* @__PURE__ */ jsx26("span", { children: /* @__PURE__ */ jsx26(BiLoaderCircle4, { className: cx8(cls.icon, cls.iconLoader), size: 20 }) }) }) : validateVin(vehicleVin) ? /* @__PURE__ */ jsx26(Tooltip6, { title: "VIN is valid!", children: /* @__PURE__ */ jsx26("span", { children: /* @__PURE__ */ jsx26(
                  BiSolidCheckCircle3,
                  {
                    size: 20,
                    style: { display: `block`, color: theme?.palette?.success?.main, cursor: `pointer` }
                  }
                ) }) }) : /* @__PURE__ */ jsx26(Tooltip6, { title: "VIN may be invalid!", children: /* @__PURE__ */ jsx26("span", { children: /* @__PURE__ */ jsx26(
                  BiHelpCircle,
                  {
                    size: 20,
                    style: { display: `block`, color: theme?.palette?.warning?.main, cursor: `pointer` }
                  }
                ) }) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles20 = (theme) => {
  const loader = keyframes4`
    0% {
      opacity: 1;
      rotate: 0deg;
    }
    6.25% {
      opacity: 0.5;
    }
    12.5% {
      opacity: 1;
    }
    18.75% {
      opacity: 0.5;
    }
    25% {
      opacity: 1;
    }
    31.25% {
      opacity: 0.5;
    }
    37.5% {
      opacity: 1;
    }
    43.75% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
      rotate: 180deg;
    }
    56.25% {
      opacity: 0.5;
    }
    62.5% {
      opacity: 1;
    }
    68.75% {
      opacity: 0.5;
    }
    75% {
      opacity: 1;
    }
    81.25% {
      opacity: 0.5;
    }
    87.5% {
      opacity: 1;
    }
    93.75% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
      rotate: 360deg;
    }
  `;
  const styles = {
    vin: css20`
      position: relative;
    `,
    vinLabel: css20`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    vinLabelRequired: css20`
      color: ${theme?.palette?.error?.main};
    `,
    vinIcon: css20`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    vinIconDisabled: css20`
      color: ${theme?.palette?.action?.disabled};
    `,
    iconLoader: css20`
      animation: ${loader} 5s linear infinite;
      user-select: none;
      pointer-events: none;
    `,
    icon: css20`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.utility?.main};
      transition: 0.1s ease-in-out;
    `
  };
  return styles;
};
var VinLookup_default = VinLookup;

// src/kit/selectors/ColorSelect.tsx
import React22 from "react";
import { css as css21, cx as cx9 } from "@emotion/css";
import { useTheme as useTheme22, Autocomplete as Autocomplete7, InputAdornment as InputAdornment11, TextField as TextField12 } from "@mui/material";
import { BiPalette } from "react-icons/bi";
import { Fragment as Fragment15, jsx as jsx27, jsxs as jsxs25 } from "react/jsx-runtime";
var ColorSelect = ({
  required,
  disabled,
  error,
  name = `color-select`,
  label = ``,
  placeholder = `Select a color...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  ...rest
}) => {
  const theme = useTheme22();
  const cls = useStyles21(theme);
  const [color, setColor] = React22.useState(value || null);
  const handleValueChange = (value2) => {
    const selectedValue = value2 || null;
    setColor(selectedValue);
    if (onChange) onChange(selectedValue);
  };
  const handleInputChange = (input) => {
    const editedInput = input || null;
    if (onInputChange) onInputChange(editedInput);
  };
  React22.useEffect(() => {
    setColor(value || null);
  }, [value]);
  return /* @__PURE__ */ jsxs25(Fragment15, { children: [
    label ? /* @__PURE__ */ jsxs25("label", { className: cls.colorLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx27("span", { className: cls.colorLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx27(
      Autocomplete7,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        options: getColors(),
        getOptionLabel: (option) => option,
        noOptionsText: "No colors found",
        disabled,
        value: color,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input) => handleInputChange(input),
        slotProps: { listbox: { "data-testid": `${name}-listbox` } },
        renderInput: (params) => /* @__PURE__ */ jsx27(
          TextField12,
          {
            ...params,
            fullWidth: true,
            required,
            error,
            name,
            placeholder,
            helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 24
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx27(InputAdornment11, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx27(BiPalette, { className: cx9(cls.colorIcon, disabled ? cls.colorIconDisabled : null), size: 20 }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles21 = (theme) => {
  const styles = {
    colorLabel: css21`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    colorLabelRequired: css21`
      color: ${theme?.palette?.error?.main};
    `,
    colorIcon: css21`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    colorIconDisabled: css21`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var ColorSelect_default = ColorSelect;

// src/kit/selectors/MakeSelect.tsx
import React23 from "react";
import { useLazyQuery as useLazyQuery7 } from "@apollo/client";

// src/kit/selectors/queries/getVehiclemakes.query.generated.ts
import { resolveExecutor as resolveExecutor22 } from "@hopdrive/sdk-core";
var GetVehiclemakesDocument = { "__text": "query getVehiclemakes {\n  vehiclemakes(order_by: {name: asc}) {\n    id\n    name\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getVehiclemakes" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "vehiclemakes" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };

// src/kit/selectors/MakeSelect.tsx
import { css as css22, cx as cx10 } from "@emotion/css";
import { useTheme as useTheme23, Autocomplete as Autocomplete8, InputAdornment as InputAdornment12, TextField as TextField13 } from "@mui/material";
import { BiSolidFactory } from "react-icons/bi";
import { Fragment as Fragment16, jsx as jsx28, jsxs as jsxs26 } from "react/jsx-runtime";
var MakeSelect = ({
  required,
  disabled,
  error,
  name = `make-select`,
  label = ``,
  placeholder = `Enter make...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  onFetch,
  queryCall = `onOpen`,
  ...rest
}) => {
  const theme = useTheme23();
  const cls = useStyles22(theme);
  const [getVehiclemakes] = useLazyQuery7(GetVehiclemakesDocument);
  const [makes, setMakes] = React23.useState([]);
  const [make, setMake] = React23.useState(value || null);
  const [internalError, setInternalError] = React23.useState(false);
  const [internalErrorText, setInternalErrorText] = React23.useState(``);
  const [loading, setLoading] = React23.useState(false);
  const fetchMakesAndSetState = async () => {
    setLoading(true);
    try {
      const res = await getVehiclemakes();
      const resMakes = res?.data?.vehiclemakes || [];
      setMakes(resMakes);
      if (onFetch) onFetch(resMakes);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch vehicle makes:`, err);
      setInternalError(true);
      setInternalErrorText(`Failed to fetch vehicle makes`);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedValue = value2 || null;
    setMake(selectedValue);
    if (onChange) onChange(selectedValue);
  };
  const handleInputChange = (input) => {
    const editedInput = input || null;
    if (onInputChange) onInputChange(editedInput);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchMakesAndSetState();
  };
  React23.useEffect(() => {
    if (queryCall === `onMount`) fetchMakesAndSetState();
  }, []);
  React23.useEffect(() => {
    setMake(value);
  }, [value]);
  return /* @__PURE__ */ jsxs26(Fragment16, { children: [
    label ? /* @__PURE__ */ jsxs26("label", { className: cls.makeLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx28("span", { className: cls.makeLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx28(
      Autocomplete8,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        includeInputInList: true,
        disabled,
        loading,
        loadingText: `Loading makes...`,
        noOptionsText: `No makes found`,
        options: makes?.map((m) => m?.name) || [],
        value: make || null,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input) => handleInputChange(input),
        onOpen: () => handleOpen(),
        ListboxProps: { "data-testid": `${name}-listbox` },
        renderInput: (params) => /* @__PURE__ */ jsx28(
          TextField13,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 24
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx28(InputAdornment12, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx28(BiSolidFactory, { className: cx10(cls.makeIcon, disabled ? cls.makeIconDisabled : null) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles22 = (theme) => {
  const styles = {
    makeLabel: css22`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    makeLabelRequired: css22`
      color: ${theme?.palette?.error?.main};
    `,
    makeIcon: css22`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    makeIconDisabled: css22`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var MakeSelect_default = MakeSelect;

// src/kit/selectors/ModelSelect.tsx
import React24 from "react";
import { useLazyQuery as useLazyQuery8 } from "@apollo/client";

// src/kit/selectors/queries/getVehiclemodelsByVehiclemake.query.generated.ts
import { resolveExecutor as resolveExecutor23 } from "@hopdrive/sdk-core";
var GetVehiclemodelsByVehiclemakeDocument = { "__text": "query getVehiclemodelsByVehiclemake($make: String) {\n  vehiclemodels(\n    where: {vehiclemake: {name: {_ilike: $make}}}\n    order_by: {name: asc}\n  ) {\n    id\n    name\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getVehiclemodelsByVehiclemake" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "make" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "vehiclemodels" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehiclemake" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_ilike" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "make" } } }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };

// src/kit/selectors/ModelSelect.tsx
import { css as css23, cx as cx11 } from "@emotion/css";
import { useTheme as useTheme24, Autocomplete as Autocomplete9, InputAdornment as InputAdornment13, TextField as TextField14 } from "@mui/material";
import { BiPurchaseTag } from "react-icons/bi";
import { Fragment as Fragment17, jsx as jsx29, jsxs as jsxs27 } from "react/jsx-runtime";
var ModelSelect = ({
  make,
  required,
  disabled,
  error,
  name = `model-select`,
  label = ``,
  placeholder = `Enter model...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  onFetch,
  queryCall = `onOpen`,
  ...rest
}) => {
  const theme = useTheme24();
  const cls = useStyles23(theme);
  const [getVehiclemodels] = useLazyQuery8(GetVehiclemodelsByVehiclemakeDocument);
  const [models, setModels] = React24.useState([]);
  const [model, setModel] = React24.useState(value || null);
  const [internalError, setInternalError] = React24.useState(false);
  const [internalErrorText, setInternalErrorText] = React24.useState(``);
  const [loading, setLoading] = React24.useState(false);
  const fetchModelsAndSetState = async () => {
    setLoading(true);
    try {
      const res = await getVehiclemodels({ variables: { make } });
      const resModels = res?.data?.vehiclemodels || [];
      const defaultModel = value || null;
      setModels(resModels);
      setModel(defaultModel);
      if (onFetch) onFetch(resModels);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch vehicle models:`, err);
      setInternalError(true);
      setInternalErrorText(`Failed to fetch vehicle models`);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedValue = value2 || null;
    setModel(selectedValue);
    if (onChange) onChange(selectedValue);
  };
  const handleInputChange = (input) => {
    const editedInput = input || null;
    if (onInputChange) onInputChange(editedInput);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchModelsAndSetState();
  };
  React24.useEffect(() => {
    if (queryCall === `onMount`) fetchModelsAndSetState();
  }, []);
  React24.useEffect(() => {
    setModel(value);
  }, [value]);
  React24.useEffect(() => {
    setModels([]);
  }, [make]);
  return /* @__PURE__ */ jsxs27(Fragment17, { children: [
    label ? /* @__PURE__ */ jsxs27("label", { className: cls.modelLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx29("span", { className: cls.modelLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx29(
      Autocomplete9,
      {
        ...rest,
        fullWidth: true,
        freeSolo: true,
        includeInputInList: true,
        disabled,
        loading,
        loadingText: `Loading models...`,
        noOptionsText: `No models found`,
        options: models?.map((m) => m?.name) || [],
        value: model || null,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input) => handleInputChange(input),
        onOpen: () => handleOpen(),
        ListboxProps: { "data-testid": `${name}-listbox` },
        renderInput: (params) => /* @__PURE__ */ jsx29(
          TextField14,
          {
            ...params,
            fullWidth: true,
            required,
            error: internalError || error,
            name,
            placeholder,
            helperText: internalErrorText || helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 36
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx29(InputAdornment13, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx29(BiPurchaseTag, { className: cx11(cls.modelIcon, disabled ? cls.modelIconDisabled : null) }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles23 = (theme) => {
  const styles = {
    modelLabel: css23`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    modelLabelRequired: css23`
      color: ${theme?.palette?.error?.main};
    `,
    modelIcon: css23`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    modelIconDisabled: css23`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var ModelSelect_default = ModelSelect;

// src/kit/selectors/YearSelect.tsx
import React25 from "react";
import { css as css24, cx as cx12 } from "@emotion/css";
import { useTheme as useTheme25, Autocomplete as Autocomplete10, InputAdornment as InputAdornment14, TextField as TextField15 } from "@mui/material";
import { BiTime } from "react-icons/bi";
import { Fragment as Fragment18, jsx as jsx30, jsxs as jsxs28 } from "react/jsx-runtime";
var YearSelect = ({
  required,
  disabled,
  error,
  name = `year-select`,
  label = ``,
  placeholder = `Select a year...`,
  helperText = ``,
  value = null,
  onChange,
  onInputChange,
  ...rest
}) => {
  const theme = useTheme25();
  const cls = useStyles24(theme);
  const [year, setYear] = React25.useState(value || null);
  const handleValueChange = (value2) => {
    const selectedValue = value2 || null;
    setYear(selectedValue);
    if (onChange) onChange(selectedValue);
  };
  const handleInputChange = (input) => {
    const editedInput = input || null;
    if (onInputChange) onInputChange(editedInput);
  };
  React25.useEffect(() => {
    setYear(value || null);
  }, [value]);
  return /* @__PURE__ */ jsxs28(Fragment18, { children: [
    label ? /* @__PURE__ */ jsxs28("label", { className: cls.yearLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx30("span", { className: cls.yearLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsx30(
      Autocomplete10,
      {
        ...rest,
        fullWidth: true,
        options: getYears(),
        getOptionLabel: (option) => option,
        noOptionsText: "No years found",
        disabled,
        value: year,
        onChange: (_, value2) => handleValueChange(value2),
        onInputChange: (_, input) => handleInputChange(input),
        slotProps: { listbox: { "data-testid": `${name}-listbox` } },
        renderInput: (params) => /* @__PURE__ */ jsx30(
          TextField15,
          {
            ...params,
            fullWidth: true,
            required,
            error,
            type: "number",
            name,
            placeholder,
            helperText,
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 4
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx30(InputAdornment14, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx30(BiTime, { className: cx12(cls.yearIcon, disabled ? cls.yearIconDisabled : null), size: 20 }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles24 = (theme) => {
  const styles = {
    yearLabel: css24`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    yearLabelRequired: css24`
      color: ${theme?.palette?.error?.main};
    `,
    yearIcon: css24`
      display: block;
      min-width: 20px;
      min-height: 20px;
      max-width: 20px;
      max-height: 20px;
      color: ${theme?.palette?.action?.active};
    `,
    yearIconDisabled: css24`
      color: ${theme?.palette?.action?.disabled};
    `
  };
  return styles;
};
var YearSelect_default = YearSelect;

// src/forms/vehicle/lookupChange.ts
function lookupFields(found) {
  return {
    color: found?.vehicle_color || null,
    make: found?.vehicle_make || null,
    manual: found?.manual_flag || false,
    model: found?.vehicle_model || null,
    stock: found?.vehicle_stock || null,
    vin: found?.vehicle_vin || null,
    year: found?.vehicle_year || null
  };
}
function keepOtherIdentifier(fields, current, source) {
  if (source === "vin") return { stock: current?.stock || fields.stock };
  return { vin: current?.vin || fields.vin };
}
function lookupChange(found, vehicle, referenceIdFromLookup, source) {
  if (referenceIdFromLookup) {
    const fields = lookupFields(found);
    const { color, make, manual, model, stock, vin, year } = fields;
    return {
      ...found,
      color,
      make,
      manual,
      model,
      referenceId: vehicle?.referenceId || found?.reference_num || null,
      stock,
      vin,
      year,
      ...keepOtherIdentifier(fields, vehicle, source)
    };
  }
  return (previous) => {
    const fields = lookupFields(found);
    return {
      ...previous,
      // This is needed to preserve ref_num
      ...fields,
      ...keepOtherIdentifier(fields, previous, source)
    };
  };
}

// src/forms/vehicle/vehicleNotice.ts
function vehicleNotice(labelPrefix, optionalVehicle, { optionalVehicleBlurb, loanerNoticeAsksForDetails }) {
  if (labelPrefix === "Loaner") {
    return { icon: "loaner", color: "utility", copy: loanerNoticeAsksForDetails ? "loaner-fill-in" : "loaner-may-leave-blank" };
  }
  if (labelPrefix === "Customer") {
    return { icon: "customer", color: "secondary", copy: optionalVehicleBlurb && optionalVehicle ? "customer-optional" : "customer" };
  }
  if (optionalVehicleBlurb && optionalVehicle) return { icon: "customer", color: "secondary", copy: "none" };
  return null;
}

// src/forms/vehicle/MovePlannerVehicleForm.tsx
import { Fragment as Fragment19, jsx as jsx31, jsxs as jsxs29 } from "react/jsx-runtime";
var NOTICE_COPY = {
  customer: /* @__PURE__ */ jsxs29(Fragment19, { children: [
    "This is the ",
    /* @__PURE__ */ jsx31("strong", { children: "customer's personal vehicle" }),
    ". Please fill out the vehicle information below."
  ] }),
  "customer-optional": /* @__PURE__ */ jsxs29(Fragment19, { children: [
    "This is the ",
    /* @__PURE__ */ jsx31("strong", { children: "customer's personal vehicle" }),
    ". Entering vehicle information is",
    " ",
    /* @__PURE__ */ jsx31("strong", { children: "optional" }),
    "."
  ] }),
  "loaner-may-leave-blank": /* @__PURE__ */ jsxs29(Fragment19, { children: [
    "This is the ",
    /* @__PURE__ */ jsx31("strong", { children: "loaner vehicle" }),
    " being assigned to the customer. If you have the loaner information on-hand, please fill out that information below. Otherwise, you should leave this section blank."
  ] }),
  "loaner-fill-in": /* @__PURE__ */ jsxs29(Fragment19, { children: [
    "This is the ",
    /* @__PURE__ */ jsx31("strong", { children: "loaner vehicle" }),
    " being assigned to the customer. Please fill out the vehicle information below."
  ] }),
  none: null
};
var MovePlannerVehicleForm = ({
  index,
  requireMakeAndModel,
  rooftopId,
  vehicle,
  setVehicle,
  appointmentMode,
  refNumLabel,
  labelPrefix
}) => {
  const theme = useTheme26();
  const cls = useStyles25(theme);
  const host = useMovePlannerHost();
  const { roCapture, referenceIdFromLookup, optionalVehicleBlurb, loanerNoticeAsksForDetails } = host.capabilities;
  const connector = host.embed?.connector;
  const customerConfig = host.rooftop.useCustomerConfig();
  const refLabel = refNumLabel || customerConfig?.reference_num_label || "Reference ID";
  const prefixLabel = (label) => labelPrefix ? `${labelPrefix} ${label}` : label;
  const { validation, type, consumer, handleConnectorFetch } = useMovePlanner();
  const vehicleIndex = `vehicle${index}`;
  const vehicleValidation = validation?.[vehicleIndex];
  const allowVinlessValet = customerConfig?.allow_vinless_valet;
  const isOptionalVehicle = !!allowVinlessValet && labelPrefix !== "Loaner";
  const notice = vehicleNotice(labelPrefix, isOptionalVehicle, { optionalVehicleBlurb, loanerNoticeAsksForDetails });
  const noticeColor = notice ? theme.palette[notice.color].main : null;
  const isConsumerVehicle = index === 1 && consumer?.first === "consumer" || index === 2 && consumer?.first === "loaner";
  const vinTrigger = isConsumerVehicle ? "consumer-vin" : "loaner-vin";
  const vinEnabled = connector ? connector.useTriggerEnabled(vinTrigger) : false;
  const stockEnabled = connector ? connector.useTriggerEnabled("stock-number") : false;
  const vinDisabled = labelPrefix === "Loaner" && !!host.embed?.settings.locks.loanerVin;
  const handleLookupChange = (source) => (found) => {
    if (setVehicle) setVehicle(lookupChange(found, vehicle, referenceIdFromLookup, source));
  };
  const handleLookupInput = (field) => (input) => {
    if (!setVehicle) return;
    if (referenceIdFromLookup) setVehicle({ ...vehicle, [field]: input });
    else setVehicle((prev) => ({ ...prev, [field]: input }));
  };
  const referenceField = roCapture ? type !== "concierge" && type !== "concierge-loaner" ? /* @__PURE__ */ jsxs29("div", { className: cls.flexItem, children: [
    /* @__PURE__ */ jsx31("label", { className: cls.textFieldLabel, htmlFor: "vehicle-reference-id", children: refLabel }),
    /* @__PURE__ */ jsx31(
      TextField16,
      {
        fullWidth: true,
        name: "vehicle-reference-id",
        placeholder: `Enter ${refLabel}...`,
        value: vehicle?.referenceId || ``,
        onChange: (e) => {
          if (setVehicle) setVehicle({ ...vehicle, referenceId: e?.target?.value || `` });
        },
        slotProps: {
          htmlInput: {
            maxLength: 24
          },
          input: {
            startAdornment: /* @__PURE__ */ jsx31(InputAdornment15, { position: "start", children: /* @__PURE__ */ jsx31(BiClipboard2, { size: 20 }) })
          }
        }
      }
    )
  ] }) : null : connector ? /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx31(
    connector.Field,
    {
      triggerType: "reference-number",
      label: refLabel,
      name: "vehicle-reference-id",
      value: vehicle?.referenceId || "",
      onChange: (value) => {
        if (setVehicle) setVehicle({ ...vehicle, referenceId: value });
      },
      onSelect: (result) => {
        if (setVehicle) setVehicle({ ...vehicle, referenceId: String(result.displayValue || "") });
        if (handleConnectorFetch) handleConnectorFetch("contract-detail", String(result.id), index);
      },
      placeholder: `Start typing ${refLabel.toLowerCase()}...`
    }
  ) }) : null;
  return /* @__PURE__ */ jsxs29("div", { className: cls.vehicle, children: [
    notice && noticeColor && /* @__PURE__ */ jsx31(InfoBlurb_default, { icon: notice.icon === "customer" ? /* @__PURE__ */ jsx31(BiSolidUser, {}) : /* @__PURE__ */ jsx31(BiSolidKey, {}), color: noticeColor, children: NOTICE_COPY[notice.copy] }),
    /* @__PURE__ */ jsxs29("div", { className: cls.flex, children: [
      referenceField,
      /* @__PURE__ */ jsxs29("div", { className: cls.flexItem, children: [
        /* @__PURE__ */ jsx31("label", { className: cls.textFieldLabel, htmlFor: "vehicle-transmission", children: "Transmission" }),
        /* @__PURE__ */ jsxs29("div", { className: cls.buttonGroup, children: [
          /* @__PURE__ */ jsx31(
            Button5,
            {
              fullWidth: true,
              color: "utility",
              variant: vehicle?.manual === false ? `contained` : `outlined`,
              startIcon: /* @__PURE__ */ jsx31(MdHdrAuto, {}),
              onClick: () => {
                if (setVehicle) setVehicle({ ...vehicle, manual: false });
              },
              sx: { height: `40px`, borderRadius: `6px 0 0 6px` },
              children: "Automatic"
            }
          ),
          /* @__PURE__ */ jsx31(
            Button5,
            {
              fullWidth: true,
              color: "utility",
              variant: vehicle?.manual === true ? `contained` : `outlined`,
              startIcon: /* @__PURE__ */ jsx31(IoCog, {}),
              onClick: () => {
                if (setVehicle) setVehicle({ ...vehicle, manual: true });
              },
              sx: { height: `40px`, borderRadius: `0 6px 6px 0` },
              children: "Manual"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx31("div", { className: cls.spacer }),
    /* @__PURE__ */ jsxs29("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: connector && vinEnabled ? /* @__PURE__ */ jsx31(
        connector.Field,
        {
          triggerType: vinTrigger,
          label: prefixLabel("VIN"),
          name: "vehicle-vin",
          value: vehicle?.vin || "",
          disabled: vinDisabled,
          onChange: (value) => {
            if (setVehicle) setVehicle({ ...vehicle, vin: value });
          },
          onSelect: (result) => {
            if (setVehicle) setVehicle({ ...vehicle, vin: String(result.displayValue || "") });
            const fetchType = isConsumerVehicle ? "contract-detail" : "vehicle-detail";
            if (handleConnectorFetch) handleConnectorFetch(fetchType, String(result.id), index, ["referenceId"]);
          },
          placeholder: "Start typing VIN...",
          required: requireMakeAndModel,
          error: !vehicleValidation?.vin,
          helperText: !vehicleValidation?.vin ? `Please enter the vehicle VIN!` : ""
        }
      ) : /* @__PURE__ */ jsx31(
        VinLookup_default,
        {
          required: requireMakeAndModel,
          disableClearable: true,
          disabled: vinDisabled,
          rooftopId,
          error: !vehicleValidation?.vin,
          name: `vehicle-vin`,
          label: prefixLabel("VIN"),
          helperText: !vehicleValidation?.vin ? `Please enter the vehicle VIN!` : ``,
          value: vehicle?.vin,
          onChange: handleLookupChange("vin"),
          onInputChange: handleLookupInput("vin")
        }
      ) }),
      !appointmentMode && /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: connector && stockEnabled ? /* @__PURE__ */ jsx31(
        connector.Field,
        {
          triggerType: "stock-number",
          label: prefixLabel("Stock"),
          name: "vehicle-stock",
          value: vehicle?.stock || "",
          onChange: (value) => {
            if (setVehicle) setVehicle({ ...vehicle, stock: value });
          },
          onSelect: (result) => {
            if (setVehicle) setVehicle({ ...vehicle, stock: String(result.displayValue || "") });
            if (handleConnectorFetch) handleConnectorFetch("vehicle-detail", String(result.id), index, ["referenceId"]);
          },
          placeholder: "Start typing stock number..."
        }
      ) : /* @__PURE__ */ jsx31(
        StockLookup_default,
        {
          rooftopId,
          name: `vehicle-stock`,
          label: prefixLabel("Stock"),
          value: vehicle?.stock,
          onChange: handleLookupChange("stock"),
          onInputChange: handleLookupInput("stock")
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx31("div", { className: cls.spacer }),
    /* @__PURE__ */ jsxs29("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx31(
        YearSelect_default,
        {
          required: requireMakeAndModel,
          error: !vehicleValidation?.year,
          name: "vehicle-year",
          label: "Year",
          helperText: !vehicleValidation?.year ? `Please select the vehicle year!` : ``,
          value: vehicle?.year || null,
          onChange: (year) => {
            if (setVehicle) setVehicle({ ...vehicle, year: year || null });
          }
        }
      ) }),
      /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx31(
        MakeSelect_default,
        {
          required: requireMakeAndModel,
          error: !vehicleValidation?.make,
          name: `vehicle-make`,
          label: `Make`,
          helperText: !vehicleValidation?.make ? `Please enter the vehicle make!` : ``,
          value: vehicle?.make,
          onChange: (make) => {
            if (setVehicle) setVehicle({ ...vehicle, make });
          },
          onInputChange: (make) => {
            if (setVehicle) setVehicle({ ...vehicle, make });
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx31("div", { className: cls.spacer }),
    /* @__PURE__ */ jsxs29("div", { className: cls.flex, children: [
      /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx31(
        ModelSelect_default,
        {
          make: vehicle?.make,
          required: requireMakeAndModel,
          error: !vehicleValidation?.model,
          name: `vehicle-model`,
          label: `Model`,
          helperText: !vehicleValidation?.model ? `Please enter the vehicle model!` : ``,
          value: vehicle?.model,
          onChange: (model) => {
            if (setVehicle) setVehicle({ ...vehicle, model });
          },
          onInputChange: (model) => {
            if (setVehicle) setVehicle({ ...vehicle, model });
          }
        }
      ) }),
      /* @__PURE__ */ jsx31("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx31(
        ColorSelect_default,
        {
          name: "vehicle-color",
          label: "Color",
          value: vehicle?.color || null,
          onChange: (color) => {
            if (setVehicle) setVehicle({ ...vehicle, color: color || null });
          }
        }
      ) })
    ] })
  ] });
};
var useStyles25 = (theme) => {
  return {
    vehicle: css25`
      position: relative;
    `,
    textFieldLabel: css25`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelRequired: css25`
      color: ${theme?.palette?.error?.main};
    `,
    buttonGroup: css25`
      display: flex;
    `,
    flex: css25`
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 12px;
      ${theme?.breakpoints?.down("sm")} {
        flex-direction: column;
      }
    `,
    flexItem: css25`
      flex: 1;
      width: 100%;
    `,
    spacer: css25`
      width: 100%;
      height: 12px;
    `
  };
};
var MovePlannerVehicleForm_default = MovePlannerVehicleForm;

// src/forms/workflowset/MovePlannerWorkflowsetForm.tsx
import { css as css27 } from "@emotion/css";

// src/kit/selectors/WorkflowsetSelect.tsx
import React26 from "react";
import { useLazyQuery as useLazyQuery9 } from "@apollo/client";
import { css as css26 } from "@emotion/css";
import { useTheme as useTheme27, InputAdornment as InputAdornment16, MenuItem as MenuItem2, TextField as TextField17, Typography as Typography12 } from "@mui/material";
import { BiFile } from "react-icons/bi";
import { Fragment as Fragment20, jsx as jsx32, jsxs as jsxs30 } from "react/jsx-runtime";
var WorkflowsetSelect = ({
  rooftopId,
  slaOverride,
  required,
  error,
  name = `workflowset-select`,
  label = ``,
  placeholder = `Select workflow...`,
  helperText = ``,
  defaultWorkflowsets = [],
  value = 0,
  onChange,
  onFetch,
  queryOverride,
  queryCall = `onMount`,
  ...rest
}) => {
  const theme = useTheme27();
  const cls = useStyles26(theme);
  const [getWorkflowsets] = useLazyQuery9(GetWorkflowsetsDocument);
  const [workflowsets, setWorkflowsets] = React26.useState(defaultWorkflowsets || []);
  const [workflowsetId, setWorkflowsetId] = React26.useState(value || 0);
  const [internalError, setInternalError] = React26.useState(false);
  const [internalErrorText, setInternalErrorText] = React26.useState(``);
  const [, setLoading] = React26.useState(false);
  const fetchWorkflowsetsAndSetState = async () => {
    setLoading(true);
    try {
      let res;
      if (queryOverride) res = await queryOverride();
      else res = await getWorkflowsets({ variables: { rooftopId: rooftopId || 0 } });
      const resWorkflowsets = res?.data?.workflowsets || [];
      const defaultWorkflowsetId = value || 0;
      setWorkflowsets(resWorkflowsets);
      setWorkflowsetId(defaultWorkflowsetId);
      if (onFetch) onFetch(resWorkflowsets);
      setInternalError(false);
      setInternalErrorText(``);
    } catch (err) {
      console.error(`Failed to fetch workflowsets:`, err);
      setInternalError(true);
      setInternalErrorText(`Failed to fetch workflowsets`);
    }
    setLoading(false);
  };
  const handleValueChange = (value2) => {
    const selectedWorkflowsetId = value2 || 0;
    setWorkflowsetId(selectedWorkflowsetId);
    if (onChange) onChange(selectedWorkflowsetId);
  };
  const handleOpen = async () => {
    if (queryCall === `onOpen`) fetchWorkflowsetsAndSetState();
  };
  React26.useEffect(() => {
    if (queryCall === `onMount`) fetchWorkflowsetsAndSetState();
  }, []);
  React26.useEffect(() => {
    setWorkflowsets(defaultWorkflowsets);
  }, [defaultWorkflowsets]);
  React26.useEffect(() => {
    setWorkflowsetId(value);
  }, [value]);
  const WorkflowsetMenuItem = (workflowset) => {
    const sla = slaOverride || workflowset?.contracts?.[0]?.sla || {};
    return /* @__PURE__ */ jsxs30(MenuItem2, { value: workflowset?.id, sx: { display: `block` }, children: [
      /* @__PURE__ */ jsx32(Typography12, { variant: "body2", sx: { display: `block`, marginBottom: `2px` }, children: workflowset?.name || `No Workflow Name` }),
      /* @__PURE__ */ jsx32(
        Typography12,
        {
          variant: "caption",
          sx: {
            display: `block`,
            whiteSpace: `wrap`,
            textWrap: `pretty`,
            marginBottom: `2px`,
            color: theme?.palette?.text?.secondary
          },
          children: workflowset?.description || `No description`
        }
      ),
      SLAinfo(sla, !!slaOverride)
    ] }, `workflowset-select-${workflowset?.id}`);
  };
  const SLAinfo = (sla, isOverride) => {
    const slaLabel = sla?.label || `Unknown SLA`;
    const defaultDuration = isOverride ? `1hr` : `48hrs`;
    const slaDuration = sla?.duration_hrs ? `${sla?.duration_hrs}${sla?.duration_hrs === 1 ? `hr` : `hrs`}` : defaultDuration;
    const slaTimestamp = isOverride ? `appointment time` : `ready by time`;
    const slaDescription = `SLA - ${slaLabel} (${slaDuration} from ${slaTimestamp})`;
    return /* @__PURE__ */ jsx32(
      Typography12,
      {
        variant: "caption",
        sx: { display: `block`, whiteSpace: `wrap`, color: theme?.palette?.secondary?.main },
        children: slaDescription
      }
    );
  };
  return /* @__PURE__ */ jsxs30(Fragment20, { children: [
    label ? /* @__PURE__ */ jsxs30("label", { className: cls.workflowsetLabel, htmlFor: name, children: [
      label,
      required ? /* @__PURE__ */ jsx32("span", { className: cls.workflowsetLabelRequired, children: " *" }) : null
    ] }) : null,
    /* @__PURE__ */ jsxs30(
      TextField17,
      {
        fullWidth: true,
        select: true,
        required,
        error: internalError || error,
        name,
        placeholder,
        helperText: internalErrorText || helperText,
        defaultValue: ``,
        value: workflowsetId || value || 0,
        onChange: (e) => handleValueChange(parseInt(e?.target?.value)),
        slotProps: {
          input: {
            startAdornment: /* @__PURE__ */ jsx32(InputAdornment16, { position: "start", children: /* @__PURE__ */ jsx32(BiFile, { size: 20 }) })
          },
          select: {
            onOpen: () => handleOpen()
          }
        },
        ...rest,
        children: [
          /* @__PURE__ */ jsx32(MenuItem2, { value: 0, sx: { color: theme?.palette?.text?.secondary }, children: placeholder || `Select a workflow` }, `workflowset-select-0`),
          workflowsets?.map((w) => WorkflowsetMenuItem(w))
        ]
      }
    )
  ] });
};
var useStyles26 = (theme) => {
  const styles = {
    workflowsetLabel: css26`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    workflowsetLabelRequired: css26`
      color: ${theme?.palette?.error?.main};
    `
  };
  return styles;
};
var WorkflowsetSelect_default = WorkflowsetSelect;

// src/forms/workflowset/MovePlannerWorkflowsetForm.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var MovePlannerWorkflowsetForm = () => {
  const host = useMovePlannerHost();
  const cls = useStyles27();
  const { validation, rooftopId, workflowsets, workflowsetId, type, setWorkflowsetId } = useMovePlanner();
  const offeredWorkflowsets = moveWorkflowsets(workflowsets);
  if (host.embed?.settings.showWorkflowsetSelect === false) return null;
  return /* @__PURE__ */ jsx33("div", { className: cls.workflowset, children: /* @__PURE__ */ jsx33(
    WorkflowsetSelect_default,
    {
      rooftopId,
      slaOverride: type?.includes(`concierge`) ? defaultConciergeSla : void 0,
      required: true,
      disabled: offeredWorkflowsets.length <= 1,
      error: !validation?.workflowsetId,
      label: "Select a Workflow",
      helperText: !validation?.workflowsetId ? `Please select a custom workflow for the move!` : ``,
      defaultWorkflowsets: offeredWorkflowsets,
      value: workflowsetId,
      onChange: setWorkflowsetId,
      queryCall: "never"
    }
  ) });
};
var useStyles27 = () => {
  return {
    workflowset: css27`
      position: relative;
      margin-top: 18px;
    `
  };
};
var MovePlannerWorkflowsetForm_default = MovePlannerWorkflowsetForm;

// src/content/MovePlannerDynamicForm.tsx
import { css as css30 } from "@emotion/css";
import { useTheme as useTheme30 } from "@mui/material";

// src/content/steps/InputStep.tsx
import { css as css28 } from "@emotion/css";
import { useTheme as useTheme28, InputAdornment as InputAdornment17, TextField as TextField18 } from "@mui/material";
import { BiText } from "react-icons/bi";
import { jsx as jsx34, jsxs as jsxs31 } from "react/jsx-runtime";
var InputStep = ({ step, value, onChange, error }) => {
  const theme = useTheme28();
  const cls = useStyles28(theme);
  const flexWidth = step.config?.flexWidth || 1;
  const placeholder = step.config?.placeholder || `Enter ${step.label.toLowerCase()}...`;
  const flexStyle = flexWidth ? {
    flex: flexWidth === 1 ? "1 1 100%" : "1 1 0",
    minWidth: flexWidth === 1 ? "100%" : `calc((100% / ${flexWidth}) - 12px)`
  } : void 0;
  return /* @__PURE__ */ jsxs31("div", { className: cls.container, style: flexStyle, children: [
    /* @__PURE__ */ jsxs31("label", { className: cls.textFieldLabel, htmlFor: `step-${step.id}`, children: [
      step.label,
      step.required ? /* @__PURE__ */ jsx34("span", { className: cls.textFieldLabelRequired, children: " *" }) : null
    ] }),
    /* @__PURE__ */ jsx34(
      TextField18,
      {
        fullWidth: flexWidth ? true : false,
        required: step.required,
        error,
        name: `step-${step.id}`,
        placeholder,
        helperText: error ? `Please enter ${step.label.toLowerCase()}!` : "",
        value: value || "",
        onChange: (e) => onChange(e?.target?.value || ""),
        slotProps: {
          htmlInput: {
            maxLength: 128
          },
          input: {
            startAdornment: /* @__PURE__ */ jsx34(InputAdornment17, { position: "start", children: /* @__PURE__ */ jsx34(BiText, { style: { fontSize: 20 } }) })
          }
        }
      }
    )
  ] });
};
var useStyles28 = (theme) => {
  return {
    container: css28`
      position: relative;
      width: 100%;
    `,
    textFieldLabel: css28`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelRequired: css28`
      color: ${theme?.palette?.error?.main};
    `
  };
};
var InputStep_default = InputStep;

// src/content/steps/SelectStep.tsx
import { css as css29 } from "@emotion/css";
import { useTheme as useTheme29, Autocomplete as Autocomplete11, InputAdornment as InputAdornment18, TextField as TextField19 } from "@mui/material";
import { BiListUl } from "react-icons/bi";
import { jsx as jsx35, jsxs as jsxs32 } from "react/jsx-runtime";
var SelectStep = ({ step, value, onChange, error }) => {
  const theme = useTheme29();
  const cls = useStyles29(theme);
  const flexWidth = step.config?.flexWidth || 1;
  const placeholder = step.config?.placeholder || `Select ${step.label.toLowerCase()}...`;
  const options = step.config?.options || [];
  const flexStyle = {
    flex: flexWidth === 1 ? "1 1 100%" : "1 1 0",
    minWidth: flexWidth === 1 ? "100%" : `calc((100% / ${flexWidth}) - 12px)`
  };
  return /* @__PURE__ */ jsxs32("div", { className: cls.container, style: flexStyle, children: [
    /* @__PURE__ */ jsxs32("label", { className: cls.textFieldLabel, htmlFor: `step-${step.id}`, children: [
      step.label,
      step.required ? /* @__PURE__ */ jsx35("span", { className: cls.textFieldLabelRequired, children: " *" }) : null
    ] }),
    /* @__PURE__ */ jsx35(
      Autocomplete11,
      {
        fullWidth: true,
        options,
        getOptionLabel: (option) => option,
        noOptionsText: "No options available",
        value: value || null,
        onChange: (_, newValue) => onChange(newValue),
        renderInput: (params) => /* @__PURE__ */ jsx35(
          TextField19,
          {
            ...params,
            fullWidth: true,
            required: step.required,
            error,
            name: `step-${step.id}`,
            placeholder,
            helperText: error ? `Please select ${step.label.toLowerCase()}!` : "",
            slotProps: {
              htmlInput: {
                ...params?.inputProps,
                maxLength: 128
              },
              input: {
                ...params?.InputProps,
                startAdornment: /* @__PURE__ */ jsx35(InputAdornment18, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx35(BiListUl, { size: 20 }) })
              }
            }
          }
        )
      }
    )
  ] });
};
var useStyles29 = (theme) => {
  return {
    container: css29`
      position: relative;
      width: 100%;
    `,
    textFieldLabel: css29`
      display: block;
      margin-bottom: 2px;
      margin-left: 6px;
      font-size: 12px;
      font-weight: 600;
    `,
    textFieldLabelRequired: css29`
      color: ${theme?.palette?.error?.main};
    `
  };
};
var SelectStep_default = SelectStep;

// src/content/steps/Step.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var Step = ({ step, value, onChange, error }) => {
  if (step.type === "input") {
    return /* @__PURE__ */ jsx36(InputStep_default, { step, value, onChange, error });
  }
  if (step.type === "select") {
    return /* @__PURE__ */ jsx36(SelectStep_default, { step, value, onChange, error });
  }
  return null;
};
var Step_default = Step;

// src/content/MovePlannerDynamicForm.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var MovePlannerDynamicForm = () => {
  const theme = useTheme30();
  const cls = useStyles30(theme);
  const { workflowsets, workflowsetId, dynamic, setDynamic, validation } = useMovePlanner();
  const workflowset = workflowsets?.find((w) => w?.id === workflowsetId) || null;
  const moveCreateWorkflowSteps = workflowset?.moveCreateWorkflow?.steps || [];
  if (!moveCreateWorkflowSteps || moveCreateWorkflowSteps.length === 0) {
    return null;
  }
  const handleStepChange = (stepId, value) => {
    if (setDynamic) {
      setDynamic({ ...dynamic, [stepId]: value });
    }
  };
  return /* @__PURE__ */ jsx37("div", { className: cls.dynamic, children: /* @__PURE__ */ jsx37("div", { className: cls.flex, children: moveCreateWorkflowSteps.map((step) => /* @__PURE__ */ jsx37(
    Step_default,
    {
      step,
      value: dynamic?.[step.id],
      onChange: (value) => handleStepChange(step.id, value),
      error: validation?.dynamic?.[step.id] === false
    },
    step.id
  )) }) });
};
var useStyles30 = (theme) => {
  return {
    dynamic: css30`
      position: relative;
      margin-top: 18px;
    `,
    title: css30`
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 12px;
      border: 1px solid ${theme?.palette?.info?.main}40;
      border-radius: 10px;
      margin-bottom: 12px;
      background-color: ${theme?.palette?.info?.main}10;
    `,
    titleIcon: css30`
      min-width: 20px;
      min-height: 20px;
      margin-top: -2px;
      font-size: 20px;
      color: ${theme?.palette?.info?.main};
    `,
    flex: css30`
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
      ${theme?.breakpoints?.down("sm")} {
        flex-direction: column;
      }
    `
  };
};
var MovePlannerDynamicForm_default = MovePlannerDynamicForm;

// src/content/whoDrivesCopy.ts
function whoDrivesCopy(liteMode) {
  if (liteMode === "lite") {
    return `When your vehicles are prepared, your drivers move them on the schedule you set. Be sure to have someone meet the driver at both ends for inspection.`;
  }
  if (liteMode === "full") {
    return `When your vehicles are prepared, one of our drivers will be sent out to move those vehicles for you. Be sure to have someone meet our driver at both ends for inspection.`;
  }
  return null;
}

// src/content/MovePlannerContent.tsx
import { Fragment as Fragment21, jsx as jsx38, jsxs as jsxs33 } from "react/jsx-runtime";
var RIDESHARE_FEATURE2 = "dispatching-rideshare";
var MovePlannerContent = ({ laneMap, header }) => {
  const theme = useTheme31();
  const cls = useStyles31(theme);
  const host = useMovePlannerHost();
  const { dynamicWorkflowSteps, separateTimeSection, laneMap: laneMapOn, rideshareForReturn, productChoiceSwitch } = host.capabilities;
  const readOnly = !!host.embed?.settings.readOnly;
  const skipTypeSelection = !!host.embed?.settings.skipTypeSelection;
  const hasHeader = header !== void 0;
  const customerConfig = host.rooftop.useCustomerConfig();
  const {
    rooftopId,
    movePlannerLocked,
    type,
    consumer,
    workflowsets,
    workflowsetId,
    move1Title,
    move2Title,
    vehicle1,
    vehicle2,
    additional1,
    additional2,
    contactInfo,
    saving,
    lanesReady,
    laneLifecycle,
    isLite,
    liteMode,
    typeRefusal: typeRefusal2,
    nothingOffered,
    rooftopConfig,
    createRideForReturn,
    setCreateRideForReturn,
    setVehicle1,
    setVehicle2,
    setAdditional1,
    setAdditional2,
    setContactInfo,
    handleSubmit,
    handleSubmitOnScheduleTimeline,
    isScheduleTimelineMode
    // handleSubmitAndAddAnother,
  } = useMovePlanner();
  const sectionRole = (index) => customerSection(type, consumer?.first) === index ? "customer" : "other";
  const hasRideshareFeature = rideshareForReturn ? host.session.useFeature(RIDESHARE_FEATURE2, rooftopId || void 0) : false;
  const handleFormSubmit = () => {
    if (isScheduleTimelineMode) {
      handleSubmitOnScheduleTimeline();
    } else {
      handleSubmit();
    }
  };
  const EligibilitySummary = host.capabilities.programCoverage ? host.programs?.EligibilitySummary : void 0;
  const mapSlot = laneMapOn ? laneMap : void 0;
  const mapVisible = !!mapSlot?.visible;
  const toggleMapVisible = () => mapSlot?.onToggle();
  const workflowset = workflowsets?.find((w) => w?.id === workflowsetId) || null;
  const move1LabelPrefix = move1Title === "CUSTOMER MOVE" ? "Customer" : move1Title === "LOANER MOVE" ? "Loaner" : void 0;
  const move2LabelPrefix = move2Title === "CUSTOMER MOVE" ? "Customer" : move2Title === "LOANER MOVE" ? "Loaner" : void 0;
  const titled = (title) => hasHeader ? /* @__PURE__ */ jsxs33("div", { className: cls.header, children: [
    header,
    title
  ] }) : title;
  if (movePlannerLocked) {
    return titled(
      /* @__PURE__ */ jsxs33("div", { className: cls.title, children: [
        /* @__PURE__ */ jsx38(Typography13, { variant: "h3", sx: { fontWeight: 600, marginBottom: `12px` }, children: "Move Planner is Locked" }),
        /* @__PURE__ */ jsxs33(Typography13, { variant: "body2", sx: { textWrap: `pretty` }, children: [
          "Your company has surpassed its monthly prepaid move amount. If you wish to increase your monthly package amount, or if you have any questions or concerns, contact a hopdrive sales representative by sending an email to",
          " ",
          /* @__PURE__ */ jsx38("a", { className: cls.lockedLink, href: "mailto:sales@hopdrive.com", children: "sales@hopdrive.com" }),
          "."
        ] })
      ] })
    );
  }
  if (nothingOffered) {
    return titled(
      /* @__PURE__ */ jsxs33("div", { className: cls.title, children: [
        /* @__PURE__ */ jsx38(Typography13, { variant: "h3", sx: { fontWeight: 600, marginBottom: `12px` }, children: nothingOffered.title }),
        /* @__PURE__ */ jsx38(Typography13, { variant: "body2", sx: { textWrap: `pretty` }, children: nothingOffered.message })
      ] })
    );
  }
  return /* @__PURE__ */ jsxs33("form", { name: "plan-form", style: readOnly ? { pointerEvents: "none" } : void 0, children: [
    titled(
      /* @__PURE__ */ jsxs33("div", { className: cls.title, children: [
        /* @__PURE__ */ jsx38(Typography13, { variant: "h3", sx: { fontWeight: 600, marginBottom: `12px` }, children: "Move Planner" }),
        /* @__PURE__ */ jsxs33(Typography13, { variant: "body2", sx: { textWrap: `pretty` }, children: [
          "Welcome to the move planner! This form allows you to set up a plan to move your vehicles.",
          " ",
          whoDrivesCopy(liteMode)
        ] }),
        liteMode === "pending" ? /* @__PURE__ */ jsx38(Box4, { sx: { mt: 1.5 }, children: /* @__PURE__ */ jsx38(InfoBlurb_default, { children: "Who drives this move is shown once its product is known." }) }) : null
      ] })
    ),
    (!skipTypeSelection || typeRefusal2) && /* @__PURE__ */ jsxs33(Fragment21, { children: [
      /* @__PURE__ */ jsx38(Divider2, { spacer: true, mb: 6, tip: `Select the type of move you would like to plan.`, children: "TYPE" }),
      /* @__PURE__ */ jsx38(MovePlannerTypeForm_default, {})
    ] }),
    productChoiceSwitch && /* @__PURE__ */ jsx38(MovePlannerProductChoiceForm_default, {}),
    /* @__PURE__ */ jsx38(
      Divider2,
      {
        spacer: true,
        mb: 6,
        tip: `Enter some high-level information that we need in order to fulfill your move request.`,
        children: "OPTIONS"
      }
    ),
    /* @__PURE__ */ jsxs33(Paper, { variant: "custom", sx: { padding: `16px` }, children: [
      /* @__PURE__ */ jsx38(MovePlannerRooftopForm_default, {}),
      moveWorkflowsets(workflowsets).length > 1 ? /* @__PURE__ */ jsx38(MovePlannerWorkflowsetForm_default, {}) : null,
      /* @__PURE__ */ jsx38(MovePlannerEmailForm_default, {}),
      /* @__PURE__ */ jsx38(MovePlannerConsumerForm_default, {}),
      dynamicWorkflowSteps && workflowset?.moveCreateWorkflow ? /* @__PURE__ */ jsx38(MovePlannerDynamicForm_default, {}) : null,
      !separateTimeSection ? /* @__PURE__ */ jsx38(MovePlannerTimeForm_default, {}) : null
    ] }),
    /* @__PURE__ */ jsx38(
      Divider2,
      {
        spacer: true,
        mb: 6,
        tip: `Select an origin and destination to create a lane between. If the location is not in our system, you may search for a Google-suggested location.`,
        actions: mapSlot ? /* @__PURE__ */ jsxs33("div", { className: cls.mapToggle, onClick: toggleMapVisible, children: [
          mapVisible ? /* @__PURE__ */ jsx38(MdMap, { size: 14 }) : /* @__PURE__ */ jsx38(MdMap, { size: 14 }),
          /* @__PURE__ */ jsx38("span", { children: mapVisible ? "Hide Map" : "Show Map" })
        ] }) : void 0,
        children: "LANE"
      }
    ),
    /* @__PURE__ */ jsx38(Paper, { variant: "custom", sx: { padding: `16px` }, children: /* @__PURE__ */ jsx38(MovePlannerLaneForm_default, { appointmentMode: false, mapVisible, laneMap: mapSlot?.Map }) }),
    separateTimeSection ? /* @__PURE__ */ jsxs33(Fragment21, { children: [
      /* @__PURE__ */ jsx38(
        Divider2,
        {
          spacer: true,
          mb: 6,
          tip: `Select the date and time for the move. You can choose a specific time or use the earliest available time.`,
          children: "TIME"
        }
      ),
      /* @__PURE__ */ jsx38(Paper, { variant: "custom", sx: { padding: `16px` }, children: /* @__PURE__ */ jsx38(MovePlannerTimeForm_default, {}) })
    ] }) : null,
    (type === `one-way` || type === `round-trip`) && /* @__PURE__ */ jsxs33(Fragment21, { children: [
      /* @__PURE__ */ jsx38(
        Divider2,
        {
          spacer: true,
          mb: 6,
          tip: `Enter contact information for pickup and delivery locations. This helps drivers coordinate with the right people.`,
          children: "CONTACT INFORMATION"
        }
      ),
      /* @__PURE__ */ jsx38(Paper, { variant: "custom", sx: { padding: `16px` }, children: /* @__PURE__ */ jsx38(MovePlannerContactInfoForm_default, { contactInfo, setContactInfo }) })
    ] }),
    /* @__PURE__ */ jsx38(Divider2, { spacer: true, mb: 6, tip: `Fill out the vehicle & additional move information.`, children: move1Title }),
    /* @__PURE__ */ jsxs33(Paper, { variant: "custom", sx: { padding: `16px` }, children: [
      /* @__PURE__ */ jsx38(
        MovePlannerVehicleForm_default,
        {
          index: 1,
          requireMakeAndModel: !customerConfig?.allow_vinless_valet && (type !== `concierge-loaner` || type === `concierge-loaner` && consumer?.first === `consumer`),
          rooftopId,
          vehicle: vehicle1,
          setVehicle: setVehicle1,
          labelPrefix: move1LabelPrefix
        },
        `vehicle1-${sectionRole(1)}`
      ),
      /* @__PURE__ */ jsx38(MovePlannerAdditionalForm_default, { additional: additional1, setAdditional: setAdditional1 }, `additional1-${sectionRole(1)}`)
    ] }),
    type === `concierge-loaner` || type === `round-trip` ? /* @__PURE__ */ jsxs33(Fragment21, { children: [
      /* @__PURE__ */ jsx38(Divider2, { spacer: true, mb: 6, tip: `Fill out the vehicle & additional move information.`, children: move2Title }),
      /* @__PURE__ */ jsxs33(Paper, { variant: "custom", sx: { padding: `16px` }, children: [
        /* @__PURE__ */ jsx38(
          MovePlannerVehicleForm_default,
          {
            index: 2,
            requireMakeAndModel: !customerConfig?.allow_vinless_valet && (type !== `concierge-loaner` || type === `concierge-loaner` && consumer?.first === `loaner`),
            rooftopId,
            vehicle: vehicle2,
            setVehicle: setVehicle2,
            labelPrefix: move2LabelPrefix
          },
          `vehicle2-${sectionRole(2)}`
        ),
        /* @__PURE__ */ jsx38(MovePlannerAdditionalForm_default, { additional: additional2, setAdditional: setAdditional2 }, `additional2-${sectionRole(2)}`)
      ] })
    ] }) : null,
    rideshareForReturn && (type === "concierge" || type === "concierge-loaner") && isLite && rooftopConfig?.rideshare_calling_enabled && hasRideshareFeature && isScheduleTimelineMode && /* @__PURE__ */ jsxs33(Box4, { sx: { display: "flex", gap: 1.5, mt: 4, mb: 2 }, children: [
      /* @__PURE__ */ jsx38(
        Button6,
        {
          variant: createRideForReturn ? "contained" : "outlined",
          color: "primary",
          onClick: () => setCreateRideForReturn?.(true),
          startIcon: /* @__PURE__ */ jsx38(BiCar, { size: 24 }),
          sx: {
            flex: 1,
            py: 2,
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none"
          },
          children: "Dispatch with Rideshare"
        }
      ),
      /* @__PURE__ */ jsx38(
        Button6,
        {
          variant: !createRideForReturn ? "contained" : "outlined",
          color: "primary",
          onClick: () => setCreateRideForReturn?.(false),
          startIcon: /* @__PURE__ */ jsx38(MdDoNotDisturb, { size: 24 }),
          sx: {
            flex: 1,
            py: 2,
            fontSize: "16px",
            fontWeight: 600,
            textTransform: "none"
          },
          children: "Dispatch without Rideshare"
        }
      )
    ] }),
    EligibilitySummary ? /* @__PURE__ */ jsx38(EligibilitySummary, {}) : null,
    !readOnly && /* @__PURE__ */ jsx38("div", { className: cls.footer, children: /* @__PURE__ */ jsx38(
      Tooltip7,
      {
        title: !saving && !lanesReady ? laneLifecycle?.phase === "failed" ? "Route calculation failed. Retry it or change either address." : laneLifecycle?.gaveUp ? LANE_GAVE_UP_MESSAGE : "Calculating route, please wait\u2026" : "",
        placement: "top",
        children: /* @__PURE__ */ jsx38("span", { children: /* @__PURE__ */ jsxs33(
          Button6,
          {
            disabled: saving || !lanesReady,
            name: "plan-submit",
            color: "primary",
            size: "large",
            onClick: handleFormSubmit,
            children: [
              "Submit Plan",
              saving ? /* @__PURE__ */ jsx38(CircularProgress2, { color: "inherit", size: 24, sx: { marginLeft: `12px` } }) : null
            ]
          }
        ) })
      }
    ) })
  ] });
};
var useStyles31 = (theme) => {
  return {
    title: css31`
      max-width: 560px;
    `,
    header: css31`
      display: flex;
      align-items: flex-start;
      gap: ${theme?.spacing(1)};
      margin-bottom: ${theme?.spacing(2)};
    `,
    lockedLink: css31`
      text-decoration: none;
      font-weight: 600;
      color: ${theme?.palette?.primary?.main};
      transition: 0.1s ease-in-out;
      :hover {
        color: ${theme?.palette?.primary?.light};
      }
    `,
    flex: css31`
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      ${theme?.breakpoints?.down("md")} {
        flex-direction: column;
      }
    `,
    flexItem: css31`
      flex: 1;
    `,
    mapToggle: css31`
      display: flex;
      align-items: center;
      gap: 4px;
      height: 20px;
      padding: 2px 8px;
      border-radius: 24px;
      font-size: 11px;
      font-weight: 500;
      white-space: nowrap;
      background-color: ${theme?.palette?.action?.hover};
      color: ${theme?.palette?.text?.disabled};
      cursor: pointer;
      user-select: none;
      transition:
        background-color 0.15s ease,
        color 0.15s ease;
      &:hover {
        background-color: ${theme?.palette?.action?.selected};
        color: ${theme?.palette?.text?.secondary};
      }
    `,
    footer: css31`
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 36px;
    `
  };
};
var MovePlannerContent_default = MovePlannerContent;

// src/moveLocation/MoveLocationEditor.tsx
import React28 from "react";
import { useMutation as useMutation5, useQuery as useQuery2 } from "@apollo/client";
import { Box as Box5, Button as Button7 } from "@mui/material";
import { useReloadGuard as useReloadGuard3 } from "@hopdrive/sdk-app-updater/react";

// src/moveDetails/useMoveDetailsEdits.ts
import React27 from "react";
import { useMutation as useMutation4 } from "@apollo/client";
import { logEvent } from "@hopdrive/sdk-events";
import { useReloadGuard as useReloadGuard2 } from "@hopdrive/sdk-app-updater/react";

// src/moveDetails/moveDetailsSave.ts
import { parsePhoneNumber } from "@hopdrive/sdk-ui";
var isPlainObject = (value) => value !== null && typeof value === "object" && !Array.isArray(value);
function getObjectDiff(oldObj = {}, newObj = {}, options = {}) {
  const { depth = 2, skipKeys = [], keysFrom = "both" } = options;
  const oldFields = {};
  const newFields = {};
  const keys = keysFrom === "old" ? Object.keys(oldObj || {}) : keysFrom === "new" ? Object.keys(newObj || {}) : [.../* @__PURE__ */ new Set([...Object.keys(oldObj || {}), ...Object.keys(newObj || {})])];
  for (const key of keys) {
    if (skipKeys.includes(key)) continue;
    const oldVal = (oldObj || {})[key] ?? null;
    const newVal = (newObj || {})[key] ?? null;
    if (depth > 0 && isPlainObject(oldVal) && isPlainObject(newVal)) {
      const nested = getObjectDiff(oldVal, newVal, { depth: depth - 1, skipKeys, keysFrom });
      if (nested) {
        oldFields[key] = nested.old;
        newFields[key] = nested.new;
      }
    } else {
      const oldNorm = oldVal != null ? JSON.stringify(oldVal) : null;
      const newNorm = newVal != null ? JSON.stringify(newVal) : null;
      if (oldNorm !== newNorm) {
        oldFields[key] = oldVal;
        newFields[key] = newVal;
      }
    }
  }
  if (Object.keys(oldFields).length === 0) return null;
  return { old: oldFields, new: newFields };
}
function moveDetailsEditsFromMove(move) {
  return {
    contact: move?.dealer_contact || "",
    notes: move?.move_details || "",
    referenceNum: move?.reference_num || "",
    vin: move?.vehicle_vin || "",
    stock: move?.vehicle_stock || "",
    consumerName: move?.consumer_name || "",
    consumerPhone: move?.consumer_phone || "",
    config: move?.config || {},
    vehicle: {
      year: move?.vehicle_year?.toString() || null,
      make: move?.vehicle_make || null,
      model: move?.vehicle_model || null,
      color: move?.vehicle_color || null
    }
  };
}
function moveDetailsEditsDiffer(edits, baseline) {
  const vehicleKeys = ["year", "make", "model", "color"];
  return edits.contact !== baseline.contact || edits.notes !== baseline.notes || edits.referenceNum !== baseline.referenceNum || edits.vin !== baseline.vin || edits.stock !== baseline.stock || edits.consumerName !== baseline.consumerName || edits.consumerPhone !== baseline.consumerPhone || JSON.stringify(edits.config) !== JSON.stringify(baseline.config) || vehicleKeys.some((key) => (edits.vehicle[key] || null) !== (baseline.vehicle[key] || null));
}
function normalizeConsumerPhone(phone) {
  return parsePhoneNumber(phone).digits || phone.trim() || null;
}
function buildMoveDetailsUpdate(move, edits, updatedBy) {
  const variables = {
    id: move.id,
    config: edits.config,
    consumer_name: edits.consumerName || null,
    consumer_phone: normalizeConsumerPhone(edits.consumerPhone),
    dealer_contact: edits.contact || null,
    move_details: edits.notes || null,
    reference_num: edits.referenceNum || null,
    updatedBy,
    vehicle_color: edits.vehicle.color || null,
    vehicle_make: edits.vehicle.make || null,
    vehicle_model: edits.vehicle.model || null,
    vehicle_stock: edits.stock || null,
    vehicle_vin: edits.vin || null,
    vehicle_year: edits.vehicle.year || null
  };
  if (Object.keys(edits.config).length === 0) {
    delete variables.config;
  }
  const metadata = getObjectDiff(move, variables, {
    skipKeys: ["id", "config", "updatedBy"],
    keysFrom: "new"
  });
  return { variables, metadata };
}
function buildMoveOdometerUpdate(move, data, updatedBy) {
  const hasPickup = !!move.pickup_workflow_data;
  const hasDelivery = !!move.delivery_workflow_data;
  const pickupWorkflowData = hasPickup && data.pickupOdometer ? { odometer: data.pickupOdometer } : null;
  const deliveryWorkflowData = hasDelivery && data.deliveryOdometer ? { odometer: data.deliveryOdometer } : null;
  const vehicleOdometer = data.deliveryOdometer || data.pickupOdometer || move.vehicle_odometer || null;
  return {
    variables: { id: move.id, pickupWorkflowData, deliveryWorkflowData, vehicleOdometer, updatedBy },
    metadata: {
      old: {
        pickup_odometer: move.pickup_workflow_data?.["odometer"] ?? null,
        delivery_odometer: move.delivery_workflow_data?.["odometer"] ?? null,
        vehicle_odometer: move.vehicle_odometer ?? null
      },
      new: {
        pickup_odometer: pickupWorkflowData?.odometer ?? null,
        delivery_odometer: deliveryWorkflowData?.odometer ?? null,
        vehicle_odometer: vehicleOdometer
      }
    }
  };
}
function moveOdometersFromMove(move) {
  return {
    pickupOdometer: String(move?.pickup_workflow_data?.["odometer"] ?? ""),
    deliveryOdometer: String(move?.delivery_workflow_data?.["odometer"] ?? "")
  };
}

// src/moveDetails/queries/updateMoveDetails.mutation.generated.ts
import { resolveExecutor as resolveExecutor24 } from "@hopdrive/sdk-core";
var UpdateMoveDetailsDocument = { "__text": 'mutation updateMoveDetails($id: bigint!, $config: jsonb, $consumer_name: String, $consumer_phone: String, $dealer_contact: String, $move_details: String, $reference_num: String, $updatedBy: String, $vehicle_color: String, $vehicle_make: String, $vehicle_model: String, $vehicle_stock: String, $vehicle_vin: String, $vehicle_year: String) {\n  update_moves(\n    where: {id: {_eq: $id}}\n    _set: {config: $config, consumer_name: $consumer_name, consumer_phone: $consumer_phone, dealer_contact: $dealer_contact, move_details: $move_details, reference_num: $reference_num, updatedat: "now()", updatedBy: $updatedBy, vehicle_color: $vehicle_color, vehicle_make: $vehicle_make, vehicle_model: $vehicle_model, vehicle_stock: $vehicle_stock, vehicle_vin: $vehicle_vin, vehicle_year: $vehicle_year}\n  ) {\n    affected_rows\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateMoveDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_name" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_phone" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "dealer_contact" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "move_details" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "reference_num" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_color" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_make" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_model" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_stock" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_vin" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_year" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_name" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_name" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "consumer_phone" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "consumer_phone" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "dealer_contact" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "dealer_contact" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "move_details" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "move_details" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "reference_num" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "reference_num" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_color" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_color" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_make" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_make" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_model" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_model" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_stock" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_stock" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_vin" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_vin" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_year" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicle_year" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };

// src/moveDetails/queries/updateMoveOdometer.mutation.generated.ts
import { resolveExecutor as resolveExecutor25 } from "@hopdrive/sdk-core";
var UpdateMoveOdometerDocument = { "__text": 'mutation updateMoveOdometer($id: bigint!, $pickupWorkflowData: jsonb, $deliveryWorkflowData: jsonb, $vehicleOdometer: String, $updatedBy: String) {\n  update_moves(\n    where: {id: {_eq: $id}}\n    _append: {pickup_workflow_data: $pickupWorkflowData, delivery_workflow_data: $deliveryWorkflowData}\n    _set: {vehicle_odometer: $vehicleOdometer, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateMoveOdometer" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupWorkflowData" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryWorkflowData" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicleOdometer" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_workflow_data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupWorkflowData" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_workflow_data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryWorkflowData" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "vehicle_odometer" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "vehicleOdometer" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };

// src/moveDetails/useMoveDetailsEdits.ts
var MOVE_DETAILS_UPDATED_EVENT = "move.details.updated";
var MOVE_DETAILS_GUARD_REASON = "Move details";
function useMoveDetailsEdits({ move, updatedBy }) {
  const { notify } = useMovePlannerHost();
  const [updateMove, { loading: detailsSaving }] = useMutation4(UpdateMoveDetailsDocument);
  const [updateOdometer, { loading: odometerSaving }] = useMutation4(UpdateMoveOdometerDocument);
  const [isEditing, setEditing] = React27.useState(false);
  const [edits, setEdits] = React27.useState(() => moveDetailsEditsFromMove(move));
  const setIsEditing = (editing) => {
    if (editing && !isEditing) setEdits(moveDetailsEditsFromMove(move));
    setEditing(editing);
  };
  useReloadGuard2(
    isEditing && moveDetailsEditsDiffer(edits, moveDetailsEditsFromMove(move)) || detailsSaving || odometerSaving,
    MOVE_DETAILS_GUARD_REASON
  );
  const [vehicleModalOpen, setVehicleModalOpen] = React27.useState(false);
  const [odometerModalOpen, setOdometerModalOpen] = React27.useState(false);
  const setField = React27.useCallback(
    (key) => (value) => setEdits((current) => ({ ...current, [key]: value })),
    []
  );
  const logAudit = async (moveId, metadata) => {
    const eventRes = await logEvent(MOVE_DETAILS_UPDATED_EVENT, {
      user: updatedBy,
      role: "dealer",
      move_id: moveId,
      customer_id: move?.customer_id ?? void 0,
      lane_id: move?.lane_id ?? void 0,
      driver_id: move?.driver_id ?? void 0,
      metadata,
      safeWithResponse: true
    });
    if (!eventRes.success) {
      console.error(`[logEvent] Failed to log ${MOVE_DETAILS_UPDATED_EVENT} for Move #${moveId}:`, eventRes.error);
    }
  };
  const save = async () => {
    if (!move?.id) return;
    try {
      const { variables, metadata } = buildMoveDetailsUpdate({ ...move, id: move.id }, edits, updatedBy);
      const res = await updateMove({ variables });
      if (res?.data?.update_moves?.affected_rows) {
        notify.success(`Changes saved!`, { toastId: `move-details-save` });
        setIsEditing(false);
        if (metadata) await logAudit(move.id, metadata);
      }
    } catch (err) {
      console.error(`Failed to save move edits:`, err);
      notify.error(`Something went wrong when saving your edits! If this problem persists, please contact us.`, {
        toastId: `move-details-save`
      });
    }
  };
  const discard = () => {
    setEdits(moveDetailsEditsFromMove(move));
    setIsEditing(false);
  };
  const submitOdometer = async (data) => {
    if (!move?.id) return;
    try {
      const { variables, metadata } = buildMoveOdometerUpdate({ ...move, id: move.id }, data, updatedBy);
      const res = await updateOdometer({ variables });
      if (res?.data?.update_moves?.affected_rows) {
        notify.success("Odometer updated!", { toastId: "odometer-save" });
        await logAudit(move.id, metadata);
      }
    } catch (err) {
      console.error("Failed to update odometer:", err);
      notify.error("Something went wrong when updating the odometer!", { toastId: "odometer-save" });
    }
  };
  return {
    isEditing,
    setIsEditing,
    edits,
    setContact: setField("contact"),
    setNotes: setField("notes"),
    setReferenceNum: setField("referenceNum"),
    setVin: setField("vin"),
    setStock: setField("stock"),
    setConsumerName: setField("consumerName"),
    setConsumerPhone: setField("consumerPhone"),
    setConfig: setField("config"),
    setVehicle: setField("vehicle"),
    save,
    discard,
    vehicleModal: { open: vehicleModalOpen, show: () => setVehicleModalOpen(true), close: () => setVehicleModalOpen(false) },
    odometerModal: { open: odometerModalOpen, show: () => setOdometerModalOpen(true), close: () => setOdometerModalOpen(false) },
    // Built each render, as the Dealer built the odometer modal's initial data.
    odometer: {
      initial: moveOdometersFromMove(move),
      hasPickup: !!move?.pickup_workflow_data,
      hasDelivery: !!move?.delivery_workflow_data
    },
    submitOdometer
  };
}

// src/moveLocation/moveLocationChange.ts
function canChangeMoveLocation(move, canEdit = true) {
  return !!move && canEdit && move.status === null;
}
async function findOrBuildMoveLane({
  transport,
  upsertLanes,
  rooftopId,
  pickup,
  delivery
}) {
  if (!rooftopId || !pickup?.id || !delivery?.id) return null;
  const { forward } = await transport.findLanePair({ customerId: rooftopId, pickupId: pickup.id, deliveryId: delivery.id });
  if (forward) return forward;
  const builtLanes = await transport.buildLaneAndInverse({ customerId: rooftopId, pickup, delivery });
  if (!builtLanes?.length) return null;
  const forwardOf = (lanes) => lanes.find(
    (lane) => (lane?.origin_location_id ?? lane?.pickup?.id) === pickup.id && (lane?.destination_location_id ?? lane?.delivery?.id) === delivery.id
  ) ?? null;
  if (!lanesNeedPersisting(builtLanes)) return forwardOf(builtLanes);
  const upsertableLanes = builtLanes.map((lane) => {
    const { pickup: _pickup, delivery: _delivery, ...laneWithoutNested } = lane;
    return laneWithoutNested;
  });
  const insertedLanes = await upsertLanes(upsertableLanes);
  return forwardOf(insertedLanes ?? []);
}

// src/moveLocation/queries/updateMoveLocationLane.mutation.generated.ts
import { resolveExecutor as resolveExecutor26 } from "@hopdrive/sdk-core";
var UpdateMoveLocationLaneDocument = { "__text": 'mutation updateMoveLocationLane($moveId: bigint!, $laneId: bigint!, $updatedBy: String) {\n  update_moves(\n    where: {id: {_eq: $moveId}}\n    _set: {lane_id: $laneId, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "updateMoveLocationLane" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "laneId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "lane_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "laneId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };

// src/moveLocation/MoveLocationEditor.tsx
import { jsx as jsx39, jsxs as jsxs34 } from "react/jsx-runtime";
var MoveLocationEditor = ({ move, role, rooftopId, updatedBy, onClose }) => {
  const { transport, notify } = useMovePlannerHost();
  const [selectedLocation, setSelectedLocation] = React28.useState(move.lane?.[role] ?? null);
  const [isLocationSaving, setLocationSaving] = React28.useState(false);
  useReloadGuard3(isLocationSaving, MOVE_DETAILS_GUARD_REASON);
  const { data } = useQuery2(GetLocationsDocument, {
    variables: { rooftopId },
    skip: !rooftopId
  });
  const [upsertLanes] = useMutation5(UpsertMovePlannerLanesDocument);
  const [updateMoveLane] = useMutation5(UpdateMoveLocationLaneDocument);
  const handleLocationChange = async (newLocation) => {
    const otherEnd = role === "pickup" ? move.lane?.delivery : move.lane?.pickup;
    if (!newLocation || !otherEnd || !move.id) return;
    setLocationSaving(true);
    try {
      const newLane = await findOrBuildMoveLane({
        transport,
        upsertLanes: async (upsertableLanes) => {
          const res = await upsertLanes({ variables: { upsertableLanes } });
          return res?.data?.insert_lanes?.returning;
        },
        rooftopId,
        pickup: role === "pickup" ? newLocation : otherEnd,
        delivery: role === "delivery" ? newLocation : otherEnd
      });
      if (newLane?.id && newLane.id !== move.lane_id) {
        await updateMoveLane({ variables: { moveId: move.id, laneId: newLane.id, updatedBy } });
        notify.success(`${role === "pickup" ? "Pickup" : "Delivery"} location updated!`, { toastId: `move-location-${role}` });
      }
    } catch (err) {
      console.error(`Failed to update ${role} location:`, err);
      notify.error("Failed to update location. Please try again.", { toastId: `move-location-${role}` });
    }
    setLocationSaving(false);
  };
  return /* @__PURE__ */ jsxs34(Box5, { sx: { display: "flex", flexDirection: "column", gap: 1.5, mt: 1 }, children: [
    /* @__PURE__ */ jsx39(
      MovePlannerLocationSelect_default,
      {
        rooftopId: move.customer_id ?? void 0,
        required: true,
        disabled: isLocationSaving,
        placeholder: `Select ${role} location...`,
        locations: data?.locations ?? [],
        location: selectedLocation,
        onLocationChange: (location) => setSelectedLocation(location || null)
      }
    ),
    /* @__PURE__ */ jsxs34(Box5, { sx: { display: "flex", gap: 1, justifyContent: "flex-end" }, children: [
      /* @__PURE__ */ jsx39(Button7, { size: "small", variant: "outlined", onClick: onClose, disabled: isLocationSaving, children: "Cancel" }),
      /* @__PURE__ */ jsx39(
        Button7,
        {
          size: "small",
          variant: "contained",
          onClick: async () => {
            if (selectedLocation) {
              await handleLocationChange(selectedLocation);
              onClose();
            }
          },
          disabled: isLocationSaving || !selectedLocation,
          children: isLocationSaving ? "Saving..." : "Save"
        }
      )
    ] })
  ] });
};
var MoveLocationEditor_default = MoveLocationEditor;

// src/moveDetails/moveDetailsEditRules.ts
var MOVE_DETAILS_LIMITS = {
  referenceNum: 48,
  vin: 17,
  stock: 24,
  contact: 128,
  notes: 512,
  consumerName: 64,
  consumerPhone: 20
};
function isMoveLite(move) {
  return !!move?.lite;
}
function canEditMoveVin(move) {
  if (!move) return false;
  const hasDriver = !!move.driver_id;
  return !hasDriver || isMoveLite(move) && (!move.status || move.status === "dispatched" || move.status === "pickup started" || move.status === "pickup arrived");
}
function moveDetailsEditableFields(move) {
  const noDriver = !!move && !move.driver_id;
  return {
    referenceNum: !!move,
    vin: canEditMoveVin(move),
    stock: noDriver,
    vehicle: noDriver,
    consumer: noDriver,
    contact: !!move,
    notes: !!move
  };
}

// src/moveDetails/EditOdometerModal.tsx
import React29 from "react";
import { css as css32 } from "@emotion/css";
import { useTheme as useTheme32, InputAdornment as InputAdornment19, TextField as TextField20, Typography as Typography14 } from "@mui/material";
import { BiTachometer } from "react-icons/bi";
import { useReloadGuard as useReloadGuard4 } from "@hopdrive/sdk-app-updater/react";
import { Fragment as Fragment22, jsx as jsx40, jsxs as jsxs35 } from "react/jsx-runtime";
var MAX_ODOMETER = 999999;
var validateOdometer = (value) => {
  if (!value && value !== "0") return "";
  const num = Number(value);
  if (!Number.isInteger(num)) return "Must be a whole number";
  if (num < 0) return "Cannot be negative";
  if (num > MAX_ODOMETER) return `Cannot exceed ${MAX_ODOMETER.toLocaleString()}`;
  return "";
};
var EditOdometerModal = ({
  open,
  onClose,
  onSubmit,
  initialData,
  hasPickupWorkflowData,
  hasDeliveryWorkflowData
}) => {
  const { Modal, ModalHeader, ModalContent, ModalFooter, ModalAction } = useMovePlannerHost().components;
  const theme = useTheme32();
  const cls = useStyles32(theme);
  const [pickupOdometer, setPickupOdometer] = React29.useState(initialData?.pickupOdometer || "");
  const [deliveryOdometer, setDeliveryOdometer] = React29.useState(initialData?.deliveryOdometer || "");
  const [pickupError, setPickupError] = React29.useState("");
  const [deliveryError, setDeliveryError] = React29.useState("");
  const holdsUnsavedWork = open && (pickupOdometer !== (initialData?.pickupOdometer || "") || deliveryOdometer !== (initialData?.deliveryOdometer || ""));
  useReloadGuard4(holdsUnsavedWork, "Odometer");
  React29.useEffect(() => {
    if (open) {
      setPickupOdometer(initialData?.pickupOdometer || "");
      setDeliveryOdometer(initialData?.deliveryOdometer || "");
      setPickupError("");
      setDeliveryError("");
    }
  }, [open, initialData]);
  const handlePickupChange = (value) => {
    if (value !== "" && !/^\d+$/.test(value)) return;
    const sanitized = value === "" ? "" : String(Number(value));
    if (sanitized.length > 6) return;
    setPickupOdometer(sanitized);
    if (pickupError) setPickupError(validateOdometer(sanitized));
  };
  const handleDeliveryChange = (value) => {
    if (value !== "" && !/^\d+$/.test(value)) return;
    const sanitized = value === "" ? "" : String(Number(value));
    if (sanitized.length > 6) return;
    setDeliveryOdometer(sanitized);
    if (deliveryError) setDeliveryError(validateOdometer(sanitized));
  };
  const handleSubmit = () => {
    const pErr = hasPickupWorkflowData ? validateOdometer(pickupOdometer) : "";
    const dErr = hasDeliveryWorkflowData ? validateOdometer(deliveryOdometer) : "";
    setPickupError(pErr);
    setDeliveryError(dErr);
    if (pErr || dErr) return;
    if (hasPickupWorkflowData && hasDeliveryWorkflowData && pickupOdometer && deliveryOdometer) {
      if (Number(pickupOdometer) > Number(deliveryOdometer)) {
        setPickupError("Start odometer cannot be higher than finish odometer");
        return;
      }
    }
    if (onSubmit) onSubmit({ pickupOdometer, deliveryOdometer });
    if (onClose) onClose();
  };
  const handleClose = () => {
    setPickupOdometer(initialData?.pickupOdometer || "");
    setDeliveryOdometer(initialData?.deliveryOdometer || "");
    setPickupError("");
    setDeliveryError("");
    if (onClose) onClose();
  };
  const hasAnyField = hasPickupWorkflowData || hasDeliveryWorkflowData;
  return /* @__PURE__ */ jsxs35(Modal, { open, children: [
    /* @__PURE__ */ jsx40(ModalHeader, { handleClose, children: "Correct Driver Odometer" }),
    /* @__PURE__ */ jsx40(ModalContent, { children: /* @__PURE__ */ jsxs35("div", { className: cls.content, children: [
      /* @__PURE__ */ jsx40(Typography14, { variant: "body2", sx: { color: theme?.palette?.text?.secondary, marginBottom: `16px` }, children: hasAnyField ? `Use this to correct odometer readings that a driver entered incorrectly during vehicle inspection (e.g. an extra digit). These values may affect reimbursement eligibility. This does not change the odometer from the original move request.` : `No workflow data is available for this move yet. Odometer values are captured by the driver during pickup and delivery inspections.` }),
      hasPickupWorkflowData ? /* @__PURE__ */ jsxs35(Fragment22, { children: [
        /* @__PURE__ */ jsx40("label", { className: cls.textFieldLabel, htmlFor: "pickup-odometer", children: "Pickup Odometer (Start)" }),
        /* @__PURE__ */ jsx40(
          TextField20,
          {
            fullWidth: true,
            id: "pickup-odometer",
            name: "pickup-odometer",
            placeholder: "Enter pickup odometer...",
            value: pickupOdometer,
            onChange: (e) => handlePickupChange(e.target.value),
            onBlur: () => setPickupError(validateOdometer(pickupOdometer)),
            error: !!pickupError,
            helperText: pickupError || " ",
            slotProps: {
              input: {
                startAdornment: /* @__PURE__ */ jsx40(InputAdornment19, { position: "start", children: /* @__PURE__ */ jsx40(BiTachometer, { size: 20 }) })
              },
              htmlInput: {
                inputMode: "numeric"
              }
            }
          }
        )
      ] }) : null,
      hasPickupWorkflowData && hasDeliveryWorkflowData ? /* @__PURE__ */ jsx40("div", { className: cls.spacer }) : null,
      hasDeliveryWorkflowData ? /* @__PURE__ */ jsxs35(Fragment22, { children: [
        /* @__PURE__ */ jsx40("label", { className: cls.textFieldLabel, htmlFor: "delivery-odometer", children: "Delivery Odometer (Finish)" }),
        /* @__PURE__ */ jsx40(
          TextField20,
          {
            fullWidth: true,
            id: "delivery-odometer",
            name: "delivery-odometer",
            placeholder: "Enter delivery odometer...",
            value: deliveryOdometer,
            onChange: (e) => handleDeliveryChange(e.target.value),
            onBlur: () => setDeliveryError(validateOdometer(deliveryOdometer)),
            error: !!deliveryError,
            helperText: deliveryError || " ",
            slotProps: {
              input: {
                startAdornment: /* @__PURE__ */ jsx40(InputAdornment19, { position: "start", children: /* @__PURE__ */ jsx40(BiTachometer, { size: 20 }) })
              },
              htmlInput: {
                inputMode: "numeric"
              }
            }
          }
        )
      ] }) : null
    ] }) }),
    /* @__PURE__ */ jsxs35(ModalFooter, { children: [
      /* @__PURE__ */ jsx40(ModalAction, { onClick: handleSubmit, disabled: !hasAnyField, children: "Submit" }),
      /* @__PURE__ */ jsx40(ModalAction, { onClick: handleClose, color: "utility", children: "Cancel" })
    ] })
  ] });
};
var useStyles32 = (_theme) => ({
  content: css32`
    position: relative;
  `,
  textFieldLabel: css32`
    display: block;
    margin-bottom: 2px;
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
  `,
  spacer: css32`
    width: 100%;
    height: 12px;
  `
});
var EditOdometerModal_default = EditOdometerModal;

// src/moveDetails/EditVehicleModal.tsx
import React30 from "react";
import { css as css33 } from "@emotion/css";
import { useTheme as useTheme33, Autocomplete as Autocomplete12, InputAdornment as InputAdornment20, TextField as TextField21, Typography as Typography15 } from "@mui/material";
import { BiPalette as BiPalette2, BiTime as BiTime2 } from "react-icons/bi";
import { jsx as jsx41, jsxs as jsxs36 } from "react/jsx-runtime";
var EditVehicleModal = ({ open, onClose, onSubmit, initialData }) => {
  const { Modal, ModalHeader, ModalContent, ModalFooter, ModalAction } = useMovePlannerHost().components;
  const theme = useTheme33();
  const cls = useStyles33(theme);
  const [year, setYear] = React30.useState(initialData?.year || null);
  const [make, setMake] = React30.useState(initialData?.make || null);
  const [model, setModel] = React30.useState(initialData?.model || null);
  const [color, setColor] = React30.useState(initialData?.color || null);
  React30.useEffect(() => {
    if (open) {
      setYear(initialData?.year || null);
      setMake(initialData?.make || null);
      setModel(initialData?.model || null);
      setColor(initialData?.color || null);
    }
  }, [open, initialData]);
  const getDisplayedVehicle = () => {
    const parts = [year, make, model].filter(Boolean);
    if (parts.length === 0) return "N/A";
    const base = parts.join(" ");
    return color ? `${base} (${color})` : base;
  };
  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({ year, make, model, color });
    }
    if (onClose) onClose();
  };
  const handleClose = () => {
    setYear(initialData?.year || null);
    setMake(initialData?.make || null);
    setModel(initialData?.model || null);
    setColor(initialData?.color || null);
    if (onClose) onClose();
  };
  return /* @__PURE__ */ jsxs36(Modal, { open, children: [
    /* @__PURE__ */ jsx41(ModalHeader, { handleClose, children: "Edit Vehicle" }),
    /* @__PURE__ */ jsx41(ModalContent, { children: /* @__PURE__ */ jsxs36("div", { className: cls.content, children: [
      /* @__PURE__ */ jsx41(Typography15, { variant: "body2", sx: { color: theme?.palette?.text?.secondary, marginBottom: `16px` }, children: "Edit the current move's vehicle record stored in our database. Your changes will be made upon clicking 'Submit', then 'Save Changes'." }),
      /* @__PURE__ */ jsxs36("div", { className: cls.flex, children: [
        /* @__PURE__ */ jsxs36("div", { className: cls.flexItem, children: [
          /* @__PURE__ */ jsx41("label", { className: cls.textFieldLabel, htmlFor: "vehicle-year", children: "Year" }),
          /* @__PURE__ */ jsx41(
            Autocomplete12,
            {
              fullWidth: true,
              options: getYears(),
              getOptionLabel: (option) => option,
              noOptionsText: "No years found",
              value: year,
              onChange: (_, value) => setYear(value || null),
              renderInput: (params) => /* @__PURE__ */ jsx41(
                TextField21,
                {
                  ...params,
                  fullWidth: true,
                  type: "number",
                  name: "vehicle-year",
                  placeholder: "Select a year...",
                  slotProps: {
                    htmlInput: {
                      ...params?.inputProps,
                      maxLength: 4
                    },
                    input: {
                      ...params?.InputProps,
                      startAdornment: /* @__PURE__ */ jsx41(InputAdornment20, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx41(BiTime2, { size: 20 }) })
                    }
                  }
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ jsx41("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx41(
          MakeSelect_default,
          {
            name: "vehicle-make",
            label: "Make",
            value: make,
            onChange: (value) => setMake(value || null),
            onInputChange: (value) => setMake(value || null)
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx41("div", { className: cls.spacer }),
      /* @__PURE__ */ jsxs36("div", { className: cls.flex, children: [
        /* @__PURE__ */ jsx41("div", { className: cls.flexItem, children: /* @__PURE__ */ jsx41(
          ModelSelect_default,
          {
            make,
            name: "vehicle-model",
            label: "Model",
            value: model,
            onChange: (value) => setModel(value || null),
            onInputChange: (value) => setModel(value || null)
          }
        ) }),
        /* @__PURE__ */ jsxs36("div", { className: cls.flexItem, children: [
          /* @__PURE__ */ jsx41("label", { className: cls.textFieldLabel, htmlFor: "vehicle-color", children: "Color" }),
          /* @__PURE__ */ jsx41(
            Autocomplete12,
            {
              fullWidth: true,
              options: getColors(),
              getOptionLabel: (option) => option,
              noOptionsText: "No colors found",
              value: color,
              onChange: (_, value) => setColor(value || null),
              renderInput: (params) => /* @__PURE__ */ jsx41(
                TextField21,
                {
                  ...params,
                  fullWidth: true,
                  name: "vehicle-color",
                  placeholder: "Select a color...",
                  slotProps: {
                    htmlInput: {
                      ...params?.inputProps,
                      maxLength: 24
                    },
                    input: {
                      ...params?.InputProps,
                      startAdornment: /* @__PURE__ */ jsx41(InputAdornment20, { position: "start", sx: { marginLeft: `8px`, marginRight: 0 }, children: /* @__PURE__ */ jsx41(BiPalette2, { size: 20 }) })
                    }
                  }
                }
              )
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx41("div", { className: cls.spacer }),
      /* @__PURE__ */ jsxs36("div", { className: cls.preview, children: [
        /* @__PURE__ */ jsx41(Typography15, { variant: "body2", sx: { fontWeight: 600 }, children: "Displayed As:" }),
        /* @__PURE__ */ jsx41(Typography15, { variant: "body2", sx: { fontWeight: 600, marginLeft: `8px` }, children: getDisplayedVehicle() })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs36(ModalFooter, { children: [
      /* @__PURE__ */ jsx41(ModalAction, { onClick: () => handleSubmit(), children: "Submit" }),
      /* @__PURE__ */ jsx41(ModalAction, { onClick: () => handleClose(), color: "utility", children: "Cancel" })
    ] })
  ] });
};
var useStyles33 = (theme) => ({
  content: css33`
    position: relative;
  `,
  textFieldLabel: css33`
    display: block;
    margin-bottom: 2px;
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
  `,
  flex: css33`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    ${theme?.breakpoints?.down("sm")} {
      flex-direction: column;
    }
  `,
  flexItem: css33`
    flex: 1;
    width: 100%;
  `,
  spacer: css33`
    width: 100%;
    height: 12px;
  `,
  preview: css33`
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid ${theme?.palette?.divider};
    border-radius: 8px;
    background-color: ${theme?.palette?.action?.hover};
  `
});
var EditVehicleModal_default = EditVehicleModal;

// src/moveDetails/MoveDetailsEditModals.tsx
import { Fragment as Fragment23, jsx as jsx42, jsxs as jsxs37 } from "react/jsx-runtime";
var MoveDetailsEditModals = ({ edits }) => /* @__PURE__ */ jsxs37(Fragment23, { children: [
  /* @__PURE__ */ jsx42(
    EditVehicleModal_default,
    {
      open: edits.vehicleModal.open,
      onClose: edits.vehicleModal.close,
      onSubmit: edits.setVehicle,
      initialData: edits.edits.vehicle
    }
  ),
  /* @__PURE__ */ jsx42(
    EditOdometerModal_default,
    {
      open: edits.odometerModal.open,
      onClose: edits.odometerModal.close,
      onSubmit: (data) => void edits.submitOdometer(data),
      initialData: edits.odometer.initial,
      hasPickupWorkflowData: edits.odometer.hasPickup,
      hasDeliveryWorkflowData: edits.odometer.hasDelivery
    }
  )
] });
var MoveDetailsEditModals_default = MoveDetailsEditModals;
export {
  ColorSelect_default as ColorSelect,
  DEALER_CAPABILITIES,
  EditOdometerModal_default as EditOdometerModal,
  EditVehicleModal_default as EditVehicleModal,
  GetAllowedHeaderRooftopsDocument,
  GetHeaderRooftopsDocument,
  GetLinkedHeaderRooftopsDocument,
  GetLocationsDocument,
  GetWorkflowsetsDocument,
  MOVE_DETAILS_LIMITS,
  MOVE_DETAILS_UPDATED_EVENT,
  MakeSelect_default as MakeSelect,
  ModelSelect_default as ModelSelect,
  MoveDetailsEditModals_default as MoveDetailsEditModals,
  MoveLocationEditor_default as MoveLocationEditor,
  MovePlannerAdditionalForm_default as MovePlannerAdditionalForm,
  MovePlannerConsumerForm_default as MovePlannerConsumerForm,
  MovePlannerContent_default as MovePlannerContent,
  MovePlannerEmailForm_default as MovePlannerEmailForm,
  MovePlannerHostProvider,
  MovePlannerLaneForm_default as MovePlannerLaneForm,
  MovePlannerLocationSelect_default as MovePlannerLocationSelect,
  MovePlannerProvider,
  MovePlannerRooftopForm_default as MovePlannerRooftopForm,
  MovePlannerTimeForm_default as MovePlannerTimeForm,
  MovePlannerTypeNotice_default as MovePlannerTypeNotice,
  MovePlannerVehicleForm_default as MovePlannerVehicleForm,
  MovePlannerWorkflowsetForm_default as MovePlannerWorkflowsetForm,
  UpdateReferenceNumOnRelatedConciergeMovesDocument,
  UpsertMovePlannerLanesDocument,
  VinLookup_default as VinLookup,
  YearSelect_default as YearSelect,
  buildMoveDetailsUpdate,
  buildMoveOdometerUpdate,
  canChangeMoveLocation,
  canEditMoveVin,
  capitalizeLaneRole,
  findOrBuildMoveLane,
  getColors,
  getLaneRoleLocationLabel,
  getYears,
  lanesNeedPersisting,
  moveDetailsEditableFields,
  moveDetailsEditsFromMove,
  mutateRelatedConciergeMoves,
  resolveCapabilities,
  typeNoticeMessage,
  useIntendedProduct,
  useMoveDetailsEdits,
  useMovePlanner,
  useMovePlannerHost
};
//# sourceMappingURL=index.mjs.map